export const cs = {
  app: {
    home: 'Domů',
    playerScout: 'Skaut hráčů',
    playerComparison: 'Porovnání hráčů',
    playerRecruitment: 'Radar',
    collections: 'Kolekce',
    favoritePlayers: 'Oblíbení hráči',
    teamAnalytics: 'Týmová analýza',
    gameAnalysis: 'Analýza zápasu',
    seasonStats: 'Statistiky sezóny',
    leagueTable: 'Tabulka ligy',
    scoresAndFixtures: 'Výsledky a zápasy',
    notifications: 'Notifikace',
    administration: 'Administrace',
    inbox: 'Doručená pošta',
    teamStats: 'Týmové statistiky',
    blog: 'Blog',
    leagues: 'Ligy',
    squadBuilder: 'Sestavovač týmu',
    playerAlerts: 'Upozornění na hráče',
    searchAlerts: 'Upozornění na vyhledávání',
    videoUploadTool: 'Nástroj pro nahrávání videí',
    videoPlaylists: 'Playlisty',
    uploadedGames: 'Nahrané zápasy',
    favoriteTeams: 'Oblíbené týmy',
    arrigo: 'Arrigo',
    validateEvents: 'Potvrďte události'
  },
  playerRecruitment: {
    title: 'Profil hráče',
    subtitle: 'Ponořte se hlouběji do charakteristik a statistik hráče',
    league: 'Liga',
    selectedSeason: 'Vybraná sezóna',
    year: 'Rok',
    radar: 'Radar',
    positions: 'Pozice',
    numberOfPlayers: 'Počet hráčů',
    template: 'Šablona',
    compareWith: 'Porovnat s',
    previousPerformance: 'Předchozí výkon',
    xGames: '{0} zápasů',
    average: 'Průměr',
    leagueAverage: 'Ligový průměr',
    selectSeason: 'Vyberte sezónu',
    positionsPlayed: 'Hrané pozice',
    minMax: 'Min & Max',
    top5Leagues: 'Top 5 lig',
    infoMessage: 'Zaškrtněte pouze jednu sezónu pro povolení Sezónní Min & Max',
    infoMessage2: 'Vyberte stejnou sezónu pro oba hráče',
    dataPer90MinText: 'Data na 90 minut',
    adjustToPossessionText: '* Upraveno podle držení míče',
    text: 'Text',
    lollipop: 'Lízátko',
    polar: 'Polární',
    noGamesBetweenDates: 'Mezi vybranými daty nebyly nalezeny žádné zápasy',
    radarTemplates: {
      Goalkeeper: 'Brankář',
      GoalkeeperCustom: 'Brankář Vlastní',
      GoalkeeperCustom1: 'Brankář Vlastní 1',
      GoalkeeperCustom2: 'Brankář Vlastní 2',
      GoalkeeperCustom3: 'Brankář Vlastní 3',
      GoalkeeperCustom4: 'Brankář Vlastní 4',
      GoalkeeperCustom5: 'Brankář Vlastní 5',
      GoalkeeperCustom6: 'Brankář Vlastní 6',
      Defender: 'Obránce',
      DefenderCustom: 'Obránce Vlastní',
      DefenderCustom1: 'Obránce Vlastní 1',
      DefenderCustom2: 'Obránce Vlastní 2',
      DefenderCustom3: 'Obránce Vlastní 3',
      DefenderCustom4: 'Obránce Vlastní 4',
      DefenderCustom5: 'Obránce Vlastní 5',
      DefenderCustom6: 'Obránce Vlastní 6',
      FullBack: 'Pravý/Levý obránce',
      FullBackCustom: 'Pravý/Levý obránce Vlastní',
      FullBackCustom1: 'Pravý/Levý obránce Vlastní 1',
      FullBackCustom2: 'Pravý/Levý obránce Vlastní 2',
      FullBackCustom3: 'Pravý/Levý obránce Vlastní 3',
      FullBackCustom4: 'Pravý/Levý obránce Vlastní 4',
      FullBackCustom5: 'Pravý/Levý obránce Vlastní 5',
      FullBackCustom6: 'Pravý/Levý obránce Vlastní 6',
      FullBackPredictive: 'Pravý/Levý obránce',
      Midfielder: 'Záložník',
      MidfielderCustom: 'Záložník Vlastní',
      MidfielderCustom1: 'Záložník Vlastní 1',
      MidfielderCustom2: 'Záložník Vlastní 2',
      MidfielderCustom3: 'Záložník Vlastní 3',
      MidfielderCustom4: 'Záložník Vlastní 4',
      MidfielderCustom5: 'Záložník Vlastní 5',
      MidfielderCustom6: 'Záložník Vlastní 6',
      MidfielderPredictive: 'Záložník',
      MidfielderDefensive: 'Defenzivní záložník',
      MidfielderOffensive: 'Ofenzivní záložník',
      AttackingMidfielder: 'Útočný záložník',
      MidfielderWing: 'Křídelní záložník',
      Winger: 'Křídlo',
      WingerCustom: 'Křídlo Vlastní',
      WingerCustom1: 'Křídlo Vlastní 1',
      WingerCustom2: 'Křídlo Vlastní 2',
      WingerCustom3: 'Křídlo Vlastní 3',
      WingerCustom4: 'Křídlo Vlastní 4',
      WingerCustom5: 'Křídlo Vlastní 5',
      WingerCustom6: 'Křídlo Vlastní 6',
      WingerOffensive: 'Útočné křídlo',
      Forward: 'Útočník',
      ForwardCustom: 'Útočník Vlastní',
      ForwardCustom1: 'Útočník Vlastní 1',
      ForwardCustom2: 'Útočník Vlastní 2',
      ForwardCustom3: 'Útočník Vlastní 3',
      ForwardCustom4: 'Útočník Vlastní 4',
      ForwardCustom5: 'Útočník Vlastní 5',
      ForwardCustom6: 'Útočník Vlastní 6',
      ForwardPredictive: 'Útočník',
      WingBack: 'Křídelní obránce',
      WingBackCustom: 'Křídelní obránce Vlastní',
      WingBackCustom1: 'Křídelní obránce Vlastní 1',
      WingBackCustom2: 'Křídelní obránce Vlastní 2',
      WingBackCustom3: 'Křídelní obránce Vlastní 3',
      WingBackCustom4: 'Křídelní obránce Vlastní 4',
      WingBackCustom5: 'Křídelní obránce Vlastní 5',
      WingBackCustom6: 'Křídelní obránce Vlastní 6',
      WingBackMedia: 'Křídelní obránce (Sociální média)',
      FullBackMedia: 'Pravý/Levý obránce (Sociální média)',
      MidfielderMedia: 'Záložník (Sociální média)',
      WingerMedia: 'Křídlo (Sociální média)',
      ForwardMedia: 'Útočník (Sociální média)',
      PhysicalWingBack: 'Fyzický křídelní obránce',
      PhysicalForward: 'Fyzický útočník',
      PhysicalWinger: 'Fyzické křídlo',
      PhysicalMidfielder: 'Fyzický záložník',
      PhysicalFullBack: 'Fyzický pravý/levý obránce',
      PhysicalDefender: 'Fyzický obránce',
      PhysicalWingBackLMO: 'Fyzický křídelní obránce',
      PhysicalForwardLMO: 'Fyzický útočník',
      PhysicalWingerLMO: 'Fyzické křídlo',
      PhysicalMidfielderLMO: 'Fyzický záložník',
      PhysicalFullBackLMO: 'Fyzický pravý/levý obránce',
      PhysicalDefenderLMO: 'Fyzický obránce'
    },
    radarTemplatesWomen: {
      Goalkeeper: 'Brankářka',
      Defender: 'Obránkyně',
      FullBack: 'Pravá/Levá obránkyně',
      FullBackPredictive: 'Pravá/Levá obránkyně',
      Midfielder: 'Záložnice',
      MidfielderPredictive: 'Záložnice',
      MidfielderDefensive: 'Defenzivní záložnice',
      MidfielderOffensive: 'Ofenzivní záložnice',
      AttackingMidfielder: 'Útočná záložnice',
      MidfielderWing: 'Křídelní záložnice',
      Winger: 'Křídlo',
      WingerOffensive: 'Útočné křídlo',
      Forward: 'Útočnice',
      ForwardPredictive: 'Útočnice',
      WingBack: 'Křídelní obránkyně',
      WingBackMedia: 'Křídelní obránkyně (Sociální média)',
      FullBackMedia: 'Pravá/Levá obránkyně (Sociální média)',
      MidfielderMedia: 'Záložnice (Sociální média)',
      WingerMedia: 'Křídlo (Sociální média)',
      ForwardMedia: 'Útočnice (Sociální média)',
      PhysicalWingBack: 'Fyzická křídelní obránkyně',
      PhysicalForward: 'Fyzická útočnice',
      PhysicalWinger: 'Fyzické křídlo',
      PhysicalMidfielder: 'Fyzická záložnice',
      PhysicalFullBack: 'Fyzická pravá/levá obránkyně',
      PhysicalDefender: 'Fyzická obránkyně',
      PhysicalWingBackLMO: 'Fyzická křídelní obránkyně',
      PhysicalForwardLMO: 'Fyzická útočnice',
      PhysicalWingerLMO: 'Fyzické křídlo',
      PhysicalMidfielderLMO: 'Fyzická záložnice',
      PhysicalFullBackLMO: 'Fyzická pravá/levá obránkyně',
      PhysicalDefenderLMO: 'Fyzická obránkyně'
    },
    radarDescription: {
      basicStatistics: {
        title: 'ZÁKLADNÍ STATISTIKY',
        minutes: 'minuty',
        goals: 'góly',
        assists: 'asistence',
        redCards: 'červené karty',
        yellowCards: 'žluté karty',
        games: 'zápasy',
        goalsReceived: 'obdržené góly bez penalt',
        xGFaced: 'obdržené xG'
      },
      profiles: {
        3: {
          1: 'Zkušený brankář s míčem u nohou, jak v krátkých, tak dlouhých přihrávkách.',
          2: 'Schopnost hrát nohama a být důležitý při zahájení hry, s dobrými procenty přihrávek na krátké i dlouhé vzdálenosti.',
          3: 'Dobrá práce nohou, díky které je tento profil zajímavou možností díky jeho metrikám procházení.',
          4: 'Profil, který vyniká svými přihrávkami, ať už ve vlastním poli nebo v poli soupeře.',
          5: 'Skvělá jistota s míčem u nohy a vysoká přihrávka.',
          6: 'Dobrá práce nohou, poskytující jistotu při odpalu míče a dokončení vysokého procenta krátkých a dlouhých přihrávek.',
          7: 'Vysoké procento dokončených průchodů, krátkých i dlouhých, poskytuje kvalitu v oběhu.'
        },
        5: {
          1: 'Obránce charakterizovaný dobrou hrou v soubojích jeden na jednoho a velkým počtem skluzů a zachycení.',
          2: 'Velmi účinný střední obránce v jednotlivých duelech, jak nad, tak v nájezdu, s dobrým předvídatelným čtením.',
          3: 'Centrální obrana s dobrým výkonem v jednotlivých obranných duelech, což se promítá do velkého objemu zotavení.',
          4: 'Profil s vysokou obrannou úrovní, schopný získat zpět velké množství míčů díky tackles a interceptions.',
          5: 'Velmi účinná obrana v nájezdu a s velkým počtem zákroků, vynikající v individuální konfrontaci.',
          6: 'Středový obránce s vysokým počtem zotavení na zápas, zručný ve čtení soupeřovy hry a řezání, s vysokou přesností a frekvencí v soubojích.',
          7: 'Defenzivní profil s vysokým objemem zotavení díky účinnosti a četnosti útoků a dobrému předvídatelnému čtení.'
        },
        6: {
          1: 'Obránce s velkým přínosem pro vytváření šancí a dobrou vizí hry.'
        },
        7: {
          1: 'Hráč s vyváženým výkonem mezi útočnou hrou (velký přínos v "xG Buildup") a defenzivní (vysoký objem znovuzískání míče).'
        },
        8: {
          1: 'Pevný v defenzivních soubojích jeden na jednoho a vysoký objem znovuzískání míče, jak ve skluzech, tak v zachyceních.'
        },
        9: {
          1: 'Hráč s velkým útočným přínosem vytvářející nebezpečné akce a šance.'
        },
        10: {
          1: 'Kompletní hráč schopný pokrýt hodně prostoru, schopný přispět k znovuzískání míče i mít relevantní procento "xG Buildup" vzhledem k celkovému počtu toho, co tým vytváří.'
        },
        11: {
          1: 'Záložník s vysokým defenzivním výkonem a velkou efektivitou v přihrávkách navzdory malému vlivu na útok.'
        },
        12: {
          1: 'Kompletní záložník s vysokým přínosem při vytváření šancí a dobrou vzdušnou efektivitou, stejně jako velkým počtem zachycení a skluzů.'
        },
        15: {
          1: 'Křídlo se schopnostmi v soubojích jeden na jednoho a dobrou úrovní dokončených center, vytvářející více očekávaných asistencí než střel.'
        },
        16: {
          1: 'Hráč s velkým objemem průnikových přihrávek a postupů s míčem, také vytvářející šance a s větším vlivem na držení míče ve středu než klasické křídlo.'
        },
        17: {
          1: 'Hráč s dobrými schopnostmi v dryblinku, jeho pohyby směřují dovnitř, aby vytvořil více střel (xG) než klíčových přihrávek (xA).'
        },
        18: {
          1: 'Útočník, který odvádí skvělou práci bez míče u nohou, umí dobře zvolit, kdy ukončit hru střelou nebo kdy přihrát.'
        },
        22: {
          1: 'Útočník s velkou mobilitou pro příjem průnikových přihrávek, stahování se na křídlo a vysokou úrovní vytvořených šancí. Vysoké procento dotyků mimo pokutové území vzhledem k celkovému počtu dotyků na zápas.'
        }
      },
      description: 'POPIS',
      conjuction: ' a ',
      conjuction2: ' a ',
      over: 'nad',
      under: 'pod',
      respectively: ', respektive',
      Defending1: {
        1: 'Jeho defenzivní výkon patří mezi nejhorší v top 5 ligách'
      },
      Defending2: {
        1: 'Nehraje dobře defenzivně, protože jeho výkon je pod průměrem'
      },
      Defending3: {
        1: 'Hraje se středním výkonem, jeho úroveň je trochu nad_pod průměrem'
      },
      Defending4: {
        1: 'Vynikající práce na defenzivních úkolech s výkonem nad průměrem'
      },
      Defending5: {
        1: 'Vynikající v defenzivních úkolech, s výkonem podobným nejlepším player_positions v top 5 ligách'
      },
      Saving1: {
        1: 'Brankář s velmi nízkým výkonem, s mnoha obtížemi při blokování míče'
      },
      Saving2: {
        1: 'Nehraje dobře jako brankář, protože jeho úroveň je pod průměrem'
      },
      Saving3: {
        1: 'Brankář s přijatelným výkonem, je v průměru 5 nejlepších lig, musí zlepšit metric_name'
      },
      Saving4: {
        1: 'Brankář s dobrou úrovní nad průměrem 5 nejlepších lig, vynikající zejména v metric_name'
      },
      Saving5: {
        1: 'Brankář je velmi kompletní hráč, všechny jeho metriky ho řadí do Top 20% při porovnání s brankáři top 5 lig v Evropě.'
      },
      Passing1: {
        1: 'S míčem je jeho úroveň mezi nejhoršími hráči'
      },
      Passing2: {
        1: 'Pokud jde o přihrávky, jeho výkon je pod průměrem'
      },
      Passing3: {
        1: 'Úroveň přihrávek je přijatelná, mírně nad_pod průměrem'
      },
      Passing4: {
        1: 'Velmi dobrá úroveň přihrávek, výrazně nad průměrem'
      },
      Passing5: {
        1: 'Velká efektivita v přihrávkách s výkonem vyšším než většina hráčů'
      },
      Aerial1: {
        1: 'Velmi slabý hráč ve vzdušné hře, mezi nejhoršími na své pozici v tomto ohledu'
      },
      Aerial2: {
        1: 'Pokud jde o získávání vzdušných míčů, hráč nehraje dobře, pod průměrem'
      },
      Aerial3: {
        1: 'Přijatelná úroveň ve vzdušné hře, trochu nad_pod průměrem'
      },
      Aerial4: {
        1: 'Vynikající výkon ve vzdušné hře, s vysokou efektivitou v tomto ohledu'
      },
      Aerial5: {
        1: 'Jeho metriky ve vzdušné hře ho řadí mezi nejlepší'
      },
      Shooting1: {
        1: 'Velmi špatné statistiky před brankou, mezi nejhoršími hráči v tomto ohledu'
      },
      Shooting2: {
        1: 'Velmi zlepšitelná úroveň střelby, pod průměrem'
      },
      Shooting3: {
        1: 'Přijatelný výkon v útočné práci, mírně nad_pod průměrem'
      },
      Shooting4: {
        1: 'Velmi dobře si vede v pokutovém území, s výkonem nad 60% hráčů'
      },
      Shooting5: {
        1: 'Velké schopnosti v útočných úkolech, s spektakulárním výkonem, řadící ho mezi nejlepší v tomto ohledu'
      },
      Association1: {
        1: 'Jeho výkon v asociaci s míčem je velmi nízký, mezi nejhoršími v top 5 ligách'
      },
      Association2: {
        1: 'Má hodně co zlepšit s míčem u nohou, protože je pod průměrným výkonem v tomto ohledu'
      },
      Association3: {
        1: 'Dobře asociuje s míčem, mírně nad_pod průměrem'
      },
      Association4: {
        1: 'Velmi dobře asociuje s míčem, představuje velmi pozoruhodnou úroveň'
      },
      Association5: {
        1: 'Mimořádná asociativní schopnost s míčem u nohou, mezi nejlepšími hráči'
      },
      BallHandling1: {
        1: 'Hrozný výkon v práci s míčem, mezi nejhoršími ve srovnání s 5 nejlepšími ligami'
      },
      BallHandling2: {
        1: 'Pokud jde o práci s míčem, jeho úrovně jsou pod průměrem'
      },
      BallHandling3: {
        1: 'Přijatelná úroveň práce s míčem, mírně nad_pod průměrem'
      },
      BallHandling4: {
        1: 'Vysoká úroveň v práci s míčem, s čísly blízkými nejlepším v tomto ohledu'
      },
      BallHandling5: {
        1: 'Výjimečná schopnost práce s míčem, mezi nejlepšími v 5 nejlepších ligách'
      },
      Crosses1: {
        1: 'Nízký výkon při centrování míče do pokutového území. Mezi nejhoršími hráči v metrikách center'
      },
      Crosses2: {
        1: 'Podprůměrný výkon při vytváření nebezpečí svými centry'
      },
      Crosses3: {
        1: 'Přijatelná úroveň při posílání center do pokutového území, trochu nad_pod průměrem'
      },
      Crosses4: {
        1: 'Dobré statistiky při centrování míče, výrazně nad průměrem'
      },
      Crosses5: {
        1: 'Velmi vysoký výkon při centrování míče do pokutového území, konkrétně mezi top 20% nejefektivnějších profilů v této kategorii'
      },
      Carries1: {
        1: 'Mezi 20% hráčů s nejhoršími čísly v přenášení míče'
      },
      Carries2: {
        1: 'Jeho výkon v přenášení míče je daleko od průměru pro hráče na jeho pozici'
      },
      Carries3: {
        1: 'Blízko průměrnému výkonu, mírně nad_pod průměrem, v přenášení míče'
      },
      Carries4: {
        1: 'Vynikající hráč s velmi dobrými čísly v hloubce a přenášení míče'
      },
      Carries5: {
        1: 'Velmi talentovaný v přenášení míče, s vysokým výkonem v metrikách kategorie Přenášení'
      },
      Turnovers1: {
        1: 'Jeho výkon je velmi negativní s vysokým objemem ztrát míče, které usnadňují soupeřům vytvářet nebezpečí. Mezi nejhoršími v této metrice'
      },
      Turnovers2: {
        1: 'Prospívá soupeřům svými četnými nebezpečnými ztrátami míče, potřebuje hodně zlepšit a snížit své ztráty míče'
      },
      Turnovers3: {
        1: 'Tento hráč je mírně nad_pod průměrem v ztrátách míče, takže je stále prostor pro zlepšení jeho výkonu'
      },
      Turnovers4: {
        1: 'Pozoruhodný výkon v ztrátách míče, nad 60% hráčů, kteří ztrácejí nejméně míčů'
      },
      Turnovers5: {
        1: 'Stojí za zmínku jeho málo ztrát míče, což ho řadí mezi nejlepší hráče v držení míče pro svůj tým'
      },
      SequenceInvolvement1: {
        1: 'Pokud jde o držení míče, čísla hovoří špatně o tomto hráči, velmi zřídka ukončuje akce střelou'
      },
      SequenceInvolvement2: {
        1: 'Jeho ukončování držení míče je docela zlepšitelné, stěží je ukončuje střelou, a to ho řadí výrazně pod průměr'
      },
      SequenceInvolvement3: {
        1: 'Přijatelná úroveň při ukončování držení míče před brankou, s percentilem trochu nad_pod průměrem, s velkou možností zlepšení'
      },
      SequenceInvolvement4: {
        1: 'Dobrá schopnost ukončovat držení míče svého týmu střelami, některé z nich končí góly, a tak má pozoruhodný výkon v této kategorii'
      },
      SequenceInvolvement5: {
        1: 'Je mezi nejlepšími hráči, pokud jde o ukončování držení míče svého týmu, ukončuje je střelami, které vytvářejí nebezpečí'
      },
      OutPlay1: {
        1: 'Můžeme identifikovat, že hráč má minimální dopad, pokud jde o narušování defenzivních struktur'
      },
      OutPlay2: {
        1: 'Jeho přínos k postupu a prolomení obrany klesá pod standardy pozice'
      },
      OutPlay3: {
        1: 'Schopný občas vytvářet výhody, hraje kolem průměru pro svou pozici'
      },
      OutPlay4: {
        1: 'Často přispívá k prolomení defenzivních linií a vytváření nerovnováhy'
      },
      OutPlay5: {
        1: 'Je řazen mezi nejlepší hráče na své pozici v eliminaci soupeřů a vytváření postupů'
      },
      LineBreakingPasses1: {
        1: 'Zřídka se pokouší nebo dokončuje přihrávky, které prolomí defenzivní linie, s velmi vzácným přínosem v těchto akcích'
      },
      LineBreakingPasses2: {
        1: 'Má potíže s konzistentním hledáním spoluhráčů mezi liniemi nebo za tlakem, s přínosem, který ho řadí pod standardy pro jeho pozici'
      },
      LineBreakingPasses3: {
        1: 'Hráč poskytuje občasné přihrávky prolomující linie, je umístěn kolem průměru pro svou pozici v těchto termínech'
      },
      LineBreakingPasses4: {
        1: 'Můžeme identifikovat, že hráč často prolomí linie svými přihrávkami a pomáhá narušit soupeřovy bloky'
      },
      LineBreakingPasses5: {
        1: 'Je mezi nejefektivnějšími přihrávajícími ve své lize v prolamování linií a odemykání tlaku. To je jedna z jeho hlavních sil jako hráče'
      },
      PassUnderPressure1: {
        1: 'Můžeme vidět, že má potíže zůstat klidný nebo efektivní, když ho soupeři uzavírají'
      },
      PassUnderPressure2: {
        1: 'Je hráč, který má potíže udržet přesnost přihrávek ve vysoce tlakových situacích'
      },
      PassUnderPressure3: {
        1: 'Hráč je umístěn kolem průměru v přihrávkách pod tlakem. Zvládá tlak rozumně dobře, i když bez konzistentně čisté realizace'
      },
      PassUnderPressure4: {
        1: 'Identifikujeme, že často uspěje v nalezení spoluhráčů navzdory tlaku, hraje nad průměrem v tomto druhu přihrávek'
      },
      PassUnderPressure5: {
        1: 'Vynikající klid a přesnost při přihrávkách pod intenzivním tlakem. Je řazen mezi nejlepší hráče na své pozici v tomto ohledu'
      },
      BallReceived1: {
        1: 'Přijímá velmi málo přihrávek v pokročilých oblastech; není hráč, který pravidelně operuje mezi liniemi'
      },
      BallReceived2: {
        1: 'Sbírá některé nepokryté příjmy v soupeřově polovině, ale bez velké konzistence'
      },
      BallReceived3: {
        1: 'Zaznamenává střední objem nebráněných příjmů v útočných zónách'
      },
      BallReceived4: {
        1: 'Často přijímá mezi liniemi a v oblastech bez tlaku'
      },
      BallReceived5: {
        1: 'Hromadí mnoho příjmů mezi liniemi, volných od obránců a v pravděpodobně klíčových zónách'
      },
      OnBallPressure1: {
        1: 'Zřídka tlačí a téměř nikdy to nedělá blízko hráče s míčem. Není intenzivní hráč'
      },
      OnBallPressure2: {
        1: 'Zapojuje se do některých silných tlaků, ale ne často. Jeho celková intenzita je spíše nízká'
      },
      OnBallPressure3: {
        1: 'Zaznamenává střední objem tlaků blízko soupeře v držení míče'
      },
      OnBallPressure4: {
        1: 'Disciplinovaný tlačící, který se pravidelně dostává blízko hráče s míčem'
      },
      OnBallPressure5: {
        1: 'Velmi intenzivní bez míče, vysoce disciplinovaný a tvrdě pracuje na tlaku na soupeře'
      },
      SpatialCoverage1: {
        1: 'Hráč vykazuje velmi omezený přínos k obsazování a kontrole prostoru, s minimálním zapojením do formace týmu a taktické struktury. Jeho prostorové pokrytí je špatné jak v držení míče, tak bez něj, což odráží malý vliv na kolektivní organizaci a kompaktnost'
      },
      SpatialCoverage2: {
        1: 'Hráč poskytuje podprůměrné prostorové pokrytí, vykazuje určitou účast na obsazování hřiště, ale s mezerami v pozicionální kontinuitě a soudržnosti se zbytkem týmu. Jeho vliv na taktickou strukturu je přerušovaný a méně konzistentní než u hráčů vyššího ranku'
      },
      SpatialCoverage3: {
        1: 'Hráč vykazuje průměrné prostorové pokrytí, přispívá stabilně k obsazování a kontrole prostoru. Jeho pozicování je obecně správné a funkční, účastní se taktické struktury týmu s mírným dopadem v obou útočných i defenzivních fázích'
      },
      SpatialCoverage4: {
        1: 'Hráč nabízí nadprůměrné prostorové pokrytí, vykazuje vysoké zapojení do obsazování hřiště a pozicionální struktury týmu. Jeho schopnost udržet formaci a přizpůsobit se přechodům významně přispívá k kompaktnosti a kontrole klíčových prostorů'
      },
      SpatialCoverage5: {
        1: 'Hráč dosahuje vynikající úrovně prostorového pokrytí, optimalizuje pozicování, aby rozhodujícím způsobem ovlivnil formaci týmu a taktickou strukturu. Jeho pochopení hry a synchronizace se zbytkem bloku mu umožňují maximalizovat obsazení strategických prostorů, jak v útoku, tak v obraně'
      },
      OffBallPressure1: {
        1: 'Hráč aplikuje velmi omezený defenzivní tlak bez míče, zřídka se zapojuje do soupeřů, aby narušil jejich akce nebo vynutil chyby. Jeho přínos k presingu a defenzivní struktuře je minimální'
      },
      OffBallPressure2: {
        1: 'Hráč poskytuje podprůměrný defenzivní tlak bez míče, občas se zapojuje do soupeřů, ale s nekonzistentním načasováním nebo pozicováním. Jeho úsilí má omezený dopad na znovuzískání míče nebo narušení soupeřovy hry'
      },
      OffBallPressure3: {
        1: 'Hráč vykazuje průměrnou úroveň tlaku bez míče, přispívá stabilně k defenzivním snahám týmu. Jeho pozicování a načasování jsou obecně efektivní, aplikuje přiměřený tlak, aby zpomalil nebo omezil možnosti soupeře'
      },
      OffBallPressure4: {
        1: 'Hráč nabízí nadprůměrný defenzivní tlak bez míče, často narušuje akce soupeřů a snižuje jejich čas a prostor. Jeho úsilí je dobře načasované a koordinované, pomáhá týmu udržet silnou defenzivní strukturu'
      },
      OffBallPressure5: {
        1: 'Hráč vyniká v aplikaci defenzivního tlaku bez míče, konzistentně obtěžuje soupeře, vynucuje ztráty míče a omezuje přihrávkové linie. Jeho intenzita, pozicování a anticipace významně zvyšují defenzivní efektivitu týmu'
      },
      Distance1: {
        1: 'Pokrývá výrazně méně prostoru než průměr (jeho pohyb na hřišti je velmi omezený)'
      },
      Distance2: {
        1: 'Jeho ujetá vzdálenost na zápas je pod tím, co je běžně vidět v špičkovém fotbalu (není tak aktivní jako průměr)'
      },
      Distance3: {
        1: 'Pokrývá rozumné množství prostoru, s čísly kolem ligového průměru (jeho fyzické zapojení je vyvážené)'
      },
      Distance4: {
        1: 'Konzistentně pokrývá vysoké vzdálenosti, s čísly, která odrážejí silnou vytrvalost (vykazuje solidní fyzický výkon)'
      },
      Distance5: {
        1: 'Jeho fyzický objem je vynikající. Mezi nejaktivnějšími hráči v top 5 ligách v ujeté vzdálenosti'
      },
      Sprint1: {
        1: 'Dělá velmi málo vysokorychlostních běhů ve srovnání s průměrem (jeho hra zahrnuje minimální sprintovací úsilí napříč zápasy)'
      },
      Sprint2: {
        1: 'Jeho frekvence sprintů je nižší než průměr pro jeho pozici (omezená explozivnost v termínech vysokorychlostních pohybů)'
      },
      Sprint3: {
        1: 'Poskytuje střední počet sprintů na zápas, v rámci očekávaného průměru (hodnoty kolem ligového průměru)'
      },
      Sprint4: {
        1: 'Vyniká frekvencí svých sprintů, výrazně nad průměrem. Ukazuje konzistentní explozivnost, přispívá vysokorychlostními běhy po celý zápas'
      },
      Sprint5: {
        1: 'Je v top 20% hráčů s nejvyšším objemem sprintů na 90 minut. Špičkový fyzický výkon v termínech opakovaných vysokorychlostních úsilí'
      },
      Acceleration1: {
        1: 'Jeho schopnost měnit tempo je jasně pod průměrem, protože provádí velmi málo explozivních akcelerací během zápasu'
      },
      Acceleration2: {
        1: 'Jeho výkon akcelerace je pod průměrem ve srovnání s podobnými hráči, protože vykazuje omezenou frekvenci krátkodobých výbuchů'
      },
      Acceleration3: {
        1: 'Zaznamenává spravedlivý počet akcelerací, blízko ligového průměru. Jeho změny tempa nevynikají, ale jeho čísla jsou správná v rámci této metriky'
      },
      Acceleration4: {
        1: 'Prokazuje silnou schopnost rychle a opakovaně akcelerovat, protože jeho míra akcelerace je jasně nad průměrem, s častými krátkými výbuchy'
      },
      Acceleration5: {
        1: 'Je mezi top 20% nejexplozivnějších hráčů v termínech opakovaných akcelerací, protože udržuje výrazně nadprůměrná čísla v rychlých startech a změnách tempa'
      },
      Speed1: {
        1: 'Pravděpodobně fyzicky pomalý hráč nebo ten, který šetří vysokointenzivní úsilí během zápasů'
      },
      Speed2: {
        1: 'Zaznamenává maximální rychlosti mírně pod konkurenčním průměrem'
      },
      Speed3: {
        1: 'Udržuje průměrné hodnoty maximální rychlosti po celý zápas'
      },
      Speed4: {
        1: 'Často dosahuje vysokých rychlostí, což naznačuje, že je rychlý a silný'
      },
      Speed5: {
        1: 'Dosahuje velmi vysokých maximálních rychlostí. Pravděpodobně rozdílový hráč v termínech tempa'
      },
      LineBreakingCarries1: {
        1: 'Zřídka prolomí linie prostřednictvím přenášení míče. Postrádá iniciativu, pokud jde o postup s míčem'
      },
      LineBreakingCarries2: {
        1: 'Dokončuje některá přenášení míče, která prolomí linie, ale bez velké pravidelné frekvence'
      },
      LineBreakingCarries3: {
        1: 'Průměrně střední počet úspěšných přenášení míče prolomujících linie'
      },
      LineBreakingCarries4: {
        1: 'Přispívá k hře častým přenášením míče přes linie a podporou postupu'
      },
      LineBreakingCarries5: {
        1: 'Skutečný specialista v přenášení míče. Konzistentně prolomí linie s míčem a ve vysokém objemu'
      },
      LineBreakingActions1: {
        1: 'Zaznamenává velmi málo akcí prolomujících linie (přihrávky a přenášení míče). Zřídka riskuje'
      },
      LineBreakingActions2: {
        1: 'Produkuje některé progresivní akce (přihrávky a přenášení míče), ale zřídka. Má tendenci hrát více horizontálně'
      },
      LineBreakingActions3: {
        1: 'Kombinuje přihrávky a přenášení míče, které pravidelně prolomí linie. Přispívá k postupu'
      },
      LineBreakingActions4: {
        1: 'Technicky zdatný a inteligentní k produkci mnoha akcí (přihrávky a přenášení míče), které prolomí soupeřovy linie'
      },
      LineBreakingActions5: {
        1: 'Skutečný specialista na postup. Má velký dopad ve svém týmu, neustále prolomí linie s míčem prostřednictvím přihrávek a přenášení míče'
      },
      OffBallRuns1: {
        1: 'Hráč dělá velmi málo účelných pohybů bez míče, nabízí omezenou podporu útočné fázi. Jeho běhy bez míče zřídka přispívají k vytváření prostoru, narušování defenzivních linií nebo zlepšování koordinace týmu v držení míče'
      },
      OffBallRuns2: {
        1: 'Hráč poskytuje podprůměrný pohyb bez míče, občas podporuje útok, ale postrádá konzistenci v načasování, směru nebo taktickém záměru. Jeho běhy mají omezený dopad na otevírání prostorů nebo zlepšování útočné struktury'
      },
      OffBallRuns3: {
        1: 'Hráč vykazuje průměrnou úroveň účelných běhů bez míče, přispívá stabilně k útočné fázi. Jeho pohyby jsou obecně dobře načasované a funkční, vytvářejí prostor a podporují týmovou hru s mírným dopadem'
      },
      OffBallRuns4: {
        1: 'Hráč vykazuje nadprůměrnou aktivitu bez míče, často dělá účelné běhy, které narušují defenzivní struktury, vytvářejí možnosti přihrávek a otevírají útočné prostory. Jeho pohybové vzorce významně přispívají k koordinaci týmu v držení míče'
      },
      OffBallRuns5: {
        1: 'Hráč vyniká v účelných pohybech bez míče, konzistentně anticipuje hru a dělá inteligentní běhy, které maximalizují útočné příležitosti. Jeho načasování, pozicování a prostorové povědomí vytvářejí neustálé hrozby a zvyšují plynulost týmu v držení míče'
      },
      OverMaxValue: {
        1: 'Má extrémní schopnost v over_max_metric_name, s výkonem nad maximální hodnotou, což dělá tohoto hráče v tomto ohledu v top 10% z 5 nejlepších lig'
      },
      OverAverageSeason: {
        1: 'Pokud jde o jeho výkon v over_average_metric_name, je nad ligovým průměrem league_name (over_average_metric_value vs average_metric_value)',
        2: 'Pokud porovnáte jeho čísla s čísly ligy league_name, v over_average_metric_name můžete říci, že jeho výkon je nad průměrem (over_average_metric_value vs average_metric_value)'
      },
      UnderMinValue: {
        1: 'Pokud jde o under_min_metric_name, měl by výrazně zlepšit svůj výkon, protože ho to řadí do nejnižšího percent_metric_name z top 5 lig'
      },
      Over70Percent: {
        1: ', zejména vynikající v over_70_metric_name s over_70_metric_value na 90 minut, respektive',
        2: ', nad 70% v over_70_metric_name s over_70_metric_value na 90 minut, respektive',
        3: ', odvádějící více než pozoruhodnou práci v over_70_metric_name s over_70_metric_value na 90 minut, respektive'
      },
      Under30Percent: {
        1: ', musí více pracovat v under_30_metric_name, protože s under_30_metric_value na 90 minut, respektive, je jeho výkon nízký',
        2: ', musí výrazně zlepšit v under_30_metric_name, protože s under_30_metric_value na 90 minut, respektive, je jeho výkon pod očekáváním',
        3: ', pokud jde o under_30_metric_name s under_30_metric_value na 90 minut respektive, musí se více snažit, aby získal lepší čísla'
      },
      OverAverageSeasonMoreThanOne: {
        1: 'Je dobré zdůraznit jejich výkon překračující ligový průměr league_name v '
      },
      OverAverageStats: {
        1: 'over_average_metric_name (over_average_metric_value vs average_metric_value v průměru)'
      },
      Over70PercentIndividualPressure: {
        1: ', vytvářející velmi dobrý individuální tlak pro znovuzískání míče',
        2: ', vysoký tlak na soupeře pro znovuzískání míče'
      },
      Under30PercentIndividualPressure: {
        1: ', musí intenzivněji tlačit, aby znovuzískal míč',
        2: ', musí vynaložit více úsilí, pokud jde o tlak na soupeře'
      }
    },
    himSelf: 'sám',
    ownSeason: 'Vlastní sezóna',
    minMaxTooltip: 'Nastavit minimální a maximální hodnoty radaru',
    infoMessage3: 'This option is only available from matchday 6'
  },
  login: {
    login: 'Přihlášení',
    latestBlogPosts: 'Nejnovější příspěvky na blogu',
    signIn: 'Přihlásit se',
    username: 'Uživatelské jméno',
    password: 'Heslo',
    passwordForgotten: 'Zapomenuté heslo',
    signUp: 'Registrace',
    enter: 'Vstoupit',
    forceTitle: 'Účet je používán',
    forceMessage: 'Účet je již připojen na jiném zařízení. Chcete ho odpojit a připojit na tomto zařízení?',
    forgotMyPassword: 'Zapomněl jsem heslo',
    firstLogin: 'První přihlášení',
    firstLoginMessage: 'Z bezpečnostních důvodů musíte při prvním přihlášení nastavit nové heslo. Kromě toho také preferovaný jazyk pro zobrazení aplikace',
    firstLoginOverview: 'Zde je přehled vašeho účtu, lig a produktů, ke kterým máte přístup.',
    passwordConfirmation: 'Potvrzení hesla',
    forgotPasswordMessage: 'Zadejte svůj email, pokud existuje platný účet spojený s tímto emailem, obdržíte ve své doručené poště další kroky pro obnovení hesla',
    resetPassword: 'Obnovit heslo',
    resetPasswordLinkInvalid: 'Tento odkaz je neplatný nebo vypršel. Požádejte o nové obnovení hesla na přihlašovací stránce.',
    skipSettings: 'Přeskočit nastavení',
    contact: 'Kontakt',
    cookiesText: 'Tento web používá cookies od Google k poskytování svých služeb a analýze vašeho provozu za účelem zajištění kvality služby, generování statistik použití a detekce a řešení zneužití.',
    contactUs: 'Kontaktujte nás',
    newsTitle: 'Novinka: Fyzické skóre!',
    newsText: 'Přidali jsme dvě nová skóre fyzické výkonnosti vedle našeho původního skóre založeného na eventových datech: <b>Skóre vytrvalosti</b> a <b>Skóre rychlosti a síly</b>.<br> Vytrvalost zvýrazňuje hráče, kteří konzistentně pokrývají prostor a udržují vysokou pracovní zátěž, zatímco Rychlost a síla se zaměřuje na maximální rychlost, sprinty a explozivní zrychlení.'
  },
  settings: {
    pageSubtitle: 'Nastavte si zážitek z aplikace',
    language: 'Jazyk',
    availableLeagues: 'Dostupné ligy',
    availableSeasons: 'Dostupné sezóny',
    availableProducts: 'Dostupné produkty',
    organization: 'Společnost',
    changePassword: 'Změnit heslo',
    seasonTemplates: 'Šablony sezón',
    seasonTemplatesSubtitle: 'Vytvořte si vlastní šablony sezón, které budou později dostupné k výběru v Žebříčku hráčů a Skautu hráčů',
    templateName: 'Název šablony',
    selectTemplate: 'Vyberte existující šablonu k úpravě',
    radarDefault: 'Výchozí radar',
    default: 'Výchozí',
    tabs: {
      options: 'Možnosti',
      templates: 'Šablony',
      availableLeagues: 'Dostupné ligy',
      contactData: 'Kontaktní údaje GBE'
    },
    contactData: {
      userDetails: 'Údaje uživatele',
      firstName: 'Jméno',
      lastName: 'Příjmení',
      contactDetails: 'Kontaktní údaje pro GBE',
      name: 'Jméno',
      phone: 'Telefon',
      mobile: 'Mobil',
      email: 'Email',
      representativeDetails: 'Údaje zástupce pro GBE'
    },
    currency: 'Měna',
    fieldPreferences: 'Předvolby hřiště',
    visualizationsPreferences: 'Předvolby vizualizací',
    fieldColor: 'Barva hřiště',
    fieldColors: {
      green: 'Zelená',
      blue: 'Modrá',
      white: 'Bílá',
      black: 'Černá',
      grey: 'Šedá'
    },
    defaultPlayerVisualization: 'Výchozí vizualizace hráče',
    appPreferences: 'Předvolby aplikace',
    darkMode: 'Tmavý režim',
    showTour: 'Zobrazit průvodce',
    customStats: 'Vlastní statistiky',
    radarTemplates: 'Šablony radarů',
    radarTemplatesSubtitle: 'Vytvořte si vlastní šablony metrik, které budou později dostupné k výběru v Radarech a Žebříčku',
    radarCategories: {
      Custom1: 'Vlastní 1',
      Custom2: 'Vlastní 2',
      Custom3: 'Vlastní 3',
      Custom4: 'Vlastní 4',
      Custom5: 'Vlastní 5',
      Custom6: 'Vlastní 6',
      Physical: 'Fyzické',
      CustomPhysical1: 'Vlastní fyzické 1',
      CustomPhysical2: 'Vlastní fyzické 2',
      CustomPhysical3: 'Vlastní fyzické 3',
      CustomPhysical4: 'Vlastní fyzické 4',
      CustomPhysical5: 'Vlastní fyzické 5',
      CustomPhysical6: 'Vlastní fyzické 6'
    },
    templateRemoveTitle: 'Odstranit šablonu',
    templateRemoveMsg: 'Chcete odstranit tuto šablonu?',
    templateEditTitle: 'Uložit šablonu',
    templateEditMsg: 'Existuje neuložená šablona, chcete ji uložit před načtením jiné šablony?',
    category: 'Kategorie',
    playerRadar: 'Radar hráče',
    teamRadar: 'Radar týmu',
    statsAlert: 'Pro uložení vložte alespoň jednu statistiku',
    recommended: 'Doporučené',
    warning: 'Existují pozice, které dosáhly maximálního povoleného počtu radarů. Prosím smažte nebo upravte jakoukoli šablonu',
    fieldPositions: {
      default: 'Driblab',
      fifa: 'FIFA',
      spanish: 'Španělské',
      numeric: 'Číselné'
    },
    showMediaMode: 'Zobrazit režim médií',
    statTemplates: 'Šablony statistik',
    statTemplatesSubtitle: 'Vytvořte si vlastní šablonu statistik výběrem z několika metrik',
    ratingFormat: {
      ratingFormat: 'Formát hodnocení',
      numbers: 'Čísla',
      letters: 'Písmena A-F'
    }
  },
  playerDetail: {
    passport: 'Pas',
    secondPassport: 'Druhý pas',
    age: 'Věk',
    dateOfBirth: 'Datum narození',
    height: 'Výška',
    weight: 'Hmotnost',
    wage: 'Plat',
    history: 'Historie',
    positions: 'Pozice',
    injuries: 'Zranění',
    transfers: 'Přestupy',
    nationalTeam: 'Národní tým',
    addFavorite: 'Přidat do oblíbených',
    removeFavorite: 'Odebrat z oblíbených',
    contractEnd: 'Konec smlouvy',
    yearsOld: ' let',
    playerAvailability: 'Dostupnost',
    playerUsage: 'Odehrané minuty',
    usage: 'Využití',
    addToCollection: 'Přidat do kolekce',
    performance: 'Výkon',
    info: 'Info',
    career: 'Kariéra',
    playerStyle: 'Styl hráče',
    radar: 'Radar',
    finishingMap: 'Mapa střel',
    threatMap: 'Mapa hrozeb',
    keyPassMap: 'Mapa klíčových přihrávek',
    beeswarm: 'Žebříček',
    allGames: 'Všechny zápasy',
    eventsMap: 'Mapa událostí',
    lbpMap: 'Průjezdy pro přerušení čáry',
    obpMap: 'Na tlak míče',
    pupMap: 'Prochází pod tlakem',
    obrMap: 'Potvrzení o míči',
    fullName: 'Celé jméno',
    academy: 'Akademie',
    name: 'Jméno',
    lastName: 'Příjmení',
    playerAvailabilityLong: '% sezóny bez zranění nebo vyloučení',
    playerUsageLong: 'Odehrané minuty',
    playerAvailability1: 'zápasů bez zranění nebo vyloučení',
    playerAvailability2: 'zápasů v této sezóně',
    playerUsage1: 'odehraných minut',
    playerUsage2: 'celkových týmových minut',
    notMinutesThisSeason: 'V této sezóně neodehrál žádné minuty',
    seasonPlaceholder: 'Neexistuje aktivní sezóna',
    inactivePlayer: 'Neaktivní hráč',
    inactivePlayerMessage: 'Pokud potřebujete více informací, můžete požádat o zprávu',
    goRequest: 'Přejít na žádost',
    warningMinutes: 'Pozor: Méně než 450 odehraných minut, analýza nemusí být reprezentativní',
    scoreWarningMinutes: 'Hráči s minimálně 450 odehranými minutami',
    pdScoreWarningMinutes: 'Hráči s minimálně 450 odehranými minutami (minimálně 60 minut na zápas)',
    warningSeasonGames: 'Sezóna má méně než 5 odehraných zápasů, takže Min & Max jsou \'Top 5 lig\'',
    warningStatsRemoved: 'Některé statistiky nejsou zobrazeny, protože nejsou dostupné pro vybranou sezónu',
    warningBeeswarm: 'Hráč není zobrazen, protože pro tuto statistiku v vybrané sezóně nejsou žádná data',
    warningPlayersZeroValue: 'Nezobrazuje se {x} hráčů s 0 ',
    onlyPlayersThatFit: 'Pouze hráči, kteří se vejdou do šablony radaru',
    gamesPlayedNotEnough: 'Možnosti deaktivovány kvůli nedostatečnému počtu odehraných zápasů',
    gbe: 'GBE',
    analysis: 'Analýza',
    documents: 'Dokumenty',
    rankDefensive: 'Defenzivní',
    rankBallHandling: 'Práce s míčem',
    rankGoal: 'Přínos gólů',
    rankXt: 'Hrozba',
    rankIndex: 'Index',
    visitHistory: 'Historie návštěv',
    placer: 'Hřiště',
    touchesMap: 'Mapa dotyků',
    heatMap: 'Teplotní mapa',
    ageProfile: 'Věkový profil',
    strongFoot: 'Silnější noha',
    player: 'Hráč',
    outOf: 'z',
    in: 'v',
    radius: 'Poloměr',
    blur: 'Rozmazání',
    careerTable: {
      nationalTeamCareer: 'Kariéra v národním týmu',
      nationalTeamCompetitions: 'Soutěže národního týmu'
    },
    physicalProgression: 'Fyzický vývoj',
    gpi: 'Globální index hráče',
    warningGPI: 'Dostupné pouze pro hráče aktivní v ELO ligách za posledních 30 dní',
    diffGPI: 'Změna od posledního zápasu',
    rankingInTheWorld: '#{0} na světě',
    rankingInTheLeague: '#{0} v {1}',
    max: 'Max',
    gpiChart: 'Graf založený na hodnotě Globálního indexu hráče z posledních {0} zápasů',
    percentileRange: 'Percentily {0} až {1}',
    months: 'měsíce',
    month: 'měsíc',
    contractExpOver4Years: 'Smlouva vyprší v',
    contractExpSoon: 'Smlouva brzy vyprší',
    contractFinalYear: 'Poslední rok smlouvy',
    freeAgent: 'Volný agent',
    gpiDescription: 'Global Player Index (GPI) je standardizovaný systém hodnocení hráčů, který hodnotí fotbalisty na základě síly jejich týmu, síly soupeře, výkonů v zápasech a dostupnosti. Inspirováno systémem hodnocení Elo, zajišťuje, že hodnocení hráčů odrážejí skutečné konkurenční prostředí spíše než libovolné základní linie.',
    turnoversMap: 'Mapa obratů a výtěžků',
    playerProfiles: {
      24: {
        label: 'Libero',
        abbreviation: 'LIB'
      },
      25: {
        label: 'Box Goalkeeper',
        abbreviation: 'PAR'
      },
      26: {
        label: 'Line',
        abbreviation: 'LIN'
      },
      27: {
        label: 'Initiator',
        abbreviation: 'INI'
      },
      28: {
        label: 'Ball Carrier',
        abbreviation: 'CON'
      },
      29: {
        label: 'Anticipator',
        abbreviation: 'ANT'
      },
      30: {
        label: 'Cover',
        abbreviation: 'COB'
      },
      31: {
        label: 'Box Defender',
        abbreviation: 'DAR'
      },
      32: {
        label: 'Deep Forward',
        abbreviation: 'DPR'
      },
      33: {
        label: 'Inside',
        abbreviation: 'INT'
      },
      34: {
        label: 'Playmaker',
        abbreviation: 'PLY'
      },
      35: {
        label: 'Defensive',
        abbreviation: 'DEF'
      },
      36: {
        label: 'Central',
        abbreviation: 'CEN'
      },
      37: {
        label: 'Ball Winner',
        abbreviation: 'REC'
      },
      38: {
        label: 'Regista',
        abbreviation: 'REG'
      },
      39: {
        label: 'Pressing',
        abbreviation: 'PRS'
      },
      40: {
        label: 'Progressive',
        abbreviation: 'PRG'
      },
      41: {
        label: 'Box-to-box',
        abbreviation: 'B2B'
      },
      42: {
        label: 'Attacking Regista',
        abbreviation: 'ROF'
      },
      43: {
        label: 'Final Third',
        abbreviation: 'ULT'
      },
      44: {
        label: 'Workhorse',
        abbreviation: 'CAB'
      },
      45: {
        label: 'Late Runner',
        abbreviation: 'LLE'
      },
      46: {
        label: 'Difference Maker',
        abbreviation: 'DES'
      },
      47: {
        label: 'Inverted Scorer',
        abbreviation: 'ING'
      },
      48: {
        label: 'Creator',
        abbreviation: 'CRE'
      },
      49: {
        label: 'Deep Midfielder',
        abbreviation: 'MPR'
      },
      50: {
        label: 'Target',
        abbreviation: 'REF'
      },
      51: {
        label: 'Link-up',
        abbreviation: 'ASO'
      },
      52: {
        label: 'Runner',
        abbreviation: 'RUP'
      },
      53: {
        label: 'Finisher',
        abbreviation: 'FIN'
      }
    },
    sucessfulTouch: 'Úspěšné doteky',
    unsuccessfulTouch: 'Neúspěšné doteky',
    showLegend: 'Zobrazit legendu'
  },
  finishingMap: {
    typesOfShot: 'Typy střel',
    shotStrategy: 'Strategie střel',
    strategiesCount: '{count} strategií',
    areas: 'Oblasti',
    bodyPart: 'Část těla',
    more: 'více',
    selectAll: 'Vybrat vše',
    minutes: 'Minuty',
    circles: 'Kruhy',
    boxes: 'Teplotní mapa pokutového území',
    lines: 'Čáry',
    games: 'Zápasy',
    perShot: 'na střelu',
    goal: 'Gól',
    missedShot: 'Minutá střela',
    savedShot: 'Chycená střela',
    shotOnPost: 'Střela na tyč',
    missedChance: 'Promarněná šance',
    openPlay: 'Otevřená hra',
    regularPlay: 'Pravidelná hra',
    fastBreak: 'Rychlý protiútok',
    individualPlay: 'Individuální hra',
    setPiece: 'Standardní situace',
    fromCorner: 'Z rohu',
    freeKick: 'Volný kop',
    indirectFreeKick: 'Nepřímý volný kop',
    throwInSetPiece: 'Standardní vhazování',
    inBox: 'V pokutovém území',
    goalArea: 'Brankoviště',
    boxLeft: 'Levá část pokutového území',
    boxCenter: 'Střed pokutového území',
    boxRight: 'Pravá část pokutového území',
    outOfBox: 'Mimo pokutové území',
    outBoxDeepLeft: 'Mimo pokutové území hluboko vlevo',
    outBoxDeepRight: 'Mimo pokutové území hluboko vpravo',
    outBoxLeft: 'Mimo pokutové území vlevo',
    outBoxCentreLeft: 'Mimo pokutové území střed-vlevo',
    outBoxCentre: 'Mimo pokutové území střed',
    outBoxCentreRight: 'Mimo pokutové území střed-vpravo',
    outBoxRight: 'Mimo pokutové území vpravo',
    left35: '+35 Vlevo',
    centreLeft35: '+35 Střed-vlevo',
    centre35: '+35 Střed',
    centreRight35: '+35 Střed-vpravo',
    right35: '+35 Vpravo',
    head: 'Hlava',
    rightFooted: 'Pravá noha',
    leftFooted: 'Levá noha',
    otherBodyPart: 'Jiná část těla',
    chart: {
      shots: 'Střely',
      xGPerShot: 'xG na střelu',
      exceptionTextPenaltyGoals: '* Penaltové střely = 0.765 xG',
      exceptionTextGKPenaltyGoals: '* Penaltové střely = 0.765 xGOT',
      exceptionTextOwnGoals: '* Vlastní góly se neberou v úvahu',
      og: 'VG',
      penaltiesExcluded: 'Penaltové góly vyloučeny',
      ownGoalsExcluded: 'Vlastní góly vyloučeny',
      sumOfxG: 'Součet xG',
      exceptionShotsOutOfRange: '* Nezobrazují se střely mimo rozsah'
    },
    inGoal: 'V brance',
    outOfGoal: 'Mimo branku',
    highLeft: 'Vysoko vlevo',
    highCenter: 'Vysoko ve středu',
    highRight: 'Vysoko vpravo',
    lowLeft: 'Nízko vlevo',
    lowCenter: 'Nízko ve středu',
    lowRight: 'Nízko vpravo',
    outHighLeft: 'Mimo vysoko vlevo',
    high: 'Mimo vysoko ve středu',
    outHighRight: 'Mimo vysoko vpravo',
    closeHighLeft: 'Blízko vysoko vlevo',
    closeHigh: 'Blízko vysoko ve středu',
    closeHighRight: 'Blízko vysoko vpravo',
    closeLeft: 'Blízko nízko vlevo',
    closeRight: 'Blízko nízko vpravo',
    finishingTable: 'Tabulka střel',
    onGoal: 'Na branku',
    distributionFilters: 'Filtry distribuce',
    penalty: 'Penalta',
    penaltyShootout: 'Penaltový rozstřel',
    onlyPercentage: 'Zobrazit procenta',
    showAll: 'Zobrazit vše',
    chanceMissed: 'Promarněná šance'
  },
  keyPassMap: {
    chart: {
      keyPasses: 'Klíčové přihrávky',
      xAPerPass: 'xA na přihrávku',
      xAOpenPlay: 'xA otevřená hra',
      xASetPiece: 'xA standardní situace'
    }
  },
  beeswarm: {
    template: 'Šablona',
    templates: {
      Goalkeeper: 'Brankář',
      Defender: 'Obránce',
      'Full-Back': 'Pravý/Levý obránce',
      FullBack: 'Pravý/Levý obránce',
      'Wing-Back': 'Křídelní obránce',
      WingBack: 'Křídelní obránce',
      Midfielder: 'Záložník',
      AttackingMidfielder: 'Útočný záložník',
      Winger: 'Křídlo',
      Forward: 'Útočník',
      Physical: 'Fyzické'
    },
    compareWith: 'Porovnat s',
    highlightPlayersOf: 'Zvýraznit hráče z',
    highlightPlayers: 'Zvýraznit hráče',
    per90: 'Data na 90 minut',
    highlightTeams: 'Zvýraznit týmy',
    filterTeams: 'Filtrovat týmy',
    warningZeros: 'Pouze pro neobrácené statistiky'
  },
  collections: {
    newCollection: 'Nová kolekce',
    editCollection: 'Upravit kolekci',
    name: 'Název',
    visibility: 'Viditelnost',
    privacity: {
      publicTitle: 'Veřejné',
      publicDescription: 'Viditelné pro vás a váš klub',
      privateTitle: 'Soukromé',
      privateDescription: 'Viditelné pouze pro vás',
      supervisedTitle: 'Dohledované',
      supervisedDescription: 'Viditelné pouze pro vás a vašeho dohledu'
    },
    addSuccess: 'Úspěšně přidáno',
    createAddSuccess: 'Vytvořeno a úspěšně přidáno',
    editSuccess: 'Úspěšně aktualizováno',
    deleteSuccess: 'Úspěšně smazáno',
    title: 'Kolekce hráčů',
    publics: 'Veřejné',
    privates: 'Soukromé',
    supervised: 'Dohledované',
    totalMarketValue: 'Celková tržní hodnota',
    avgMarketValue: 'Průměrná tržní hodnota',
    avgAge: 'Průměrný věk',
    searchBarPlaceholder: 'Pro přidání do kolekce vyhledejte a vyberte hráče',
    deleteCollection: 'Smazat kolekci',
    deleteCollectionMessage: 'Kolekce bude odstraněna, jste si jisti?',
    removePlayer: 'Odebrat hráče',
    removePlayerMessage: 'Hráč bude odebrán z kolekce, jste si jisti?',
    subtitle: 'Organizujte svůj skauting',
    notExitingTemplate: 'Zatím neexistují žádné šablony'
  },
  searchbar: {
    placeholder: 'Zadejte pro vyhledávání (např. `david arsenal´)',
    players: 'Hráči',
    teams: 'Týmy',
    games: 'Zápasy',
    leagues: 'Ligy',
    explore: 'Prozkoumat více výsledků',
    placeholderNoResults: 'Žádné výsledky pro šablonu',
    teamPlaceholder: 'Pro porovnání týmu ho vyhledejte a vyberte'
  },
  favorites: {
    showOnly: 'Zobrazit pouze',
    selfFavorites: 'Moje oblíbené',
    clubFavorites: 'Oblíbené klubu',
    contractExpiration: 'Vypršení smlouvy',
    groupBy: 'Seskupit podle',
    noGrouped: 'Žádné',
    maxSelection: 'Lze vybrat pouze',
    selectAtleastOne: 'Vyberte alespoň jeden',
    comparePlayers: 'Porovnat hráče',
    selectedPlayers: 'vybraných hráčů',
    subtitle: 'Spravuj své oblíbené',
    generateXlsx: 'Vygenerovat XLSX',
    generating: 'Generování...',
    subscribed: 'Přihlášeno k odběru',
    subscribedTooltip: 'Přihlaste se k odběru, abyste obdrželi email, když bude odehrán zápas',
    deleteSelected: 'Smazat vybrané'
  },
  expiration: {
    summer: 'Léto',
    winter: 'Zima'
  },
  positions: {
    noposition: 'Bez pozice',
    goalkeeper: 'Brankář',
    goalkeepers: 'Brankáři',
    defender: 'Obránce',
    defenders: 'Obránci',
    defenses: 'Obránci',
    fullback: 'Pravý/Levý obránce',
    fullbacks: 'Praví/Leví obránci',
    midfielder: 'Záložník',
    midfielders: 'Záložníci',
    winger: 'Křídlo',
    wingers: 'Křídla',
    forward: 'Útočník',
    forwards: 'Útočníci',
    wingback: 'Křídelní obránce',
    wingbacks: 'Křídelní obránci'
  },
  dPos: {
    1: {
      name: 'Brankář',
      alias: ''
    },
    2: {
      name: 'Pravý krajní obránce',
      alias: 'RFB'
    },
    3: {
      name: 'Pravý střední obránce',
      alias: 'RCB'
    },
    4: {
      name: 'Levý střední obránce',
      alias: 'LCB'
    },
    5: {
      name: 'Levý krajní obránce',
      alias: 'LFB'
    },
    6: {
      name: 'Defenzivní záložník',
      alias: 'DM'
    },
    7: {
      name: 'Pravé křídlo',
      alias: 'RW'
    },
    8: {
      name: 'Střední záložník',
      alias: 'CM'
    },
    9: {
      name: 'Útočník',
      alias: 'ST'
    },
    10: {
      name: 'Útočný záložník',
      alias: 'AM'
    },
    11: {
      name: 'Levé křídlo',
      alias: 'LW'
    }
  },
  charts: {
    seasonsCompareSelectLabel: 'Porovnat s',
    lastSeasonSelectText: 'Minulá sezóna',
    lastAndCurrentSeasonSelectText: 'Minulá + Současná sezóna',
    currentSeasonSelectText: 'Současná sezóna',
    lastNgamesSelectText: 'Posledních {x} zápasů',
    npgVsXGTitle: 'Góly bez penalt VS xG',
    totalXGLabel: 'Celkové xG',
    xGLabel: 'xG',
    totalNPGLabel: 'Celkové góly bez penalt',
    xGAgainstvsNPGAgainstTitle: 'Obdržené xG VS Obdržené góly bez penalt',
    totalXGAgainstLabel: 'Celkové obdržené xG',
    xGAgainstLabel: 'Obdržené xG',
    totalNPGAgainstLabel: 'Celkové obdržené góly bez penalt',
    xGvsxGAgainstTitle: 'xG VS Obdržené xG',
    pointsVsXPointsTitle: 'Body VS Očekávané body',
    xTTitle: 'Průběh hry',
    totalXPoints: 'Celkové xBody',
    totalPoints: 'Celkové body',
    requestedReports: 'Požadované zprávy',
    playersScouted: 'Skautovaní hráči',
    performanceVSAverageChart: 'Výkon VS Průměr',
    perPositions: 'Podle pozic',
    perLeagues: 'Podle lig',
    perMonths: 'Podle měsíců',
    perClients: 'Podle klientů',
    ofPreposition: 'z',
    idJChartTitle: 'Iniciativa hry',
    idJChartLabel: 'Index GI',
    vJOChartTitle: 'Objem útočné hry',
    vJOChartLabel: 'Index OGV',
    preJOChartTitle: 'Přesnost útočné hry',
    preJOChartLabel: 'Index OGPre',
    proJOChartTitle: 'Postup útočné hry',
    proJOChartLabel: 'Index OGPro',
    chart: 'Graf',
    table: 'Tabulka',
    showLeaguesWithAtLeast: 'Zobrazit ligy s alespoň',
    playersScoutedSuffix: 'skautovaných hráčů',
    last20gamesSelectText: 'Posledních 20 zápasů',
    last10gamesSelectText: 'Posledních 10 zápasů'
  },
  table: {
    history: {
      season: 'Sezóna',
      team: 'Tým',
      position: 'Pozice',
      side: 'Strana',
      games: 'Zápasy',
      minutes: 'Min',
      goals: 'Góly bez penalt (G)',
      assists: 'A',
      yellowCards: 'ŽK',
      redCards: 'ČK',
      gameLost: 'ZP',
      gamesMissed: 'Zmeškané zápasy',
      goalsReceived: 'NPGC (GC)'
    },
    injury: {
      season: 'Sezóna',
      team: 'Tým',
      injury: 'Zranění',
      dateFrom: 'Datum začátku',
      dateTo: 'Datum konce',
      daysLost: 'Ztracené dny',
      gamesLost: 'Ztracené zápasy',
      allInjuries: 'Všechna zranění'
    },
    transfers: {
      season: 'Sezóna',
      date: 'Datum',
      teamFrom: 'Tým z',
      teamTo: 'Tým do',
      marketValue: 'Tržní hodnota',
      fee: 'Poplatek',
      type: 'Typ'
    },
    caps: {
      team: 'Tým',
      debut: 'Debut',
      games: 'Zápasy',
      goals: 'Góly',
      coachDuringDebut: 'Trenér při debutu',
      debutAge: 'Věk při debutu'
    },
    roster: {
      country: 'Země',
      player: 'Hráč',
      positions: 'Pozice',
      minutes: 'Minuty',
      games: 'Zápasy',
      goals: 'Góly',
      assists: 'Asistence',
      cards: 'Karty',
      gamesExplicit: 'Odehrané zápasy'
    },
    league: {
      title: 'Profil ligy',
      subtitle: 'Ponořte se hlouběji do žebříčku a statistik ligy',
      team: 'Tým',
      games: 'ZP',
      gamesExplicit: 'Odehrané zápasy',
      gamesRanking: 'ZP',
      gamesRankingExplicit: 'Odehrané zápasy',
      points: 'Body',
      pointsExplicit: 'Body',
      expectedPoints: 'xP',
      expectedPointsExplicit: 'Očekávané body',
      goalsScored: 'Góly bez penalt',
      goalsScoredExplicit: 'Góly bez penalt',
      xG: 'xG',
      xGExplicit: 'Očekávané góly',
      goalsAgainst: 'Obdržené góly bez penalt',
      goalsAgainstExplicit: 'Obdržené góly bez penalt',
      xGAgainst: 'Obdržené xG',
      xGAgainstExplicit: 'Obdržené očekávané góly',
      xGAgainstDiff: 'Rozdíl obdržených xG',
      xGAgainstDiffExplicit: 'Rozdíl obdržených očekávaných gólů',
      form: 'Forma',
      sos: 'SoS',
      sosExplicit: 'Síla programu',
      sosHfa: 'SoS domácí výhoda',
      sosHfaExplicit: 'Domácí výhoda',
      difficultyAboveAvg: 'Obtížnost nad průměrem',
      differentGames: '* Různý počet odehraných zápasů',
      berth: 'Místo'
    },
    usersOfClient: {
      userName: 'Jméno',
      userRole: 'Uživatel',
      devRole: 'Vývojář',
      adminRole: 'Admin',
      servicesRole: 'Služby',
      xgRole: 'XG',
      radarRole: 'Radar',
      beeswarmRole: 'Žebříček',
      elevenRole: 'Jedenáctky',
      similarityRole: 'Podobnost',
      gameAnalysisRole: 'Analýza zápasu',
      clientStatsRole: 'Statistiky klienta',
      created: 'Vytvořeno',
      type: 'Typ',
      logins: 'Přihlášení',
      lastLogin: 'Poslední přihlášení',
      trialDate: 'Datum zkušební verze'
    },
    clientLeagues: {
      league: 'Liga',
      area: 'Oblast',
      tier: 'Úroveň',
      seasons: 'Sezóny',
      currentMatchDay: 'Kolo',
      regular: 'Pravidelná',
      youthLeague: 'Mládežnická',
      clientActive: 'Aktivní',
      visibleLeagues: 'Viditelné ligy',
      male: 'liga mužů',
      female: 'ženská liga'
    },
    connections: {
      title: 'Běžné kombinace',
      playerFrom: 'Od hráče',
      playerTo: 'K hráči',
      passes: 'Přihrávky',
      passesTooltip: 'Celkový počet úspěšných přihrávek',
      passesFinalThird: 'Přihrávky finální třetina',
      passesFinalThirdTooltip: 'Přihrávky finální třetina'
    },
    playerPassMapData: {
      title: 'Statistiky přihrávek',
      player: 'Hráč',
      passes: 'Přihrávky',
      passesPct: '% Přihrávek',
      xA: 'xA',
      xG: 'xG',
      xT: 'xHrozba',
      playerTooltip: 'Jméno hráče',
      passesTooltip: 'Celkový počet přihrávek',
      passesPctTooltip: '% Úspěšných přihrávek',
      xATooltip: 'Očekávané asistence',
      xGTooltip: 'Očekávané góly',
      xTTooltip: 'Očekávaná hrozba'
    },
    playerAllGames: {
      gameDate: 'Datum',
      game: 'Zápas',
      team: 'Tým',
      positionsPlayed: 'Pozice',
      minsPlayed: 'Minuty',
      gameActions: 'Akce',
      gameDateTooltip: 'Datum zápasu',
      gameTooltip: 'Zápas',
      positionsPlayedTooltip: 'Hrané pozice',
      minsPlayedTooltip: 'Odehrané minuty',
      gameActionsTooltip: 'Góly, Asistence, Karty',
      from: 'Začátek',
      to: 'Konec',
      goalText: 'Gól v',
      assistText: 'Asistence v',
      penaltyText: 'Penalta v',
      ownGoalText: 'Vlastní gól v',
      yellowCardText: 'Žlutá karta v',
      secondYellowCardText: 'Druhá žlutá karta v',
      redCardText: 'Červená karta v',
      substitutionIN: 'Nástup v',
      substitutionOUT: 'Odchod v',
      suspendedText: 'Vyloučení',
      Team: 'Zařízení'
    },
    gameFlow: {
      phase: 'Fáze ',
      mins: 'Minuty',
      team: 'Tým',
      period: 'Období',
      possession: '%Držení',
      possessionTooltip: '% Držení míče',
      xT: 'xHrozba',
      xTTooltip: 'Očekávaná hrozba',
      pft: 'Přihrávky finální třetina',
      pftTooltip: 'Přihrávky finální třetina',
      xG: 'xG',
      xGTooltip: 'Očekávané góly'
    }
  },
  game: {
    title: 'Profil zápasu',
    subtitle: 'Ponořte se hlouběji do charakteristik a statistik zápasu',
    header: {
      gameDetails: 'Detaily',
      gameStats: 'Statistiky',
      gameFinishingMap: 'Mapa střel',
      gameKeyPassMap: 'Mapa klíčových přihrávek',
      gamePassMap: 'Mapa přihrávek',
      gameThreat: 'Hrozba zápasu',
      gameFlow: 'Průběh zápasu',
      gameAnalysis: 'Analýza zápasu',
      gamePhysicalStats: 'Fyzické statistiky',
      possessions: 'Držení míče',
      bench: 'Náhradníci',
      video: 'Zajímavé momenty videa',
      preGame: 'Předzápas',
      postGame: 'Po zápase',
      areaCoverage: 'Oblast pokrytí'
    },
    passMap: {
      typeOfPlay: 'Typ hry:',
      passes: 'Přihrávky:',
      team: 'Tým',
      minutes: 'Minuty:',
      select: 'Vybrat',
      all: 'Vše',
      attacking: 'Útočné',
      defending: 'Defenzivní',
      forwards: 'Vpřed',
      backwards: 'Vzad',
      sideways: 'Do strany',
      longBall: 'Dlouhá přihrávka',
      successfullPasses: 'Úspěšné přihrávky',
      homeTeam: 'Domácí',
      awayTeam: 'Hosté',
      passingMatrix: 'Matice přihrávek',
      passer: 'Přihrávající',
      receiver: 'Přijímající',
      passOutcome: 'Výsledek Přihrávky',
      passDirection: 'Směr Přihrávky',
      half: 'Polovina',
      offensive: 'Útočná',
      defensive: 'Obranná',
      passingConnections: 'Přihrávková spojení',
      pitchView: 'Hřiště',
      passSingular: 'Přihrávka',
      passPlural: 'Přihrávky',
      playerLocation: 'Umístění hráče',
      passLegend: 'Průměrná poloha dotyku',
      minuteRange: 'Rozsah minut'
    },
    stats: {
      summary: 'Shrnutí',
      attacking: 'Útok',
      defending: 'Obrana',
      contribution: 'Přínos',
      possession: 'Držení míče',
      expectedPoints: 'Očekávané body',
      directness: 'Přímost',
      ppda: 'PPDA',
      xg: 'xG',
      xG: 'xG',
      xGSetPiece: 'xG standardní situace',
      xA: 'xA',
      xASetPiece: 'xA standardní situace',
      xT: 'xT',
      xTSetPiece: 'xT standardní situace',
      touchesInOppBox: 'Dotyků v soupeřově pokutovém území',
      passesFinalThird: 'Přihrávky finální třetina',
      interceptions: 'Zachycení',
      recoveries: 'Znovuzískání míče',
      recoveriesOppHalf: 'Znovuzískání míče v soupeřově polovině',
      tackles: 'Skluzy',
      tacklesWasDribbled: 'Vyhrané obranné souboje 1 na 1',
      fouls: 'Fauly',
      yellowCards: 'Žluté karty',
      redCards: 'Červené karty',
      passes: 'Přihrávky',
      passing: 'Úspěšnost přihrávek %',
      crosses: 'Centry',
      crossing: 'Úspěšnost center %',
      shots: 'Střely',
      shotsOnTarget: 'Střely na branku',
      ppdaExplicit: 'Obdržené přihrávky na defenzivní akci',
      xgExplicit: 'Očekávané góly',
      xp: 'xP',
      ExpectedPassing: 'xP %',
      seasonAvg: 'Průměr soutěže',
      winChanceTooltip: 'Pravděpodobnost výhry založeno na vygenerovaném a obdrženém xG',
      drawChance: 'Remíza',
      xgAgainst: 'Obdržené xG',
      averagePossession: 'Držení míče',
      averageShots: 'Střely',
      averagexG: 'Očekávané góly',
      fieldTilt: 'Naklonění hřiště',
      fieldTiltExplicit: 'Naklonění hřiště',
      recoveriesRate: 'Míra obnovy',
      turnoversRate: 'Míra obratu'
    },
    detail: {
      halfTime: 'Poločas',
      overTime: 'Prodloužení',
      showStats: 'Zobrazit statistiky',
      hideStats: 'Skrýt statistiky',
      bench: 'Náhradníci',
      showShotOptions: 'Zobrazit možnosti střel',
      hideShotOptions: 'Skrýt možnosti střel',
      showPassOptions: 'Zobrazit možnosti přihrávek',
      hidePassOptions: 'Skrýt možnosti přihrávek',
      endGame: 'Konec zápasu',
      penalties: 'Penalty'
    },
    timeline: {
      events: {
        goal: 'Gól',
        goal_ownGoal: 'Vlastní gól',
        goal_penalty: 'Gól z penalty',
        card: 'Karta',
        card_yellowCard: 'Žlutá karta',
        card_secondYellowCard: 'Druhá žlutá karta',
        card_redCard: 'Červená karta',
        formationChange: 'Změna formace',
        substitution: 'Střídání',
        saveShot: 'Chycená střela',
        saveShot_penalty: 'Chycená penalty',
        missedShot: 'Minutá střela',
        missedShot_penalty: 'Minutá penalty',
        shotOnPost: 'Střela na tyč',
        shotOnPost_penalty: 'Střela na tyč z penalty',
        drinksBreak_startDrinksBreak: 'Start Cooling Break',
        drinksBreak_endDrinksBreak: 'End Cooling Break',
        assist: 'Assist'
      },
      gameTimeline: 'Game Timeline'
    },
    gameFlow: {
      goalOf: 'Gól ',
      redCardTo: 'Červená karta ',
      missedPenalty: 'Minutá penalty'
    },
    gameThreat: {
      typeOfPlay: 'Typ akce',
      regularPlay: 'Pravidelná hra',
      setPiece: 'Standardní situace',
      setPiecePlay: 'Standardní situace',
      throwInSetPiecePlay: 'Vhazování',
      throwInPlay: 'Vhazování',
      gkThrow: 'Vhazování brankáře',
      gkKick: 'Výkop brankáře',
      kickOff: 'Výkop',
      actionEnding: 'Konec akce',
      pass: 'Přihrávka',
      shot: 'Střela',
      foul: 'Faul',
      other: 'Jiné',
      threat: 'Hrozba',
      legendSumOfXT: 'Součet xT',
      legendPass: 'Přihrávka',
      legendShot: 'Střela',
      legendCarryAndAction: 'Přenášení míče a akce',
      legendCarryAndPass: 'Přenášení míče a přihrávka',
      legendOnlyShowing: 'Zobrazují se pouze individuální akce s xT > ',
      legendOnlyShowingPart1: 'Zobrazují se pouze individuální',
      legendOnlyShowingPart2: 'akce s xT > ',
      legendOnlyShowingSetPiece: 'Zobrazují se pouze akce ze standardních situací s xT > ',
      legendOnlyShowingOpenPlay: 'Zobrazují se pouze akce z otevřené hry s xT > ',
      legendPlays: 'Akce',
      legendPerPlay: 'na akci',
      legendCarry: 'Přenášení míče',
      penaltyPlay: 'Penalta',
      freeKickTakenPlay: 'Volný kop',
      cornerTakenPlay: 'Roh',
      fromCornerPlay: 'Z rohu',
      keeperThrowPlay: 'Vhazování brankáře',
      fastBreakPlay: 'Rychlý protiútok',
      indirectPlay: 'Nepřímá hra',
      minutes: 'Minuty',
      games: 'Zápasy',
      xT: 'xT',
      xTPer90: 'xT na 90\''
    },
    gameAnalysis: {
      next: 'Další',
      previous: 'Předchozí',
      phaseLabel: 'Fáze',
      phasesLabel: 'Fáze',
      dot: '. ',
      comma: ', ',
      from: 'Od',
      to: 'Do',
      and: ' a ',
      steps: {
        finishingMapFullGame: 'Mapa střel',
        keyPassMapFullGame: 'Mapa klíčových přihrávek',
        gameFlow: 'Průběh zápasu',
        finishingMapPerPhases: 'Mapa střel podle fází',
        keyPassMapPerPhases: 'Mapa klíčových přihrávek podle fází',
        passMapPerPhases: 'Mapa přihrávek podle fází'
      },
      step1: {
        table: {
          draw: 'Remíza',
          win: 'Výhra',
          lose: 'Prohra',
          possession: 'Držení míče',
          xP: 'Očekávané body',
          directness: 'Přímost',
          ppda: 'PPDA',
          xG: 'xG',
          xGOpenPlay: 'xG otevřená hra',
          xGSetPiece: 'xG standardní situace',
          xA: 'xA',
          xAOpenPlay: 'xA otevřená hra'
        },
        text: {
          firstParagraph: {
            1: 'Mapa vpravo zobrazuje očekávané góly vygenerované týmem home_team_name a away_team_name. Vyplněné kruhy jsou střely, které skončily gólem. Velikost kruhů závisí na hodnotě xG každé střely. '
          },
          lastParagraph: {
            1: 'Procentuální pravděpodobnost výsledku a počet očekávaných bodů se počítají pomocí simulace střel (provádí se 100 000 simulací střel a možnost výsledků a získání bodů se hodnotí prediktivním způsobem). '
          },
          targetHighTeamXG: {
            1: 'target_team_name, stejně jako rival_team_name, dokázal vytvořit vysoký objem očekávaných gólů'
          },
          targetHighTeamOpenPlayXG: {
            1: 'V tomto zápase většina šancí target_team_name pocházela z otevřené hry'
          },
          targetHighTeamOpenPlayXGvsGameRival: {
            1: 'V tomto zápase většina šancí target_team_name byla vytvořena otevřenou hrou (na rozdíl od rival_team_name)'
          },
          targetHighTeamSetPieceXG: {
            1: 'V tomto zápase většina šancí target_team_name pocházela ze standardních situací'
          },
          targetHighTeamSetPieceXGvsGameRival: {
            1: 'V tomto zápase většina šancí target_team_name byla vytvořena standardními situacemi (na rozdíl od rival_team_name)'
          },
          targetHighTeamCornerXG: {
            1: 'V tomto zápase většina šancí target_team_name pocházela z rohových kopů'
          },
          targetLowTeamGoalConversion: {
            1: ' ale konverze gólů byla nízká'
          },
          dot: {
            1: '. '
          },
          targetHighTeamXGOPandSP: {
            1: 'target_team_name vytvořil vysoký objem očekávaných gólů jak v otevřené hře, tak ve standardních situacích'
          },
          targetHighTeamGoalConversion: {
            1: ' také s vysokým poměrem konverze gólů. '
          },
          targetLowTeamGoalConversionZeroGoals: {
            1: ', nebyl schopen skórovat žádnou z vytvořených šancí'
          },
          targetLowTeamGoalConversionScoringGoals: {
            1: ' ale vytvořil nebezpečí pro skórování více gólů'
          },
          targetHighTeamXGvsGameRival: {
            1: 'V tomto zápase target_team_name vygeneroval více nebezpečí než rival_team_name'
          },
          targetLowTeamGoalConversionScoringGoals2: {
            1: ' a mohl skórovat více gólů. '
          },
          targetHighTeamXGZeroGoals: {
            1: ' ale nebyl schopen skórovat žádné góly z vytvořených šancí. '
          },
          targetHighTeamXGGoalDiff: {
            1: ' což odpovídá šanci na výhru team_winning_chance podle naší post-zápasové simulace. '
          },
          startTargetHighTeamOpenPlayXG: {
            1: ' Většina šancí target_team_name pocházela z otevřené hry. '
          },
          startTargetHighTeamSetPieceXG: {
            1: ' Většina šancí target_team_name byla vytvořena standardními situacemi. '
          },
          startTargetHighTeamCornerXG: {
            1: ' Většina šancí pocházela z rohových kopů. '
          },
          targetSimilarTeamXG: {
            1: 'V tomto zápase oba týmy vygenerovaly podobné množství nebezpečí pro soupeře v termínech xG, '
          },
          targetSimilarTeamXGGoalDiff: {
            1: 'ale target_team_name odvedl lepší práci při dokončování šancí. '
          },
          targetLowTeamXGGoalDiff: {
            1: 'Bez ohledu na výsledek, target_team_name nevygeneroval mnoho nebezpečí pro soupeře v termínech očekávaných gólů. '
          },
          targetLowTeamXGZeroGoalDiff: {
            1: 'target_team_name nevygeneroval dostatek nebezpečí pro soupeře v termínech očekávaných gólů, aby vyhrál zápas'
          },
          rivalHighTeamXG: {
            1: 'a dovolil rival_team_name vygenerovat příliš mnoho nebezpečí. '
          },
          rivalHighTeamXGGoalDiff: {
            1: ' S touto tvorbou je to zápas, který by target_team_name vyhrál pouze team_winning_chance krát podle naší post-zápasové simulace. '
          },
          targetHighTeamGoalConversion2: {
            1: ' s vysokým poměrem konverze gólů'
          },
          winningChance: {
            1: 'Vzhledem k počtu střel a xG obou týmů by target_team_name měl vyhrát tento zápas team_winning_chance krát. '
          },
          highPlayerXGManyShots: {
            1: 'Je zajímavé poznamenat, že player_name vygeneroval xg_value xG v shots_value střelách'
          },
          highPlayerXGMoreThanOneGoal: {
            1: ' potřeboval xg_value xG pro skórování gólu. '
          },
          highPlayerXGOneGoal: {
            1: ' pro skórování gólu. '
          },
          highPlayerXGAnyGoal: {
            1: ', ačkoli nebyl schopen skórovat žádný gól. '
          },
          highPlayerXGNotManyShots: {
            1: 'Stojí za zmínku, že player_name vygeneroval xg_value xG v několika střelách'
          },
          highManyPlayerXG: {
            1: 'Je zajímavé poznamenat, že player_name a player_name2 vygenerovali xg_value a xg_value2 <b>xG</b> respektive. '
          },
          highTeamXGPerShot: {
            1: 'Pokud jde o výběr střel target_team_name, byly velmi dobré z hlediska pravděpodobnosti stát se gólem, s průměrným xG na střelu xg_per_shot_value. '
          },
          highTeamXGPerShotVSGameRival: {
            1: 'Výběr střel target_team_name byl mnohem lepší než rival_team_name, s průměrem xg_per_shot_value xG na střelu. '
          },
          xGTimesNotAfter70xG: {
            1: 'Navzdory vysokému vygenerovanému xG měl target_team_name problémy vytvářet nebezpečí na konci zápasu. '
          },
          xGTimesBefore25xG: {
            1: 'target_team_name vytvořil hodně nebezpečí zejména na začátku obou poločasů. '
          },
          xGTimesAfter25xG: {
            1: 'target_team_name vytvořil hodně nebezpečí zejména na konci obou poločasů. '
          },
          xGTimesBefore25xGvsItself: {
            1: 'target_team_name vytvořil většinu nebezpečí na začátku prvního poločasu. '
          },
          xGTimesAfter25xGvsItself: {
            1: 'target_team_name vytvořil většinu nebezpečí na konci prvního poločasu. '
          },
          xGTimesBefore70xGvsItself: {
            1: 'target_team_name vytvořil většinu nebezpečí na začátku druhého poločasu. '
          },
          xGTimesAfter70xGvsItself: {
            1: 'target_team_name vytvořil většinu nebezpečí na konci druhého poločasu. '
          },
          xGTimesBefore25xG2: {
            1: 'target_team_name začal zápas velmi solidně se šancemi, které vygenerovaly xg_value očekávaných gólů. '
          },
          xGTimesAfter25xG2: {
            1: 'target_team_name dokončil první poločas zápasu se šancemi, které vygenerovaly xg_value očekávaných gólů. '
          },
          xGTimesBefore70xG: {
            1: 'target_team_name vyšel z poločasové přestávky se šancemi, které vygenerovaly xg_value očekávaných gólů. '
          },
          xGTimesAfter70xG: {
            1: 'target_team_name dokončil druhý poločas se šancemi, které vygenerovaly xg_value očekávaných gólů. '
          },
          xGTimesAfter70xGOverOneDotTwo: {
            1: 'target_team_name vytvořil hodně nebezpečí na konci druhého poločasu. '
          },
          xGTimesBefore70xGOverOneDotTwo: {
            1: 'target_team_name vytvořil hodně nebezpečí na začátku druhého poločasu. '
          },
          xGTimesAfter25xGOverOneDotTwo: {
            1: 'target_team_name vytvořil hodně nebezpečí na konci prvního poločasu. '
          },
          xGTimesBefore25xGOverOneDotTwo: {
            1: 'target_team_name vytvořil hodně nebezpečí na začátku prvního poločasu. '
          },
          xGTimesFirstHalfXGSecondHalfXGRival: {
            1: 'target_team_name vygeneroval většinu svého nebezpečí v prvním poločasu, zatímco rival_team_name udělal totéž ve druhém poločasu. '
          },
          xGTimesSecondHalfXGFirstHalfXGRival: {
            1: 'target_team_name vygeneroval většinu svého nebezpečí ve druhém poločasu, zatímco rival_team_name udělal totéž v prvním poločasu. '
          },
          xGTimesFirstHalfXGFirstHalfXGRival: {
            1: 'Je to zápas, kde většina nebezpečí v termínech očekávaných gólů byla vygenerována během prvního poločasu. '
          },
          xGTimesSecondHalfXGSecondHalfXGRival: {
            1: 'Je to zápas, kde většina nebezpečí v termínech očekávaných gólů byla vygenerována během druhého poločasu. '
          },
          xGTimesFirstHalfXG: {
            1: 'target_team_name dokázal vytvořit většinu nebezpečí v prvním poločasu. '
          },
          xGTimesSecondHalfXG: {
            1: 'target_team_name dokázal vytvořit většinu nebezpečí během druhého poločasu. '
          },
          xGTimesFirstHalfXGRival: {
            1: 'target_team_name dovolil většinu nebezpečí v termínech očekávaných gólů v prvním poločasu. '
          },
          xGTimesSecondHalfXGRival: {
            1: 'target_team_name dovolil většinu nebezpečí v termínech očekávaných gólů během druhého poločasu. '
          },
          highInBoxXG: {
            1: 'Mapa střel zobrazuje, jak většina nebezpečí pocházela ze střel uvnitř pokutového území. '
          },
          highOutOfBoxXG: {
            1: 'V mapě střel lze pozorovat, že v tomto zápase target_team_name vygeneroval hodně nebezpečí z mimo pokutové území. '
          },
          highInBoxXGRival: {
            1: 'Chceme upozornit, že většina nebezpečí obdržených target_team_name pocházela ze střel uvnitř pokutového území. '
          },
          highInBoxXGRival2: {
            1: ' Je také zajímavé zdůraznit, že většina nebezpečí obdržených target_team_name pocházela ze střel uvnitř pokutového území. '
          },
          highOutOfBoxXGRival: {
            1: 'target_team_name si vedl dobře při vyhýbání se nebezpečí uvnitř pokutového území. '
          },
          highTeamChancesHighPPDARival: {
            1: 'Nedostatek tlaku target_team_name, umožňující ppda_value přihrávek na defenzivní akci, byl jedním z klíčů pro rival_team_name k vytvoření vysokého počtu šancí. '
          },
          lowPPDAWithGoalDiff: {
            1: 'target_team_name dovolil pouze ppda_value přihrávek na defenzivní akci, což byl jeden z klíčů k vítězství. '
          },
          lowPPDA: {
            1: 'target_team_name odvedl skvělou práci při přerušování hry rival_team_name, dovolil pouze průměrně ppda_value přihrávek na defenzivní akci. '
          },
          highPossession: {
            1: 'target_team_name měl kontrolu nad míčem s possession_value držení míče'
          },
          highPPDARival: {
            1: ' stejně jako plynulá distribuce míče'
          },
          chancesCreated: {
            1: ', což jim umožnilo mít vysoký počet šancí z otevřené hry (chances_value). '
          },
          chancesCreatedRival: {
            1: ', ačkoli rival_team_name dokázal vytvořit vysoký počet šancí z otevřené hry (chances_value). '
          },
          xGPerShotRival: {
            1: ', ačkoli rival_team_name dokázal vytvořit nebezpečnější šance s xg_per_shot_value xG na střelu. '
          },
          winGame: {
            1: ' což byl jeden z klíčů k vítězství v zápase. '
          },
          notEnoughWinGame: {
            1: ' což nestačilo k vítězství v zápase. '
          },
          goalsFromErrorsFirstGoal: {
            1: 'První gól vznikl z chyby player_error_name, kterou využil player_name'
          },
          goalsFromErrorsFirstGoalFinalResult: {
            1: 'První a jediný gól vznikl z chyby player_error_name, kterou využil player_name'
          },
          lastPhaseOfGame: {
            1: ' v poslední fázi zápasu. '
          },
          goalsFromErrorsFinalResultGoalToLead: {
            1: 'Finální gól k vítězství v zápase vznikl z chyby player_error_name, která vedla k gólu player_name. '
          },
          goalsFromErrorsFinalResultGoalToTie: {
            1: 'Finální gól k remíze v zápase vznikl z chyby player_error_name, která vedla k gólu player_name. '
          },
          goalsFromErrorsGoalToTie: {
            1: 'Chyba player_error_name vedla k šanci na remízu pro target_team_name. '
          },
          goalsFromErrorsGoalToLead: {
            1: 'target_team_name se dostal do vedení využitím chyby player_error_name'
          },
          xGChance: {
            1: ' se šancí xg_value xG. '
          },
          rivalGoalsFromErrorsFinalResultGoalToLead: {
            1: 'Finální gól rival_team_name k vítězství v zápase vznikl z chyby player_error_name, která vedla k gólu player_name. '
          },
          rivalGoalsFromErrorsGoalToTie: {
            1: 'Chyba player_error_name vedla k šanci na remízu pro rival_team_name. '
          },
          rivalGoalsFromErrorsGoalToLead: {
            1: 'rival_team_name se dostal do vedení využitím chyby player_error_name'
          },
          hugeChancesMissedOneScored: {
            1: 'target_team_name se stalo, že skóroval jedinou velkou šanci, kterou vytvořil během zápasu, což je gól player_name, který vidíme v mapě xG s xG xg_value. '
          },
          hugeChancesMissedMoreThanOneScored: {
            1: 'target_team_name se stalo, že skóroval všechny velké šance, které vytvořil během zápasu'
          },
          hugeChancesMissedZeroGoalsOneChance: {
            1: 'player_name měl jedinou velkou šanci target_team_name na skórování s xG xg_value. '
          },
          hugeChancesMissedZeroGoalsMoreChances: {
            1: 'target_team_name nebyl schopen skórovat žádnou z chances_value šancí nad 40% pravděpodobnosti stát se gólem. '
          },
          oneHugeChancesBeforeFirstGameGoal: {
            1: 'player_name měl velkou šanci xg_value xG dostat se do vedení. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoal: {
            1: 'target_team_name měl chances_value šancí s xG nad 40% dostat se do vedení. '
          },
          moreThanOneBigChancesBeforeFirstGameGoal: {
            1: 'target_team_name měl chances_value šancí s vysokým xG dostat se do vedení. '
          },
          shotOnPostBeforeFirstGameGoal: {
            1: 'player_name měl šanci dostat se do vedení s xg_value xG, která trefila tyč. '
          },
          beforeEndOfGame: {
            1: 'Před koncem zápasu, '
          },
          oneHugeChancesAfterFirstGameGoal: {
            1: 'player_name měl šanci xg_value xG vyhrát zápas. '
          },
          moreThanOneHugeChancesAfterFirstGameGoal: {
            1: 'target_team_name měl chances_value šancí s xG nad 40% vyhrát zápas. '
          },
          moreThanOneBigChancesAfterFirstGameGoal: {
            1: 'target_team_name měl chances_value šancí s vysokým xG vyhrát zápas. '
          },
          oneHugeChancesBeforeFirstGameGoalRival: {
            1: 'player_name měl velkou šanci xg_value xG dostat se do vedení. '
          },
          moreThanOneHugeChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name měl chances_value šancí s xG nad 40% dostat se do vedení. '
          },
          moreThanOneBigChancesBeforeFirstGameGoalRival: {
            1: 'target_team_name měl chances_value šancí s vysokým xG dostat se do vedení. '
          },
          shotOnPostBeforeFirstGameGoalRival: {
            1: 'player_name měl šanci dostat se do vedení s xg_value xG, která trefila tyč. '
          },
          bigChancesMissedWhenLosingByOne: {
            1: 'player_name měl šanci xg_value xG srovnat zápas bez štěstí. '
          },
          moreThanOneBigChancesMissedWhenLosingByOne: {
            1: 'target_team_name měl chances_value šancí srovnat zápas s pravděpodobností skórování vyšší než 30%. '
          },
          shotOnPostWhenLosingByOne: {
            1: 'player_name měl šanci xg_value xG srovnat zápas, která skončila zásahem do tyče. '
          }
        }
      },
      step2: {
        table: {
          draw: 'Remíza',
          win: 'Výhra',
          possession: 'Držení míče',
          xP: 'Očekávané body',
          directness: 'Přímost',
          ppda: 'PPDA',
          xA: 'xA',
          xAOpenPlay: 'xA otevřená hra',
          xASetPiece: 'xA standardní situace',
          chancesCreated: 'Vytvořené šance',
          shotsOnTarget: 'Střely na branku'
        },
        text: {
          firstParagraph: {
            1: 'Tento obrázek zobrazuje očekávané asistence <b style=\'color:home_color\'>home_team_name</b> a <b>away_team_name</b>.'
          },
          xAPerKeyPass: {
            1: ' xA na klíčovou přihrávku. '
          },
          keyPassesGeneratedFrom: {
            1: ', zejména klíčové přihrávky vygenerované z '
          },
          highTeamXAvsXG: {
            1: 'Jak ukazuje mapa xA, většina nebezpečí vytvořeného target_team_name pochází z kombinované hry spíše než z individuálních akcí'
          },
          openPlay: {
            1: 'otevřená hra'
          },
          setPiece: {
            1: 'standardní situace'
          },
          cornerKicks: {
            1: 'rohové kopy'
          },
          combinationPlays: {
            1: 'kombinovaná hra'
          },
          dot: {
            1: '. '
          },
          comma: {
            1: ', '
          },
          averageTeamXAvsXG: {
            1: 'V tomto zápase target_team_name vygeneroval nebezpečí z obou kombinované hry'
          },
          individualActions: {
            1: ' a individuálních akcí. '
          },
          dangerFromIndividualActions: {
            1: 'V tomto zápase většina nebezpečí vygenerovaného target_team_name pocházela z individuálních akcí.'
          },
          highTeamXAvsXGRival: {
            1: ' Šance, které target_team_name dovolil během zápasu, pocházely z kombinované hry, jak zobrazuje mapa xA.'
          },
          rivalStrongKeyPassesFrom: {
            1: ' rival_team_name byl silný v klíčových přihrávkách pocházejících z '
          },
          manyPlayerKeyPasses: {
            1: 'Je zajímavé poznamenat, že player_name vytvořil xa_value xA v key_passes klíčových přihrávkách'
          },
          playerAssists: {
            1: ' potřeboval xa_per_assist xA na asistenci.'
          },
          giveAssist: {
            1: ' pro poskytnutí asistence.'
          },
          noAssists: {
            1: ', ačkoli žádná z jeho přihrávek neskončila asistencí.'
          },
          highXANotManyShots: {
            1: 'Je zajímavé poznamenat, že player_name vytvořil xa_value xA v několika přihrávkách'
          },
          manyPlayersHighXA: {
            1: 'Je zajímavé poznamenat, že player_name a player_name2 vygenerovali xa_value a xa_value2 xA respektive.'
          },
          xATimes: {
            1: 'target_team_name vygeneroval většinu svého nebezpečí v prvním poločasu, zatímco rival_team_name udělal totéž v '
          },
          firstHalf: {
            1: ' prvním poločasu. '
          },
          secondHalf: {
            1: ' druhém poločasu. '
          },
          left: {
            1: 'levé straně '
          },
          center: {
            1: 'středu '
          },
          right: {
            1: 'pravé straně '
          },
          xAFirstHalfFirstHalfRival: {
            1: 'Je to zápas, kde většina nebezpečí v termínech očekávaných gólů byla vygenerována během '
          },
          xAFirstHalf: {
            1: 'target_team_name dokázal vytvořit většinu nebezpečí v '
          },
          xATimesXARival: {
            1: 'target_team_name dovolil příliš mnoho nebezpečí v termínech očekávaných gólů v '
          },
          xASides: {
            1: ' Většina nebezpečí target_team_name byla vytvořena z side_name (xa_value <b>xA</b>)'
          },
          xASidesRival: {
            1: 'zatímco rival_team_name vygeneroval většinu z side_name (xa_value <b>xA</b>)'
          },
          dangerCreationRival: {
            1: 'Tvorba nebezpečí rival_team_name pocházela, zejména, z side_name (xa_value <b>xA</b>). '
          },
          speciallyEffective: {
            1: 'target_team_name byl obzvláště efektivní v '
          },
          xAPerChanceCreated: {
            1: ' s průměrem xa_value'
          },
          speciallyEffectiveRival: {
            1: 'rival_team_name byl obzvláště efektivní v '
          }
        }
      },
      step3: {
        text: {
          chance: ' šance',
          chances: ' šancí',
          goal: ' gól',
          goals: ' gólů',
          home: 'domácí',
          away: 'hosté',
          last: 'poslední',
          first: 'první',
          goalScorer: 'střelec gólu',
          goalScorers: 'střelci gólů',
          lastPhase: 'V poslední fázi zápasu, ',
          phase: {
            1: 'V této phase_position fázi zápasu, '
          },
          moreXT: {
            1: '<b style=\'color:more_color\'>more_xt_team_name</b> vygeneroval více očekávané hrozby (<b style=\'color:more_color\'>more_xt_team_value xT</b>) než <b style=\'color:less_color\'>less_xt_team_name</b> (<b style=\'color:less_color\'>less_xt_team_value xT</b>)'
          },
          sameTeamMoreMinutes: {
            1: 'a dělal to déle v tomto období (<b style=\'color:more_color\'>more_time_xt_minutes min.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes min.</b> soupeře)'
          },
          rivalTeamMoreMinutes: {
            1: 'nicméně, jeho soupeř generoval nebezpečí déle (<b style=\'color:more_color\'>more_time_xt_minutes min.</b> vs <b style=\'color:less_color\'>less_time_xt_minutes min.</b> soupeře) v tomto období zápasu'
          },
          maxXTValue: {
            1: '<b style=\'color:max_color\'>max_xt_team_name</b> byl tým, který vytvořil nejvíce nebezpečí (<b style=\'color:max_color\'>max_xt_team_value xT</b>) v <b style=\'color:max_color\'>max_xt_team_minute\'</b>'
          },
          maxXTValueRival: {
            1: ', zatímco <b style=\'color:max_rival_color\'>max_xt_rival_team_name</b> vygeneroval své největší nebezpečí (<b style=\'color:max_rival_color\'>max_xt_rival_team_value xT</b>) v <b style=\'color:max_rival_color\'>max_xt_rival_team_minute\'</b>'
          },
          bothTeamsScoreButDraw: {
            1: 'Oba týmy dokázaly porazit soupeřova brankáře <b>number_of_goals_each_team</b> krát každý. Domácí tým prostřednictvím <b style=\'color:#3366FF\'>home_player_name_goals</b> a hostující tým prostřednictvím <b>away_player_name_goals</b>'
          },
          oneTeamTakesTheLead: {
            1: 'Pokud jde o góly, <b style=\'color:replace_color\'>goal_scored_team_name</b> předčil soupeře o <b style=\'color:replace_color\'>difference_number_of_goals</b> rozdílu, když porazil jejich brankáře s <b style=\'color:replace_color\'>home_player_name_goals</b> jako goal_scorer_word'
          }
        }
      },
      step4: {
        table: {
          team: 'Tým',
          period: 'Období',
          possession: 'Držení',
          ppda: 'PPDA',
          xGOpenPlay: 'xG otevřená hra',
          tooltip: {
            team: 'Tým',
            period: 'Období',
            possession: 'Držení míče',
            ppda: 'Obdržené přihrávky na defenzivní akci',
            xGOpenPlay: 'xG otevřená hra'
          }
        },
        text: {
          clearly: 'jasně',
          very: 'velmi ',
          haveGotText1: 'dostal pouze',
          haveGotText2: 'měl dostat více než',
          gaveUpPoss: 'vzdal držení míče',
          lostPoss: 'ztratil držení míče',
          too: 'příliš ',
          possession: {
            1: 'Během této fáze zápasu <b style=\'color:team_color\'>team_name</b> clearly_text kontroloval držení míče'
          },
          equalPossession: {
            1: 'V této fázi zápasu nikdo nedominoval druhému, protože práce s míčem byla docela vyvážená, ačkoli při pohledu na čísla <b style=\'color:team_color\'>team_name</b> mírně předčil své soupeře s <b style=\'color:team_color\'>possession_value%</b> držení míče'
          },
          lowPossessionHighPPDA: {
            1: '. <b style=\'color:target_team_color\'>target_team_name</b> se špatným tlakem na míč dovolil <b style=\'color:rival_team_color\'>rival_team_name</b> dát <b style=\'color:target_team_color\'>ppda_value přihrávek na defenzivní akci</b>'
          },
          lowPossessionLowPPDA: {
            1: ', ale <b style=\'color:target_team_color\'>target_team_name</b> odvedl dobrou práci při presingu na míč, když rival_team_name měl držení míče, s <b>PPDA</b> <b>ppda_value</b>'
          },
          highPossessionLowPPDA: {
            1: ' a byl schopen hrát díky very_textnízké intenzitě presingu od rival_team_name'
          },
          highPossessionHighPPDA: {
            1: ' ačkoli intenzita presingu rival_team_name byla very_texthigh'
          },
          highPossessionHighPFT: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> získal vysoké držení míče dávaje <b>pft_value</b> <b>Přihrávek ve finální třetině</b> hřiště. '
          },
          highPossessionMidLowPFT: {
            1: 'Bez ohledu na vysoké držení míče, <b style=\'color:target_team_color\'>target_team_name</b> have_got_text <b>pft_value</b> <b>Přihrávek ve finální třetině</b>. '
          },
          lowPossessionHighPFT: {
            1: 'Ačkoli <b style=\'color:target_team_color\'>target_team_name</b> possession_text během této fáze, dokázal dát <b>pft_value</b> <b>Přihrávek ve finální třetině</b>. '
          },
          midPossessionHighPFT: {
            1: 'Docela vyrovnané držení míče během této fáze nezastavilo <b style=\'color:target_team_color\'>target_team_name</b> před dáváním <b>pft_value</b> <b>Přihrávek ve finální třetině</b>. '
          },
          highPFTHighTouchesIOB: {
            1: ' Kromě kontroly hry ve finální třetině, <b style=\'color:target_team_color\'>target_team_name</b> také měl hodně přítomnosti v soupeřově pokutovém území. '
          },
          highPFTLowTouchesIOB: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> kontroloval míč ve finální třetině, ale nedokázal dostat mnoho míčů do soupeřova pokutového území'
          },
          highPFTMidTouchesIOB: {
            1: 'Vzhledem k počtu <b>Přihrávek ve finální třetině</b>, <b style=\'color:target_team_color\'>target_team_name</b> měl vytvořit více nebezpečí v soupeřově pokutovém území'
          },
          lowPFTHighTouchesIOB: {
            1: 'Ačkoli <b style=\'color:target_team_color\'>target_team_name</b> nedokončil mnoho přihrávek ve finální třetině, dokázal dosáhnout soupeřova pokutového území mnohokrát. '
          },
          midPFTHighTouchesIOB: {
            1: 'Vzhledem k počtu dokončených přihrávek ve finální třetině, <b style=\'color:target_team_color\'>target_team_name</b> dosáhl soupeřova pokutového území mnohokrát. '
          },
          maxDirectness: {
            1: 'Stojí za zmínku, že toto je fáze zápasu, kdy <b style=\'color:max_dir_color\'>target_team_name</b> hrál více útočně s <b>Přímostí</b> <b>directness_value</b>. '
          },
          maxXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> dokázal vygenerovat více xG než v jiných fázích zápasu '
          },
          highXGFifthQuintile: {
            1: ' <b style=\'color:target_team_color\'>target_team_name</b> dokázal vygenerovat vysoký objem očekávaných gólů'
          },
          highXG: {
            1: 'vygeneroval dobrý objem očekávaných gólů'
          },
          highXGLowPossession: {
            1: ' navzdory tomu, že neměl kontrolu nad míčem'
          },
          highXGLowShots: {
            1: ' pouze v několika střelách, s <b>xG na střelu</b> <b>xg_per_shot_value</b>'
          },
          highXGLowXGPerShot: {
            1: ' ačkoli xG na střelu bylo too_textnízké. '
          },
          lowXGZeroXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nebyl schopen vygenerovat žádné nebezpečí pro soupeře'
          },
          lowXGMinXG: {
            1: 'Pokud jde o generování očekávaných gólů, toto bylo špatné období pro <b style=\'color:target_team_color\'>target_team_name</b>'
          },
          lowXGFirstQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> vygeneroval velmi nízký objem očekávaných gólů'
          },
          lowXGSecondQuintileXG: {
            1: '<b style=\'color:target_team_color\'>target_team_name</b> nebyl schopen vygenerovat dobrý objem očekávaných gólů'
          },
          lowXGHighPossession: {
            1: ' i přesto, že měl kontrolu nad míčem. '
          },
          lowXGHighShots: {
            1: ' navzdory mnoha střelám'
          },
          lowXGHighPFT: {
            1: ' navzdory dokončení <b>pft_value</b> <b>Přihrávek ve finální třetině</b> hřiště. '
          },
          midXGQuintileMinXG: {
            1: 'Ačkoli generování xG nebylo špatné, toto byla nejslabší fáze zápasu pro <b style=\'color:target_team_color\'>target_team_name</b> v tomto ohledu'
          },
          midXGQuintileMaxXG: {
            1: 'Toto byla fáze, během které <b style=\'color:target_team_color\'>target_team_name</b> dokázal vygenerovat nejvyšší <b>xG (xg_value)</b>'
          }
        }
      },
      step5: {
        table: {
          team: 'Tým',
          period: 'Období',
          possession: 'Držení',
          directness: 'Přímost',
          passesFinalThird: 'Přihrávky finální třetina',
          tooltip: {
            team: 'Tým',
            period: 'Období',
            possession: 'Držení míče',
            directness: 'Přímost',
            passesFinalThird: 'Přihrávky finální třetina'
          }
        },
        text: {
          last: 'poslední',
          goal: 'gól',
          goals: 'gólů',
          chance: 'šance',
          chances: 'šancí',
          first: 'první',
          homeTeam: 'domácí tým',
          awayTeam: 'hostující tým',
          home: 'domácí',
          away: 'hosté',
          clearly: 'jasně',
          slightly: 'mírně',
          firstOrLastPhase: {
            1: 'V této phase_position fázi zápasu, ',
            2: 'V phase_position období zápasu, '
          },
          phase: {
            1: 'Během tohoto období zápasu, '
          },
          bothZeroGoalsScored: {
            1: 'bez toho, aby kterýkoli tým dokázal změnit skóre.'
          },
          equalGoalsScored: {
            1: 'dostali se k skórování <b>number_goals</b>'
          },
          differentGoalsScored: {
            1: 'dostali se k skórování <b>number_goals</b>'
          },
          equalPossesion: {
            1: 'oba týmy měly míč přesně <b>poss_value%</b> času'
          },
          morePossesion: {
            1: '<b style=\'color:more_color\'>more_poss_team_name</b> měl míč déle (<b style=\'color:more_color\'>more_poss_team_value%</b> času) než jeho soupeř <b style=\'color:less_color\'>less_poss_team_name</b> (<b style=\'color:less_color\'>less_poss_team_value%</b> času)'
          },
          equalDirectness: {
            1: 'oba týmy hrály se stejnou přímostí (<b>directness_value</b> každý)'
          },
          moreDirectnessSameTeam: {
            1: 'také byli více vertikální než jejich soupeři, hráli s přímostí <b style=\'color:more_color\'>more_dir_team_value</b> vs <b style=\'color:less_color\'>less_dir_team_value</b>'
          },
          moreDirectnessDifferentTeam: {
            1: 'nicméně, home_away tým hrál s větší přímostí (<b style=\'color:more_color\'>more_dir_team_value</b>) než jeho soupeř (<b style=\'color:less_color\'>less_dir_team_value</b>)'
          },
          equalChancesCreated: {
            1: 'Oba týmy vytvořily stejný počet šancí, přesně <b>chances_created_value</b> chance_text.'
          },
          moreChancesCreated: {
            1: '<b style=\'color:less_color\'>less_cc_team_name</b> vytvořil pouze <b style=\'color:less_color\'>less_cc_team_value less_chance_text</b> a byl adverb_text předčěn soupeřem (<b style=\'color:more_color\'>more_cc_team_value more_chance_text vytvořeno</b>). '
          },
          equalXA: {
            1: 'Oba týmy měly stejné příležitosti, jak se odráží v <b>xa_value očekávaných asistencí</b>, '
          },
          moreXA: {
            1: 'home_away tým vygeneroval <b>diff_xa_team_value očekávaných asistencí</b> (<b style=\'color:more_color\'>more_xa_team_value</b> versus <b style=\'color:less_color\'>less_xa_team_value</b>) více než soupeř, '
          },
          xAOpenPlay: {
            1: 'vytvářejíce respektive <b style=\'color:more_color\'>more_xa_op_value</b> a <b style=\'color:less_color\'>less_xa_op_value xA otevřená hra</b>.'
          }
        }
      },
      step6: {
        text: {
          eachOne: ' každý ',
          respectively: ', respektive',
          with: ' (s <b style=\'color:replace_color\'>other_player_name</b>)',
          playerWas: 'hráč byl',
          playerWere: 'hráči byli',
          firstPhase: {
            1: 'V této první části zápasu, nejdůležitější player_text ',
            2: 'Pokud jde o první část zápasu, kdo vynikl byl '
          },
          otherPhase: {
            1: 'Mezi <b style=\'color:replace_color\'>min_from\'</b> a <b style=\'color:replace_color\'>min_to\'</b> by měl být zmíněn '
          },
          lastPhase: {
            1: 'V poslední části zápasu, zmínit ',
            2: 'Pokud jde o poslední fázi zápasu, '
          },
          playerMaxSuccessfullPasses: {
            1: '<b style=\'color:replace_color\'>player_name</b>, protože provedl nejvyšší počet úspěšných přihrávek svého týmu, přesně <b style=\'color:replace_color\'>successfull_passes_value přihrávek</b> '
          },
          playerMaxTotalPasses: {
            1: 'což se stává ještě cennější, když čísla ukazují, že také byl'
          },
          playerMaxTotalPasses2: {
            1: 'with_text hráč s nejvíce pokusy o přihrávky (<b style=\'color:replace_color\'>total_passes_value přihrávek</b>). '
          },
          playerNotMaxTotalPasses: {
            1: 'ačkoli se nepokusil o nejvíce přihrávek (<b style=\'color:replace_color\'>player_name</b> s <b style=\'color:replace_color\'>total_passes_value přihrávkami</b>). '
          },
          playersMaxSuccessfullPassesTotalPasses: {
            1: 'zkoušejíce během tohoto období <b style=\'color:replace_color\'>total_passes_value přihrávek</b> každý. '
          },
          playerMaxPctPasses: {
            1: 'Pokud jde o <b style=\'color:replace_color\'>% dokončených přihrávek</b>, <b style=\'color:replace_color\'>player_name</b> má vysokých <b style=\'color:replace_color\'>max_pct_passes_value%</b>. ',
            2: 'V souvislosti s úspěšností přihrávek stojí za zmínku <b style=\'color:replace_color\'>player_name</b> s <b style=\'color:replace_color\'>max_pct_passes_value%</b> úspěšností přihrávek</b>. '
          },
          playerSumTotalXG: {
            1: 'V tomto časovém okně tým vygeneroval celkem <b style=\'color:replace_color\'>sum_xg_value xG</b>, ',
            2: 'Během tohoto období, <b style=\'color:replace_color\'>team_name</b> vytvořil <b style=\'color:replace_color\'>xG</b> <b style=\'color:replace_color\'>sum_xg_value</b>, '
          },
          ZeroSumXG: {
            1: 'Navzdory celkovému počtu <b style=\'color:replace_color\'>all_team_total_passes</b> mezi celým týmem, bylo to marné, protože se nepodařilo vytvořit jedinou šanci. ',
            2: '<b style=\'color:replace_color\'>all_team_total_passes</b> provedené v tomto období negenerovaly jedinou střeleckou šanci. '
          },
          playerMaxXGMaxXADiffPlayer: {
            1: 's <b style=\'color:replace_color\'>player_xg_name</b> s <b style=\'color:replace_color\'>xg_value xG</b> a <b style=\'color:replace_color\'>player_xa_name</b> s <b style=\'color:replace_color\'>xa_value xA</b> jako nejnebezpečnějšími hráči z hlediska vytváření šancí. '
          },
          playerMaxXGMaxXASamePlayer: {
            1: 'když <b style=\'color:replace_color\'>player_name</b> s <b style=\'color:replace_color\'>xg_value xG</b> a <b style=\'color:replace_color\'>xa_value xA</b> byl původcem většiny šancí svého týmu. '
          },
          playersMaxXGMaxXA: {
            1: 'díky mimo jiné <b style=\'color:replace_color\'>players_name</b>, kteří spustili <b style=\'color:replace_color\'>xa_value xA</b> každý svými klíčovými přihrávkami. '
          },
          playerMaxXGZeroXA: {
            1: 'když <b style=\'color:replace_color\'>player_xg_name</b> s <b style=\'color:replace_color\'>xg_value xG</b> měl plnou váhu šancí, musel je vytvářet sám, protože nedostal žádné klíčové přihrávky. '
          },
          playersMaxXGZeroXA: {
            1: 'když <b style=\'color:replace_color\'>player_xg_name</b> s <b style=\'color:replace_color\'>xg_value xG</b> měl šance, musel je vytvářet sám, protože nedostali žádné klíčové přihrávky. '
          },
          oneMaxConnections: {
            1: 'Pár, který si mezi sebou vyměnil nejvíce přihrávek během tohoto úseku zápasu, byl <b style=\'color:replace_color\'>couple_name</b>, s celkem <b style=\'color:replace_color\'>connections_value přihrávkami</b>. ',
            2: 'Duo tvořené <b style=\'color:replace_color\'>couple_name</b> si vyměnilo <b style=\'color:replace_color\'>connections_value</b> krát míč. ',
            3: 'Duo <b style=\'color:replace_color\'>couple_name</b> byli ti, kteří si v tomto úseku zápasu vyměnili míč nejvíce, dělali to dokonce na <b style=\'color:replace_color\'>connections_value</b> šancích. '
          },
          twoMaxConnections: {
            1: 'Dva páry tvořené <b style=\'color:replace_color\'>couple_name</b> a <b style=\'color:replace_color\'>couple_name2</b> byly nejčastějšími kombinacemi pro toto období, vyměňujíce si míč <b style=\'color:replace_color\'>connections_value</b> krát. '
          },
          moreThanTwoMaxConnections: {
            1: 'Páry hráčů, jako <b style=\'color:replace_color\'>couple_name</b>, si vyměnily <b style=\'color:replace_color\'>connections_value přihrávek</b>. '
          },
          oneMinConnections: {
            1: 'Na druhé straně, <b style=\'color:replace_color\'>couple_name</b> si vyměnili míč nejméně, pouze <b style=\'color:replace_color\'>connections_value přihrávek</b>. ',
            2: 'Na druhém extrému, tandem složený z <b style=\'color:replace_color\'>couple_name</b> se spojil pouze <b style=\'color:replace_color\'>connections_value</b> krát. '
          },
          twoMinConnections: {
            1: 'Na druhé straně, <b style=\'color:replace_color\'>couple_name</b> a <b style=\'color:replace_color\'>couple_name2</b> si mezi sebou stěží vyměnili přihrávky (<b style=\'color:replace_color\'>connections_value přihrávek</b>). '
          },
          moreThanTwoMinConnections: {
            1: 'Několik kombinací se nedostatečně spojilo, jako duo <b style=\'color:replace_color\'>couple_name</b>, které s <b style=\'color:replace_color\'>connections_value přihrávkami</b> patří mezi nejméně časté kombinace. '
          }
        }
      },
      step7: {
        ballPossession: 'Držení míče',
        gamePossessionDist: 'Distribuce držení míče'
      }
    },
    gamePossessionMap: {
      of: 'z',
      to: 'do',
      and: 'a',
      endsWith: 'Končí s',
      time: 'Čas',
      touches: 'Dotyků',
      passes: 'Přihrávek',
      threat: 'Hrozba',
      xG: 'xG',
      xT: 'xT',
      minutes: 'Minuty',
      duration: 'Délka',
      endsGoal: 'Končí gólem',
      endsInBox: 'Končí v pokutovém území',
      withShot: 'Se střelou',
      withCross: 'S centrem',
      possession: 'Držení míče',
      events: 'Události',
      filters: 'Filtry',
      filtersWarning: 'Hrozba se vztahuje pouze na držení míče bez střel',
      sumWarning: 'Filtr se vztahuje na součet xG všech střel v sekvenci, proto může být větší než 1',
      show: 'Zobrazit',
      sequenceNumbers: 'Číslo sekvence',
      jerseyNumbers: 'Dres',
      pass: 'Přihrávka',
      carryAndPass: 'Přenášení míče a přihrávka',
      carryAndAction: 'Přenášení míče a akce',
      carryAndShot: 'Přenášení míče a střela',
      shotFailed: 'Nepovedená střela',
      goal: 'Gól',
      savedShot: 'Chycená střela',
      missedShot: 'Minutá střela',
      shotOnPost: 'Střela na tyč',
      headerGoal: 'Gól hlavou',
      headerFailed: 'Nepovedená hlavička',
      failed: 'nepovedená',
      with: 's'
    },
    report: {
      title: 'Zpráva ze zápasu',
      maps: 'Mapy',
      xGRace: 'Závod xG',
      lineups: 'Sestavy',
      button: 'Vygenerovat kompletní PDF zprávu ze zápasu',
      mobileButton: 'PDF zpráva',
      most: 'Nejvíce',
      topXPlayers: 'Top {x} hráčů',
      mobileButtonXY: 'XY report',
      mobileButtonPD: 'PD report',
      pDReportTitle: 'Zpráva o fyzických datech hry'
    },
    avgScoreTooltip: 'Průměrné skóre za minutu',
    status: {
      scheduled: 'Naplánováno',
      postponed: 'Odloženo',
      cancelled: 'Zrušeno',
      inPlay: 'Žít',
      finished: 'Hotovo',
      awarded: 'Oceněno',
      dataAvailable: 'Data budou k dispozici v následujících hodinách'
    },
    preGameAnalysis: {
      showExpectations: 'Zobrazit očekávání',
      hideExpectations: 'Skrýt očekávání',
      goalsPeriods: 'Období cílů',
      synergyIndex: 'Synergický index',
      synergyIndexSubtitle: 'Celková pevnost spojení pasažér-finišer'
    }
  },
  general: {
    1: 'Jeden',
    2: 'Dva',
    3: 'Tři',
    4: 'Čtyři',
    5: 'Pět',
    8: 'Vlevo',
    9: 'Oboje',
    10: 'Vpravo',
    create: 'Vytvořit',
    save: 'Uložit',
    cancel: 'Zrušit',
    delete: 'Smazat',
    edit: 'Upravit',
    reset: 'Resetovat',
    go: 'Jít',
    formErrors: {
      required: 'Pole je povinné',
      passwordMatch: 'Hesla se neshodují',
      minLength: 'Minimální délka',
      maxLength: 'Maximální délka',
      emailValid: 'E-mail musí být platný',
      youthAge: 'Věk musí být mezi 10 a 23',
      seasonYear: 'Rok musí být mezi 2016 a 2050',
      integer: 'Desetinná čísla nejsou povolena'
    },
    confirmationTitle: 'Jste si jisti?',
    confirmationMessage: 'Prosím potvrďte, zda chcete provést akci',
    yes: 'Ano',
    no: 'Ne',
    search: 'Vyhledat',
    clearFilters: 'Vymazat filtry',
    minimum: 'Minimum',
    maximum: 'Maximum',
    minimumPercent: '(%)Minimální procento',
    period: 'Období',
    exclude: 'Vyloučit',
    team: 'Tým',
    clear: 'Vymazat',
    all: 'Vše',
    ground1: 'Vše',
    ground2: 'Domácí',
    ground3: 'Hosté',
    filter: 'Filtr',
    noData: 'Nebyly nalezeny žádné výsledky',
    noDataGivenFilters: 'Nebyly nalezeny žádné výsledky s danými filtry',
    similarityMinutesWarning: 'Žádná data kvůli méně než 450 odehraným minutám',
    templateOnlyEditable: 'Šablonu může upravovat pouze ',
    close: 'Zavřít',
    load: 'Načíst',
    filters: 'Filtry',
    players: 'hráči',
    teams: 'týmy',
    compare: 'Porovnat',
    seeMore: 'Vidět více',
    seeLess: 'Vidět méně',
    request: 'Požádat',
    notes: 'Poznámky',
    closeSession: 'Ukončit',
    settings: 'Nastavení',
    player: 'Hráč',
    state: 'Stav',
    updated: 'Aktualizováno',
    file: 'Soubor',
    uploadFile: 'Nahrát soubor',
    reports: 'Zprávy',
    download: 'Stáhnout',
    new: 'Nový',
    comparison: 'Porovnání',
    scout: 'Skaut',
    favorites: 'Oblíbené',
    moreOptions: 'Více možností',
    lessOptions: 'Méně možností',
    today: 'Dnes',
    home: 'Domácí',
    away: 'Hosté',
    until: 'do',
    firstHalf: 'První poločas',
    secondHalf: 'Druhý poločas',
    firstPeriodOT: 'První H. prodloužení',
    secondPeriodOT: 'Druhý H. prodloužení',
    postponed: 'Odloženo',
    stats: 'Statistiky',
    yesterday: 'Včera',
    last: 'Poslední',
    startDate: 'Datum začátku',
    active: 'Aktivní',
    playerLimit: 'Limit hráčů',
    type: 'Typ',
    successMessage: 'Operace byla úspěšná',
    failMessage: 'Operace selhala',
    by: 'Od',
    checkYourInbox: 'Zkontrolujte svou doručenou poštu',
    faq: 'Glosář',
    globalSearch: 'Globální vyhledávání',
    gamesLost: 'Ztracené zápasy',
    outOf: 'z',
    avgSeason: 'Průměr sezóny',
    leftDays: 'zbývajících dní',
    notifyError: 'Upozornit na chybu',
    notify: 'Upozornit',
    comments: 'Komentáře',
    searches: 'Vyhledávání',
    now: 'Nyní',
    twoHoursAgo: 'Před dvěma hodinami',
    incomings: 'Příchody',
    departures: 'Odchody',
    transferLoans: 'Půjčky',
    transfers: 'Přestupy',
    movements: 'Pohyby',
    incomes: 'Příjmy',
    expenditures: 'Výdaje',
    action: 'Akce',
    target: 'Cíl',
    uses: 'Použití',
    users: 'Uživatelé',
    since: 'od',
    mediaMode: 'Režim médií',
    white: 'Bílá',
    enabled: 'Povoleno',
    disabled: 'Zakázáno',
    left: 'Vlevo',
    right: 'Vpravo',
    both: 'Oboje',
    'left-both': 'Vlevo oboje',
    'right-both': 'Vpravo oboje',
    'left foot': 'Levá',
    'right foot': 'Pravá',
    files: 'Soubory',
    confirm: 'Potvrdit',
    currentStep: 'Aktuální krok',
    phases: 'Fáze',
    entries: 'Záznamy',
    none: 'Žádné',
    times: 'krát',
    darkMode: 'Tmavý režim',
    client: 'Klient',
    visits: 'Návštěvy',
    lastVisit: 'Poslední návštěva',
    strong: 'Silný',
    medium: 'Střední',
    weak: 'Slabý',
    goal: 'Gól',
    list: 'Seznam',
    map: 'Mapa',
    copiedToClipboard: 'Zkopírováno do schránky',
    division: 'Divize',
    many: 'Mnoho',
    few: 'Málo',
    median: 'Medián',
    topRight: 'Vpravo nahoře',
    topLeft: 'Vlevo nahoře',
    bottomRight: 'Vpravo dole',
    bottomLeft: 'Vlevo dole',
    library: 'Knihovna',
    mediaLibrary: 'Knihovna médií',
    for: 'Pro',
    stat: 'Statistika',
    position: 'Pozice',
    order: 'Pořadí',
    add: 'Přidat',
    visualization: 'Vizualizace',
    basic: 'Základní',
    selectAll: 'Vybrat vše',
    unselectAll: 'Zrušit výběr všeho',
    distribution: 'Distribuce',
    end: 'Konec',
    accuracy: 'přesnost',
    opponent: 'Soupeř',
    ownTeam: 'Vlastní tým',
    center: 'Střed',
    line: 'Čára',
    live: 'Živě',
    unavailable: 'nedostupné',
    calendar: 'Kalendář',
    activeLeague: 'Liga v průběhu',
    similarity: 'Podobnost',
    emptyForSelectAll: 'Prázdné vybere vše',
    size: 'Velikost',
    selectPlayersRestriction: 'Vyberte mezi 1 a {x} hráči',
    group: 'Skupina',
    alerts: 'Upozornění',
    shortcuts: 'Zkratky',
    share: 'Sdílet',
    dataAvailable: 'Data budou brzy dostupná',
    someStatsAvailableSoon: 'Některé statistiky budou brzy dostupné',
    monthGamesWarning: 'Zápasy vybraného měsíce budou brzy dostupné',
    metrics: 'Metriky',
    competition: 'Soutěž',
    code: 'Kód',
    alias: 'Alias',
    never: 'Nikdy',
    unlimited: 'Neomezeně',
    user: 'Uživatel',
    warning: 'Varování',
    requests: 'Žádosti',
    contactSales: 'Kontaktovat prodej',
    comingSoon: 'Již brzy!',
    firstPost: '1. tyč',
    secondPost: '2. tyč',
    dZone: 'D zóna',
    penaltySpot: 'Penaltové místo',
    secondPlay: '2. hra',
    otherZone: 'Jiná zóna',
    baseline: 'Základní čára',
    youth: 'Mládež',
    male: 'Muž',
    direct: 'Přímý',
    indirect: 'Nepřímý',
    processing: 'Zpracovávání',
    addNew: 'Přidat nový',
    createdBy: 'Vytvořeno',
    downloading: 'Stahování',
    displayType: 'Typ zobrazení',
    alreadyExists: 'již existuje',
    aggregation: 'Agregace',
    unavailableLeagues: 'Nemáte přístup k žádné z lig, ve kterých hráč hrál',
    meters: 'Metry',
    quantity: 'Množství',
    allTime: 'Všechny časy',
    games: 'Zápasy',
    unit: 'Jednotka',
    categories: 'Kategorie',
    maintenanceWarning: 'Probíhá údržba',
    maintenanceMessage: 'Provádíme některé aktualizace. Změny, které právě provedete, nebudou uloženy. Děkujeme za trpělivost!',
    seeAll: 'Zobrazit vše',
    from: 'Od',
    to: 'komu',
    showFilters: 'Zobrazit filtry',
    hideFilters: 'Skrýt filtry',
    horizontal: 'Horizontální',
    vertical: 'Vertikální',
    drop: 'Pokles',
    orientation: 'Orientace',
    goalProbability: 'Pravděpodobnost cíle',
    assistProbability: 'Pravděpodobnost pomoci',
    attackingDirection: 'Směr útoku',
    currentTeam: 'Současný tým',
    expectations: 'Očekávání',
    sideBySide: 'Bok po boku',
    teamValue: 'Týmová hodnota',
    fieldLayout: 'Rozložení pole',
    searchPlaceholder: 'Type {x} letters at least to search',
    crests: 'Hřebeny',
    pcts: 'PCT'
  },
  playerScout: {
    dlabDatabase: 'Databáze Driblab',
    league: 'Liga',
    top5: 'Top 5',
    topCountries: 'Země',
    tier: 'Úroveň',
    division1: 'První liga',
    division2: 'Druhá liga',
    division3: 'Třetí liga',
    division4: 'Čtvrtá liga',
    division5: 'Pátá liga',
    division6: 'Šestá divize',
    summary: 'Shrnutí',
    offensive: 'Útok',
    defensive: 'Obrana',
    gk: 'BR',
    all: 'Vše',
    physical: 'Fyzické',
    arrigo: 'Arrigo',
    yearTooltip: 'Povolen pouze jeden rok',
    expectedThreat: 'xHrozba',
    expectedThreatTooltip: 'Hrozba přidaná ke všem držením míče',
    expectedThreatOP: 'xHrozba otevřená hra',
    expectedThreatOPTooltip: 'Hrozba přidaná k držení míče v otevřené hře',
    expectedThreatInTeam: 'xHrozba v týmu %',
    expectedThreatInTeamTooltip: 'Procento hrozby přidané hráčem týmu',
    ballProgression: 'Postup míče',
    ballProgressionTooltip: 'Postupy o +10 metrů',
    deepProgression: 'Hluboké postupy',
    deepProgressionTooltip: 'Postupy míče do poslední pětiny',
    ballRetention: '% Udržení míče',
    ballRetentionTooltip: 'Procento akcí, kde byl míč úspěšně udržen',
    ballRetentionOppHalf: '% Udržení míče v soupeřově polovině',
    ballRetentionOppHalfExplicit: 'Procento času, kdy máte držení míče a neskončíte jeho ztrátou v soupeřově polovině',
    finishing: 'Dokončování',
    finishingTooltip: 'Procento střel končících gólem',
    scoringContribution: 'Přínos ke skórování',
    scoringContributionTooltip: 'Asistence + Góly',
    xgPerShot: 'xG na střelu',
    xgPerGoal: 'xG na gól',
    headerPerCross: 'Hlavička na centr',
    completedCrosses: 'Dokončené centry',
    crossingPct: '% Centrování',
    crossingEfficiency: 'Efektivita center',
    crossingEfficiencyTooltip: 'Efektivita center (měří kvalitu a množství)',
    longBalls: 'Dlouhé přihrávky',
    longPassing: '% Dlouhá přihrávka',
    dribblingPct: '% Dryblink',
    throughBalls: 'Průnikové přihrávky',
    oppBoxTouches: 'Dotyků v soupeřově pokutovém území',
    oppBoxTouchesTooltip: 'Dotyků v soupeřově pokutovém území',
    openPlayKeyPasses: 'Klíčové přihrávky otevřená hra',
    openPlayKeyPassesTooltip: 'Přihrávky v otevřené hře končící střelou',
    xGBuildup: 'xG Buildup',
    xGBuildupTooltip: 'xG sekvencí končících střelou, kde byl hráč zapojen (kromě xG střely a klíčové přihrávky)',
    Assists: 'Asistence',
    passPercentage: '% Přihrávky',
    passPerLongBall: 'Přihrávka na dlouhou přihrávku',
    passPerLongBallExplicit: 'Přihrávka na dlouhou přihrávku',
    nonPenaltyGoals: 'Góly bez penalt',
    xG: 'xG',
    xGExplicit: 'Očekávané góly',
    shots: 'Střely',
    xGShot: 'xG na střelu',
    xGChain: 'xG Chain',
    xGChainTooltip: 'xG sekvencí končících střelou, kde byl hráč zapojen',
    chancesCreated: 'Přihrávky následované střelou',
    chances: 'Šance',
    dribbles: 'Dryblinky',
    dribblesSuccessfull: 'Úspěšné dryblinky',
    touches: 'Dotyků v soupeřově pokutovém území',
    xA: 'xA',
    xAExplicit: 'Očekávané asistence',
    xAOpenPlay: 'xA otevřená hra',
    xAOpenPlayExplicit: 'Očekávané asistence otevřená hra',
    passesOpponentBox: 'Přihrávky v soupeřově pokutovém území',
    passesOB: 'Přihrávky v pokutovém území',
    passesFinalThirdTooltip: 'Přihrávky finální třetina',
    passesSuccessful: 'Úspěšné přihrávky',
    passesSuccessfulTooltip: 'Úspěšné přihrávky',
    ballProgressionPassing: 'Postup míče přihrávkami',
    ballProgressionPassingTooltip: 'Postup míče přihrávkami',
    ballProgressionDribbling: 'Postup míče přenášením',
    ballProgressionDribblingTooltip: 'Postup míče přenášením',
    passesTotal: 'Přihrávky',
    passesTotalTooltip: 'Celkem pokusů o přihrávky',
    shortPassesSuccessful: 'Úspěšné krátké přihrávky',
    shortPassesSuccessfulTooltip: 'Počet dokončených krátkých přihrávek',
    shortPassesTotal: 'Celkem krátkých přihrávek',
    shortPassesTotalTooltip: 'Počet pokusů o krátké přihrávky',
    tackles: 'Skluzy *',
    adjustedTackles: 'Skluzy upravené podle držení míče',
    interceptions: 'Zachycení *',
    adjustedInterceptions: 'Zachycení upravená podle držení míče',
    aerials: 'Vzdušné souboje',
    aerialsPercent: '% Vzdušné souboje',
    aerialEfficiency: 'Efektivita vzdušných soubojů',
    aerialEfficiencyTooltip: 'Efektivita vzdušných soubojů (měří kvalitu a množství)',
    twd: 'TwD',
    tacklesWasDribbled: 'Vyhrané obranné souboje 1 na 1',
    fouls: 'Fauly',
    indPressure: 'Individuální tlak',
    pressure: 'Tlak',
    dispossessed: 'Ozbavení míče',
    recoveries: 'Znovuzískání míče',
    primary: 'Primární',
    secondary: 'Sekundární',
    position: 'Pozice',
    nationality: 'Národnost',
    height: 'Výška (cm)',
    minHeight: 'Min. výška',
    maxHeight: 'Max. výška',
    age: 'Věk',
    minAge: 'Min. věk',
    maxAge: 'Max. věk',
    games: 'Zápasy',
    minGames: 'Min. zápasy',
    maxGames: 'Max. zápasy',
    minutes: 'Minuty',
    minMinutes: 'Min. minuty',
    maxMinutes: 'Max. minuty',
    minPercentMinutes: 'Min. procento minut',
    dates: 'Datumy',
    marketValue: '(€) Tržní hodnota',
    teams: 'Týmy',
    contractEnd: 'Konec smlouvy',
    minValue: 'Min. hodnota',
    maxValue: 'Max. hodnota',
    excludeTeams: 'Vyloučit týmy',
    recentSearches: 'Nedávná vyhledávání',
    saveSearch: 'Uložit vyhledávání',
    loadSearch: 'Načíst vyhledávání',
    loadCollection: 'Načíst kolekci',
    collection: 'Kolekce',
    search: 'Vyhledat',
    searchesList: 'Seznamy vyhledávání',
    mySearches: 'Moje vyhledávání',
    mySearchesDescription: 'Ta, která jste dříve uložili',
    recentSearchesDescription: 'Posledních 10 vyhledávání, která jste provedli',
    searchToLoad: 'Vyhledávání k načtení',
    recentSearch: 'Nedávné vyhledávání',
    saveSearchSuccess: 'Vyhledávání úspěšně uloženo',
    removeSearch: 'Smazat vyhledávání',
    removeSearchMessage: 'Jste si jisti, že chcete smazat vyhledávání?',
    updateSearch: 'Aktualizovat vyhledávání',
    updateSearchMessage: 'Opravdu chcete aktualizovat vyhledávání?',
    deleteSearchSuccess: 'Vyhledávání bylo smazáno',
    playersFound: 'nalezených hráčů',
    addToCollection: 'Přidat do kolekce',
    npg: 'Góly bez penalt',
    goals: 'Góly',
    value: 'Hodnota',
    nationalTeams: 'Národní týmy',
    gbeScore: 'GBE',
    dlIndex: 'Skóre',
    minGbe: 'Min. GBE',
    goalsConceded: 'Obdržené góly',
    npgConceded: 'Obdržené góly bez penalt',
    npgConcededTooltip: 'Obdržené góly bez penalt',
    xGOTConceded: 'Obdržené xG na branku',
    xGOTConcededTooltip: 'xG střel přijatých na branku',
    goalsPrevented: 'Zabráněné góly',
    xGFacedPerShotOnTarget: 'xG na branku na střelu',
    xGFacedPerShotOnTargetTooltip: 'xG na branku na obdrženou střelu',
    xGSavedPerxGFacedOnTarget: 'xG zásahy',
    xGSavedPerxGFacedOnTargetTooltip: 'Procento zásahů s ohledem na xG',
    savesPct: '% Zásahy',
    savesOutOfBoxPct: '% Zásahy mimo pokutové území',
    savesInBoxPct: '% Zásahy v pokutovém území',
    xGFacedPerGoal: 'Obdržené xG na gól',
    xGFacedPerGoalTooltip: 'xG potřebné pro skórování gólu',
    catchingPct: '% Chycení',
    catchingTooltip: 'Procento zásahů chycených',
    passingOwnHalfPct: '% Přihrávky vlastní polovina',
    passingOwnHalfPctTooltip: 'Procento úspěšných přihrávek ve vlastní polovině',
    passingOppHalfPct: '% Přihrávky soupeřova polovina',
    passingOppHalfPctTooltip: 'Procento úspěšných přihrávek v soupeřově polovině',
    passingContribution: '% Přínos přihrávek',
    passingContributionTooltip: 'Přínos hrozby přihrávkami - nad průměrem',
    shotsPerGoal: 'Střely na gól',
    passesFinalThird: 'Přihrávky finální třetina',
    passingFinalThird: '% Přihrávky finální třetina',
    claimAccuracy: 'Přesnost vyběhnutí',
    claimAccuracyTooltip: 'Míče vyběhnuté nad průměrem',
    highTurnovers: 'Vysoké ztráty míče',
    highTurnoversTooltip: 'Ztráty míče blíže než 40 metrů od branky',
    shotEndingHighTurnovers: 'Střela končící vysokou ztrátou míče',
    shotEndingHighTurnoversTooltip: 'Střela končící vysokou ztrátou míče',
    goalEndingHighTurnovers: 'Gól končící vysokou ztrátou míče',
    goalEndingHighTurnoversTooltip: 'Gól končící vysokou ztrátou míče',
    avgCarriesProgress: 'Průměrný postup',
    avgCarriesProgressTooltip: 'Průměrná vzdálenost pohybu míče vertikálně (metry)',
    carriesChance: 'Končící šancí',
    carriesChanceTooltip: 'Přenášení míče následované klíčovou přihrávkou',
    carriesAssist: 'Končící asistencí',
    carriesAssistTooltip: 'Přenášení míče následované asistencí',
    carriesShot: 'Končící střelou',
    carriesShotTooltip: 'Přenášení míče následované střelou',
    carriesGoal: 'Končící gólem',
    carriesGoalTooltip: 'Přenášení míče následované gólem',
    shotEndingSequence: 'Končící střelou',
    shotEndingSequenceTooltip: 'Počet sekvencí končících střelou, kde byl hráč zapojen',
    goalEndingSequence: 'Končící gólem',
    goalEndingSequenceTooltip: 'Počet sekvencí končících gólem, kde byl hráč zapojen',
    gbeScoreTooltip: 'Schválení řídícího orgánu FA Football',
    goalsPreventedTooltip: 'Góly bez penalt zachráněné brankářem (Obdržené xG - Obdržené góly bez penalt)',
    freePlayers: 'Volní hráči',
    index: 'Index',
    playerName: 'Jméno',
    teamName: 'Tým',
    secondPos: 'Druhá pozice',
    side: 'Strana',
    onlyOnLoan: 'Pouze na hostování',
    dob: 'Narození',
    countryName: 'Země',
    secondCountryName: 'Druhá země',
    seasonYear: 'Sezóna',
    assists: 'Asistence',
    placeholder: 'Můžete začít přidávat filtry lig',
    placeholder2: 'Klikněte na tlačítko vyhledávání pro zobrazení výsledků',
    passesPct: '% Přihrávky',
    passingPct: '% Přihrávky',
    oppBoxPasses: 'Přihrávky v soupeřově pokutovém území',
    adjustedClearances: 'Upravené vymetení',
    aerialsPct: '% Vzdušné souboje',
    leagueCountryCode: 'Kód země ligy',
    shooting: '% Střely na branku',
    xtPassing: 'xT přihrávky',
    xtPassingTooltip: 'Hrozba přidaná přihrávkami',
    xtDribbling: 'xT přenášení míče',
    xtDribblingTooltip: 'Hrozba přidaná přenášením míče',
    foot: 'Silnější noha',
    aggressiveActions: 'Agresivní akce',
    aggressiveActionsTooltip: 'Počet pokusů o skluzy v následujících dvou sekundách po ztrátě míče',
    tacklesAttempted: 'Celkem pokusů o skluzy',
    highDefensiveActionPct: '% HD akce',
    highDefensiveActionPctTooltip: 'Procento defenzivních akcí provedených 40 metrů blízko soupeřovy branky',
    individualPressureOppHalf: 'Tlak soupeřova polovina',
    individualPressureOppHalfTooltip: 'Metrika měřící počet úspěšných snah (znovuzískání míče) provedených hráčem při presingu soupeře v soupeřově polovině',
    xGBuildUp5Pass: 'xG Buildup 5p',
    xGBuildUp5PassTooltip: 'Množství xG, kterého se hráč zúčastnil, pouze posledních 5 přihrávek (kromě střel a přihrávek vedoucích ke střele)',
    chancesCreatedOpenPlay: 'Vytvořené šance otevřená hra',
    chancesCreatedOpenPlayTooltip: 'Počet přihrávek vedoucích ke střele během otevřené hry',
    fmf: {
      Defender: 'Obránce',
      aerial: 'Vzdušné',
      goodDefender: 'Dobrý obránce',
      goodPresence: 'Dobrá přítomnost',
      playmaking: 'Tvorba hry',
      Fullback: 'Pravý/Levý obránce',
      defensiveness: 'Defenzivnost',
      offensiveness: 'Ofenzivnost',
      fast: 'Rychlý',
      Forward: 'Útočník',
      goalChances: 'Gólové šance',
      goodDecissions: 'Dobrá rozhodnutí',
      individualTechnique: 'Individuální technika',
      Goalkeeper: 'Brankář',
      footWork: 'Práce nohou',
      leadership: 'Vedení',
      Midfielder: 'Defenzivní záložník',
      balance: 'Rovnováha',
      ballRetention: '% Udržení míče',
      offensivePasses: 'Útočné přihrávky',
      recoveries: 'Znovuzískání míče',
      shotToGoal: 'Střela na gól',
      'Attacking-Midfielder': 'Útočný záložník',
      defensiveGame: 'Defenzivní hra',
      offensiveGame: 'Ofenzivní hra',
      Winger: 'Křídlo',
      crossing: 'Centrování',
      deepProgressions: 'Hluboké postupy',
      defendingEffort: 'Defenzivní úsilí',
      facing: 'Čelní'
    },
    yellowCards: 'Žluté karty',
    redCards: 'Červené karty',
    alert: 'Upozornění',
    yearOfBirth: 'Rok narození',
    minYearOfBirth: 'Min. rok narození',
    maxYearOfBirth: 'Max. rok narození',
    women: 'Ženy',
    continental: 'Kontinentální',
    countryCup: 'Národní pohár',
    statsName: 'Název statistiky',
    abbreviation: 'Zkratka',
    abbr: {
      position: 'POS',
      secondPos: 'SP',
      seasonYear: 'SY',
      marketValue: 'MV(€)',
      contractEnd: 'CE',
      height: 'H(cm)',
      side: 'SD',
      strongFoot: 'SF',
      games: 'G'
    },
    warningRegularSeason: 'Zobrazuje se pouze odehraná poslední pravidelná sezóna',
    gamesWith60PlusMinsTooltip: 'Minimální počet odehraných her s více než 60 minutami',
    starts: 'Začíná',
    minGPI: 'Min. GPI',
    maxGPI: 'Max. GPI',
    tertiary: 'Tertiary'
  },
  playerComparison: {
    upTo5Players: 'Porovnat až 5 hráčů',
    requestReport: 'Požádat o zprávu',
    searchBarPlaceholder: 'Hledat hráče nebo tým',
    allStats: 'Všechny statistiky',
    placeholder: 'Můžete začít přidávat hráče'
  },
  reports: {
    detailedInsights: 'Získat detailní poznatky',
    features: 'Funkce zprávy',
    performance: 'Výkon',
    evolution: 'Vývoj',
    compareWithMyTeam: 'Porovnat s mým týmem',
    similarPlayers: 'Podobní hráči',
    potentialTeams: 'Potenciální týmy',
    requestSuccess: 'Žádost úspěšně odeslána',
    requestAt: 'Požádáno',
    reportConversation: 'Konverzace o zprávě',
    writeYourMessage: 'Napište svou zprávu...',
    you: 'Vy'
  },
  state: {
    requested: 'Požádáno',
    inProgress: 'Probíhá',
    delivered: 'Doručeno'
  },
  langs: {
    es: 'Španělština',
    en: 'Angličtina',
    fr: 'Francouzština',
    de: 'Němčina',
    it: 'Italština',
    pt: 'Portugalština',
    tr: 'Turečtina',
    jp: 'Japonština',
    cn: 'Čínština',
    sa: 'Arabština',
    nl: 'Nizozemština',
    pl: 'Polština',
    sv: 'Švédština',
    cs: 'Cechština',
    ko: 'Korejska',
    hu: 'Mađarska',
    ru: 'Ruska'
  },
  langsArea: {
    europe: 'Evropa',
    asia: 'Asie',
    arabic: 'Arabština'
  },
  inbox: {
    subtitle: 'Zůstaňte informováni',
    new_injury_alert: 'Nové upozornění na zranění',
    new_contract_alert: 'Nové upozornění na smlouvu',
    new_team_alert: 'Nové upozornění na přestup',
    new_marketValue_alert: 'Nové upozornění na tržní hodnotu',
    new_game_alert: 'Nové upozornění na odehraný zápas',
    receive_mail: 'Přijímat email',
    receive_mail_subtitle: 'Přijímat denní email s hráči, kteří splňují filtry',
    receive_notifications: 'Notifikace',
    receive_notifications_subtitle: 'Přijímat notifikace v aplikaci s hráči, kteří splňují filtry',
    changedTo: 'Změněno na',
    alerts: 'Upozornění',
    includedIn: 'Zahrnuto v',
    noContract: 'Bez smlouvy',
    newMessages: 'Nové zprávy',
    reply: {
      reply: 'Odpovědět',
      replyTitle: 'Poskytnout zpětnou vazbu klientovi:',
      replyPlaceholder: 'Uživatel obdrží odpověď spolu s aktualizací stavu'
    }
  },
  gameAnalysis: {
    subtitle: 'Získat poznatky z nejnovějších zápasů',
    subtitle2: 'Zobrazování zápasů v příštích sedmi dnech',
    subtitle3: 'Získat poznatky z nejnovějších zápasů a prozkoumat ty příští',
    seeDetail: 'Zobrazit detaily'
  },
  statsNaming: {
    Possession: 'Držení míče',
    TimePossession: 'Čas držení míče',
    PassesPerShots: 'Přihrávky na střelu',
    PPDA: 'PPDA',
    ExpectedPoints: 'Očekávané body',
    Points: 'Body',
    Directness: 'Přímost',
    PassesPerLongBall: 'Přihrávky na dlouhou přihrávku',
    CrossingPerXG: 'Centry na xG',
    PenaltySavedPenaltyFaced: 'Zachráněné penalty/Obdržené penalty',
    Goals: 'Góly',
    PenaltyShots: 'Penalty střely',
    PenaltyGoals: 'Penalty góly',
    NonPenaltyGoals: 'Góly bez penalt',
    NPGOpenPlay: 'Góly bez penalt otevřená hra',
    NPGSetPiece: 'Góly bez penalt standardní situace',
    Shooting: 'Střelba',
    Finishing: 'Dokončování',
    xGEfficiency: 'Efektivita xG',
    HeaderPerShot: 'Hlavička na střelu',
    HeaderPerCross: 'Hlavička na centr',
    HeadedGoals: 'Cíle v čele',
    GoalsConceded: 'Inkasované branky',
    SavesInBox: 'Uloží do krabice',
    SavesOutBox: 'Uloží mimo krabici',
    Assists: 'Asistence',
    ThroughBalls: 'Průnikové přihrávky',
    CrossEfficiency: 'Efektivita center',
    ScoringContribution: 'Přínos ke skórování',
    xAssistsOpenPlay: 'Očekávané asistence otevřená hra',
    xAssistsSetPiece: 'Očekávané asistence standardní situace',
    xAssistsOpenPlayInTeam: 'Očekávané asistence otevřená hra v týmu',
    xAssistsSetPieceInTeam: 'Očekávané asistence standardní situace v týmu',
    xGBuildupFinalThird: 'xG Build Up finální třetina',
    xGChainFinalThird: 'xG Chain finální třetina',
    BallProgressionPassing: 'Postup míče přihrávkami',
    BallProgressionDribbling: 'Postup míče přenášením',
    TacklesWasDribbled: 'Vyhrané obranné souboje 1 na 1',
    TacklesSuccessful: 'Úspěšné skluzy',
    Interceptions: 'Zachycení',
    Clearances: 'Vymetení',
    Fouls: 'Fauly',
    Recoveries: 'Znovuzískání míče',
    Shots: 'Střely',
    ShotsPerGoal: 'Střely na gól',
    ShortPassesSuccessful: 'Úspěšné krátké přihrávky',
    PassingSuccessForwardPct: '% Úspěšnost přihrávek vpřed',
    PassingSuccessBackwardPct: '% Úspěšnost přihrávek vzad',
    PassingForwardBackwardPct: '% Přihrávky vpřed na přihrávky vzad',
    LongBallPerPassesPct: '% Dlouhá přihrávka na přihrávky',
    LongBallReceived: 'Obdržené dlouhé přihrávky',
    LongBallReceivedOppHalf: 'Obdržené dlouhé přihrávky soupeřova polovina',
    OffensiveActions: 'Útočné akce',
    DribblesAttempted: 'Pokusy o dryblink',
    SuccessfulDribblesPct: '% Úspěšné dryblinky',
    OffensiveTouchesOutBoxPct: '% Útočné dotyky mimo pokutové území',
    BallRetention: '% Udržení míče',
    PassingPct: '% Přihrávky',
    PassingOwnHalfPct: '% Přihrávky vlastní polovina',
    PassingOppHalfPct: '% Přihrávky soupeřova polovina',
    PassingFinalThird: 'Přihrávky do finální třetiny',
    PassesFinalThirdTotal: 'Celkový počet projde finále ⅓',
    PassingFinalThirdPct: '% Přihrávky do finální třetiny',
    LongBallSuccessful: 'Dokončené dlouhé přihrávky',
    LongBallPct: '% Dlouhé přihrávky',
    LongBallTotal: 'Celkem dlouhé koule',
    SavesPct: '% Zásahy',
    SavesInBoxPct: '% Zásahy v pokutovém území',
    SavesOutOfBoxPct: '% Zásahy mimo pokutové území',
    xGSavedPerXGFacedOnTarget: 'Zachráněné xG/Obdržené xG na branku',
    xGFacedOnTargetPerGoalReceived: 'Obdržené xG na gól',
    xGFacedOnTargetEfficiency: 'Zabráněné góly',
    xGFacedOnTarget: 'Obdržené xG na branku',
    IndividualPressure: 'Individuální tlak',
    AerialEfficiency: 'Efektivita vzdušných soubojů',
    AerialWins: 'Vítězství ve vzdušných soubojích',
    AerialWinsPct: '% Vítězství ve vzdušných soubojích',
    xG: 'Očekávané góly',
    xGDiff: 'Rozdíl xG',
    xGOpenPlay: 'xG otevřená hra',
    xGSetPiece: 'xG standardní situace',
    xGPerShot: 'xG na střelu',
    ChancesCreated: 'Vytvořené šance',
    CompletedCrosses: 'Dokončené centry',
    Crossing: '% Centrování',
    OpenPlayKeyPasses: 'Klíčové přihrávky otevřená hra',
    OpenPlayKeyPassesInTeam: '% Klíčové přihrávky otevřená hra v týmu',
    OpenPlayPassesIntoOpponentBox: 'Celkem přihrávek otevřená hra do pokutového území',
    OpenPlayPassesIntoOpponentBoxSuccessful: 'Přihrávky otevřená hra do pokutového území',
    xAssists: 'Očekávané asistence',
    xGChain: 'xG Chain',
    xGBuildup: 'xG Build Up',
    xGBuildupInTeam: 'xG Build Up v týmu',
    BallProgression: 'Postup míče',
    SuccessfulDribbles: 'Úspěšné dryblinky',
    Dispossessed: 'Ozbavení míče',
    TouchesInOpponentBox: 'Dotyků v soupeřově pokutovém území',
    xGSavedPerShot: 'Zachráněné xG na střelu',
    BallRetentionOppHalf: '% Udržení míče v soupeřově polovině',
    DeepProgression: 'Hluboký postup',
    DeepProgressionFinalThird: 'Hluboký postup do finální třetiny',
    FoulsTaken: 'Obdržené fauly',
    PenaltiesTaken: 'Obdržené penalty',
    BlockedCrosses: 'Zablokované centry',
    BlockedShots: 'Zablokované střely',
    Blocks: 'Bloky',
    NonPenaltyGoalsAgainst: 'Obdržené góly bez penalt',
    Headers: 'Hlavičky',
    AveragePassDistance: 'Průměrná vzdálenost přihrávek',
    ProgressiveRuns: 'Progresivní přenášení míče',
    xT: 'Očekávaná hrozba (xT)',
    xTOpenPlay: 'xT otevřená hra',
    xTSetPiece: 'xT standardní situace',
    xGOT: 'Očekávané góly na branku',
    BadActions: 'Špatné akce',
    BadActionsOwnHalf: 'Špatné akce vlastní polovina',
    AerialsWonOwnBox: 'Vítězství ve vzdušných soubojích vlastní pokutové území',
    AerialsWonOppBox: 'Vítězství ve vzdušných soubojích soupeřovo pokutové území',
    AerialsTotalOppBox: 'Celkem vzdušných soubojů soupeřovo pokutové území',
    AerialsTotalOwnBox: 'Celkem vzdušných soubojů vlastní pokutové území',
    FoulsOwnHalfPct: '% Faulů vlastní polovina',
    RecoveriesOppHalf: 'Znovuzískání míče soupeřova polovina',
    DuelsPct: '% Úspěšné souboje',
    TacklesUnsuccessful: 'Neúspěšné skluzy',
    TacklesWasDribbledFirstThird: 'Vyhrané obranné souboje 1 na 1 první třetina',
    TacklesWasDribbledSecondThird: 'Vyhrané obranné souboje 1 na 1 druhá třetina',
    TacklesWasDribbledFinalThird: 'Vyhrané obranné souboje 1 na 1 finální třetina',
    BallProgressionFinalThird: 'Postup míče finální třetina',
    DuelsTotal: 'Souboje',
    QuickRecoveries: 'Rychlá znovuzískání míče',
    ShotsPerNPG: 'Střely na góly bez penalt',
    ShotsOutBox: 'Střely mimo pokutové území',
    GoalsOutBox: 'Góly mimo pokutové území',
    ShootingOutBox: '% Střelba mimo pokutové území',
    HandPassing: '% Přihrávky rukou',
    Catching: '% Chycení',
    Caught: 'Chytil zachraňuje',
    ClaimAccuracy: 'Přesnost vyběhnutí',
    HighTurnovers: 'Vysoké ztráty míče',
    ShotEndingHighTurnovers: 'Střela končící vysokou ztrátou míče',
    GoalEndingHighTurnovers: 'Gól končící vysokou ztrátou míče',
    AverageCarriesProgress: 'Průměrný postup přenášením míče',
    ChanceEndingCarries: 'Přenášení míče končící šancí',
    AssistEndingCarries: 'Přenášení míče končící asistencí',
    ShotEndingCarries: 'Přenášení míče končící střelou',
    GoalEndingCarries: 'Přenášení míče končící gólem',
    ShotEndingSequence: 'Sekvence končící střelou',
    GoalEndingSequence: 'Sekvence končící gólem',
    xGPerNPG: 'xG na góly bez penalt',
    AerialWonOffensive: 'Vítězství ve vzdušných soubojích útočné',
    AerialWonDefensive: 'Vítězství ve vzdušných soubojích defenzivní',
    xGAgainst: 'Obdržené xG',
    xGDiffAgainst: 'Rozdíl obdrženého xG',
    xGPerNPGAgainst: 'Obdržené xG na góly bez penalt',
    xGSetPieceAgainst: 'Obdržené xG standardní situace',
    xGOpenPlayAgainst: 'Obdržené xG otevřená hra',
    xGPerShotAgainst: 'Obdržené xG na střelu',
    ShotsAgainst: 'Obdržené střely',
    ShotsOnTargetAgainst: 'Obdržené střely na branku',
    ShotsOnTargetInBoxAgainst: 'Střely na cíl v krabici přijaty',
    ShotsOnTargetOutBoxAgainst: 'Střely na cíl mimo krabici Přiznáno',
    RivalPossession: 'Držení míče soupeře',
    AerialDefensivePct: '% Vzdušné souboje defenzivní',
    HighRecoveries: 'Vysoká znovuzískání míče',
    HighDefensiveActions: 'Vysoké defenzivní akce',
    HighDefensiveActionPct: '% Vysoké defenzivní akce',
    HighDefensiveDistance: 'Vysoká defenzivní vzdálenost',
    PassesPerPossession: 'Přihrávky na držení míče',
    LengthPerPossession: 'Vzdálenost na držení míče',
    xTNet: 'Čisté xT',
    AvgCarriesDistance: 'Průměrná vzdálenost přenášení míče',
    PassesForwardPct: '% Přihrávky vpřed',
    PassesForwardSuccessful: 'Úspěšné předání',
    PassesForwardTotal: 'Celkový počet dopředných průjezdů',
    TacklesAttempted: 'Pokusy o skluzy',
    DuelsLost: 'Prohrané souboje',
    Carries: 'Přenášení míče',
    CarriesPct: '% Přenášení míče',
    Aerials: 'Vzdušné souboje',
    ProgressivePassesReceivedIntoBox: 'Progresivní přihrávky obdržené do pokutového území',
    PassesOppHalf: 'Přihrávky soupeřova polovina',
    ShotsOnTarget: 'Střely na branku',
    AggressiveActions: 'Agresivní akce',
    Crosses: 'Centry',
    xGBuildup5pass: 'xG Build Up 5 přihrávek',
    SpeedSequence: 'Rychlost sekvence',
    Touches: 'Dotyků',
    AerialsTotalOppHalf: 'Celkem vzdušných soubojů soupeřova polovina',
    AerialsWonOppHalf: 'Antény vyhrál Opp. Půl',
    AerialsWonOppHalfPct: '% Vítězství ve vzdušných soubojích soupeřova polovina',
    AerialsPctOppBox: '% Vítězství ve vzdušných soubojích soupeřovo pokutové území',
    AerialsPctOwnBox: '% Vítězství ve vzdušných soubojích vlastní pokutové území',
    AerialDefensive: 'Vzdušné souboje defenzivní',
    AerialOffensive: 'Vzdušné souboje útočné',
    AerialOffensivePct: '% Vzdušné souboje útočné',
    IndividualPressureOppHalf: 'Individuální tlak soupeřova polovina',
    ChancesCreatedOP: 'Vytvořené šance otevřená hra',
    TouchesPerShot: 'Dotyků na střelu',
    PassesFinalThirdTotalPct: '% Přihrávky finální třetina',
    xACrosses: 'xA z center',
    Passes: 'Přihrávky',
    PassesSuccessful: 'Úspěšné přihrávky',
    TacklesWasDribbledFouls: '% Pozemní souboje',
    OffsidesCaught: 'Chycené ofsajdy',
    ProgressivePassesReceivedFinalThird: 'Progresivní přihrávky obdržené finální třetina',
    ProgressivePassesReceived: 'Progresivní přihrávky obdržené',
    Breadth: 'Šířka',
    DuelsDefTotal: 'Defenzivní souboje',
    DefensiveActions: 'Defenzivní akce',
    ProgressivePassesReceivedOppHalf: 'Progresivní přihrávky obdržené soupeřova polovina',
    CompletedCrossesOP: 'Dokončené centry otevřená hra',
    CrossingOP: '% Centrování otevřená hra',
    CrossesOP: 'Total Crosses Open Play',
    PassingContribution: '% Přínos přihrávek',
    BallProgressionOppHalfInTeam: '% Postup míče soupeřova polovina v týmu',
    PassesOPIntoBoxInTeam: '% Přihrávky otevřená hra do pokutového území v týmu',
    TouchesOppBoxInTeam: '% Dotyků soupeřovo pokutové území v týmu',
    xGOPInTeam: '% xG otevřená hra v týmu',
    DeepPasses: 'Hluboké přihrávky',
    DeepPassesTotal: 'Hluboké průsmyky',
    DefensiveDuelsPct: '% Defenzivní souboje',
    DefensiveDistance: 'Defenzivní vzdálenost',
    QuickRecoveriesPct: '% Rychlá znovuzískání míče',
    DiffDefensiveDistanceTeam: 'Rozdíl defenzivní vzdálenosti týmu',
    xTPassing: 'xT přihrávky',
    xTPassing100Passes: 'xT přihrávky 100 přihrávek',
    ProgressivePassesAccurate: 'Progresivní přihrávky',
    PassAbility: 'Schopnost přihrávky',
    OPPassesIntoOppBoxPct: '% Přihrávky otevřená hra do soupeřova pokutového území',
    EntriesOppBox: 'Vstupy do soupeřova pokutového území',
    Crosses6yardBox: 'Centry do šestnáctky',
    Cutbacks: 'Cutbacky',
    xTDribbling: 'xT dryblink',
    AvgShotDistance: 'Průměrná vzdálenost střel',
    xGOnTarget: 'xG na branku',
    FinishingxGOT: 'Dokončování xGOT',
    DribblesWonOwnHalf: 'Dokončené dryblinky vlastní polovina',
    DribblesOwnHalf: 'Dryblinky vlastní polovina',
    DribblesOwnHalfPct: '% Dryblinky vlastní polovina',
    DribblesWonOppHalf: 'Dokončené dryblinky soupeřova polovina',
    DribblesOppHalf: 'Dryblinky soupeřova polovina',
    DribblesOppHalfPct: '% Dryblinky soupeřova polovina',
    DribblesWonFinalThird: 'Dokončené dryblinky finální třetina',
    DribblesFinalThird: 'Dryblinky finální třetina',
    DribblesFinalThirdPct: '% Dryblinky finální třetina',
    ShotEndingHighRecoveries: 'Střela končící vysokým znovuzískáním míče',
    PassingFinalThirdAgainst: 'Obdržené přihrávky finální třetina',
    OpenPlayPassesIntoOpponentBoxAgainst: 'Celkem obdržených přihrávek otevřená hra do pokutového území',
    EntriesOppBoxAgainst: 'Obdržené vstupy do pokutového území',
    DeepProgressionAgainst: 'Obdržený hluboký postup',
    TouchesInOpponentBoxAgainst: 'Obdržené dotyky v pokutovém území',
    Score: 'Skóre',
    PDScore: 'Fyzické skóre',
    OrlegiScore: 'Skóre Orlegi',
    SirScore: 'Skóre Sirius',
    ExcScore: 'Skóre Excelsior',
    xTOPInTeam: 'xT otevřená hra v týmu',
    YellowCards: 'Žluté karty',
    RedCards: 'Červené karty',
    xTOpenPlayAgainst: 'Obdržené xT otevřená hra',
    xTSetPieceAgainst: 'Obdržené xT standardní situace',
    NPGOpenPlayAgainst: 'Obdržené góly bez penalt otevřená hra',
    NPGSetPieceAgainst: 'Obdržené góly bez penalt standardní situace',
    PassesOppHalfPerPossession: 'Přihrávky soupeřova polovina na držení míče',
    AverageTimeRecovery: 'Průměrný čas znovuzískání',
    ExpectedPassing: '% Očekávané přihrávky',
    NumPossession10Passes: 'Držení míče 10 přihrávek',
    PassesReceived: 'Obdržené přihrávky',
    PassesReceivedFinalThird: 'Obdržené přihrávky finální třetina',
    ProgressivePassesTotalPct: '% Progresivní přihrávky',
    ShortPassesPct: '% Krátké přihrávky',
    TouchesOppBoxOppTeam: 'Dotyků soupeřovo pokutové území soupeřův tým',
    ShotsOnTargetOppTeam: 'Střely na branku soupeřův tým',
    NPGOppTeam: 'Góly bez penalt soupeřův tým',
    ShotsOpenPlay: 'Střely otevřená hra',
    xGSetPiecePerxG: 'xG standardní situace na xG',
    ShotsOpenPlayAgainst: 'Obdržené střely otevřená hra',
    ShotsFromDribble: 'Střely po Driblinku',
    GoalsFromDribble: 'Góly po Driblinku',
    PassesIntoFinalThird: 'Přihrávky do Ofenzivní Třetiny',
    PassesIntoFinalThirdTotal: 'Celkem přechází do poslední třetiny',
    PassesInsideFinalThird: 'Přihrávky v Ofenzivní Třetině',
    PassesInsideFinalThirdTotal: 'Celkový počet průchodů ve finále ⅓',
    PassesFinalThirdNoArea: 'Projde finálem, třetí (W/O Box)',
    PassesIntoOppBox: 'Přihrávky do Vápna Soupeře',
    CarriesFinalThird: 'Driblinky do Ofenzivní Třetiny',
    CarriesInsideFinalThird: 'Driblinky v Ofenzivní Třetině',
    CarriesFinalThirdNoBox: 'Nese poslední třetí (W/O Box)',
    CarriesIntoOppBox: 'Driblinky do Vápna Soupeře',
    TimePossessionAgainst: 'Držení Míče Soupeře',
    TimePossessionTotal: 'Celkové Držení Míče',
    PassesInBox: 'Přihrávky ve Vlastním Vápně',
    LongThrowInSuccessful: 'Úspěšné Dlouhé Auty',
    LongThrowInTotal: 'Celkem Dlouhých Autů',
    LongThrowInPct: '% Úspěšných Dlouhých Autů',
    Games: 'Odehrané hry',
    PointsPerGame: 'Body za hru',
    ExpectedPointsDiff: 'Očekávaný rozdíl bodů',
    PassesTotalOwnHalf: 'Celkem přejde vlastní polovinu',
    PassesOwnHalf: 'Míjí vlastní polovinu',
    PassesTotalOppHalf: 'Absolvuje celkem Opp polovinu',
    ProgressivePassesTotal: 'Celkový počet progresivních průchodů',
    DuelsWon: 'Vyhrané duely',
    NonPenaltySaves: 'Beztrestné úspory',
    BadActionsOppHalf: 'Špatné akce Opp Half',
    CarriesSuccessful: 'Nese úspěšné',
    ShotsOnTargetOutBox: 'Střely na cíl mimo krabici',
    TotalDistance: 'Celková vzdálenost',
    DistanceIP: 'Vzdálenost TIP',
    DistanceOOP: 'Vzdálenost OTIP',
    SprintsNumber: 'Množství sprintů',
    SprintsDistance: 'Vzdálenost sprintů',
    WalkingDistance: 'Vzdálenost chůze',
    JoggingDistance: 'Vzdálenost joggingu',
    RunningDistance: 'Vzdálenost běhu',
    ExtremeAccelerations: 'Extrémní zrychlení',
    NumberOfRuns: 'Množství běhů',
    HsrNumber: 'Množství HSR',
    HsrDistance: 'Vzdálenost HSR',
    SprintNumberDeclinePct: '% Pokles množství sprintů',
    SprintDistanceDeclinePct: '% Pokles vzdálenosti sprintů',
    SprintNumberDecline: 'Pokles množství sprintů',
    SprintDistanceDecline: 'Pokles vzdálenosti sprintů',
    HsrDistancePct: '% Vzdálenost HSR',
    SprintDistancePct: '% Vzdálenost sprintů',
    Accelerations: 'Zrychlení',
    ExplosiveDistance: 'Výbušná vzdálenost',
    MaxSpeed: 'Max. rychlost',
    AvgMaxSpeed: 'Průměrná max. rychlost',
    MaxAccelerations: 'Max. zrychlení',
    BypassedPlayersByPasses: 'Obehraní hráči přihrávkami',
    BypassedDefendersByPasses: 'Obehraní obránci přihrávkami',
    PassesBypassingPlayers: 'Přihrávky obcházející hráče',
    PassesBypassingDefenders: 'Přihrávky obcházející obránce',
    BypassedPlayersPerPass: 'Obehraní hráči na přihrávku',
    BypassedDefendersPerPass: 'Obehraní obránci na přihrávku',
    LineBreakingPasses: 'Přihrávky prolomující linii',
    LineBreakingPassesMD: 'Přihrávky prolomující linii MD',
    LineBreakingPassesM: 'Přihrávky prolomující linii M',
    LineBreakingThroughBalls: 'Průnikové přihrávky prolomující linii',
    LineBreakingPassesPerPass: '% Přihrávky prolomující linii na přihrávku',
    TotalPassesUnderStrongPressure: 'Celkem přihrávek pod silným tlakem',
    TotalPassesUnderLightPressure: 'Celkem přihrávek pod tlakem',
    SuccessfulPassesUnderStrongPressure: 'Úspěšné přihrávky pod silným tlakem',
    SuccessfulPassesUnderLightPressure: 'Úspěšné přihrávky pod tlakem',
    PassingUnderStrongPressure: '% Přihrávky pod silným tlakem',
    PassingUnderLightPressure: '% Přihrávky pod tlakem',
    PassReceiptsInSpaceCompleted: 'Dokončené přihrávky do prostoru',
    PassReceiptsInSpace: 'Přihrávky do prostoru',
    PassReceiptsInSpaceCompletedFirstThird: 'Převzetí v Prostoru - První Třetina',
    PassReceiptsInSpaceCompletedSecondThird: 'Převzetí v Prostoru - Druhá Třetina',
    PassReceiptsInSpaceCompletedFinalThird: 'Převzetí v Prostoru - Ofenzivní Třetina',
    PassReceiptsInSpaceCompletedOppHalfRight: 'Převzetí v Prostoru - Pravá Strana Soupeře',
    PassReceiptsInSpaceCompletedOppHalfCenter: 'Převzetí v Prostoru - Střed Soupeře',
    PassReceiptsInSpaceCompletedOppHalfLeft: 'Převzetí v Prostoru - Levá Strana Soupeře',
    PassReceiptsInSpaceFirstThird: 'Převzetí v Prostoru v První Třetině',
    PassReceiptsInSpaceSecondThird: 'Převzetí v Prostoru v Druhé Třetině',
    PassReceiptsInSpaceFinalThird: 'Převzetí v Prostoru v Ofenzivní Třetině',
    PassReceiptsInSpaceOppHalfRight: 'Převzetí v Prostoru - Pravá Polovina Soupeře',
    PassReceiptsInSpaceOppHalfCenter: 'Převzetí v Prostoru - Střední Část Soupeře',
    PassReceiptsInSpaceOppHalfLeft: 'Převzetí v Prostoru - Levá Polovina Soupeře',
    TotalStrongOnBallPressures: 'Celkem silných tlaků na míč',
    TotalLightOnBallPressures: 'Celkem tlaků na míč',
    SuccessfulStrongOnBallPressures: 'Úspěšné silné tlaky na míč',
    SuccessfulLightOnBallPressures: 'Úspěšné tlaky na míč',
    StrongOnBallPressuresPct: '% Silné tlaky na míč',
    LightOnBallPressuresPct: '% Tlaky na míč',
    TimesBypassedByPasses: 'Krát obehrán přihrávkami',
    TimesBypassedByCarries: 'Krát obehrán přenášením míče',
    TimesBypassedByActions: 'Krát obehrán akcemi',
    BypassedPlayersByCarries: 'Obehraní hráči přenášením míče',
    BypassedDefendersByCarries: 'Obehraní obránci přenášením míče',
    BypassedPlayersByActions: 'Obehraní hráči akcemi',
    BypassedDefendersByActions: 'Obehraní obránci akcemi',
    CarriesBypassingPlayers: 'Přenášení míče obcházející hráče',
    CarriesBypassingDefenders: 'Přenášení míče obcházející obránce',
    BypassedPlayersPerCarry: 'Obehraní hráči na přenášení míče',
    BypassedDefendersPerCarry: 'Obehraní obránci na přenášení míče',
    LineBreakingCarries: 'Přenášení míče prolomující linii',
    LineBreakingCarriesMD: 'Přenášení míče prolomující linii MD',
    LineBreakingCarriesM: 'Přenášení míče prolomující linii M',
    LineBreakingCarriesD: 'Přenášení míče prolomující linii D',
    LineBreakingCarriesPerCarry: '% Přenášení míče prolomující linii na přenášení míče',
    LineBreakingActions: 'Akce prolomující linii',
    LineBreakingActionsMD: 'Akce prolomující linii MD',
    LineBreakingActionsM: 'Akce prolomující linii M',
    LineBreakingActionsD: 'Akce prolomující linii D',
    PassesPerLineBreakingPass: 'Přihrávky na přihrávku prolomující linii',
    CarriesPerLineBreakingCarry: 'Přenášení míče na přenášení míče prolomující linii',
    LinesBrokenByPasses: 'Linie prolomené přihrávkami',
    LinesBrokenByCarries: 'Linie prolomené přenášením míče',
    LinesBrokenByActions: 'Linie prolomené akcemi',
    LinesBrokenPerPass: 'Linie prolomené na přihrávku',
    LinesBrokenPerCarry: 'Linie prolomené na přenášení míče',
    AvgLastDefenderDistanceIP: 'Vzdálenost posledního obránce IP',
    AvgLastDefenderDistanceOOP: 'Vzdálenost posledního obránce OOP',
    AvgDefensiveLineDistanceIP: 'Vzdálenost defenzivní linie IP',
    AvgDefensiveLineDistanceOOP: 'Vzdálenost defenzivní linie OOP',
    AvgRBDistanceIP: 'Vzdálenost pravého obránce IP',
    AvgRBDistanceOOP: 'Vzdálenost pravého obránce OOP',
    AvgLBDistanceIP: 'Vzdálenost levého obránce IP',
    AvgLBDistanceOOP: 'Vzdálenost levého obránce OOP',
    AvgBlockDistanceIP: 'Vzdálenost bloku IP',
    AvgBlockDistanceOOP: 'Vzdálenost bloku OOP',
    AvgBlockAreaIP: 'Oblast bloku IP',
    AvgBlockAreaOOP: 'Oblast bloku OOP',
    AvgDefensiveLineWidthOOP: 'Šířka defenzivní linie OOP',
    AvgOffensiveLineLastThirdWidthIP: 'Šířka útočné linie poslední třetina IP',
    AvgLByIP: 'Pozice levého obránce IP',
    AvgRByIP: 'Pozice pravého obránce IP',
    AvgOffensiveLineDistanceIP: 'Vzdálenost útočné linie IP',
    AvgOffensiveLineLastThirdDistanceIP: 'Vzdálenost útočné linie poslední třetina IP',
    AvgOffensiveLineWidthIP: 'Šířka útočné linie IP',
    OffBallRuns: 'Celkem běhů bez míče',
    OffBallRunsOverlap: 'Běhy bez míče overlap',
    OffBallRunsUnderlap: 'Běhy bez míče underlap',
    OffBallRunsRunAhead: 'Běhy bez míče vpřed',
    OffBallRunsRunBehind: 'Běhy bez míče vzad',
    OffBallRunsCrossReceiver: 'Běhy bez míče příjemce centru',
    OffBallRunsSupport: 'Běhy bez míče podpora',
    OffBallRunsComingShort: 'Běhy bez míče přiblížení',
    description: {
      Possession: 'Procento držení míče týmu',
      TimePossession: 'Čas držení míče týmu',
      PassesPerShots: 'Průměrný počet přihrávek na střelu',
      PPDA: 'Obdržené přihrávky na defenzivní akci. PPDA měří tlak, který tým vyvíjí na soupeřovy hráče, když mají držení míče. Hodnota odpovídá průměrnému počtu přihrávek v řadě, které soupeř dokázal dokončit před přerušením. Čím vyšší je hodnota, tím více přihrávek bylo soupeři dovoleno dokončit',
      Directness: 'Měří, jak přímočarý tým je. Vysoká hodnota přímosti souvisí s vyšším množstvím přihrávek vpřed ve srovnání s přihrávkami do stran',
      ExpectedPoints: 'Počet bodů očekávaných týmem, vypočítaný na základě vygenerovaných a obdržených očekávaných gólů. Tato metrika nám umožňuje lépe posoudit výkon týmu během zápasu (nebo sady zápasů) ve srovnání s počtem skutečně dosažených bodů',
      PassesPerLongBall: 'Procento úspěšných dlouhých přihrávek z celkového počtu dokončených přihrávek',
      CrossingPerXG: 'Procento očekávaných gólů pocházejících z center',
      PenaltySavedPenaltyFaced: 'Procento zachráněných penalty střel ze všech obdržených penalty střel',
      Goals: 'Počet gólů vstřelených',
      PenaltyShots: 'Celkový počet střel z penalty',
      PenaltyGoals: 'Celkový počet gólů z penalty',
      NonPenaltyGoals: 'Počet gólů vstřelených kromě gólů z penalty',
      NPGOpenPlay: 'Počet gólů vstřelených otevřenou hrou kromě gólů z penalty',
      NPGSetPiece: 'Počet gólů vstřelených standardními situacemi kromě gólů z penalty',
      Shooting: 'Procento střel na branku',
      Finishing: 'Procento střel končících gólem',
      xGEfficiency: 'Množství očekávaných gólů potřebných pro hráče, aby vstřelil gól',
      HeaderPerShot: 'Počet hlaviček provedených',
      HeaderPerCross: 'Procento center, které hráč hlavičkoval, z celkového počtu center dokončených týmem',
      Assists: 'Počet asistencí',
      ThroughBalls: 'Počet přihrávek pro hráče provádějícího útočný běh, aby vytvořil šanci na gól',
      CrossEfficiency: 'Metrika, která kombinuje procento úspěšných center spolu s objemem úspěšných center',
      ScoringContribution: 'Počet asistencí a gólů',
      xAssistsOpenPlay: 'Počet očekávaných asistencí vygenerovaných otevřenou hrou',
      xAssistsSetPiece: 'Počet očekávaných asistencí vygenerovaných standardními situacemi',
      xAssistsOpenPlayInTeam: 'Počet očekávaných asistencí vygenerovaných otevřenou hrou v týmu',
      xAssistsSetPieceInTeam: 'Počet očekávaných asistencí vygenerovaných standardními situacemi v týmu',
      xGChainFinalThird: 'Množství xG, kterého se hráč zúčastnil ve finální třetině',
      xGBuildupFinalThird: 'Množství xG, kterého se hráč zúčastnil ve finální třetině (kromě střel a přihrávek vedoucích ke střele)',
      BallProgressionPassing: 'Počet krát, kdy hráč posune míč o 10 metrů nebo více přihrávkou',
      BallProgressionDribbling: 'Počet krát, kdy hráč posune míč o 10 metrů nebo více přenášením míče',
      TacklesWasDribbled: 'Metrika, která zohledňuje procento krát, kdy hráč znovuzíská míč skluzem vs. krát, kdy byl obehrán. Čím vyšší indikátor, tím lépe',
      TacklesSuccessful: 'Počet úspěšných skluzů provedených hráčem',
      Interceptions: 'Počet krát, kdy hráč zachytí přihrávku, aby zabránil míči dosáhnout cíle',
      Clearances: 'Počet krát, kdy hráč vymete míč z defenzivní zóny',
      Fouls: 'Počet faulů spáchaných hráčem',
      Recoveries: 'Počet míčů znovuzískaných hráčem',
      Shots: 'Počet celkových střel',
      ShotsPerGoal: 'Střely na branku potřebné pro vstřelení gólu bez penalty brankáři',
      ShortPassesSuccessful: 'Krátké přihrávky (pod 12 metrů) dokončené',
      PassingSuccessForwardPct: 'Procento úspěšných přihrávek ve směru vpřed',
      PassingSuccessBackwardPct: 'Procento úspěšných přihrávek vzad',
      PassingForwardBackwardPct: 'Poměr přihrávek ve směru vpřed proti přihrávkám vzad',
      LongBallPerPassesPct: 'Procento dlouhých přihrávek dokončených (>32 metrů) ze všech přihrávek dokončených hráčem.',
      LongBallReceived: 'Dlouhé přihrávky (>32 metrů) obdržené hráčem',
      LongBallReceivedOppHalf: 'Dlouhé přihrávky (>32 metrů) obdržené hráčem v soupeřově polovině',
      OffensiveActions: 'Útočné akce',
      DribblesAttempted: 'Pokusy o dryblink',
      SuccessfulDribblesPct: 'Úspěšné dryblinky/celkový počet pokusů o dryblink',
      OffensiveTouchesOutBoxPct: '% Útočné dotyky mimo pokutové území',
      BallRetention: 'Procento času, kdy máte držení míče a neskončíte jeho ztrátou',
      PassingPct: 'Procento dokončených přihrávek ze všech přihrávek provedených hráčem',
      PassingOwnHalfPct: 'Procento dokončených přihrávek ze všech přihrávek provedených hráčem (pouze přihrávky ve vlastní polovině)',
      PassingOppHalfPct: 'Procento dokončených přihrávek ze všech přihrávek provedených hráčem (pouze přihrávky do soupeřovy poloviny)',
      PassingFinalThird: 'Úspěšné přihrávky do finální třetiny',
      PassesFinalThirdTotal: 'Celkový počet pokusů o přihrávky, s výjimkou křížků, standardek, rohů a vhazování, které končí v poslední třetině',
      PassingFinalThirdPct: 'Procento dokončených přihrávek ze všech přihrávek provedených hráčem (pouze přihrávky do finální třetiny)',
      LongBallSuccessful: 'Dokončené přihrávky přes 32 metrů',
      LongBallPct: 'Dokončené přihrávky přes 32 metrů/ Celkem pokusů o přihrávky přes 32 metrů.',
      LongBallTotal: 'Celkový počet přejezdů nad 32 metrů',
      SavesPct: 'Procento zásahů z celkového počtu obdržených střel',
      SavesInBoxPct: 'Procento zachráněných střel přicházejících z pokutového území',
      SavesOutOfBoxPct: 'Procento zachráněných střel přicházejících zvenku pokutového území',
      xGSavedPerXGFacedOnTarget: 'Koeficient, který udává procento očekávaného xG, které brankář zachránil. Hodnota 1 v této metrice by znamenala, že brankář zachránil všechny očekávané góly střel obdržených týmem, zatímco hodnota 0 by znamenala, že všechny očekávané góly vygenerované soupeřem skončily gólem',
      xGFacedOnTargetPerGoalReceived: 'Metrika, která udává, kolik očekávaných gólů je potřeba pro vstřelení gólu určitému brankáři. Vysoké skóre v této metrice znamená, že pro přeměnu gólu na tohoto brankáře je nutné vytvořit vysoký počet xG',
      xGFacedOnTargetEfficiency: 'Počet gólů bez penalty zabráněných brankářem. Toto je počet očekávaných gólů na branku obdržených brankářem minus počet (bez penalty) obdržených gólů. Udává počet gólů, které nebyly vstřeleny soupeřem díky brankáři',
      xGFacedOnTarget: 'Celkové xG (zachráněné a vstřelené) obdržené brankářem',
      IndividualPressure: 'Metrika, která měří počet úspěšných snah (znovuzískání míče) provedených hráčem při presingu soupeře',
      AerialEfficiency: 'Metrika, která kombinuje procento úspěšných vzdušných soubojů spolu s objemem vítězství ve vzdušných soubojích',
      AerialWins: 'Počet vzdušných soubojů, které hráč vyhraje',
      AerialWinsPct: 'Počet vzdušných soubojů, které hráč vyhraje z celkového počtu vzdušných soubojů, ve kterých byl hráč zapojen',
      xG: 'Očekávané góly vygenerované. Tato metrika měří pravděpodobnost, že střela skončí gólem na základě různých proměnných (vzdálenost, úhel, typ hry, část těla, ...) takové akce.',
      xGDiff: 'Rozdíl mezi xG a Góly',
      xGOpenPlay: 'Očekávané góly vygenerované otevřenou hrou',
      xGSetPiece: 'Očekávané góly vygenerované standardními situacemi',
      xGPerShot: 'Průměrné xG střel provedených hráčem. Tato metrika měří průměrnou nebezpečnost provedených střel. Čím vyšší, tím pravděpodobnější je, že vaše střely skončí gólem. Vysoké xG na střelu znamená, že hráč si své střely dobře vybírá.',
      ChancesCreated: 'Počet přihrávek vedoucích ke střele',
      CompletedCrosses: 'Počet dokončených center',
      Crossing: 'Procento center, která byla dokončena z pokusů o centr',
      OpenPlayKeyPasses: 'Počet přihrávek dokončených během otevřené hry',
      OpenPlayKeyPassesInTeam: 'Procento přihrávek dokončených během otevřené hry v týmu',
      OpenPlayPassesIntoOpponentBox: 'Celkový počet pokusů o přihrávky do soupeřova pokutového území během otevřené hry',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Počet přihrávek dokončených do soupeřova pokutového území během otevřené hry',
      xAssists: 'Metrika, která analyzuje kvalitu vytvořených šancí, které se odehrávají v zápase. Každá asistence vedoucí ke střele má hodnotu založenou na pravděpodobnosti, že střela skončí gólem. Tato hodnota je přiřazena podle místa přihrávky, typu (centr průniková přihrávka standardní situace…), stavu hry atd. Na rozdíl od xG je xA metrika, kterou by hráč ideálně měl mít vyšší než jeho počet asistencí, protože tvůrce může kontrolovat pouze kvalitu svých přihrávek (xA), zatímco jeho počet asistencí závisí na dokončovateli',
      xGChain: 'Množství xG, kterého se hráč zúčastnil',
      xGBuildup: 'Podobné jako xG Chain, ale nezohledňuje poslední 2 hráče sekvence (kromě střel a přihrávek vedoucích ke střele)',
      xGBuildupInTeam: 'Podobné jako xG Chain, ale nezohledňuje poslední 2 hráče sekvence (kromě střel a přihrávek vedoucích ke střele) v týmu',
      BallProgression: 'Počet krát, kdy hráč postoupí o 10 nebo více metrů buď přihrávkou, přenášením míče nebo kombinací obou',
      SuccessfulDribbles: 'Dryblinky úspěšně dokončené',
      Dispossessed: 'Počet krát, kdy je hráč obehrán a ztratí držení míče',
      TouchesInOpponentBox: 'Počet krát, kdy je držení míče v soupeřově pokutovém území',
      xGSavedPerShot: 'Průměrná pravděpodobnost gólu obdržených střel na branku',
      BallRetentionOppHalf: 'Procento času, kdy máte držení míče a neskončíte jeho ztrátou v soupeřově polovině',
      DeepProgression: 'Počet krát, kdy je dosaženo poslední pětiny hřiště přenášením míče, plus počet krát, kdy je držení míče v poslední pětině',
      DeepProgressionFinalThird: 'Počet krát, kdy je dosaženo finální třetiny hřiště přenášením míče, plus počet krát, kdy je držení míče ve finální třetině',
      FoulsTaken: 'Počet krát, kdy byl hráč faulován',
      PenaltiesTaken: 'Počet krát, kdy byl hráč faulován v soupeřově pokutovém území',
      BlockedCrosses: 'Centry zablokované',
      BlockedShots: 'Střely zablokované',
      NonPenaltyGoalsAgainst: 'Počet obdržených gólů bez penalty',
      GoalsConceded: 'Počet inkasovaných gólů',
      Headers: 'Počet střel provedených hlavou',
      HeadedGoals: 'Počet gólů vstřelených hlavou',
      Points: 'Počet bodů dosažených týmem',
      SavesInBox: 'Počet záchrany střel uvnitř boxu',
      SavesOutBox: 'Počet zákroků při střelách mimo box',
      ShotsOnTargetInBoxAgainst: 'Počet inkasovaných střel na terč zevnitř boxu',
      ShotsOnTargetOutBoxAgainst: 'Počet inkasovaných střel na terč zvenčí',
      AveragePassDistance: 'Průměrná vzdálenost přihrávek v metrech',
      ProgressiveRuns: 'Úspěšná přenášení míče, která přiblíží držení míče o 20% k soupeřově brance',
      xT: 'Očekávaná hrozba (xT) je metrika, která měří hrozbu, kterou hráč vytváří pro soupeře přenášením nebo přihrávkami míče do oblastí, kde je pravděpodobnost, že držení míče skončí gólem, vyšší.',
      xTOpenPlay: 'Očekávaná hrozba vygenerovaná během otevřené hry',
      xTSetPiece: 'Očekávaná hrozba vygenerovaná standardními situacemi',
      xGOT: 'Očekávané góly na branku. Počet očekávaných gólů obdržených brankářem. Tato metrika zohledňuje pouze střely na branku (Minuté střely a střely na tyč jsou vyloučeny)',
      BadActions: 'Součet všech špatných akcí (neúspěšná přihrávka, neúspěšný pokus o obehrání, ozbavení míče, ofsajdová přihrávka, neúspěšný dotyk míče)',
      BadActionsOwnHalf: 'Součet všech špatných akcí (neúspěšná přihrávka, neúspěšný pokus o obehrání, ozbavení míče, ofsajdová přihrávka, neúspěšný dotyk míče) ve vlastní polovině',
      AerialsWonOwnBox: 'Vítězství ve vzdušných soubojích vlastní pokutové území',
      AerialsWonOppBox: 'Vítězství ve vzdušných soubojích soupeřovo pokutové území',
      AerialsTotalOppBox: 'Celkem vzdušných soubojů soupeřovo pokutové území',
      AerialsTotalOwnBox: 'Celkem vzdušných soubojů vlastní pokutové území',
      FoulsOwnHalfPct: 'Procento faulů spáchaných ve vlastní polovině',
      RecoveriesOppHalf: 'Počet míčů znovuzískaných hráčem v soupeřově polovině',
      DuelsPct: 'Procento úspěšných soubojů',
      TacklesUnsuccessful: 'Počet krát, kdy hráč neuspěje ve znovuzískání míče, když ho soupeř úspěšně obehrává',
      TacklesWasDribbledFirstThird: 'Procento krát, kdy hráč znovuzíská míč, když je konfrontován ve finální třetině',
      TacklesWasDribbledSecondThird: 'Skluzy/Byl obehrán druhá třetina',
      TacklesWasDribbledFinalThird: 'Skluzy/Byl obehrán finální třetina',
      BallProgressionFinalThird: 'Postup míče finální třetina',
      DuelsTotal: 'Celkový počet skluzů, vzdušných soubojů, dotyků míče, dryblinků a faulů spáchaných',
      QuickRecoveries: 'Znovuzískání míče 40 metrů nebo více od vlastní branky provedené 8 sekund po ztrátě držení míče',
      ShotsPerNPG: 'Průměrný počet střel pro vstřelení gólu bez penalty',
      ShotsOutBox: 'Počet střel zvenku pokutového území',
      GoalsOutBox: 'Počet gólů zvenku pokutového území',
      ShootingOutBox: 'Procento střel na branku zvenku pokutového území',
      HandPassing: 'Přesnost přihrávek rukou',
      Catching: 'Procento zásahů, při kterých brankář chytí míč',
      Caught: 'Šetří tam, kde brankář chytí a drží míč, čímž zabrání jakékoli druhé hře',
      ClaimAccuracy: 'Měří, jak dobrý je brankář v chytání/blokování vzdušných míčů. Číslo nad 1 znamená, že brankář chytí více vzdušných míčů, než se očekávalo',
      HighTurnovers: 'Ztráty míče blíže než 40 metrů od vlastní branky',
      ShotEndingHighTurnovers: 'Vysoké ztráty míče (ztráty míče blíže než 40 metrů od vlastní branky) končící střelou soupeřova týmu',
      GoalEndingHighTurnovers: 'Vysoké ztráty míče (ztráty míče blíže než 40 metrů od vlastní branky) končící gólem soupeřova týmu',
      AverageCarriesProgress: 'Průměrná vzdálenost, kterou hráč posune míč vertikálně na přenášení míče (metry)',
      ChanceEndingCarries: 'Přenášení míče alespoň 7 metrů končící přihrávkou, která je následována střelou',
      AssistEndingCarries: 'Přenášení míče alespoň 7 metrů končící přihrávkou, která je následována gólem',
      ShotEndingCarries: 'Přenášení míče alespoň 7 metrů končící střelou',
      GoalEndingCarries: 'Přenášení míče alespoň 7 metrů končící gólem',
      ShotEndingSequence: 'Počet sekvencí končících střelou, kde byl hráč zapojen',
      GoalEndingSequence: 'Počet sekvencí končících gólem, kde byl hráč zapojen',
      xGPerNPG: 'Očekávané góly potřebné pro vstřelení gólu bez penalty',
      AerialWonOffensive: 'Vítězství ve vzdušných soubojích útočné',
      AerialWonDefensive: 'Vítězství ve vzdušných soubojích defenzivní',
      xGAgainst: 'Obdržené očekávané góly',
      xGDiffAgainst: 'Rozdíl mezi obdrženými očekávanými góly a obdrženými góly',
      xGPerNPGAgainst: 'Obdržené očekávané góly na obdržený gól bez penalty',
      xGSetPieceAgainst: 'Obdržené očekávané góly vygenerované standardními situacemi',
      xGOpenPlayAgainst: 'Obdržené očekávané góly vygenerované otevřenou hrou',
      xGPerShotAgainst: 'Obdržené očekávané góly na obdrženou střelu',
      ShotsAgainst: 'Počet obdržených střel',
      ShotsOnTargetAgainst: 'Počet obdržených střel na branku',
      RivalPossession: 'Držení míče soupeře',
      AerialDefensivePct: 'Procento vítězství ve vzdušných soubojích bez držení míče',
      HighRecoveries: 'Znovuzískání míče provedená 40 metrů nebo blíže k soupeřově brance',
      HighDefensiveActions: 'Defenzivní akce (Skluzy, Zachycení, Bloky, Fauly a 1vs1) provedené 40 metrů nad vlastní základní čárou',
      HighDefensiveActionPct: 'Procento defenzivních akcí (Skluzy, Zachycení, Bloky, Fauly a 1vs1) provedených 40 metrů nad vlastní základní čárou',
      HighDefensiveDistance: 'Průměrná vzdálenost od vlastní branky všech defenzivních akcí',
      PassesPerPossession: 'Počet přihrávek na držení míče',
      LengthPerPossession: 'Vzdálenost na držení míče',
      xTNet: 'Čisté xT',
      AvgCarriesDistance: 'Průměrná vzdálenost přenášení míče',
      PassesForwardPct: '% Přihrávky vpřed',
      PassesForwardSuccessful: 'Úspěšné předání',
      PassesForwardTotal: 'Celkový počet dopředných průjezdů',
      TacklesAttempted: 'Pokusy o skluzy',
      DuelsLost: 'Prohrané souboje',
      Carries: 'Přenášení míče',
      CarriesPct: '% Přenášení míče',
      Aerials: 'Celkový počet vzdušných soubojů',
      ProgressivePassesReceivedIntoBox: 'Progresivní přihrávky obdržené do pokutového území',
      PassesOppHalf: 'Úspěšné přihrávky končící v soupeřově polovině',
      ShotsOnTarget: 'Střely na branku',
      AggressiveActions: 'Počet pokusů o skluzy v následujících dvou sekundách po ztrátě držení míče',
      Crosses: 'Celkový počet center',
      xGBuildup5pass: 'Množství xG, kterého se hráč zúčastnil, pouze posledních 5 přihrávek (kromě střel a přihrávek vedoucích ke střele)',
      DefensiveDistance: 'Průměrná vzdálenost k vlastní brance provedených defenzivních soubojů',
      SpeedSequence: 'Průměrná rychlost (metry uražené za čas strávený) všech držení míče týmu',
      Touches: 'Počet krát, kdy má hráč držení míče',
      AerialsTotalOppHalf: 'Celkem vzdušných soubojů v soupeřově polovině',
      AerialsWonOppHalf: 'Letecké souboje úspěšné na polovinu soupeře',
      AerialsWonOppHalfPct: 'Procento vítězství ve vzdušných soubojích v soupeřově polovině',
      AerialsPctOppBox: 'Procento vítězství ve vzdušných soubojích v soupeřově pokutovém území',
      AerialsPctOwnBox: 'Procento vítězství ve vzdušných soubojích ve vlastním pokutovém území',
      AerialDefensive: 'Celkový počet vzdušných soubojů, když soupeřův tým má držení míče',
      AerialOffensive: 'Celkový počet vzdušných soubojů, když vlastní tým má držení míče',
      AerialOffensivePct: 'Procento vítězství ve vzdušných soubojích, když vlastní tým má držení míče',
      IndividualPressureOppHalf: 'Metrika, která měří počet úspěšných snah (znovuzískání míče) provedených hráčem při presingu soupeře v soupeřově polovině',
      ChancesCreatedOP: 'Počet přihrávek vedoucích ke střele během otevřené hry',
      TouchesPerShot: 'Počet krát, kdy hráči dotknou míče na střelu',
      PassesFinalThirdTotalPct: 'Procento přihrávek (úspěšných i neúspěšných) do finální třetiny',
      xACrosses: 'Očekávané asistence vygenerované z center',
      Passes: 'Celkový počet přihrávek',
      PassesSuccessful: 'Počet dokončených přihrávek',
      TacklesWasDribbledFouls: 'Procento vyhraných skluzů ve vztahu k celkovým skluzům a spáchaným faulům',
      OffsidesCaught: 'Chycené ofsajdy',
      ProgressivePassesReceivedFinalThird: 'Progresivní přihrávky obdržené finální třetina',
      ProgressivePassesReceived: 'Progresivní přihrávky obdržené',
      Breadth: 'Součet skluzů, výzev, zachycení a spáchaných faulů na stranách hřiště',
      DuelsDefTotal: 'Součet celkových skluzů, defenzivních vzdušných soubojů a spáchaných faulů',
      DefensiveActions: 'Defenzivní akce, když soupeř zkouší dryblink (Skluzy, Výzvy a Fauly)',
      ProgressivePassesReceivedOppHalf: 'Progresivní přihrávky obdržené soupeřova polovina',
      CompletedCrossesOP: 'Dokončené centry otevřená hra',
      CrossingOP: 'Procento center dokončených ze všech pokusů o centr otevřená hra',
      CrossesOP: 'Celkový počet křížků během otevřené hry',
      PassingContribution: 'Procento, které měří hrozbu přihrávek s ohledem na pozici příjemce',
      BallProgressionOppHalfInTeam: '% Postup míče soupeřova polovina v týmu',
      PassesOPIntoBoxInTeam: '% Přihrávky otevřená hra do pokutového území v týmu',
      TouchesOppBoxInTeam: '% Dotyků soupeřovo pokutové území v týmu',
      xGOPInTeam: '% xG otevřená hra v týmu',
      DeepPasses: 'Přihrávky zvenku 20metrového poloměru soupeřovy branky, které končí uvnitř této oblasti',
      DeepPassesTotal: 'Celkový počet pokusů o přihrávky z vnějšku 20metrového okruhu soupeřovy branky, které končí uvnitř tohoto prostoru',
      DefensiveDuelsPct: 'Procento vyhraných defenzivních soubojů z celkových defenzivních soubojů',
      QuickRecoveriesPct: 'Procento rychlých znovuzískání míče k zachycení a pokusům o skluzy',
      DiffDefensiveDistanceTeam: 'Rozdíl mezi defenzivní vzdáleností hráče a defenzivní vzdáleností jeho týmu',
      xTPassing: 'Očekávaná hrozba vygenerovaná pouze z přihrávek',
      xTPassing100Passes: 'Očekávaná hrozba vygenerovaná pouze z přihrávek a na 100 přihrávek',
      ProgressivePassesAccurate: 'Dokončené přihrávky 10 metrů nebo více na ose X',
      PassAbility: 'Poměr dokončených přihrávek k očekávaným přihrávkám (xP)',
      OPPassesIntoOppBoxPct: 'Procento dokončených přihrávek otevřená hra do soupeřova pokutového území a pokusů o přihrávky otevřená hra do soupeřova pokutového území',
      EntriesOppBox: 'Počet přihrávek a přenášení míče do soupeřova pokutového území',
      Crosses6yardBox: 'Celkový počet center končících v šestnáctce',
      Cutbacks: 'Přihrávky ze základní čáry zpět a dovnitř soupeřova pokutového území',
      xTDribbling: 'Očekávaná hrozba vygenerovaná pouze z dryblinků',
      AvgShotDistance: 'Průměrná vzdálenost celkového počtu provedených střel',
      xGOnTarget: 'Očekávané góly ze střel na branku. Měří pravděpodobnost, že střela skončí gólem pomocí koncové polohy střely',
      FinishingxGOT: 'Procento střel na branku končících gólem nad průměrem. Tato metrika měří, jakou hodnotu útočník přidává kvalitou svých střel',
      DribblesWonOwnHalf: 'Úspěšné dryblinky provedené ve vlastní polovině',
      DribblesOwnHalf: 'Počet pokusů o dryblink provedených ve vlastní polovině',
      DribblesOwnHalfPct: 'Procento úspěšných dryblinků a pokusů o dryblink provedených ve vlastní polovině',
      DribblesWonOppHalf: 'Úspěšné dryblinky provedené v soupeřově polovině',
      DribblesOppHalf: 'Počet pokusů o dryblink provedených v soupeřově polovině',
      DribblesOppHalfPct: 'Procento úspěšných dryblinků a pokusů o dryblink provedených v soupeřově polovině',
      DribblesWonFinalThird: 'Úspěšné dryblinky provedené ve finální třetině',
      DribblesFinalThird: 'Počet pokusů o dryblink provedených ve finální třetině',
      DribblesFinalThirdPct: 'Procento úspěšných dryblinků a pokusů o dryblink provedených ve finální třetině',
      ShotEndingHighRecoveries: 'Vysoká znovuzískání míče (znovuzískání míče provedená 40 metrů nebo blíže k soupeřově brance) končící střelou',
      PassingFinalThirdAgainst: 'Úspěšné přihrávky od soupeře do finální třetiny',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Celkový počet pokusů o přihrávky od soupeře do vlastního pokutového území během otevřené hry',
      EntriesOppBoxAgainst: 'Počet přihrávek a přenášení míče od soupeře do vlastního pokutového území',
      DeepProgressionAgainst: 'Počet krát, kdy soupeř dosáhne poslední pětiny hřiště přenášením míče, plus počet krát, kdy je držení míče v první pětině',
      TouchesInOpponentBoxAgainst: 'Počet krát, kdy má soupeř držení míče v našem pokutovém území',
      Score: 'Výkon hráče založený na různých metrikách',
      PDScore: 'Fyzický výkon hráče založený na různých fyzických metrikách',
      OrlegiScore: 'Výkon hráče založený na různých metrikách',
      SirScore: 'Výkon hráče založený na různých metrikách',
      ExcScore: 'Výkon hráče založený na různých metrikách',
      xTOPInTeam: 'Očekávaná hrozba vygenerovaná během otevřené hry v týmu',
      YellowCards: 'Obdržené žluté karty',
      RedCards: 'Obdržené červené karty',
      xTOpenPlayAgainst: 'Obdržená očekávaná hrozba během otevřené hry',
      xTSetPieceAgainst: 'Obdržená očekávaná hrozba standardními situacemi',
      NPGOpenPlayAgainst: 'Počet obdržených gólů otevřenou hrou kromě gólů z penalty',
      NPGSetPieceAgainst: 'Počet obdržených gólů standardními situacemi kromě gólů z penalty',
      PassesOppHalfPerPossession: 'Přihrávky soupeřova polovina na držení míče',
      AverageTimeRecovery: 'Průměrný čas znovuzískání',
      ExpectedPassing: 'Procento přihrávek, které měly být dokončeny',
      NumPossession10Passes: 'Držení míče vygenerovaná 10 nebo více přihrávkami',
      PassesReceived: 'Obdržené přihrávky',
      PassesReceivedFinalThird: 'Obdržené přihrávky finální třetina',
      ProgressivePassesTotalPct: 'Procento progresivních přihrávek',
      ShortPassesPct: 'Procento krátkých přihrávek',
      TouchesOppBoxOppTeam: 'Počet soupeřových akcí obdržených uvnitř vlastního pokutového území, když je hráč na hřišti',
      ShotsOnTargetOppTeam: 'Střely na branku obdržené, když je hráč na hřišti',
      NPGOppTeam: 'Góly bez penalty obdržené, když je hráč na hřišti',
      xGSetPiecePerxG: 'Očekávané góly vygenerované standardními situacemi potřebné pro vygenerování jednoho očekávaného gólu',
      ShotsOpenPlay: 'Počet střel vygenerovaných otevřenou hrou',
      ShotsOpenPlayAgainst: 'Počet střel obdržených otevřenou hrou',
      ShotsFromDribble: 'Střely provedené po obdriblování soupeře',
      GoalsFromDribble: 'Góly vstřelené po obdriblování soupeře',
      PassesIntoFinalThird: 'Úspěšné přihrávky z ofenzivní třetiny',
      PassesIntoFinalThirdTotal: 'Celkový počet pokusů o přihrávky, které začínají venku a končí v poslední třetině',
      PassesInsideFinalThird: 'Úspěšné přihrávky uvnitř ofenzivní třetiny (začátek i konec v téže zóně)',
      PassesInsideFinalThirdTotal: 'Celkový počet pokusů o přihrávky v poslední třetině (začátek a konec v poslední třetině)',
      PassesFinalThirdNoArea: 'Projde finálem, třetí (W/O Box)',
      PassesIntoOppBox: 'Úspěšné přihrávky končící v pokutovém území soupeře',
      CarriesFinalThird: 'Driblinky alespoň 7 metrů končící v ofenzivní třetině',
      CarriesInsideFinalThird: 'Driblinky alespoň 7 metrů uvnitř ofenzivní třetiny (začátek i konec ve stejné zóně)',
      CarriesFinalThirdNoBox: 'Nese poslední třetí (W/O Box)',
      CarriesIntoOppBox: 'Driblinky alespoň 7 metrů končící v pokutovém území soupeře',
      TimePossessionAgainst: 'Doba držení míče týmem soupeře',
      TimePossessionTotal: 'Celková doba držení míče obou týmů',
      PassesInBox: 'Úspěšné přihrávky ve vlastním pokutovém území',
      LongThrowInSuccessful: 'Úspěšné dlouhé vhazování z autu, delší než 20 metrů',
      LongThrowInTotal: 'Celkový počet dlouhých vhazování z autu přes 20 metrů',
      LongThrowInPct: 'Procento úspěšných dlouhých autů (20+ metrů)',
      Games: 'Odehrané hry',
      PointsPerGame: 'Body za hru',
      ExpectedPointsDiff: 'Očekávaný rozdíl bodů',
      PassesTotalOwnHalf: 'Celkový počet přihrávek z vlastní poloviny',
      PassesOwnHalf: 'Počet úspěšných přihrávek z vlastní poloviny',
      PassesTotalOppHalf: 'Celkový počet přihrávek ze soupeřovy poloviny',
      ProgressivePassesTotal: 'Celkový počet průchodů 10 a více metrů v ose X',
      DuelsWon: 'Úspěšné duely (úkoly, antény, doteky míčem, driblování a spáchané fauly)',
      NonPenaltySaves: 'Šetří kromě trestných střílení',
      BadActionsOppHalf: 'Součet všech špatných akcí spáchaných (neúspěšná přihrávka, neúspěšné převzetí, vyřazení, přihrávka do ofsajdu, neúspěšný dotek míče) na soupeřově polovině',
      CarriesSuccessful: 'Počet náběhů alespoň 7 metrů zakončených úspěšnou akcí',
      ShotsOnTargetOutBox: 'Střely na cíl z vnější strany boxu',
      TotalDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu',
      WalkingDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí nižší než 2 m/s (7,2 km/h)',
      JoggingDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí mezi 2 m/s (7,2 km/h) a 4 m/s (14,4 km/h)',
      RunningDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí mezi 4 m/s (14,4 km/h) a 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Počet krát, kdy hráč zrychluje více než 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Počet běhů dokončených rychlostí mezi 4 m/s (14,4 km/h) a 5,5 m/s (19,8 km/h)',
      DistanceIP: 'Vzdálenost (Tým v držení míče), kterou hráč urazil během zápasu s držením míče',
      DistanceOOP: 'Vzdálenost OTIP (Soupeřův tým v držení míče), kterou hráč urazil během zápasu bez držení míče',
      HsrNumber: 'Počet krát, kdy se hráč pohybuje rychlostí větší nebo rovnou 5,5 m/s (19,8 km/h), ale menší než 7 m/s (25,2 km/h) po dobu alespoň 1 sekundy',
      HsrDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí větší nebo rovnou 5,5 m/s (19,8 km/h), ale menší než 7 m/s (25,2 km/h)',
      HsrDistancePct: 'Procento vzdálenosti HSR (Běh vysokou rychlostí) ve vztahu k celkové uražené vzdálenosti',
      SprintsNumber: 'Počet krát, kdy se hráč pohybuje rychlostí větší nebo rovnou 7 m/s (25,2 km/h) po dobu alespoň 1 sekundy',
      SprintsDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí větší nebo rovnou 7 m/s (25,2 km/h)',
      SprintNumberDeclinePct: 'Procentuální pokles počtu provedených sprintů ve srovnání s druhým poločasem zápasu',
      SprintDistanceDeclinePct: 'Procentuální pokles vzdálenosti uběhnuté během sprintování ve srovnání s druhým poločasem zápasu',
      SprintNumberDecline: 'Pokles počtu provedených sprintů ve srovnání s druhým poločasem zápasu',
      SprintDistanceDecline: 'Pokles vzdálenosti uběhnuté během sprintování ve srovnání s druhým poločasem zápasu',
      SprintDistancePct: 'Procento vzdálenosti sprintů ve vztahu k celkové uražené vzdálenosti',
      Accelerations: 'Počet krát, kdy hráč zrychluje mezi 1,5 m/s<sup>2</sup> a 3 m/s<sup>2</sup>',
      ExplosiveDistance: 'Výbušná vzdálenost',
      MaxSpeed: 'Maximální rychlost dosažená hráčem',
      AvgMaxSpeed: 'Průměr maximální rychlosti dosažené hráčem',
      MaxAccelerations: 'Maximální metry/sekundu<sup>2</sup> dosažené hráčem',
      BypassedPlayersByPasses: 'Celkový počet soupeřů (obránců a záložníků) obehrán přihrávkami',
      BypassedDefendersByPasses: 'Celkový počet soupeřů (obránců) obehrán přihrávkami',
      PassesBypassingPlayers: 'Počet přihrávek, které obehrály hráče',
      PassesBypassingDefenders: 'Počet přihrávek, které obehrály obránce',
      BypassedPlayersPerPass: 'Celkový počet hráčů obehrán na přihrávky',
      BypassedDefendersPerPass: 'Celkový počet obránců obehrán na přihrávky',
      LineBreakingPasses: 'Počet dokončených přihrávek, které úspěšně proniknou jednou nebo více defenzivními liniemi',
      LineBreakingPassesMD: 'Počet dokončených přihrávek, které úspěšně proniknou liniemi záložníků a obránců',
      LineBreakingPassesM: 'Počet dokončených přihrávek, které úspěšně proniknou linií záložníků',
      LineBreakingThroughBalls: 'Počet dokončených přihrávek, které úspěšně proniknou defenzivní linií',
      LineBreakingPassesPerPass: 'Procento přihrávek prolomujících linii na přihrávku',
      TotalPassesUnderStrongPressure: 'Celkový počet přihrávek provedených pod silným tlakem (do 0-2 metrů od nejbližšího soupeře)',
      TotalPassesUnderLightPressure: 'Celkový počet přihrávek provedených pod tlakem (do 2-4 metrů od nejbližšího soupeře)',
      SuccessfulPassesUnderStrongPressure: 'Počet úspěšných přihrávek provedených pod silným tlakem (do 0-2 metrů od nejbližšího soupeře)',
      SuccessfulPassesUnderLightPressure: 'Počet úspěšných přihrávek provedených pod tlakem (do 2-4 metrů od nejbližšího soupeře)',
      PassingUnderStrongPressure: 'Procento úspěšných přihrávek a celkových přihrávek obou pod silným tlakem (do 0-2 metrů od nejbližšího soupeře)',
      PassingUnderLightPressure: 'Procento úspěšných přihrávek a celkových přihrávek obou pod tlakem (do 2-4 metrů od nejbližšího soupeře)',
      PassReceiptsInSpaceCompleted: 'Přihrávky provedené, kde je příjemce v útočné polovině a nemá obránce v poloměru 5 metrů ve směru k brance',
      PassReceiptsInSpace: 'Přihrávky obdržené v útočné polovině a není obránce v poloměru 5 metrů ve směru k brance',
      PassReceiptsInSpaceCompletedFirstThird: 'Přihrávky, kdy příjemce je v první třetině bez obránce v okruhu 5 metrů směrem k bráně',
      PassReceiptsInSpaceCompletedSecondThird: 'Přihrávky, kdy příjemce je v druhé třetině bez obránce v okruhu 5 metrů směrem k bráně',
      PassReceiptsInSpaceCompletedFinalThird: 'Přihrávky, kdy příjemce je v ofenzivní třetině bez obránce v okruhu 5 metrů směrem k bráně',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Přihrávky, kdy příjemce je na pravé polovině soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Přihrávky, kdy příjemce je uprostřed poloviny soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Přihrávky, kdy příjemce je na levé polovině soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceFirstThird: 'Převzetí míče v první třetině bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceSecondThird: 'Převzetí míče v druhé třetině bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceFinalThird: 'Převzetí míče v ofenzivní třetině bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceOppHalfRight: 'Převzetí míče na pravé polovině soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceOppHalfCenter: 'Převzetí míče ve středu poloviny soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceOppHalfLeft: 'Převzetí míče na levé polovině soupeře bez obránce v okruhu 5 metrů',
      TotalStrongOnBallPressures: 'Počet silných tlaků na míč (do 0-2 metrů od nositele míče)',
      TotalLightOnBallPressures: 'Počet tlaků na míč (do 2-4 metrů od nositele míče)',
      SuccessfulStrongOnBallPressures: 'Počet úspěšných silných tlaků na míč (do 0-2 metrů)',
      SuccessfulLightOnBallPressures: 'Počet úspěšných tlaků na míč (do 2-4 metrů)',
      StrongOnBallPressuresPct: 'Procento úspěšných a celkových silných tlaků na míč (do 0-2 metrů od nejbližšího soupeře)',
      LightOnBallPressuresPct: 'Procento úspěšných a celkových tlaků na míč (do 2-4 metrů od nejbližšího soupeře)',
      TimesBypassedByPasses: 'Celkový počet krát obehrán přihrávkou',
      TimesBypassedByCarries: 'Celkový počet krát obehrán přenášením míče',
      TimesBypassedByActions: 'Celkový počet krát obehrán přihrávkou a přenášením míče dohromady',
      BypassedPlayersByCarries: 'Celkový počet soupeřů (obránců a záložníků) obehrán přenášením míče',
      BypassedDefendersByCarries: 'Celkový počet soupeřů (obránců) obehrán přenášením míče',
      BypassedPlayersByActions: 'Celkový počet soupeřů (obránců a záložníků) obehrán přihrávkami a přenášením míče dohromady',
      BypassedDefendersByActions: 'Celkový počet soupeřů (obránců) obehrán přihrávkami a přenášením míče dohromady',
      CarriesBypassingPlayers: 'Počet přenášení míče, která obehrála hráče',
      CarriesBypassingDefenders: 'Počet přenášení míče, která obehrála obránce',
      BypassedPlayersPerCarry: 'Průměrný počet soupeřů obehrán na přenášení míče',
      BypassedDefendersPerCarry: 'Průměrný počet obránců obehrán na přenášení míče',
      LineBreakingCarries: 'Počet přenášení míče, která úspěšně proniknou jednou nebo více defenzivními liniemi',
      LineBreakingCarriesMD: 'Počet přenášení míče, která úspěšně proniknou liniemi záložníků a obránců',
      LineBreakingCarriesM: 'Počet přenášení míče, která úspěšně proniknou linií záložníků',
      LineBreakingCarriesD: 'Počet přenášení míče, která úspěšně proniknou defenzivní linií',
      LineBreakingCarriesPerCarry: 'Procento přenášení míče prolomujících linii na přenášení míče',
      LineBreakingActions: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou jednou nebo více defenzivními liniemi',
      LineBreakingActionsMD: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou liniemi záložníků a obránců',
      LineBreakingActionsM: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou linií záložníků',
      LineBreakingActionsD: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou defenzivní linií',
      PassesPerLineBreakingPass: 'Poměr mezi celkovým počtem přihrávek na přihrávku prolomující linii',
      CarriesPerLineBreakingCarry: 'Poměr mezi celkovým počtem přenášení míče na přenášení míče prolomující linii',
      LinesBrokenByPasses: 'Celkový počet linií prolomených přihrávkami',
      LinesBrokenByCarries: 'Celkový počet linií prolomených přenášením míče',
      LinesBrokenByActions: 'Celkový počet linií prolomených přihrávkami a přenášením míče dohromady',
      LinesBrokenPerPass: 'Poměr mezi celkovým počtem linií prolomených na přihrávku',
      LinesBrokenPerCarry: 'Poměr mezi celkovým počtem linií prolomených na přenášení míče',
      AvgLastDefenderDistanceIP: 'Vzdálenost mezi posledním obráncem (nejblíže k vlastní brance) a brankovou čárou v držení míče',
      AvgLastDefenderDistanceOOP: 'Vzdálenost mezi posledním obráncem (nejblíže k vlastní brance) a brankovou čárou bez držení míče',
      AvgDefensiveLineDistanceIP: 'Vzdálenost mezi pozicí nejhlubší defenzivní linie a brankou v držení míče',
      AvgDefensiveLineDistanceOOP: 'Vzdálenost mezi pozicí nejhlubší defenzivní linie a brankou bez držení míče',
      AvgRBDistanceIP: 'Vzdálenost od pravého obránce k jejich vlastní brance v držení míče',
      AvgRBDistanceOOP: 'Vzdálenost od pravého obránce k jejich vlastní brance bez držení míče',
      AvgLBDistanceIP: 'Vzdálenost od levého obránce k jejich vlastní brance v držení míče',
      AvgLBDistanceOOP: 'Vzdálenost od levého obránce k jejich vlastní brance bez držení míče',
      AvgBlockDistanceIP: 'Vzdálenost mezi nejhlubším a nejpokročilejším hráčem v poli v držení míče',
      AvgBlockDistanceOOP: 'Vzdálenost mezi nejhlubším a nejpokročilejším hráčem v poli bez držení míče',
      AvgBlockAreaIP: 'Oblast ohraničujícího boxu obklopujícího všechny hráče v poli (míra toho, kolik prostoru tým zabírá) v držení míče',
      AvgBlockAreaOOP: 'Oblast ohraničujícího boxu obklopujícího všechny hráče v poli (míra toho, kolik prostoru tým zabírá) bez držení míče',
      AvgDefensiveLineWidthOOP: 'Šířka nejzadnější linie hráčů (nejdále od jejich vlastní branky) bez držení míče',
      AvgOffensiveLineLastThirdWidthIP: 'Horizontální šířka útočné linie v poslední třetině v držení míče',
      AvgLByIP: 'Pozice levého obránce v držení míče',
      AvgRByIP: 'Pozice pravého obránce v držení míče',
      AvgOffensiveLineDistanceIP: 'Vzdálenost mezi vlastní brankou a útočnou linií v držení míče',
      AvgOffensiveLineLastThirdDistanceIP: 'Vzdálenost mezi vlastní brankou a útočnou linií v poslední třetině v držení míče',
      AvgOffensiveLineWidthIP: 'Horizontální šířka útočné linie v držení míče',
      OffBallRuns: 'Záměrné pohyby bez míče (běhy) na podporu útočné fáze',
      OffBallRunsOverlap: 'Běhy, kde se hráč pohybuje kolem vnější strany spoluhráče (blíže k postranní čáře), zatímco tento spoluhráč má míč',
      OffBallRunsUnderlap: 'Běhy, kde se hráč pohybuje uvnitř spoluhráče, berouc vnitřní trasu (blíže ke středu hřiště)',
      OffBallRunsRunAhead: 'Běh vpřed, který jde za nositele míče, ale zůstává před posledním obráncem',
      OffBallRunsRunBehind: 'Běh vpřed, který proniká do poslední defenzivní linie, dostává se mezi obránce a brankáře',
      OffBallRunsCrossReceiver: 'Hráč běží do pokutového území a pozicuje se, aby přijal centr od spoluhráče',
      OffBallRunsSupport: 'Hráč běží, aby se zarovnal s nositelem míče, nabízeje blízkou možnost přihrávky v útoku',
      OffBallRunsComingShort: 'Hráč se pohybuje směrem k nositeli míče, aby nabídl blízkou podporu nebo možnost přihrávky od branky',
      AerialsOppHalf: 'Úspěšné vzdušné souboje v soupeřově polovině',
      CarriesIntoFinalThird: 'Potrubí o délce nejméně 7 metrů zvenčí dovnitř poslední třetiny',
      SpeedScore: 'Fyzický výkon hráče na základě různých metrik rychlosti',
      EnduranceScore: 'Vytrvalostní fyzický výkon hráče na základě různých metrik',
      SwitchPlaySuccessful: 'Počet dokončených přihrávek nad 32 metrů, kdy je boční posunutí míče větší než jeho posunutí směrem k soupeřově brance',
      SwitchPlayTotal: 'Celkový počet pokusů o přihrávky nad 32 metrů, kde je boční posunutí míče větší než jeho posunutí směrem k soupeřově brance',
      PassesInsideOppHalf: 'Celkový počet přihrávek, které začínají a končí v polovině soupeře',
      PassesInsideOppHalfSuccessful: 'Počet dokončených přihrávek, které začínají i končí v polovině soupeře',
      TacklesAttemptedFirstThird: 'Celkový počet pokusů o zákroky v první třetině hřiště',
      TacklesAttemptedSecondThird: 'Celkový počet pokusů o zákroky ve druhé třetině hřiště',
      TacklesFirstThird: 'Počet úspěšných zákroků v první třetině hřiště',
      TacklesSecondThird: 'Počet úspěšných zákroků ve druhé třetině hřiště',
      FoulsOwnHalf: 'Počet faulů spáchaných na vlastní polovině hráče',
      TouchesOppHalf: 'Počet doteků míče na soupeřově polovině',
      TacklesAttemptedNotAdjusted: 'Celkový počet pokusů o útok bez úpravy držení míče',
      TacklesSuccessfulNotAdjusted: 'Celkový počet úspěšných soubojů bez úpravy držení míče',
      AvgTop5MaxSpeed: 'Průměr pěti nejvyšších maximálních rychlostí hráče',
      LBPReceived: 'Počet přijatých průchodů pro přerušení řádku. Jedná se o dokončené přihrávky, které posouvají míč alespoň o 10 % blíže k brance soupeře a protínají dvojici obránců v těsné blízkosti nebo cestují za obrannou linii.',
      LBPMReceived: 'Počet obdržených přihrávek, které prorazily středovou linii soupeře',
      LBPMDReceived: 'Počet obdržených přihrávek, které prorazí jak středem zálohy soupeře, tak i obrannými řadami',
      ThroughBallReceived: 'Počet obdržených přihrávek, které prolomí poslední obrannou linii soupeře',
      HsrDistanceIP: 'Vzdálenost ve sprintu >21 km/h v držení',
      HsrDistanceOOP: 'Vzdálenost ve sprintu >21 km/h mimo držení',
      JoggingDistanceIP: 'Jogging vzdálenost v držení',
      JoggingDistanceOOP: 'Vzdálenost běhu z držení',
      RunningDistanceIP: 'Běžecká vzdálenost v držení',
      RunningDistanceOOP: 'Běžící vzdálenost z držení',
      SprintsDistanceIP: 'Vzdálenost ve sprintu >24 km/h v držení',
      SprintsDistanceOOP: 'Vzdálenost sprintu >24 km/h mimo držení',
      WalkingDistanceIP: 'Docházková vzdálenost v držení',
      WalkingDistanceOOP: 'Pěší vzdálenost mimo držení',
      RunningNumberIP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second with possession',
      RunningNumberOOP: 'Number of times that the Player is moving at a speed between 4 m/s (14.4 km/h) and 5.5 m/s (19.8 km/h) for a time period of at least 1 second without possession',
      RunningDistancePctIP: 'Percentage of Running Distance with respect to total distance travelled with possession',
      RunningDistancePctOOP: 'Percentage of Running Distance with respect to total distance travelled without possession',
      RunningDistancePct: 'Percentage of Running Distance with respect to total distance travelled',
      HsrNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      HsrNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 5.5 m/s (19.8 km/h) but less than 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsNumberIP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second with possession',
      SprintsNumberOOP: 'Number of times that the Player is moving at a speed that is greater than or equal to 7 m/s (25.2 km/h) for a time period of at least 1 second without possession',
      SprintsDistancePctIP: 'Percentage of Sprint Distance with respect to total distance travelled with possession',
      SprintsDistancePctOOP: 'Percentage of Sprint Distance with respect to total distance travelled without possession',
      SprintsDistancePct: 'Percentage of Sprint Distance with respect to total distance travelled',
      PossessionRegain: 'Kolikrát přinutíte soupeře ztratit držení',
      HandPassesSuccessful: 'Úspěšné přihrávky rukama (brankáři nebo vhazování při standardce)',
      HandPassesTotal: 'Celkový počet přihrávek rukama (brankáři nebo vhazování při standardce)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player'
    },
    subtitles: {
      Possession: 'Procento držení míče týmu',
      TimePossession: 'Čas držení míče týmu',
      PassesPerShots: 'Průměrný počet přihrávek na střelu',
      PPDA: 'Tlak, který tým vyvíjí na soupeřovy hráče, když mají držení míče',
      Directness: 'Vyšší množství přihrávek vpřed ve srovnání s přihrávkami do stran',
      ExpectedPoints: 'Počet bodů očekávaných týmem, vypočítaný na základě očekávaných gólů',
      PassesPerLongBall: 'Procento úspěšných dlouhých přihrávek z celkového počtu dokončených přihrávek',
      CrossingPerXG: 'Procento očekávaných gólů pocházejících z center',
      PenaltySavedPenaltyFaced: 'Procento zachráněných penalty střel ze všech obdržených penalty střel',
      Goals: 'Počet gólů vstřelených',
      PenaltyShots: 'Celkový počet střel z penalty',
      PenaltyGoals: 'Celkový počet gólů z penalty',
      NonPenaltyGoals: 'Góly (kromě penalty)',
      AerialWins: 'Vítězství ve vzdušných soubojích',
      AerialEfficiency: 'Metrika, která kombinuje vítězství ve vzdušných soubojích s celkovým počtem vzdušných soubojů',
      AerialWinsPct: 'Procento vítězství ve vzdušných soubojích',
      Assists: 'Asistence',
      Catching: 'Procento zásahů, při kterých brankář chytí míč',
      Caught: 'Šetří tam, kde brankář chytí a drží míč, čímž zabrání jakékoli druhé hře',
      ChancesCreated: 'Počet přihrávek vedoucích ke střele',
      ClaimAccuracy: 'Míče vyběhnuté nad průměrem',
      CompletedCrosses: 'Centry úspěšně dokončené',
      Crossing: 'Procento úspěšných center',
      Dispossessed: 'Ztráty míče',
      Finishing: 'Procento střel končících gólem',
      xGEfficiency: 'Množství očekávaných gólů potřebných pro hráče, aby vstřelil gól',
      Fouls: 'Fauly spáchané',
      DeepProgression: 'Počet krát, kdy je dosaženo poslední pětiny hřiště přenášením míče, plus počet krát, kdy je držení míče v poslední pětině',
      DeepProgressionFinalThird: 'Krát, kdy má hráč držení míče ve finální třetině',
      FoulsTaken: 'Obdržené fauly',
      IndividualPressure: 'Úspěšné snahy (znovuzískání míče)',
      Interceptions: 'Zachycení míče',
      LongBallPct: 'Procento dokončených přihrávek alespoň 32 metrů',
      LongBallTotal: 'Celkový počet přejezdů nad 32 metrů',
      LongBallSuccessful: 'Dokončené přihrávky alespoň 32 metrů',
      NPGOpenPlay: 'Góly (kromě penalty) otevřenou hrou',
      NPGSetPiece: 'Góly (kromě penalty) standardními situacemi',
      OpenPlayKeyPasses: 'Přihrávky končící střelou (kromě asistencí) v otevřené hře',
      OpenPlayKeyPassesInTeam: 'Procento přihrávek končících střelou (kromě asistencí) v otevřené hře v týmu',
      PassingFinalThird: 'Úspěšné přihrávky do finální třetiny',
      PassesFinalThirdTotal: 'Celkový počet pokusů o přihrávky, s výjimkou křížků, standardek, rohů a vhazování, které končí v poslední třetině',
      PassingFinalThirdPct: 'Procento úspěšných přihrávek ve finální třetině',
      PassingOppHalfPct: 'Procento úspěšných přihrávek do soupeřovy poloviny',
      PassingOwnHalfPct: 'Procento úspěšných přihrávek do vlastní poloviny',
      PassingPct: 'Procento úspěšných přihrávek',
      Recoveries: 'Znovuzískání míče (skluzy nebo zachycení)',
      SavesInBoxPct: 'Procento zásahů ze střel v pokutovém území',
      SavesOutOfBoxPct: 'Procento zásahů ze střel mimo pokutové území',
      SavesPct: 'Procento zásahů',
      ScoringContribution: 'Počet asistencí a gólů',
      xAssistsOpenPlay: 'Počet očekávaných asistencí vygenerovaných otevřenou hrou',
      xAssistsSetPiece: 'Počet očekávaných asistencí vygenerovaných standardními situacemi',
      xAssistsOpenPlayInTeam: 'Počet očekávaných asistencí vygenerovaných otevřenou hrou v týmu',
      xAssistsSetPieceInTeam: 'Počet očekávaných asistencí vygenerovaných standardními situacemi v týmu',
      xGChainFinalThird: 'Množství xG, kterého se hráč zúčastnil ve finální třetině',
      xGBuildupFinalThird: 'Množství xG, kterého se hráč zúčastnil ve finální třetině (kromě střel a přihrávek vedoucích ke střele)',
      BallProgressionPassing: 'Počet krát, kdy hráč posune míč o 10 metrů nebo více přihrávkou',
      BallProgressionDribbling: 'Počet krát, kdy hráč posune míč o 10 metrů nebo více přenášením míče',
      Shooting: 'Procento střel (kromě penalty) na branku',
      Shots: 'Počet střel',
      ShotsPerGoal: 'Průměrný počet střel potřebných pro vstřelení gólu',
      SuccessfulDribbles: 'Úspěšné dryblinky',
      TacklesSuccessful: 'Celkový počet skluzů',
      TacklesWasDribbled: 'Procento soubojů vyhraných skluzem',
      ThroughBalls: 'Počet přihrávek prolomujících defenzivní linii',
      TouchesInOpponentBox: 'Počet kontrol míče v soupeřově pokutovém území',
      xAssists: 'Očekávané asistence vygenerované',
      xG: 'Očekávané góly vygenerované',
      xGDiff: 'Rozdíl mezi xG a Góly',
      xGOpenPlay: 'Očekávané góly vygenerované otevřenou hrou',
      xGSetPiece: 'Očekávané góly vygenerované standardními situacemi',
      xGBuildup: 'Zapojení do xG Build Up',
      xGBuildupInTeam: 'Zapojení do xG Build Up v týmu',
      BallProgression: 'Postupy přihrávkou nebo přenášením míče alespoň 10 metrů',
      xGChain: 'Zapojení do xG Chain',
      xGPerNPG: 'Očekávané góly potřebné pro vstřelení gólu bez penalty',
      xGPerShot: 'Průměrné xG na střelu',
      xGSavedPerShot: 'Průměrné zachráněné xG na obdrženou střelu',
      xGSavedPerXGFacedOnTarget: 'Průměrné zachráněné xG na obdržené xG na branku',
      xGFacedOnTargetPerGoalReceived: 'Očekávané góly potřebné pro vstřelení gólu určitému brankáři',
      xGFacedOnTargetEfficiency: 'Počet gólů bez penalty zabráněných brankářem',
      xGFacedOnTarget: 'Celkové xG (zachráněné a vstřelené) obdržené brankářem',
      HighTurnovers: 'Ztráty míče blíže než 40 metrů od vlastní branky',
      OpenPlayPassesIntoOpponentBox: 'Celkem přihrávek otevřená hra do soupeřova pokutového území',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'Dokončené přihrávky otevřená hra do soupeřova pokutového území',
      ChancesCreatedOP: 'Počet přihrávek vedoucích ke střele během otevřené hry',
      PenaltiesTaken: 'Počet krát, kdy byl hráč faulován v soupeřově pokutovém území',
      BlockedCrosses: 'Centry zablokované',
      BlockedShots: 'Střely zablokované',
      NonPenaltyGoalsAgainst: 'Počet obdržených gólů bez penalty',
      Headers: 'Počet střel provedených hlavou',
      AveragePassDistance: 'Průměrná vzdálenost přihrávek v metrech',
      ProgressiveRuns: 'Úspěšná přenášení míče, která přiblíží držení míče o 20% k soupeřově brance',
      xT: 'Hrozba vygenerovaná pohybem míče do nebezpečných oblastí',
      xTOpenPlay: 'Očekávaná hrozba vygenerovaná během otevřené hry',
      xTSetPiece: 'Očekávaná hrozba vygenerovaná standardními situacemi',
      xGOT: 'Počet očekávaných gólů obdržených brankářem',
      BadActions: 'Součet všech špatných akcí',
      BadActionsOwnHalf: 'Součet všech špatných akcí ve vlastní polovině',
      AerialsWonOwnBox: 'Vítězství ve vzdušných soubojích vlastní pokutové území',
      AerialsWonOppBox: 'Vítězství ve vzdušných soubojích soupeřovo pokutové území',
      AerialsTotalOppBox: 'Celkem vzdušných soubojů soupeřovo pokutové území',
      AerialsTotalOwnBox: 'Celkem vzdušných soubojů vlastní pokutové území',
      FoulsOwnHalfPct: 'Procento faulů spáchaných ve vlastní polovině',
      RecoveriesOppHalf: 'Počet míčů znovuzískaných hráčem v soupeřově polovině',
      DuelsPct: 'Procento úspěšných soubojů',
      TacklesUnsuccessful: 'Počet krát, kdy hráč neuspěje ve znovuzískání míče, když ho soupeř úspěšně obehrává',
      TacklesWasDribbledFirstThird: 'Procento krát, kdy hráč znovuzíská míč, když je konfrontován ve finální třetině',
      TacklesWasDribbledSecondThird: 'Vyhrané obranné souboje 1 na 1 druhá třetina',
      TacklesWasDribbledFinalThird: 'Vyhrané obranné souboje 1 na 1 finální třetina',
      BallProgressionFinalThird: 'Počet krát, kdy hráč postoupí o 10 nebo více metrů ve finální třetině',
      DuelsTotal: 'Celkový počet skluzů, vzdušných soubojů, dotyků míče, dryblinků a faulů spáchaných',
      QuickRecoveries: 'Znovuzískání míče 40 metrů nebo více od vlastní branky provedené 8 sekund po ztrátě držení míče',
      ShotsPerNPG: 'Průměrný počet střel pro vstřelení gólu bez penalty',
      ShotsOutBox: 'Počet střel zvenku pokutového území',
      GoalsOutBox: 'Počet gólů zvenku pokutového území',
      ShootingOutBox: 'Procento střel na branku zvenku pokutového území',
      HandPassing: 'Přesnost přihrávek rukou',
      ShotEndingHighTurnovers: 'Vysoké ztráty míče (ztráty míče blíže než 40 metrů od vlastní branky) končící střelou soupeřova týmu',
      GoalEndingHighTurnovers: 'Vysoké ztráty míče (ztráty míče blíže než 40 metrů od vlastní branky) končící gólem soupeřova týmu',
      AverageCarriesProgress: 'Průměrná vzdálenost, kterou hráč posune míč vertikálně na přenášení míče (metry)',
      ChanceEndingCarries: 'Přenášení míče alespoň 7 metrů končící přihrávkou, která je následována střelou',
      AssistEndingCarries: 'Přenášení míče alespoň 7 metrů končící přihrávkou, která je následována gólem',
      ShotEndingCarries: 'Přenášení míče alespoň 7 metrů končící střelou',
      GoalEndingCarries: 'Přenášení míče alespoň 7 metrů končící gólem',
      ShotEndingSequence: 'Počet sekvencí končících střelou, kde byl hráč zapojen',
      GoalEndingSequence: 'Počet sekvencí končících gólem, kde byl hráč zapojen',
      AerialWonOffensive: 'Vítězství ve vzdušných soubojích útočné',
      AerialWonDefensive: 'Vítězství ve vzdušných soubojích defenzivní',
      xGAgainst: 'Obdržené očekávané góly',
      xGDiffAgainst: 'Rozdíl mezi obdrženými očekávanými góly a obdrženými góly',
      xGPerNPGAgainst: 'Obdržené očekávané góly na obdržený gól bez penalty',
      xGOpenPlayAgainst: 'Obdržené očekávané góly vygenerované otevřenou hrou',
      xGSetPieceAgainst: 'Obdržené očekávané góly vygenerované standardními situacemi',
      xGPerShotAgainst: 'Obdržené očekávané góly na obdrženou střelu',
      ShotsAgainst: 'Obdržené střely',
      ShotsOnTargetAgainst: 'Obdržené střely na branku',
      RivalPossession: 'Držení míče soupeře',
      AerialDefensivePct: 'Procento vítězství ve vzdušných soubojích bez držení míče',
      HighRecoveries: 'Znovuzískání míče provedená 40 metrů blízko soupeřovy branky',
      HighDefensiveActions: 'Defenzivní akce (Skluzy, Zachycení, Bloky, Fauly a 1vs1) provedené 40 metrů nad vlastní základní čárou',
      HighDefensiveActionPct: 'Procento defenzivních akcí (Skluzy, Zachycení, Bloky, Fauly a 1vs1) provedených 40 metrů nad vlastní základní čárou',
      HighDefensiveDistance: 'Průměrná vzdálenost od vlastní branky všech defenzivních akcí',
      PassesPerPossession: 'Počet přihrávek na držení míče',
      LengthPerPossession: 'Vzdálenost na držení míče',
      xTNet: 'Čisté xT',
      AvgCarriesDistance: 'Průměrná vzdálenost přenášení míče',
      PassesForwardPct: '% Přihrávky vpřed',
      PassesForwardSuccessful: 'Úspěšné předání',
      PassesForwardTotal: 'Celkový počet dopředných průjezdů',
      TacklesAttempted: 'Pokusy o skluzy',
      DuelsLost: 'Prohrané souboje',
      Carries: 'Přenášení míče',
      CarriesPct: '% Přenášení míče',
      Aerials: 'Celkový počet vzdušných soubojů',
      ProgressivePassesReceivedIntoBox: 'Progresivní přihrávky obdržené do pokutového území',
      PassesOppHalf: 'Úspěšné přihrávky končící v soupeřově polovině',
      LongBallReceived: 'Počet dlouhých přihrávek (>32 metrů) obdržených',
      ShotsOnTarget: 'Střely na branku',
      AggressiveActions: 'Počet pokusů o skluzy v následujících dvou sekundách po ztrátě držení míče',
      Crosses: 'Celkový počet center',
      xGBuildup5pass: 'Množství xG, kterého se hráč zúčastnil, pouze posledních 5 přihrávek (kromě střel a přihrávek vedoucích ke střele)',
      DefensiveDistance: 'Průměrná vzdálenost k vlastní brance provedených defenzivních soubojů',
      SpeedSequence: 'Průměrná rychlost (metry uražené za čas strávený) všech držení míče týmu',
      Touches: 'Počet krát, kdy má hráč držení míče',
      AerialsTotalOppHalf: 'Celkem vzdušných soubojů v soupeřově polovině',
      AerialsWonOppHalf: 'Letecké souboje úspěšné na polovinu soupeře',
      AerialsWonOppHalfPct: 'Procento vítězství ve vzdušných soubojích v soupeřově polovině',
      AerialsPctOppBox: 'Procento vítězství ve vzdušných soubojích v soupeřově pokutovém území',
      AerialsPctOwnBox: 'Procento vítězství ve vzdušných soubojích ve vlastním pokutovém území',
      AerialDefensive: 'Celkový počet vzdušných soubojů, když soupeřův tým má držení míče',
      AerialOffensive: 'Celkový počet vzdušných soubojů, když vlastní tým má držení míče',
      AerialOffensivePct: 'Procento vítězství ve vzdušných soubojích, když vlastní tým má držení míče',
      IndividualPressureOppHalf: 'Znovuzískání míče hráčem při presingu soupeře v soupeřově polovině',
      TouchesPerShot: 'Počet krát, kdy hráči dotknou míče na střelu',
      PassesFinalThirdTotalPct: 'Procento přihrávek (úspěšných i neúspěšných) do finální třetiny',
      xACrosses: 'Očekávané asistence vygenerované z center',
      Passes: 'Celkový počet přihrávek',
      PassesSuccessful: 'Počet dokončených přihrávek',
      TacklesWasDribbledFouls: 'Procento vyhraných skluzů ve vztahu k celkovým skluzům a spáchaným faulům',
      OffsidesCaught: 'Chycené ofsajdy',
      ProgressivePassesReceivedFinalThird: 'Progresivní přihrávky obdržené finální třetina',
      ProgressivePassesReceived: 'Progresivní přihrávky obdržené',
      Breadth: 'Součet skluzů, výzev, zachycení a spáchaných faulů na stranách hřiště',
      DuelsDefTotal: 'Součet celkových skluzů, defenzivních vzdušných soubojů a spáchaných faulů',
      DefensiveActions: 'Defenzivní akce, když soupeř zkouší dryblink (Skluzy, Výzvy a Fauly)',
      ProgressivePassesReceivedOppHalf: 'Progresivní přihrávky obdržené soupeřova polovina',
      CompletedCrossesOP: 'Dokončené centry otevřená hra',
      CrossingOP: 'Procento center dokončených ze všech pokusů o centr otevřená hra',
      CrossesOP: 'Celkový počet křížků během otevřené hry',
      PassingContribution: 'Procento, které měří hrozbu přihrávek s ohledem na pozici příjemce',
      BallProgressionOppHalfInTeam: '% Postup míče v soupeřově polovině v týmu',
      PassesOPIntoBoxInTeam: '% Přihrávky otevřená hra do pokutového území v týmu',
      TouchesOppBoxInTeam: '% Dotyků soupeřovo pokutové území v týmu',
      xGOPInTeam: '% xG otevřená hra v týmu',
      DeepPasses: 'Přihrávky zvenku 20metrového poloměru soupeřovy branky, které končí uvnitř této oblasti',
      DeepPassesTotal: 'Celkový počet pokusů o přihrávky z vnějšku 20metrového okruhu soupeřovy branky, které končí uvnitř tohoto prostoru',
      DefensiveDuelsPct: 'Procento vyhraných defenzivních soubojů z celkových defenzivních soubojů',
      QuickRecoveriesPct: 'Procento rychlých znovuzískání míče k zachycení a pokusům o skluzy',
      DiffDefensiveDistanceTeam: 'Rozdíl mezi defenzivní vzdáleností hráče a defenzivní vzdáleností jeho týmu',
      xTPassing: 'Očekávaná hrozba vygenerovaná pouze z přihrávek',
      xTPassing100Passes: 'Očekávaná hrozba vygenerovaná pouze z přihrávek a na 100 přihrávek',
      ProgressivePassesAccurate: 'Dokončené přihrávky 10 metrů nebo více na ose X',
      PassAbility: 'Poměr dokončených přihrávek k očekávaným přihrávkám (xP)',
      OPPassesIntoOppBoxPct: 'Procento dokončených přihrávek otevřená hra do soupeřova pokutového území a pokusů o přihrávky otevřená hra do soupeřova pokutového území',
      EntriesOppBox: 'Počet přihrávek a přenášení míče do soupeřova pokutového území',
      Crosses6yardBox: 'Celkový počet center končících v šestnáctce',
      Cutbacks: 'Přihrávky ze základní čáry zpět a dovnitř soupeřova pokutového území',
      xTDribbling: 'Očekávaná hrozba vygenerovaná pouze z dryblinků',
      AvgShotDistance: 'Průměrná vzdálenost celkového počtu provedených střel',
      xGOnTarget: 'Očekávané góly ze střel na branku',
      FinishingxGOT: 'Procento střel na branku končících gólem nad průměrem',
      DribblesWonOwnHalf: 'Úspěšné dryblinky provedené ve vlastní polovině',
      DribblesOwnHalf: 'Počet pokusů o dryblink provedených ve vlastní polovině',
      DribblesOwnHalfPct: 'Procento úspěšných dryblinků a pokusů o dryblink provedených ve vlastní polovině',
      DribblesWonOppHalf: 'Úspěšné dryblinky provedené v soupeřově polovině',
      DribblesOppHalf: 'Počet pokusů o dryblink provedených v soupeřově polovině',
      DribblesOppHalfPct: 'Procento úspěšných dryblinků a pokusů o dryblink provedených v soupeřově polovině',
      DribblesWonFinalThird: 'Úspěšné dryblinky provedené ve finální třetině',
      DribblesFinalThird: 'Počet pokusů o dryblink provedených ve finální třetině',
      DribblesFinalThirdPct: 'Procento úspěšných dryblinků a pokusů o dryblink provedených ve finální třetině',
      ShotEndingHighRecoveries: 'Vysoká znovuzískání míče (znovuzískání míče provedená 40 metrů nebo blíže k soupeřově brance) končící střelou',
      PassingFinalThirdAgainst: 'Úspěšné přihrávky od soupeře do finální třetiny',
      OpenPlayPassesIntoOpponentBoxAgainst: 'Celkový počet pokusů o přihrávky od soupeře do vlastního pokutového území během otevřené hry',
      EntriesOppBoxAgainst: 'Počet přihrávek a přenášení míče od soupeře do vlastního pokutového území',
      DeepProgressionAgainst: 'Počet krát, kdy soupeř dosáhne poslední pětiny hřiště přenášením míče, plus počet krát, kdy je držení míče v první pětině',
      TouchesInOpponentBoxAgainst: 'Počet krát, kdy má soupeř držení míče v našem pokutovém území',
      Score: 'Výkon hráče založený na různých metrikách',
      PDScore: 'Fyzický výkon hráče založený na různých fyzických metrikách',
      OrlegiScore: 'Skóre Orlegi',
      SirScore: 'Skóre Sirius',
      ExcScore: 'Výkon hráče založený na různých metrikách',
      xTOPInTeam: 'Očekávaná hrozba vygenerovaná během otevřené hry v týmu',
      YellowCards: 'Obdržené žluté karty',
      RedCards: 'Obdržené červené karty',
      xTOpenPlayAgainst: 'Obdržená očekávaná hrozba během otevřené hry',
      xTSetPieceAgainst: 'Obdržená očekávaná hrozba standardními situacemi',
      NPGOpenPlayAgainst: 'Počet obdržených gólů bez penalty otevřenou hrou',
      NPGSetPieceAgainst: 'Počet obdržených gólů bez penalty standardními situacemi',
      PassesOppHalfPerPossession: 'Přihrávky soupeřova polovina na držení míče',
      AverageTimeRecovery: 'Průměrný čas znovuzískání',
      ExpectedPassing: 'Procento přihrávek, které měly být dokončeny',
      NumPossession10Passes: 'Držení míče vygenerovaná 10 nebo více přihrávkami',
      PassesReceived: 'Obdržené přihrávky',
      PassesReceivedFinalThird: 'Obdržené přihrávky finální třetina',
      ProgressivePassesTotalPct: 'Procento progresivních přihrávek',
      ShortPassesPct: 'Procento krátkých přihrávek',
      TouchesOppBoxOppTeam: 'Počet soupeřových akcí obdržených uvnitř vlastního pokutového území, když je hráč na hřišti',
      ShotsOnTargetOppTeam: 'Střely na branku obdržené, když je hráč na hřišti',
      NPGOppTeam: 'Góly bez penalty obdržené, když je hráč na hřišti',
      xGSetPiecePerxG: 'Očekávané góly vygenerované standardními situacemi potřebné pro vygenerování jednoho očekávaného gólu',
      ShotsOpenPlay: 'Počet střel vygenerovaných otevřenou hrou',
      ShotsOpenPlayAgainst: 'Počet střel obdržených otevřenou hrou',
      ShotsFromDribble: 'Střely provedené po obdriblování soupeře',
      GoalsFromDribble: 'Góly vstřelené po obdriblování soupeře',
      PassesIntoFinalThird: 'Úspěšné přihrávky z ofenzivní třetiny',
      PassesIntoFinalThirdTotal: 'Celkový počet pokusů o přihrávky, které začínají venku a končí v poslední třetině',
      PassesInsideFinalThird: 'Úspěšné přihrávky uvnitř ofenzivní třetiny (začátek i konec v téže zóně)',
      PassesInsideFinalThirdTotal: 'Celkový počet pokusů o přihrávky v poslední třetině (začátek a konec v poslední třetině)',
      PassesFinalThirdNoArea: 'Projde finálem, třetí (W/O Box)',
      PassesIntoOppBox: 'Úspěšné přihrávky končící v pokutovém území soupeře',
      CarriesFinalThird: 'Driblinky alespoň 7 metrů končící v ofenzivní třetině',
      CarriesInsideFinalThird: 'Driblinky alespoň 7 metrů uvnitř ofenzivní třetiny (začátek i konec ve stejné zóně)',
      CarriesFinalThirdNoBox: 'Nese poslední třetí (W/O Box)',
      CarriesIntoOppBox: 'Driblinky alespoň 7 metrů končící v pokutovém území soupeře',
      TimePossessionAgainst: 'Doba držení míče týmem soupeře',
      TimePossessionTotal: 'Celková doba držení míče obou týmů',
      PassesInBox: 'Úspěšné přihrávky ve vlastním pokutovém území',
      LongThrowInSuccessful: 'Úspěšné dlouhé vhazování z autu, delší než 20 metrů',
      LongThrowInTotal: 'Celkový počet dlouhých vhazování z autu přes 20 metrů',
      LongThrowInPct: 'Procento úspěšných dlouhých autů (20+ metrů)',
      Games: 'Odehrané hry',
      PointsPerGame: 'Body za hru',
      ExpectedPointsDiff: 'Očekávaný rozdíl bodů',
      PassesTotalOwnHalf: 'Celkový počet přihrávek z vlastní poloviny',
      PassesOwnHalf: 'Počet úspěšných přihrávek z vlastní poloviny',
      PassesTotalOppHalf: 'Celkový počet přihrávek ze soupeřovy poloviny',
      ProgressivePassesTotal: 'Celkový počet průchodů 10 a více metrů v ose X',
      DuelsWon: 'Úspěšné duely (úkoly, antény, doteky míčem, driblování a spáchané fauly)',
      NonPenaltySaves: 'Šetří kromě trestných střílení',
      BadActionsOppHalf: 'Součet všech špatných akcí spáchaných na soupeřově polovině',
      CarriesSuccessful: 'Počet náběhů alespoň 7 metrů zakončených úspěšnou akcí',
      ShotsOnTargetOutBox: 'Střely na cíl z vnější strany boxu',
      TotalDistance: 'Celková vzdálenost',
      WalkingDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí nižší než 2 m/s (7,2 km/h)',
      JoggingDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí mezi 2 m/s (7,2 km/h) a 4 m/s (14,4 km/h)',
      RunningDistance: 'Celková vzdálenost, kterou hráč urazil během zápasu rychlostí mezi 4 m/s (14,4 km/h) a 5,5 m/s (19,8 km/h)',
      ExtremeAccelerations: 'Počet krát, kdy hráč zrychluje více než 3 m/s<sup>2</sup>',
      NumberOfRuns: 'Počet běhů dokončených rychlostí mezi 14,4 km/h a 19,8 km/h',
      HsrDistance: 'Vzdálenost běhu vysokou rychlostí > 19,8 km/h',
      HsrNumber: 'Množství běhů vysokou rychlostí > 19,8 km/h',
      HsrDistancePct: '% Vzdálenost běhu vysokou rychlostí',
      SprintsNumber: 'Množství sprintů > 25,2 km/h',
      SprintsDistance: 'Vzdálenost sprintů > 25,2 km/h',
      SprintNumberDeclinePct: '% Pokles množství sprintů',
      SprintDistanceDeclinePct: '% Pokles vzdálenosti sprintů',
      SprintNumberDecline: 'Pokles počtu sprintů ve srovnání s druhým poločasem',
      SprintDistanceDecline: 'Pokles vzdálenosti uběhnuté během sprintování ve srovnání s druhým poločasem',
      SprintDistancePct: '% Vzdálenost sprintů',
      Accelerations: 'Množství zrychlení',
      MaxSpeed: 'Max. rychlost',
      AvgMaxSpeed: 'Průměr maximální rychlosti dosažené hráčem',
      MaxAccelerations: 'Maximální metry/sekundu<sup>2</sup> dosažené hráčem',
      BypassedPlayersByPasses: 'Celkový počet soupeřů (obránců a záložníků) obehrán přihrávkami',
      BypassedDefendersByPasses: 'Celkový počet soupeřů (obránců) obehrán přihrávkami',
      PassesBypassingPlayers: 'Počet přihrávek, které obehrály hráče',
      PassesBypassingDefenders: 'Počet přihrávek, které obehrály obránce',
      BypassedPlayersPerPass: 'Celkový počet hráčů obehrán na přihrávky',
      BypassedDefendersPerPass: 'Celkový počet obránců obehrán na přihrávky',
      LineBreakingPasses: 'Počet přihrávek, které úspěšně proniknou jednou nebo více defenzivními liniemi',
      LineBreakingPassesMD: 'Počet přihrávek, které úspěšně proniknou liniemi záložníků a obránců',
      LineBreakingPassesM: 'Počet přihrávek, které úspěšně proniknou linií záložníků',
      LineBreakingThroughBalls: 'Počet přihrávek, které úspěšně proniknou defenzivní linií',
      LineBreakingPassesPerPass: 'Procento přihrávek prolomujících linii na přihrávku',
      TotalPassesUnderStrongPressure: 'Celkový počet přihrávek provedených pod silným tlakem (do 0-2 metrů od nejbližšího soupeře)',
      TotalPassesUnderLightPressure: 'Celkový počet přihrávek provedených pod tlakem (do 2-4 metrů od nejbližšího soupeře)',
      SuccessfulPassesUnderStrongPressure: 'Počet úspěšných přihrávek provedených pod silným tlakem (do 0-2 metrů od nejbližšího soupeře)',
      SuccessfulPassesUnderLightPressure: 'Počet úspěšných přihrávek provedených pod tlakem (do 2-4 metrů od nejbližšího soupeře)',
      PassingUnderStrongPressure: 'Procento úspěšných přihrávek a celkových přihrávek obou pod silným tlakem (do 0-2 metrů od nejbližšího soupeře)',
      PassingUnderLightPressure: 'Procento úspěšných přihrávek a celkových přihrávek obou pod tlakem (do 2-4 metrů od nejbližšího soupeře)',
      PassReceiptsInSpaceCompleted: 'Přihrávky provedené, kde je příjemce v útočné polovině a nemá obránce v poloměru 5 metrů ve směru k brance',
      PassReceiptsInSpace: 'Přihrávky obdržené v útočné polovině a není obránce v poloměru 5 metrů ve směru k brance',
      PassReceiptsInSpaceCompletedFirstThird: 'Přihrávky, kdy příjemce je v první třetině bez obránce v okruhu 5 metrů směrem k bráně',
      PassReceiptsInSpaceCompletedSecondThird: 'Přihrávky, kdy příjemce je v druhé třetině bez obránce v okruhu 5 metrů směrem k bráně',
      PassReceiptsInSpaceCompletedFinalThird: 'Přihrávky, kdy příjemce je v ofenzivní třetině bez obránce v okruhu 5 metrů směrem k bráně',
      PassReceiptsInSpaceCompletedOppHalfRight: 'Přihrávky, kdy příjemce je na pravé polovině soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'Přihrávky, kdy příjemce je uprostřed poloviny soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'Přihrávky, kdy příjemce je na levé polovině soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceFirstThird: 'Převzetí míče v první třetině bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceSecondThird: 'Převzetí míče v druhé třetině bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceFinalThird: 'Převzetí míče v ofenzivní třetině bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceOppHalfRight: 'Převzetí míče na pravé polovině soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceOppHalfCenter: 'Převzetí míče ve středu poloviny soupeře bez obránce v okruhu 5 metrů',
      PassReceiptsInSpaceOppHalfLeft: 'Převzetí míče na levé polovině soupeře bez obránce v okruhu 5 metrů',
      TotalStrongOnBallPressures: 'Počet silných tlaků na míč (do 0-2 metrů od nositele míče)',
      TotalLightOnBallPressures: 'Počet tlaků na míč (do 2-4 metrů od nositele míče)',
      SuccessfulStrongOnBallPressures: 'Počet úspěšných silných tlaků na míč (do 0-2 metrů)',
      SuccessfulLightOnBallPressures: 'Počet úspěšných tlaků na míč (do 2-4 metrů)',
      StrongOnBallPressuresPct: 'Procento úspěšných a celkových silných tlaků na míč (do 0-2 metrů od nejbližšího soupeře)',
      LightOnBallPressuresPct: 'Procento úspěšných a celkových tlaků na míč (do 2-4 metrů od nejbližšího soupeře)',
      TimesBypassedByPasses: 'Celkový počet krát obehrán přihrávkou',
      TimesBypassedByCarries: 'Celkový počet krát obehrán přenášením míče',
      TimesBypassedByActions: 'Celkový počet krát obehrán přihrávkou a přenášením míče dohromady',
      BypassedPlayersByCarries: 'Celkový počet soupeřů (obránců a záložníků) obehrán přenášením míče',
      BypassedDefendersByCarries: 'Celkový počet soupeřů (obránců) obehrán přenášením míče',
      BypassedPlayersByActions: 'Celkový počet soupeřů (obránců a záložníků) obehrán přihrávkami a přenášením míče dohromady',
      BypassedDefendersByActions: 'Celkový počet soupeřů (obránců) obehrán přihrávkami a přenášením míče dohromady',
      CarriesBypassingPlayers: 'Počet přenášení míče, která obehrála hráče',
      CarriesBypassingDefenders: 'Počet přenášení míče, která obehrála obránce',
      BypassedPlayersPerCarry: 'Průměrný počet soupeřů obehrán na přenášení míče (alespoň 7 metrů)',
      BypassedDefendersPerCarry: 'Průměrný počet obránců obehrán na přenášení míče (alespoň 7 metrů)',
      LineBreakingCarries: 'Počet přenášení míče, která úspěšně proniknou jednou nebo více defenzivními liniemi',
      LineBreakingCarriesMD: 'Počet přenášení míče, která úspěšně proniknou liniemi záložníků a obránců',
      LineBreakingCarriesM: 'Počet přenášení míče, která úspěšně proniknou linií záložníků',
      LineBreakingCarriesD: 'Počet přenášení míče, která úspěšně proniknou defenzivní linií',
      LineBreakingCarriesPerCarry: 'Procento přenášení míče prolomujících linii na přenášení míče',
      LineBreakingActions: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou jednou nebo více defenzivními liniemi',
      LineBreakingActionsMD: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou liniemi záložníků a obránců',
      LineBreakingActionsM: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou linií záložníků',
      LineBreakingActionsD: 'Počet přihrávek a přenášení míče dohromady, která úspěšně proniknou defenzivní linií',
      PassesPerLineBreakingPass: 'Poměr mezi celkovým počtem přihrávek na přihrávku prolomující linii',
      CarriesPerLineBreakingCarry: 'Poměr mezi celkovým počtem přenášení míče na přenášení míče prolomující linii',
      LinesBrokenByPasses: 'Celkový počet linií prolomených přihrávkami',
      LinesBrokenByCarries: 'Celkový počet linií prolomených přenášením míče',
      LinesBrokenByActions: 'Celkový počet linií prolomených přihrávkami a přenášením míče dohromady',
      LinesBrokenPerPass: 'Poměr mezi celkovým počtem linií prolomených na přihrávku',
      LinesBrokenPerCarry: 'Poměr mezi celkovým počtem linií prolomených na přenášení míče',
      AvgLastDefenderDistanceIP: 'Vzdálenost mezi posledním obráncem (nejblíže k vlastní brance) a brankovou čárou v držení míče',
      AvgLastDefenderDistanceOOP: 'Vzdálenost mezi posledním obráncem (nejblíže k vlastní brance) a brankovou čárou bez držení míče',
      AvgDefensiveLineDistanceIP: 'Vzdálenost mezi pozicí nejhlubší defenzivní linie a brankou v držení míče',
      AvgDefensiveLineDistanceOOP: 'Vzdálenost mezi pozicí nejhlubší defenzivní linie a brankou bez držení míče',
      AvgRBDistanceIP: 'Vzdálenost od pravého obránce k jejich vlastní brance v držení míče',
      AvgRBDistanceOOP: 'Vzdálenost od pravého obránce k jejich vlastní brance bez držení míče',
      AvgLBDistanceIP: 'Vzdálenost od levého obránce k jejich vlastní brance v držení míče',
      AvgLBDistanceOOP: 'Vzdálenost od levého obránce k jejich vlastní brance bez držení míče',
      AvgBlockDistanceIP: 'Vzdálenost mezi nejhlubším a nejpokročilejším hráčem v poli v držení míče',
      AvgBlockDistanceOOP: 'Vzdálenost mezi nejhlubším a nejpokročilejším hráčem v poli bez držení míče',
      AvgBlockAreaIP: 'Oblast ohraničujícího boxu obklopujícího všechny hráče v poli (míra toho, kolik prostoru tým zabírá) v držení míče',
      AvgBlockAreaOOP: 'Oblast ohraničujícího boxu obklopujícího všechny hráče v poli (míra toho, kolik prostoru tým zabírá) bez držení míče',
      AvgDefensiveLineWidthOOP: 'Šířka nejzadnější linie hráčů (nejdále od jejich vlastní branky) bez držení míče',
      AvgOffensiveLineLastThirdWidthIP: 'Horizontální šířka útočné linie v poslední třetině v držení míče',
      AvgLByIP: 'Pozice levého obránce v držení míče',
      AvgRByIP: 'Pozice pravého obránce v držení míče',
      AvgOffensiveLineDistanceIP: 'Vzdálenost mezi vlastní brankou a útočnou linií v držení míče',
      AvgOffensiveLineLastThirdDistanceIP: 'Vzdálenost mezi vlastní brankou a útočnou linií v poslední třetině v držení míče',
      AvgOffensiveLineWidthIP: 'Horizontální šířka útočné linie v držení míče',
      OffBallRuns: 'Záměrné pohyby bez míče (běhy) na podporu útočné fáze',
      OffBallRunsOverlap: 'Běhy, kde se hráč pohybuje kolem vnější strany spoluhráče (blíže k postranní čáře), zatímco tento spoluhráč má míč',
      OffBallRunsUnderlap: 'Běhy, kde se hráč pohybuje uvnitř spoluhráče, berouc vnitřní trasu (blíže ke středu hřiště)',
      OffBallRunsRunAhead: 'Běh vpřed, který jde za nositele míče, ale zůstává před posledním obráncem',
      OffBallRunsRunBehind: 'Běh vpřed, který proniká do poslední defenzivní linie, dostává se mezi obránce a brankáře',
      OffBallRunsCrossReceiver: 'Hráč běží do pokutového území a pozicuje se, aby přijal centr od spoluhráče',
      OffBallRunsSupport: 'Hráč běží, aby se zarovnal s nositelem míče, nabízeje blízkou možnost přihrávky v útoku',
      OffBallRunsComingShort: 'Hráč se pohybuje směrem k nositeli míče, aby nabídl blízkou podporu nebo možnost přihrávky od branky',
      AerialsOppHalf: 'Úspěšné vzdušné souboje v soupeřově polovině',
      CarriesIntoFinalThird: 'Potrubí o délce nejméně 7 metrů zvenčí dovnitř poslední třetiny',
      DribblesAttempted: 'Počet pokusů o dribling',
      SpeedScore: 'Fyzický výkon hráče na základě různých metrik rychlosti',
      EnduranceScore: 'Vytrvalostní fyzický výkon hráče na základě různých metrik',
      GoalsConceded: 'Počet inkasovaných gólů',
      HeadedGoals: 'Počet gólů vstřelených hlavou',
      SavesInBox: 'Počet uložení ze střel uvnitř krabice',
      SavesOutBox: 'Počet záchrany ze střel mimo box',
      ShotsOnTargetInBoxAgainst: 'Počet inkasovaných střel na cíl zevnitř boxu',
      ShotsOnTargetOutBoxAgainst: 'Počet inkasovaných střel na terč zvenčí',
      SwitchPlaySuccessful: 'Počet dokončených přihrávek nad 32 metrů, kdy je boční posunutí míče větší než jeho posunutí směrem k soupeřově brance',
      SwitchPlayTotal: 'Celkový počet pokusů o přihrávky nad 32 metrů, kde je boční posunutí míče větší než jeho posunutí směrem k soupeřově brance',
      PassesInsideOppHalf: 'Celkový počet přihrávek, které začínají a končí v polovině soupeře',
      PassesInsideOppHalfSuccessful: 'Počet dokončených přihrávek, které začínají i končí v polovině soupeře',
      TacklesAttemptedFirstThird: 'Celkový počet pokusů o zákroky v první třetině hřiště',
      TacklesAttemptedSecondThird: 'Celkový počet pokusů o zákroky ve druhé třetině hřiště',
      TacklesFirstThird: 'Počet úspěšných zákroků v první třetině hřiště',
      TacklesSecondThird: 'Počet úspěšných zákroků ve druhé třetině hřiště',
      FoulsOwnHalf: 'Počet faulů spáchaných na vlastní polovině hráče',
      TouchesOppHalf: 'Počet doteků míče na soupeřově polovině',
      TacklesAttemptedNotAdjusted: 'Celkový počet pokusů o útok bez úpravy držení míče',
      TacklesSuccessfulNotAdjusted: 'Celkový počet úspěšných soubojů bez úpravy držení míče',
      AvgTop5MaxSpeed: 'Průměr pěti nejvyšších maximálních rychlostí hráče',
      LBPReceived: 'Počet přijatých průchodů pro přerušení řádku',
      LBPMReceived: 'Počet obdržených přihrávek, které prorazily středovou linii soupeře',
      LBPMDReceived: 'Počet obdržených přihrávek, které prorazí jak středem zálohy soupeře, tak i obrannými řadami',
      ThroughBallReceived: 'Počet obdržených přihrávek, které prolomí poslední obrannou linii soupeře',
      ShortPassesSuccessful: 'Počet dokončených krátkých průchodů (méně než 12 metrů).',
      PassingSuccessForwardPct: 'Procento úspěšných přihrávek vpřed',
      PassingSuccessBackwardPct: 'Procento úspěšných zpětných přihrávek',
      PassingForwardBackwardPct: 'Poměr přihrávek vpřed k přihrávkám vzad',
      LongBallPerPassesPct: 'Procento dlouhých míčů vzhledem k celkovému počtu přihrávek',
      LongBallReceivedOppHalf: 'Počet dlouhých míčů obdržených v soupeři',
      OffensiveActions: 'Útočné akce',
      SuccessfulDribblesPct: 'Úspěšné driblování/celkový počet provedených pokusů o driblování',
      OffensiveTouchesOutBoxPct: '% útočných doteků mimo box',
      HsrDistanceIP: 'Vzdálenost ve sprintu >21 km/h v držení',
      HsrDistanceOOP: 'Vzdálenost ve sprintu >21 km/h mimo držení',
      JoggingDistanceIP: 'Jogging vzdálenost v držení',
      JoggingDistanceOOP: 'Vzdálenost běhu z držení',
      RunningDistanceIP: 'Běžecká vzdálenost v držení',
      RunningDistanceOOP: 'Běžící vzdálenost z držení',
      SprintsDistanceIP: 'Vzdálenost ve sprintu >24 km/h v držení',
      SprintsDistanceOOP: 'Vzdálenost sprintu >24 km/h mimo držení',
      WalkingDistanceIP: 'Docházková vzdálenost v držení',
      WalkingDistanceOOP: 'Pěší vzdálenost mimo držení',
      PossessionRegain: 'Kolikrát přinutíte soupeře ztratit držení',
      HandPassesSuccessful: 'Úspěšné přihrávky rukama (brankáři nebo vhazování při standardce)',
      HandPassesTotal: 'Celkový počet přihrávek rukama (brankáři nebo vhazování při standardce)',
      InterceptionsNotAdjusted: 'Number of times the player intercepts a pass to prevent the ball reaching its target',
      Clearances: 'Number of times the player hits the ball clear of the defensive zone',
      ClearancesNotAdjusted: 'Number of times the player hits the ball clear of the defensive zone',
      RecoveriesNotAdjusted: 'Number of balls recovered by a player (via Tackles or Interceptions)'
    },
    abbr: {
      Possession: 'POS%',
      TimePossession: 'TP',
      PassesPerShots: 'PPS',
      PPDA: 'PPDA',
      ExpectedPoints: 'XP',
      Points: 'P',
      Directness: 'DIR',
      PassesPerLongBall: 'PPLB',
      CrossingPerXG: 'CPxG',
      PenaltySavedPenaltyFaced: 'PSPF',
      Goals: 'GOA',
      PenaltyShots: 'PS',
      PenaltyGoals: 'PG',
      NonPenaltyGoals: 'NPG',
      NPGOpenPlay: 'NPGOP',
      NPGSetPiece: 'NPGSP',
      Shooting: 'SHO%',
      Finishing: 'FIN%',
      xGEfficiency: 'xGE',
      HeaderPerShot: 'HPS',
      HeaderPerCross: 'HPC',
      Assists: 'ASS',
      ThroughBalls: 'TB',
      CrossEfficiency: 'CE',
      ScoringContribution: 'SC',
      xAssistsOpenPlay: 'xAOP',
      xAssistsSetPiece: 'xASP',
      xAssistsOpenPlayInTeam: 'xAOPiT',
      xAssistsSetPieceInTeam: 'xASPiT',
      xGBuildupFinalThird: 'xGBUPFT',
      xGChainFinalThird: 'xGCFT',
      BallProgressionPassing: 'BPP',
      BallProgressionDribbling: 'BPD',
      TacklesWasDribbled: 'TWD%',
      TacklesSuccessful: 'STA',
      Interceptions: 'INT',
      Clearances: 'CLE',
      Fouls: 'FOU',
      Recoveries: 'REC',
      Shots: 'SHO',
      ShotsPerGoal: 'SPG',
      ShortPassesSuccessful: 'SPS',
      PassingSuccessForwardPct: 'PSF%',
      PassingSuccessBackwardPct: 'PSB%',
      PassingForwardBackwardPct: 'PFB%',
      LongBallPerPassesPct: 'LBP%',
      LongBallReceived: 'LBR',
      LongBallReceivedOppHalf: 'LBROH',
      OffensiveActions: 'OA',
      DribblesAttempted: 'DAT',
      SuccessfulDribblesPct: 'SD%',
      OffensiveTouchesOutBoxPct: 'OTOB%',
      BallRetention: 'BR',
      PassingPct: 'PA%',
      PassingOwnHalfPct: 'POH%',
      PassingOppHalfPct: 'POPH%',
      PassingFinalThird: 'PFT',
      PassesFinalThirdTotal: 'PFTT',
      PassingFinalThirdPct: 'PT%',
      LongBallSuccessful: 'LBS',
      LongBallPct: 'LB%',
      LongBallTotal: 'TLB',
      SavesPct: 'S%',
      SavesInBoxPct: 'SIB%',
      SavesOutOfBoxPct: 'SOOB%',
      xGSavedPerXGFacedOnTarget: 'xGSPFOT',
      xGFacedOnTargetPerGoalReceived: 'xGFOTPGR',
      xGFacedOnTargetEfficiency: 'xGFOTE',
      xGFacedOnTarget: 'xGFOT',
      IndividualPressure: 'IP',
      AerialEfficiency: 'AE',
      AerialWins: 'AEW',
      AerialWinsPct: 'AE%',
      xG: 'xG',
      xGDiff: 'xGD',
      xGOpenPlay: 'xGOP',
      xGSetPiece: 'xGSP',
      xGPerShot: 'xGPS',
      ChancesCreated: 'CC',
      CompletedCrosses: 'SCR',
      Crossing: 'CR%',
      OpenPlayKeyPasses: 'OPKP',
      OpenPlayKeyPassesInTeam: 'OPKPiT%',
      OpenPlayPassesIntoOpponentBox: 'OPPOPPB',
      OpenPlayPassesIntoOpponentBoxSuccessful: 'OPPOPPBS',
      xAssists: 'xA',
      xGChain: 'xGC',
      xGBuildup: 'xGBUP',
      xGBuildupInTeam: 'xGBUPiT',
      BallProgression: 'BP',
      SuccessfulDribbles: 'SDR',
      Dispossessed: 'TOV',
      TouchesInOpponentBox: 'TOB',
      xGSavedPerShot: 'xGSS',
      BallRetentionOppHalf: 'BROPPH',
      DeepProgression: 'DP',
      DeepProgressionFinalThird: 'DPFT',
      FoulsTaken: 'FOUR',
      PenaltiesTaken: 'PT',
      BlockedCrosses: 'BC',
      BlockedShots: 'BS',
      Blocks: 'BLO',
      NonPenaltyGoalsAgainst: 'NPGC',
      Headers: 'HEA',
      AveragePassDistance: 'APD',
      ProgressiveRuns: 'PRC',
      xT: 'xT',
      xTOpenPlay: 'xTOP',
      xTSetPiece: 'xTSP',
      xGOT: 'xGOT',
      BadActions: 'BA',
      BadActionsOwnHalf: 'BAOH',
      AerialsWonOwnBox: 'AWOB',
      AerialsWonOppBox: 'AWOPPB',
      AerialsTotalOppBox: 'ATOPPB',
      AerialsTotalOwnBox: 'ATOB',
      FoulsOwnHalfPct: 'FOH%',
      RecoveriesOppHalf: 'ROH',
      DuelsPct: 'D%',
      TacklesUnsuccessful: 'UTA',
      TacklesWasDribbledFirstThird: 'TWDFT',
      TacklesWasDribbledSecondThird: 'TWDST',
      TacklesWasDribbledFinalThird: 'TWDFT',
      BallProgressionFinalThird: 'BPFT',
      DuelsTotal: 'DT',
      QuickRecoveries: 'QR',
      ShotsPerNPG: 'SPNPG',
      ShotsOutBox: 'SOB',
      GoalsOutBox: 'GOB',
      ShootingOutBox: 'SOB%',
      HandPassing: 'HP',
      Catching: 'CAT',
      Caught: 'CAU',
      ClaimAccuracy: 'CA',
      HighTurnovers: 'HTOV',
      ShotEndingHighTurnovers: 'SEHT',
      GoalEndingHighTurnovers: 'GEHT',
      AverageCarriesProgress: 'ACP',
      ChanceEndingCarries: 'CEC',
      AssistEndingCarries: 'AEC',
      ShotEndingCarries: 'SEC',
      GoalEndingCarries: 'GEC',
      ShotEndingSequence: 'SES',
      GoalEndingSequence: 'GES',
      xGPerNPG: 'xGPNPG',
      AerialWonOffensive: 'AWO',
      AerialWonDefensive: 'AWD',
      xGAgainst: 'xGC',
      xGDiffAgainst: 'xGDC',
      xGPerNPGAgainst: 'xGPNPGA',
      xGOpenPlayAgainst: 'xGOPC',
      xGSetPieceAgainst: 'xGSPC',
      xGPerShotAgainst: 'xGSC',
      ShotsAgainst: 'STC',
      ShotsOnTargetAgainst: 'SOTC',
      RivalPossession: 'RP',
      AerialDefensivePct: 'AD%',
      HighRecoveries: 'HR',
      HighDefensiveActions: 'HDA',
      HighDefensiveActionPct: 'HDA%',
      HighDefensiveDistance: 'HDD',
      PassesPerPossession: 'PPP',
      LengthPerPossession: 'LPP',
      xTNet: 'xTN',
      AvgCarriesDistance: 'ACD',
      PassesForwardPct: 'PF%',
      PassesForwardSuccessful: 'SFP',
      PassesForwardTotal: 'TFP',
      TacklesAttempted: 'ATA',
      DuelsLost: 'DL',
      Carries: 'CARR',
      CarriesPct: 'CARR%',
      Aerials: 'AER',
      ProgressivePassesReceivedIntoBox: 'PPRIB',
      PassesOppHalf: 'POPH',
      ShotsOnTarget: 'SOT',
      AggressiveActions: 'AA',
      Crosses: 'CRO',
      xGBuildup5pass: 'xGBUP5',
      DefensiveDistance: 'DD',
      SpeedSequence: 'SS',
      Touches: 'TOU',
      AerialsTotalOppHalf: 'ATOPPH',
      AerialsWonOppHalf: 'AWOPPH',
      AerialsWonOppHalfPct: 'AWOH%',
      AerialsPctOppBox: 'AOPPB%',
      AerialsPctOwnBox: 'AOB%',
      AerialDefensive: 'AD',
      AerialOffensive: 'AO',
      AerialOffensivePct: 'AO%',
      IndividualPressureOppHalf: 'IPOPPH',
      ChancesCreatedOP: 'CCOP',
      TouchesPerShot: 'TPS',
      PassesFinalThirdTotalPct: 'PFT%',
      xACrosses: 'xAC',
      Passes: 'PAS',
      PassesSuccessful: 'SPA',
      TacklesWasDribbledFouls: 'TWDF',
      OffsidesCaught: 'OC',
      ProgressivePassesReceivedFinalThird: 'PPRFT',
      ProgressivePassesReceived: 'PPR',
      Breadth: 'BRD',
      DuelsDefTotal: 'DDT',
      DefensiveActions: 'DA',
      ProgressivePassesReceivedOppHalf: 'PPROH',
      CompletedCrossesOP: 'CCOP',
      CrossingOP: 'COP',
      CrossesOP: 'COP',
      PassingContribution: 'PC',
      BallProgressionOppHalfInTeam: 'BPOPPHiT',
      PassesOPIntoBoxInTeam: 'POBIT',
      TouchesOppBoxInTeam: 'TOBIT',
      xGOPInTeam: 'xGOPiT',
      DeepPasses: 'DP',
      DeepPassesTotal: 'DPCT',
      DefensiveDuelsPct: 'DD%',
      QuickRecoveriesPct: 'QR%',
      DiffDefensiveDistanceTeam: 'DDDT',
      xTPassing: 'xTP',
      xTPassing100Passes: 'xTP100',
      ProgressivePassesAccurate: 'APP',
      xP: 'xP',
      PassAbility: 'PA',
      OPPassesIntoOppBoxPct: 'OPPIOB%',
      EntriesOppBox: 'EOPPB',
      Crosses6yardBox: 'C6YB',
      Cutbacks: 'CUT',
      xTDribbling: 'xTD',
      AvgShotDistance: 'ASD',
      xGOnTarget: 'xGOT',
      FinishingxGOT: 'FxGOT',
      DribblesWonOwnHalf: 'DWOH',
      DribblesOwnHalf: 'DOH',
      DribblesOwnHalfPct: 'DOH%',
      DribblesWonOppHalf: 'DWOPH',
      DribblesOppHalf: 'DOPH',
      DribblesOppHalfPct: 'DOPH%',
      DribblesWonFinalThird: 'DWFT',
      DribblesFinalThird: 'DFT',
      DribblesFinalThirdPct: 'DFT%',
      ShotEndingHighRecoveries: 'SEHR',
      PassingFinalThirdAgainst: 'PFTC',
      OpenPlayPassesIntoOpponentBoxAgainst: 'OPPOBC',
      EntriesOppBoxAgainst: 'EOBC',
      DeepProgressionAgainst: 'DPC',
      TouchesInOpponentBoxAgainst: 'TOBC',
      Score: 'SCO',
      PDScore: 'SCO',
      OrlegiScore: 'SCO',
      SirScore: 'SCO',
      ExcScore: 'SCO',
      xTOPInTeam: 'xTOPiT',
      YellowCards: 'YC',
      RedCards: 'RC',
      xTOpenPlayAgainst: 'xTOPC',
      xTSetPieceAgainst: 'xTSPC',
      NPGOpenPlayAgainst: 'NPG OPC',
      NPGSetPieceAgainst: 'NPG SPC',
      PassesOppHalfPerPossession: 'POHP',
      AverageTimeRecovery: 'ATR',
      ExpectedPassing: 'xP%',
      NumPossession10Passes: 'P10P',
      PassesReceived: 'PR',
      PassesReceivedFinalThird: 'PRLFT',
      ProgressivePassesTotalPct: 'PP%',
      ShortPassesPct: 'SP%',
      TouchesOppBoxOppTeam: 'TOBOT',
      ShotsOnTargetOppTeam: 'SOTOT',
      NPGOppTeam: 'NPGOT',
      xGSetPiecePerxG: 'xGSPPxG',
      ShotsOpenPlay: 'SOP',
      ShotsOpenPlayAgainst: 'SOPA',
      ShotsFromDribble: 'SFD',
      GoalsFromDribble: 'GFD',
      PassesIntoFinalThird: 'PIFT',
      PassesIntoFinalThirdTotal: 'PIFTT',
      PassesInsideFinalThird: 'PINSFT',
      PassesInsideFinalThirdTotal: 'PINSFTT',
      PassesFinalThirdNoArea: 'PFTNA',
      PassesIntoOppBox: 'PIOB',
      CarriesFinalThird: 'CFT',
      CarriesInsideFinalThird: 'CINSFT',
      CarriesFinalThirdNoBox: 'CFTNB',
      CarriesIntoOppBox: 'CIOB',
      TimePossessionAgainst: 'TPA',
      TimePossessionTotal: 'TPT',
      PassesInBox: 'PIB',
      LongThrowInSuccessful: 'LTInS',
      LongThrowInTotal: 'LTInT',
      LongThrowInPct: 'LTIn%',
      Games: 'GAM',
      PointsPerGame: 'PPG',
      ExpectedPointsDiff: 'XPD',
      PassesTotalOwnHalf: 'PTOH',
      PassesOwnHalf: 'POH',
      PassesTotalOppHalf: 'PTOPPH',
      ProgressivePassesTotal: 'TPP',
      DuelsWon: 'DW',
      NonPenaltySaves: 'NPS',
      BadActionsOppHalf: 'BAOPPH',
      CarriesSuccessful: 'CS',
      ShotsOnTargetOutBox: 'SOTOB',
      TotalDistance: 'DST',
      WalkingDistance: 'WLKD',
      JoggingDistance: 'JOGD',
      RunningDistance: 'RUND',
      ExtremeAccelerations: 'XACC',
      NumberOfRuns: 'RUNQ',
      HsrDistance: 'HSRD',
      HsrNumber: 'HSRQ',
      HsrDistancePct: 'HSRD%',
      SprintsNumber: 'SPRQ',
      SprintsDistance: 'SPRD',
      SprintNumberDeclinePct: 'SQD%',
      SprintDistanceDeclinePct: 'SDD%',
      SprintNumberDecline: 'SQD',
      SprintDistanceDecline: 'SDD',
      SprintDistancePct: 'SPRD%',
      Accelerations: 'ACC',
      MaxSpeed: 'MS',
      AvgMaxSpeed: 'AvgMS',
      MaxAccelerations: 'MACC',
      HeadedGoals: 'HG',
      GoalsConceded: 'GC',
      SavesInBox: 'SIB',
      SavesOutBox: 'VZLYKAT',
      BypassedPlayersByPasses: 'ByPP',
      BypassedDefendersByPasses: 'ByPD',
      PassesBypassingPlayers: 'PByPP',
      PassesBypassingDefenders: 'PByPD',
      BypassedPlayersPerPass: 'ByPPPP',
      BypassedDefendersPerPass: 'ByPDPP',
      LineBreakingPasses: 'LBP',
      LineBreakingPassesMD: 'LBPMD',
      LineBreakingPassesM: 'LBPM',
      LineBreakingThroughBalls: 'LBTB',
      LineBreakingPassesPerPass: 'LBPP%',
      TotalPassesUnderStrongPressure: 'TPUSP',
      TotalPassesUnderLightPressure: 'TPUP',
      SuccessfulPassesUnderStrongPressure: 'SPUSP',
      SuccessfulPassesUnderLightPressure: 'SPULP',
      PassingUnderStrongPressure: 'PUSP%',
      PassingUnderLightPressure: 'PULP%',
      PassReceiptsInSpaceCompleted: 'PRSC',
      PassReceiptsInSpace: 'PRS',
      PassReceiptsInSpaceCompletedFirstThird: 'PRSC1T',
      PassReceiptsInSpaceCompletedSecondThird: 'PRSC2T',
      PassReceiptsInSpaceCompletedFinalThird: 'PRSC3T',
      PassReceiptsInSpaceCompletedOppHalfRight: 'PRSCOHR',
      PassReceiptsInSpaceCompletedOppHalfCenter: 'PRSCOHC',
      PassReceiptsInSpaceCompletedOppHalfLeft: 'PRSCOHL',
      PassReceiptsInSpaceFirstThird: 'PRS1T',
      PassReceiptsInSpaceSecondThird: 'PRS2T',
      PassReceiptsInSpaceFinalThird: 'PRS3T',
      PassReceiptsInSpaceOppHalfRight: 'PRSOHR',
      PassReceiptsInSpaceOppHalfCenter: 'PRSOHC',
      PassReceiptsInSpaceOppHalfLeft: 'PRSOHL',
      TotalStrongOnBallPressures: 'TSBP',
      TotalLightOnBallPressures: 'TBP',
      SuccessfulStrongOnBallPressures: 'SSBP',
      SuccessfulLightOnBallPressures: 'SLBP',
      StrongOnBallPressuresPct: 'SBP%',
      LightOnBallPressuresPct: 'BP%',
      TimesBypassedByPasses: 'ByPPAS',
      TimesBypassedByCarries: 'ByPC',
      TimesBypassedByActions: 'ByPA',
      BypassedPlayersByCarries: 'ByPPC',
      BypassedDefendersByCarries: 'ByPDC',
      BypassedPlayersByActions: 'ByPPA',
      BypassedDefendersByActions: 'ByPDA',
      CarriesBypassingPlayers: 'CByPP',
      CarriesBypassingDefenders: 'CByPD',
      BypassedPlayersPerCarry: 'ByPPPC',
      BypassedDefendersPerCarry: 'ByPDPC',
      LineBreakingCarries: 'LBC',
      LineBreakingCarriesMD: 'LBCMD',
      LineBreakingCarriesM: 'LBCM',
      LineBreakingCarriesD: 'LBCD',
      LineBreakingCarriesPerCarry: 'LBCC%',
      LineBreakingActions: 'LBA',
      LineBreakingActionsMD: 'LBAMD',
      LineBreakingActionsM: 'LBAM',
      LineBreakingActionsD: 'LBAD',
      PassesPerLineBreakingPass: 'PPLBP',
      CarriesPerLineBreakingCarry: 'CPLBC',
      LinesBrokenByPasses: 'LBByP',
      LinesBrokenByCarries: 'LBByC',
      LinesBrokenByActions: 'LBByA',
      LinesBrokenPerPass: 'LBPP',
      LinesBrokenPerCarry: 'LBPC',
      AvgLastDefenderDistanceIP: 'ALDDIP',
      AvgLastDefenderDistanceOOP: 'ALDDIP',
      AvgDefensiveLineDistanceIP: 'ALDDIP',
      AvgDefensiveLineDistanceOOP: 'ALDDIP',
      AvgRBDistanceIP: 'ARBDIP',
      AvgRBDistanceOOP: 'ARBDOOP',
      AvgLBDistanceIP: 'ALBDIP',
      AvgLBDistanceOOP: 'ALBDOOP',
      AvgBlockDistanceIP: 'ABDIP',
      AvgBlockDistanceOOP: 'ABDOOP',
      AvgBlockAreaIP: 'ABAIP',
      AvgBlockAreaOOP: 'ABAOOP',
      AvgDefensiveLineWidthOOP: 'ADLWOOP',
      AvgOffensiveLineLastThirdWidthIP: 'AOLLTWIP',
      AvgLByIP: 'ALBIP',
      AvgRByIP: 'ARBIP',
      AvgOffensiveLineDistanceIP: 'AOLDIP',
      AvgOffensiveLineLastThirdDistanceIP: 'AOLTDIP',
      AvgOffensiveLineWidthIP: 'AOLWIP',
      OffBallRuns: 'OBR',
      OffBallRunsOverlap: 'OBRO',
      OffBallRunsUnderlap: 'OBRU',
      OffBallRunsRunAhead: 'OBRA',
      OffBallRunsRunBehind: 'OBRB',
      OffBallRunsCrossReceiver: 'OBRCR',
      OffBallRunsSupport: 'OBRS',
      OffBallRunsComingShort: 'OBRCS',
      AerialsOppHalf: 'AOPPH',
      SpeedScore: 'SSCO',
      EnduranceScore: 'ESCO',
      HeadedShots: 'HS',
      HeadedXG: 'Hlavou xG',
      HeadedSetPieceTooltip: 'Zobrazují se pouze hráči, kteří mají hlavičky ze standardek',
      CarriesIntoFinalThird: 'CIF⅓',
      SwitchPlaySuccessful: 'SPS',
      SwitchPlayTotal: 'SPT',
      PassesInsideOppHalf: 'PiOH',
      PassesInsideOppHalfSuccessful: 'PiOHS',
      TacklesAttemptedFirstThird: 'TAF⅓',
      TacklesAttemptedSecondThird: 'TAS⅓',
      TacklesFirstThird: 'TF⅓',
      TacklesSecondThird: 'TS⅓',
      FoulsOwnHalf: 'FOH',
      TouchesOppHalf: 'TOPPH',
      TacklesAttemptedNotAdjusted: 'TANA',
      TacklesSuccessfulNotAdjusted: 'TSNA',
      AvgTop5MaxSpeed: 'AT5MS',
      LBPReceived: 'LBPR',
      LBPMReceived: 'LBPMR',
      LBPMDReceived: 'LBPMDR',
      ThroughBallReceived: 'TBR',
      DistanceIP: 'DST IP',
      WalkingDistanceIP: 'WLKD IP',
      JoggingDistanceIP: 'JOGD IP',
      RunningDistanceIP: 'RUND IP',
      HsrDistanceIP: 'HSRD IP',
      SprintsDistanceIP: 'SPRD IP',
      RunningNumberIP: 'RUNQ IP',
      HsrNumberIP: 'HSRQ IP',
      SprintsNumberIP: 'SPRQ IP',
      DistanceOOP: 'DST OOP',
      WalkingDistanceOOP: 'WLKD OOP',
      JoggingDistanceOOP: 'JOGD OOP',
      RunningDistanceOOP: 'RUND OOP',
      HsrDistanceOOP: 'HSRD OOP',
      SprintsDistanceOOP: 'SPRD OOP',
      RunningNumberOOP: 'RUNQ OOP',
      HsrNumberOOP: 'HSRQ OOP',
      SprintsNumberOOP: 'SPRQ OOP',
      PossessionRegain: 'PR',
      HandPassesSuccessful: 'SHP',
      HandPassesTotal: 'THP',
      InterceptionsNotAdjusted: 'INT',
      ClearancesNotAdjusted: 'CLE',
      RecoveriesNotAdjusted: 'REC'
    },
    AerialsOppHalf: 'Vzdušné souboje soupeřova polovina',
    CarriesIntoFinalThird: 'Jede do poslední ⅓',
    scoreDifference: 'Rozdíl ve skóre: Ukazuje, zda výkon této hry byl nad nebo pod průměrem sezóny',
    SpeedScore: 'Rychlost Skóre výkonu',
    EnduranceScore: 'Skóre vytrvalosti',
    SwitchPlaySuccessful: 'Přepnutí přehrávání bylo úspěšné',
    SwitchPlayTotal: 'Přepněte Přehrát celkem',
    PassesInsideOppHalf: 'Prochází uvnitř Opp Half',
    PassesInsideOppHalfSuccessful: 'Průchody uvnitř Opp Napůl úspěšné',
    TacklesAttemptedFirstThird: 'První pokus o řešení ⅓',
    TacklesAttemptedSecondThird: 'Pokus o pokus o druhou ⅓',
    TacklesFirstThird: 'Úspěšná první ⅓',
    TacklesSecondThird: 'Úspěšná druhá ⅓',
    FoulsOwnHalf: 'Fauly na vlastní polovině',
    TouchesOppHalf: 'Dotýká se Opp Half',
    TacklesAttemptedNotAdjusted: 'Pokus o náčiní neupraveno',
    TacklesSuccessfulNotAdjusted: 'Úspěšné řešení neupraveno',
    AvgTop5MaxSpeed: 'Průměrná nejvyšší 5 maximální rychlost',
    LBPReceived: 'Přijaté průkazy pro přerušení čáry',
    LBPMReceived: 'Přijaté průjezdy pro přerušení linky (M Line).',
    LBPMDReceived: 'Přijaté průjezdy pro přerušení linky (MD Line).',
    ThroughBallReceived: 'Prostřednictvím přijatých koulí',
    recoveriesRate: 'Poměr obnovy',
    turnoversRate: 'Poměr ztrát',
    HeadedShots: 'Střely hlavou',
    HeadedXG: 'Hlavou xG',
    HeadedSetPieceTooltip: 'Zobrazují se pouze hráči, kteří mají hlavičky ze standardek',
    HsrDistanceIP: 'HSR Vzdálenost IP',
    HsrDistanceOOP: 'HSR Vzdálenost OOP',
    JoggingDistanceIP: 'Jogging Vzdálenost IP',
    JoggingDistanceOOP: 'Vzdálenost běhu OOP',
    RunningDistanceIP: 'Běžící vzdálenost IP',
    RunningDistanceOOP: 'Běžecká vzdálenost OOP',
    SprintsDistanceIP: 'Sprinty Vzdálenost IP',
    SprintsDistanceOOP: 'Vzdálenost sprintů OOP',
    WalkingDistanceIP: 'Pěší vzdálenost IP',
    WalkingDistanceOOP: 'Pěší vzdálenost OOP',
    PossessionRegain: 'Znovuzískání držení',
    HandPassesSuccessful: 'Úspěšné přihrávky rukou',
    HandPassesTotal: 'Ruční přihrávky',
    SprintsNumberIP: 'Počet sprintů IP',
    SprintsNumberOOP: 'Množství sprintů OOP',
    RunningNumberIP: 'Běžící množství IP',
    RunningNumberOOP: 'Běžící množství OOP',
    HsrNumberIP: 'HSR Množství IP',
    HsrNumberOOP: 'HSR Množství OOP',
    InterceptionsNotAdjusted: 'Interceptions',
    ClearancesNotAdjusted: '',
    RecoveriesNotAdjusted: 'Recoveries'
  },
  team: {
    title: 'Týmový list',
    subtitle: 'Ponořte se hlouběji do charakteristik a statistik týmu',
    averageAge: 'Průměrný věk',
    transferBalance: 'Bilance přestupů',
    roster: 'Soupiska',
    stadium: 'Stadion',
    coach: 'Trenér',
    transfers: 'Přestupy',
    trends: 'Trendy',
    loans: 'Půjčky',
    loanFrom: 'Půjčka od',
    loanTo: 'Půjčka do',
    latestGames: 'Nejnovější zápasy',
    latestXGames: 'Nejnovějších {0} zápasů',
    playingFor: 'Hraje za',
    overview: 'Přehled',
    visualization: 'Vizualizace',
    location: 'Umístění',
    outcome: 'Výsledek',
    beeswarm: 'Pořadí',
    parentTeam: 'Hlavní tým',
    childTeam: 'Mládežnický tým',
    preferredFormation: 'Preferovaná formace',
    mostFrecuentFormations: 'Nejčastější formace',
    viewType: 'Typ zobrazení',
    overviewTab: {
      axisXTotal: 'Celkem',
      axisXper90: 'Na 90\'',
      dataPerGameText: 'Data na zápas',
      season: 'Sezóna',
      last: 'Poslední',
      current: 'Aktuální',
      TeamStyle: 'Styl',
      TeamDefensive: 'Defenzivní',
      TeamOffensive: 'Útočný',
      TeamCustom1: 'Vlastní 1',
      TeamCustom2: 'Vlastní 2',
      TeamCustom3: 'Vlastní 3',
      TeamCustom4: 'Vlastní 4',
      coach: 'Trenér',
      groups: {
        Goals: {
          name: 'Góly',
          desc: 'Zobrazuje góly z penalty a góly bez penalty (Otevřená hra a standardní situace).'
        },
        Assists: {
          name: 'Asistence',
          desc: 'Hráči s více asistencemi (Otevřená hra a standardní situace) v této sezóně.'
        },
        xG: {
          name: 'Očekávané góly',
          desc: 'Očekávané góly z otevřené hry a standardních situací'
        },
        xA: {
          name: 'Očekávané asistence',
          desc: 'Očekávané asistence z otevřené hry a standardních situací.'
        },
        Finishing: {
          name: 'Dokončování',
          desc: 'Procento střel končících gólem.'
        },
        ScoringContribution: {
          name: 'Přínos ke skórování',
          desc: 'Počet asistencí a gólů týmu.'
        },
        xT: {
          name: 'Očekávaná hrozba',
          desc: 'Očekávaná hrozba vygenerovaná z otevřené hry, standardních situací a negativního xT.'
        }
      },
      stats: {
        openPlay: 'Otevřená hra',
        setPiece: 'Standardní situace',
        negative: 'Negativní',
        npg: 'Góly bez penalty',
        goalsPenalty: 'Góly z penalty',
        npgOpenPlay: 'Góly bez penalty otevřená hra',
        npgSetPiece: 'Góly bez penalty standardní situace',
        assists: 'Asistence',
        assistsConceded: 'Inkasované asistence',
        assistsOpenPlay: 'Asistence otevřená hra',
        assistsSetPiece: 'Asistence standardní situace',
        xGOpenPlay: 'xG otevřená hra',
        xGSetPiece: 'xG standardní situace',
        xAOpenPlay: 'xA otevřená hra',
        xASetPiece: 'xA standardní situace',
        xAConceded: 'Inkasované xA',
        nonPenaltyShots: 'Střely bez penalty',
        penaltyShots: 'Střely z penalty',
        xT: 'Očekávaná hrozba',
        xTOpenPlay: 'xT otevřená hra',
        xTSetPiece: 'xT standardní situace',
        xTNeg: 'Negativní xT',
        totalFinishing: 'Dokončování',
        nonPenaltyFinishing: 'Dokončování bez penalty',
        goalsPenaltyFinishing: 'Dokončování z penalty',
        goal: 'Gól',
        notGoal: 'Není gól',
        chance: 'Šance',
        finished: 'Dokončeno',
        notFinished: 'Nedokončeno',
        walkingDistance: 'Chůze',
        joggingDistance: 'Jogging ',
        runningDistance: 'Běh ',
        hsrDistance: 'HSR',
        sprintsDistance: 'Sprintování',
        runningNumber: 'Běhy',
        hsrNumber: 'HSR Sprinty',
        sprintsNumber: 'Sprinty',
        maxSpeed: 'Max. rychlost',
        accelerations: 'Zrychlení',
        extremeAccelerations: 'Extrémní zrychlení',
        maxAcceleration: 'Maximální zrychlení'
      }
    },
    teamAnalysis: 'Analýza týmu',
    agentView: {
      positions: {
        gk: 'BR',
        leftFullback: 'Levý obránce',
        centralDefender: 'Střední obránce',
        rightFullback: 'Pravý obránce',
        midfielder: 'Záložník',
        attackingMidfielder: 'Útočný záložník',
        leftWinger: 'Levé křídlo',
        rightWinger: 'Pravé křídlo',
        fw: 'Útočník'
      },
      groups: {
        contractEnd: 'Měsíce',
        age: 'Let',
        availability: 'Dostupnost'
      },
      placer: {
        legend: 'Síla založená na věku, smlouvě, dostupnosti a výkonu'
      }
    },
    transfersTab: {
      valueMovements: 'Hodnota pohybů',
      valueTransfers: 'Hodnota přestupů',
      valueLoans: 'Hodnota půjček',
      avgAgeMovements: 'Průměrný věk pohybů',
      avgAgeTransfers: 'Průměrný věk přestupů',
      avgAgeLoans: 'Průměrný věk půjček',
      operations: {
        buys: {
          buy: 'Koupě',
          loan: 'Půjčka',
          'end of loan': 'Konec půjčky',
          'free transfer': 'Volný přestup',
          free: 'Volný',
          'loan transfer': 'Půjčka',
          other: 'Jiné'
        },
        sells: {
          buy: 'Prodej',
          loan: 'Půjčka',
          'end of loan': 'Konec půjčky',
          'free transfer': 'Volný přestup',
          free: 'Volný',
          'loan transfer': 'Půjčka',
          other: 'Jiné',
          retired: 'Ukončil kariéru'
        }
      }
    },
    trendsTab: {
      streaks: 'Série',
      wins: 'Vítězství',
      cleanSheets: 'Čistá konta',
      goalPeriods: 'Období vstřelených gólů',
      concededGoalPeriods: 'Období obdržených gólů',
      comebacks: 'Návraty',
      avgTime: 'Průměrný čas',
      kindOfGoals: 'Typ gólů',
      percentWinning: '% Vítězství',
      percentDrawing: '% Remízy',
      percentLosing: '% Prohry',
      totalOf: 'Celkem',
      minutes: 'minut',
      before: 'Před',
      after: 'Po',
      playedOn: 'Hráno dne',
      scored: 'Vstřeleno',
      conceded: 'Obdrženo',
      ownGoals: 'Vlastní góly',
      phasesOfGame: 'Fáze hry',
      intensityLabel: 'Intenzita zóny',
      intensityByTeam: 'Podle týmu %',
      intensityByLeagueAvg: 'Podle průměru ligy %',
      buildup: 'Buildup',
      midfieldProgression: 'Postup středem hřiště',
      attackOpposition: 'Útok na soupeře',
      attackingTransition: 'Útočný přechod',
      highPress: 'Vysoký tlak',
      midBlock: 'Střední blok',
      lowBlock: 'Nízký blok',
      defensiveTransition: 'Defenzivní přechod',
      draws: 'Remízy',
      losts: 'Prohry',
      chokes: 'Škrcení',
      zoneTooltip: 'Určuje kritéria použitá pro barevný přechod každého bloku:',
      teamPctTooltip: 'Na základě procenta celkového času odehraného týmem v každé zóně.',
      leagueAvgPctTooltip: 'Porovná procento týmu s průměrem ligy pro každou zónu.',
      leagueAvgMinsTooltip: 'Použije stejná srovnávací kritéria vůči lize, ale vyhodnotí celkový čas v minutách místo v procentech.',
      losses: 'Ztráty',
      results: 'Výsledky',
      kindOfConcededGoals: 'Typy inkasovaných cílů',
      showMinutes: 'Zobrazit minuty'
    },
    onOff: 'Zapnuto/Vypnuto',
    dragUpToXPlayers: 'Přetáhněte až {x} hráčů',
    selectUpToXPlayers: 'Vyberte až {x} hráčů',
    onOffTab: {
      G90: 'Góly 90',
      GA90: 'Obdržené góly 90',
      diffG90: 'Rozdíl gólů 90',
      XG90: 'xG 90',
      XGA90: 'Obdržené xG 90',
      diffXG90: 'Rozdíl xG 90',
      playersOn: 'Kombinace ZAPNUTO',
      playersOff: 'Kombinace VYPNUTO',
      ground: 'Hřiště',
      playersOnThePitch: 'Hráči na hřišti',
      playersOffThePitch: 'Hráči mimo hřiště',
      attackTitle: 'Útok',
      attackSubTitle: 'Útočné statistiky',
      defenseTitle: 'Obrana',
      defenseSubTitle: 'Defenzivní statistiky',
      associationTitle: 'Asociace',
      associationSubTitle: 'Asociační statistiky',
      comboOn: 'Aktivní kombinace',
      comboOff: 'Jakákoli jiná',
      diffGoals90: 'Rozdíl gólů 90',
      goals90: 'Góly bez penalty 90',
      goalsAgainst90: 'Obdržené góly bez penalty 90',
      xgAgainstPer90: 'Obdržené xG 90',
      xgDiffPer90: 'Rozdíl xG 90',
      xgPer90: 'xG 90',
      xt90: 'xT 90',
      shotsOnTarget90: 'Střely na branku 90',
      touchesOppBox90: 'Dotyků soupeřovo pokutové území 90',
      shotsOnTargetAgainst90: 'Obdržené střely na branku 90',
      ppda90: 'PPDA 90',
      xa90: 'xA 90',
      directness90: 'Přímost 90',
      possession: 'Držení míče %',
      pctPasses: 'Přihrávky %',
      pctPassesFinalThird: 'Přihrávky finální třetina %',
      placeholder: 'Začněte výběrem týmu',
      subtitle: 'Optimalizujte metriky týmu přidáním nebo odebráním hráčů ze sestavy'
    },
    terms: {
      short: 'Krátkodobé',
      mid: 'Střednědobé',
      long: 'Dlouhodobé'
    },
    report: {
      title: 'Zpráva o týmu',
      selectedPeriod: 'Vybrané období',
      stackedCharts: 'Skládané grafy',
      radars: 'Radary',
      generalData: 'Obecná data',
      scoringChances: 'Střelecké šance',
      areasReport: 'Zpráva o oblastech',
      setPieceReport: 'Zpráva o standardních situacích',
      corners: 'Rohové kopy',
      cornersAgainst: 'Obdržené rohové kopy',
      indirectFreeKicks: 'Nepřímé volné kopy',
      indirectFreeKicksAgainst: 'Obdržené nepřímé volné kopy',
      freeKicks: 'Volné kopy',
      freeKicksAgainst: 'Obdržené volné kopy',
      penaltys: 'Penalty',
      freeKicksContribution: 'Přínos volných kopů',
      shotsContribution: 'Přínos střel',
      topXPlayersByStats: 'Top {x} hráčů podle statistik',
      lastShotZone: 'Poslední zóna střely',
      throwSide: 'Strana vhazování',
      kindOfThrow: 'Typ vhazování',
      scored: 'Vstřeleno',
      against: 'Proti',
      perGame: 'na zápas',
      total: 'Celkem',
      efficiency: 'Efektivita',
      organizedAttack: 'Organizovaný útok',
      offTransition: 'Útočný přechod',
      chances: 'Šance',
      chancesScored: 'Vstřelené šance',
      chancesAgainst: 'Obdržené šance',
      goalsScored: 'Vstřelené góly',
      goalsAgainst: 'Obdržené góly',
      goalsOrganizedAttack: 'Góly organizovaný útok',
      goalsOffTransition: 'Góly útočný přechod',
      goalsSetPiece: 'Góly standardní situace',
      goalsOrganizedAttackScored: 'Vstřelené góly org. útok',
      goalsOrganizedAttackAgainst: 'Obdržené góly org. útok',
      goalsOffTransitionScored: 'Vstřelené góly útočný přechod',
      goalsOffTransitionAgainst: 'Obdržené góly útočný přechod',
      goalsSetPieceScored: 'Vstřelené góly standardní situace',
      goalsSetPieceAgainst: 'Obdržené góly standardní situace',
      crossSide: 'Strana centru',
      externalShot: 'Vnější střela',
      innerPlay: 'Vnitřní hra',
      throwIn: 'Vhazování',
      box: 'Pokutové území',
      zone2: 'Zóna 2',
      goalsPerPhases: 'Góly na fáze'
    },
    minutesAlert: '*Zobrazují se pouze hráči s 450 nebo více odehranými minutami',
    minutesException: 'Nejsou žádní hráči s 450 nebo více odehranými minutami. Zobrazují se všichni hráči',
    analysis: 'Analýza',
    substitutions: 'Střídání',
    attackZones: 'Útočné zóny',
    formations: 'Formace',
    shotZones: 'Zóny střel',
    crossings: 'Centrování',
    byTime: 'Podle času',
    byPosition: 'Podle pozice',
    byPlayer: 'Podle hráče',
    W: 'Vítězství',
    D: 'Remíza',
    L: 'Prohra',
    substitutionsByGame: 'Střídání podle zápasu',
    substitutionsShort: 'Střídání',
    avgSeasonShort: 'Průměr sezóny',
    startingAt: 'Začíná v',
    endingAt: 'Končí v',
    startingAtInfo: 'Zobrazuje podíl držení míče na základě umístění první události',
    endingAtInfo: 'Zobrazuje podíl držení míče na základě umístění poslední události',
    endingWithShot: 'Končí střelou',
    endingInBox: 'Končí v pokutovém území',
    pfX: 'PF {x}',
    bySide: 'Podle strany',
    cornerKicks: 'Rohové kopy',
    included: 'Zahrnuto',
    excluded: 'Vyloučeno',
    onlyCorner: 'Pouze rohové kopy',
    sizeByMarketValue: 'Velikost podle tržní hodnoty',
    timeInTeam: 'Sezóny v týmu',
    newSignings: 'Nové přestupy',
    sizeBy: 'Velikost podle',
    connections: 'Spojení',
    assistant: 'Přihrávající',
    finisher: 'Dokončující',
    playersMinutesAlert: 'Zobrazují se pouze hráči s odehranými minutami ve vybrané sezóně',
    strategyFilterTooltip: 'Zobrazte události, které se staly během setů nebo během otevřené hry',
    sideFilterTooltip: 'Zobrazit pouze sady, které začínají na zvolené straně (vlevo nebo vpravo)',
    teamMinutesAlert: '*Zobrazeny pouze týmy se 450 nebo více odehranými minutami',
    homeCoach: 'Domácí trenér',
    awayCoach: 'Trenér venku'
  },
  leagueTable: {
    subtitle: 'Zkontrolujte, jak ligy probíhají'
  },
  leagueMatchdays: {
    byRound: 'Podle kola',
    byDate: 'Podle data',
    byTeam: 'Podle týmu'
  },
  teamStats: {
    subtitle: 'Porovnejte, jak si týmy vedou',
    xGDiffPerGame: 'xGD',
    xGDiffPerGameExplicit: 'Rozdíl mezi očekávanými góly a góly',
    expectedPointsDiff: 'xPD',
    expectedPointsDiffExplicit: 'Rozdíl mezi očekávanými body a body',
    games: 'ZÁP',
    gamesExplicit: 'Odehrané zápasy',
    pointsPerGame: 'BPZ',
    pointsPerGameExplicit: 'Body na zápas'
  },
  roles: {
    ROLE_USER: 'Uživatel',
    ROLE_ADMIN: 'Admin',
    ROLE_REPORTS: 'Driblab Reports',
    ROLE_API: 'Driblab API',
    ROLE_PHYSICAL_DATA: 'Driblab Physical Data',
    ROLE_VIDEO: 'Capture',
    ROLE_EVENTING_DATA: 'Driblab XY',
    ROLE_DRIBLAB_HUB: 'Driblab Hub',
    ROLE_TRACKING: 'Tracking',
    ROLE_ARRIGO: 'Arrigo',
    ROLE_API_description: 'Snadno extrahujte informace o hráčích, týmech, zápasech a ligách ve formátu JSON.',
    ROLE_EVENTING_DATA_description: 'Ponořte se hluboko do statistik pomocí radarových grafů, žebříčků hráčů, map a dalších nástrojů založených na více než 100 výkonnostních metrikách.',
    ROLE_PHYSICAL_DATA_description: 'Přístup k fitness datům a filtrování hráčů podle různých výkonnostních metrik (vzdálenost, rychlost, sprinty, zrychlení…).',
    ROLE_VIDEO_description: 'Poskytněte videa a sestavy a získejte zápasy označené událostmi a statistikami pro hloubkovou analýzu.',
    ROLE_DRIBLAB_HUB_description: 'Efektivně sledujte a spravujte skautingové úkoly pomocí kalendářů, poznámek, upozornění a sdílení dokumentů.',
    ROLE_TRACKING_description: 'Přijímejte pozicová data všech hráčů v zápase prostřednictvím našeho API pro komplexní analýzu.',
    ROLE_ARRIGO_description: 'Kombinujte eventing a tracking data do inovativních metrik, které jdou nad rámec tradičních a přidávají hodnotu každé akci.',
    ROLE_REPORTS_description: 'Požádejte o podrobné skautingové zprávy od našeho týmu analytiků, abyste našli perfektní tým nebo hráče.',
    ROLE_RAW_EVENTING: 'Raw Eventing'
  },
  administration: {
    pageSubtitle: 'Spravujte provoz aplikace',
    newClient: 'Nový klient',
    clientDuplicateName: 'Klient s tímto názvem již existuje. Vyberte jej v seznamu a pomocí „Nový uživatel“ přidejte uživatele k tomuto klientovi.',
    newUser: 'Nový uživatel',
    editClient: 'Upravit klienta',
    editUser: 'Upravit uživatele',
    clientName: 'Název',
    permissions: 'Oprávnění',
    releaseUser: 'Uvolnit uživatele',
    connectAsUser: 'Připojit se jako uživatel',
    releaseModalTitle: 'Potvrzení uvolnění uživatele',
    releaseModalMessage: 'Uživatel obdrží e-mail o svém novém účtu. Jste si jisti, že ho chcete upozornit?',
    clientType: {
      Driblab: 'Driblab',
      Team: 'Tým',
      Brand: 'Značka',
      Federation: 'Federace',
      Media: 'Média',
      Agency: 'Agentura',
      Individual: 'Jednotlivec'
    },
    userType: {
      Ownership: 'Vlastnictví',
      SportingDirector: 'Sportovní ředitel',
      Brand: 'Značka',
      Federation: 'Federace',
      Media: 'Média',
      Agency: 'Agentura',
      Individual: 'Jednotlivec',
      Scout: 'Skaut',
      Coach: 'Trenér',
      supervision: {
        title: 'Hierarchie dohledu',
        subtitle: 'Dohled směřuje pouze dolů. Dohled na stejné úrovni není povolen.',
        supervisesLowerLevels: 'Dohlíží na všechny níže uvedené role',
        ruleNoSameLevel: 'Role na stejné úrovni nemohou navzájem dohlížet.',
        ruleOnlyDownwards: 'Dohled je povolen pouze z vyšších do nižších rolí.',
        ruleLevel3NoSupervision: 'Nejnižší úroveň nemá žádná oprávnění k dohledu.',
        currentUserType: 'Váš aktuální typ uživatele'
      }
    },
    visibleYears: 'Viditelné roky',
    areaModalTitle: 'Potvrzení aktivace/deaktivace lig',
    areaModalMessage: 'Jste si jisti, že chcete aktivovat/deaktivovat všechny ligy z vybrané oblasti?',
    countStats: 'Počítat statistiky',
    userClientModalTitle: 'Uživatel již existuje u jiného klienta',
    eventing: 'Eventing',
    hub: 'Hub',
    contract: 'Smlouva',
    contracts: 'Smlouvy',
    invoiceName: 'Název faktury',
    contractFee: 'Poplatek za smlouvu',
    renewal: 'Obnova',
    consultancy: 'Poradenství',
    deleteContract: 'Smazat smlouvu klienta',
    deleteContractMessage: 'Smlouva bude trvale odstraněna. Jste si jisti?',
    activeVsHired: 'Aktivní vs Najatí',
    requestedVsHired: 'Požadováno vs Najatí',
    activeVsHiredWithPlaceholder: '{0} Aktivní vs {1} Najatí',
    requestedVsHiredWithPlaceholder: '{0} Vyžádáno vs {1} Najato',
    salesRepresentative: 'Obchodní zástupce',
    periodicities: {
      periodicity: 'Periodicita',
      annual: 'Roční',
      biannual: 'Pololetní',
      quarterly: 'Čtvrtletní',
      monthly: 'Měsíční',
      bimonthly: 'Dvouměsíční',
      onePayment: 'Jednorázová platba',
      fourmonthly: 'Každé čtyři měsíce'
    },
    paymentMethods: {
      payment: 'Platba',
      method: 'Metoda',
      transfer: 'Převod',
      mandate: 'Mandát'
    },
    marketingOptions: {
      marketing: 'Marketing',
      socialMediaAdd: 'Reklama na sociálních sítích',
      videoWithFeedback: 'Video s feedbackem'
    },
    status: {
      status: 'Status',
      pending: 'Čekající',
      active: 'Aktivní',
      expiringSoon: 'Brzy vyprší',
      expired: 'Vypršel',
      expiringSoonWithDays: 'Smlouva brzy vyprší: zbývá {0} dnů'
    },
    updates: {
      roleAdded: '<b>{0}</b> přidal roli <b>{1}</b> do <b>{2}</b>.',
      roleRemoved: '<b>{0}</b> odebral roli <b>{1}</b> z <b>{2}</b>.',
      leagueAdded: '<b>{0}</b> přidal <b>{1}</b> do ligy <b>{2}</b>.',
      leagueRemoved: '<b>{0}</b> odebral <b>{1}</b> z ligy <b>{2}</b>.',
      seasonAdded: '<b>{0}</b> přidal <b>{1}</b> do řady <b>{2}</b>.',
      seasonRemoved: '<b>{0}</b> odebral <b>{1}</b> ze série <b>{2}</b>.',
      updateNotesPlaceholder: 'Uveďte prosím kontext pro změnu nebo sem přidejte jakékoli relevantní poznámky...',
      updates: 'Aktualizace',
      products: 'Produkty'
    },
    clients: 'klienti',
    trials: 'Zkoušky',
    activeClients: 'Aktivní klienti',
    activeTrials: 'Aktivní zkoušky',
    activeTrialUsers: 'Aktivní zkušební uživatelé',
    activeContracts: 'Aktivní smlouvy',
    expiration: 'Vypršení platnosti',
    clientWarnings: {
      activeContractInactiveClient: 'Klienti s aktivními smlouvami, ale bez povolených uživatelů',
      activeContractTrialUsers: 'Klienti se zkušebními uživateli, když je smlouva aktivní',
      activeUsersWithoutContract: 'Klienti s aktivními uživateli bez zkušební verze, ale bez aktivní smlouvy',
      upcomingExpirations: 'Blížící se expirace',
      renewedContracts: 'Klienti na základě obnovených smluv',
      clientsWithWarnings: 'Klienti vyžadující pozornost',
      enabledUsersWithoutContract: '„Povolení uživatelé bez zkušební verze bez aktivní smlouvy“',
      trialUsersWithContract: 'Uživatelé ve zkušebním režimu navzdory aktivní smlouvě',
      activeContractInactiveUsers: 'Klient má aktivní smlouvu se všemi neaktivními uživateli',
      activeContract: 'Tento klient má aktivní smlouvu',
      noEnabledUsers: 'Tento klient nemá žádné povolené uživatele',
      ongoingTrialInactiveUsers: 'Klienti s probíhající zkušební verzí, ale bez povolených uživatelů',
      neverLoggedIn: 'Klienti, kteří se nikdy nepřihlásili'
    },
    daysLeft: 'Zbývající dny',
    expiringSoon: 'Brzy vyprší platnost',
    loggedThisWeek: 'Přihlášeno tento týden',
    withWarnings: 'S varováními',
    ofActiveClients: 'aktivních klientů',
    endingIn30Days: 'končí za 30 dní',
    neverLogged: 'nikdy se nepřihlásil',
    ofActiveTrials: 'aktivních zkoušek',
    activeClientsWithoutTrial: 'aktivní klienti (kromě zkušební verze)',
    renewals: 'Obnovení',
    ofActiveContracts: 'aktivních smluv'
  },
  dashboards: {
    lastGame: 'Analýza posledního zápasu',
    lastGameSimple: 'Poslední zápas',
    seeAllGameInfo: 'Zobrazit všechny informace o zápase',
    nextGame: 'Náhled dalšího zápasu',
    myTeam: 'Můj tým',
    lastMatchdayGames: 'Poslední kolo',
    lastAdded: 'Poslední přidané',
    myFavorites: 'Moje oblíbené',
    seeAllFavorites: 'Zobrazit všechny oblíbené',
    placeholderFavorites: 'Oblíbené můžete přidat z detailu hráče',
    placeholderTeamFavorites: 'Oblíbené můžete přidat z detailu týmu',
    placeholderLeagueFavorites: 'Oblíbené můžete přidat z detailu ligy',
    myCollections: 'Moje kolekce',
    placeholderCollections: 'Zatím nemáte žádné kolekce',
    lastCreated: 'Poslední vytvořené',
    seeAllCollections: 'Zobrazit všechny kolekce',
    seeRival: 'Zobrazit soupeře',
    seeMyTeam: 'Zobrazit můj tým',
    title: 'Přehled nástěnky',
    subtitle: 'Vítejte zpět',
    recentPlayers: 'Nedávní hráči',
    lastScouted: 'Poslední skautovaní',
    scout: 'Skaut',
    reportsRequested: 'Zprávy',
    lastRequested: 'Poslední požadované',
    goInbox: 'Přejít do schránky',
    placeholderLastScouted: 'Hráče můžete vyhledat v levém panelu nebo v nástroji skaut',
    placeholderReports: 'Zprávy můžete požádat z detailu hráče',
    nationalPlayers: 'Nejcennější národní hráči v jiných zemích',
    lastGames: 'Poslední zápasy',
    nationalPlayersShort: 'Národní hráči v jiných zemích',
    nextMatchdayGames: 'Další kolo',
    injuredPlayers: 'Zranění hráči',
    atPresent: 'V současnosti',
    seeAllPlayers: 'Zobrazit všechny hráče',
    suspendedPlayers: 'Suspendovaní hráči',
    placeholderInjured: 'Nejsou žádní zranění hráči',
    teamValueImpacted: 'Ovlivněná hodnota týmu',
    placeholderSuspended: 'Nejsou žádní suspendovaní hráči',
    placeholderNextGame: 'Není k dispozici žádný zápas',
    placeholderNoGames: 'Zatím nejsou k dispozici žádné zápasy',
    placeholderLastMatchDayNotFound: 'Poslední kolo není k dispozici',
    placeholderNextMatchDayNotFound: 'Další kolo není k dispozici',
    usersMostSearch: 'Uživatelé s nejvíce vyhledáváními',
    lastTwoDays: 'Poslední dva dny',
    searchesHistory: 'Historie vyhledávání',
    dayByDay: 'Denně',
    activeUsersTitle: 'Aktivní uživatelé',
    activeUsersSubtitle: 'Přihlášeni alespoň jednou v posledním měsíci',
    onlineUsersTitle: 'Online uživatelé',
    onlineUsersSubtitle: 'Vyhledali něco v poslední hodině',
    searchesPerformed: 'Provedená vyhledávání',
    onlyClients: 'Pouze klienti',
    activeClientsTitle: 'Aktivní klienti',
    activeClientsSubtitle: 'Mají alespoň jednoho aktivního uživatele',
    last24Hours: 'Posledních 24 hodin',
    activityHistory: 'Historie aktivity',
    loginHistory: 'Historie přístupů',
    failLogins: 'Neúspěšné přístupy',
    successLogins: 'Úspěšné přístupy',
    clientStats: 'Statistiky klientů',
    playersMostSearch: 'Hráči s nejvíce vyhledáváními',
    toolsMoreUsed: 'Nejvíce používané nástroje',
    hotPlayers: 'Populární hráči',
    last_month: 'Poslední měsíc',
    last_week: 'Poslední týden',
    last_day: 'Poslední den',
    nClients: 'Počet klientů',
    userDashboard: 'Uživatelská nástěnka',
    userDashboardSubtitle: 'Souhrn aktivity účtu',
    offlineDaysOfClient: 'Offline dny pro každého klienta',
    hideNoConnected: 'Skrýt nepřipojené',
    onlyTrial: 'Pouze zkušební klienti',
    daysWithoutLogin: 'Dny bez přihlášení',
    trialDays: 'Zkušební dny'
  },
  faq: {
    subtitle: 'Zjistěte více o tom, co je Driblab PRO',
    categories: {
      playerMetrics: 'Metriky hráčů',
      teamMetrics: 'Metriky týmů',
      positions: 'Pozice týmu',
      tools: 'Nástroje',
      api: 'API',
      videos: 'Tutoriály',
      playerPositions: 'Pozice hráčů',
      userTypes: 'Typy uživatelů'
    },
    positions: {
      GK: 'Brankář',
      DR: 'Pravý obránce / Pravý krajní obránce (RB)',
      DC: 'Střední obránce / Stoper (CB)',
      DL: 'Levý obránce / Levý krajní obránce (LB)',
      DMR: 'Pravý křídelní obránce (RWB)',
      DMC: 'Defenzivní záložník (CDM)',
      DML: 'Levý křídelní obránce (LWB)',
      MR: 'Pravý záložník (RM)',
      MC: 'Střední záložník (CM)',
      ML: 'Levý záložník (LM)',
      AMR: 'Útočný záložník vpravo / Pravé křídlo (RW)',
      AMC: 'Útočný záložník ve středu / Ofenzivní záložník',
      AML: 'Útočný záložník vlevo / Levé křídlo (LW)',
      FWR: 'Útočník vpravo / Pravý útočník (RS)',
      FW: 'Útočník / Střední útočník (ST)',
      FWL: 'Útočník vlevo / Levý útočník (LS)'
    },
    metrics: {
      categories: {
        Association: 'Asociace',
        Saving: 'Zachraňování',
        Shooting: 'Střelba',
        Defending: 'Obrana',
        Passing: 'Přihrávky',
        BallHandling: 'Práce s míčem',
        Aerial: 'Vzdušné souboje',
        Physical: 'Fyzická kondice',
        Predictive: 'Prediktivní',
        Arrigo: 'Arrigo',
        Score: 'Skóre',
        Turnovers: 'Ztráty míče',
        Carries: 'Nosičství',
        SequenceInvolvement: 'Zapojení do sekvencí',
        Crosses: 'Centrování',
        Distance: 'Vzdálenost',
        Sprint: 'Sprint',
        Acceleration: 'Zrychlení',
        MaxAcceleration: 'Maximální zrychlení',
        Speed: 'Rychlost',
        OutPlay: 'Překonání',
        LineBreakingPasses: 'Přihrávky prolamující linie',
        LineBreakingCarries: 'Nosičství prolamující linie',
        LineBreakingActions: 'Akce prolamující linie',
        PassUnderPressure: 'Přihrávka pod tlakem',
        BallReceived: 'Příjem míče',
        PassesUnderPressure: 'Prochází Pod Tlakem',
        OnBallPressureReceived: 'Tlak na míč přijatý',
        OnBallPressure: 'Tlak na míč',
        BallReceiptsInSpace: 'Příjem míče v prostoru',
        SpatialCoverage: 'Prostorové pokrytí',
        OffBallPressure: 'Tlak bez míče',
        OffBallRuns: 'Běhy bez míče',
        NoCategory: 'Ostatní',
        subcategories: {
          Quality: 'Kvalita',
          Quantity: 'Množství',
          TeamComparison: 'Srovnání týmů',
          Receptions: 'Příjmy',
          LongBalls: 'Dlouhé míče',
          Efficiency: 'Efektivita',
          Ratio: 'Poměr',
          Defensive: 'Defenzivní',
          Offensive: 'Útočný',
          Foot: 'Noha',
          Progression: 'Progrese',
          TopValue: 'Nejvyšší hodnota',
          Predictive: 'Prediktivní',
          Distance: 'Vzdálenost',
          Aerial: 'Vzdušné souboje',
          Crosses: 'Centrování',
          NoCategory: 'Ostatní'
        },
        desc: {
          Association: 'Asociace',
          Saving: 'Zachraňování',
          Shooting: 'Střelba',
          Defending: 'Obrana',
          Passing: 'Přihrávky',
          BallHandling: 'Práce s míčem',
          Aerial: 'Vzdušné souboje',
          Physical: 'Fyzická kondice',
          Predictive: 'Prediktivní',
          Arrigo: 'Arrigo',
          Score: 'Skóre',
          Turnovers: 'Ztráty míče',
          Carries: 'Nosičství',
          SequenceInvolvement: 'Zapojení do sekvencí',
          Crosses: 'Centrování',
          Distance: 'Vzdálenost uražená různými rychlostmi',
          Sprint: 'Sprint různými rychlostmi',
          Acceleration: 'Zrychlení',
          Speed: 'Rychlost dosažená hráči v určitém okamžiku během zápasu',
          OutPlay: 'Překonání',
          LineBreakingPasses: 'Přihrávky prolamující linie',
          LineBreakingCarries: 'Nosičství prolamující linie',
          LineBreakingActions: 'Akce prolamující linie',
          PassUnderPressure: 'Přihrávka pod tlakem',
          BallReceived: 'Příjem míče',
          OnBallPressureReceived: 'Tlak na míč přijatý',
          OnBallPressure: 'Tlak na míč',
          BallReceiptsInSpace: 'Příjem míče v prostoru',
          SpatialCoverage: 'Prostorové pokrytí',
          OffBallPressure: 'Tlak bez míče',
          OffBallRuns: 'Běhy bez míče',
          HandPassing: 'Přihrávky prováděné brankáři rukou nebo vhazování při standardce'
        },
        abbr: {
          Association: 'Asociace',
          Saving: 'Zachraňování',
          Shooting: 'Střelba',
          Defending: 'Obrana',
          Passing: 'Přihrávky',
          BallHandling: 'Práce s míčem',
          Aerial: 'Vzdušné souboje',
          Physical: 'Fyzická kondice',
          Predictive: 'Prediktivní',
          Arrigo: 'Arrigo',
          Score: 'Skóre',
          Turnovers: 'Ztráty míče',
          Carries: 'Nosičství',
          SequenceInvolvement: 'Zapojení do sekvencí',
          Crosses: 'Centrování',
          Distance: 'Vzdálenost',
          Sprint: 'Sprint',
          Acceleration: 'Zrychlení',
          MaxAcceleration: 'Max. zrychlení',
          Speed: 'Rychlost',
          OutPlay: 'Překonání',
          LineBreakingPasses: 'Přihrávky prolamující linie',
          LineBreakingCarries: 'Nosičství prolamující linie',
          LineBreakingActions: 'Akce prolamující linie',
          PassUnderPressure: 'Přihrávka pod tlakem',
          BallReceived: 'Příjem míče',
          OnBallPressureReceived: 'Tlak na míč přijatý',
          OnBallPressure: 'Tlak na míč',
          BallReceiptsInSpace: 'Příjem míče v prostoru',
          SpatialCoverage: 'Prostorové pokrytí',
          OffBallPressure: 'Tlak bez míče',
          OffBallRuns: 'Běhy bez míče',
          HandPassing: 'Ruční předávání'
        },
        HandPassing: 'Ruční předávání'
      },
      types: {
        1: 'Na 90',
        2: 'Procento',
        3: 'Míra',
        4: 'Efektivita',
        5: 'Průměr',
        6: 'Na zápas',
        7: 'Rozdíl',
        8: 'Max'
      },
      moreInfo: 'Více informací najdete zde'
    },
    api: {
      subtitle: 'Získejte data z různých požadavků',
      resourcesTitle: 'Zdroje',
      authentication: 'Autentizace',
      authText: 'Pro volání API musíte do každého požadavku zahrnout hlavičku `Authorization` s hodnotou `Bearer {API_TOKEN}`',
      generate: 'Generovat',
      tokenPlaceholder: 'Pokud nemáte token nebo vypršel, klikněte na \'Generovat\'',
      pathParameters: 'Parametry cesty',
      queryParameters: 'Parametry dotazu',
      responseModel: 'Model odpovědi',
      tokenWarning: '* Pro použití API vygenerujte token',
      pathParamsWarning: '* Existují nevyplněné parametry cesty',
      genericDescription: 'API (Application Programming Interface) umožňuje vývojářům přistupovat k datům nebo funkcionalitě a integrovat je do svých vlastních aplikací. Naše API pro fotbalové statistiky poskytuje komplexní přístup k různým datovým bodům o zemích, soutěžích, týmech, hráčích, zápasech a dalších. Použitím tohoto API můžete vytvářet aplikace, které využívají naše bohaté fotbalové údaje pro analýzy, vizualizace nebo jiná inovativní řešení.',
      methods: {
        getAllCountries: 'Tato metoda načte kompletní seznam všech zemí dostupných v API, poskytující klíčové detaily jako jedinečný identifikátor a název každé země. Tento endpoint je ideální pro aplikace vyžadující geografická fotbalová data, umožňující funkce jako výběr země, filtrování a analýzy. Slouží také jako základní zdroj pro interakci s jinými endpointy závislými na parametru `countryId`, zajišťující plynulou navigaci a integraci s širší datovou sadou API.',
        getCountryDetail: 'Tato metoda poskytuje podrobné informace o konkrétní zemi dostupné v API. Pomocí tohoto endpointu můžete načíst data jako název země, kód a jakákoli relevantní metadata s ní spojená. Tato metoda je obzvláště užitečná pro aplikace vyžadující specifické detaily o zemi pro zlepšení uživatelského zážitku, jako je zobrazení kontextových informací nebo vytváření přizpůsobených poznatků na základě geografických dat. Doplňuje jiné endpointy tím, že umožňuje hlubší průzkum vybrané země.',
        getCountryCompetitions: 'Tato metoda načte seznam všech soutěží dostupných v rámci konkrétní země. Je to cenný zdroj pro vytváření funkcí, které uživatelům umožňují prozkoumávat soutěže podle regionu, poskytující bezproblémový způsob propojení dat země s jejími přidruženými turnaji. Tento endpoint je nezbytný pro aplikace zaměřené na lokalizovaný fotbalový obsah nebo regionální analýzy.',
        getAllCompetitionTypes: 'Tato metoda vrátí seznam všech typů soutěží dostupných v API, jako jsou ligy, poháry a mezinárodní turnaje. Tento endpoint je ideální pro kategorizaci soutěží a poskytování uživatelům organizovaného pohledu na různé typy pokrytých událostí. Je obzvláště užitečný pro vytváření funkcí jako filtry nebo rozbalovací seznamy, které uživatelům umožňují prozkoumávat fotbalová data na základě povahy soutěže.',
        getAllCompetitions: 'Tato metoda načte komplexní seznam všech soutěží dostupných v API, bez ohledu na typ nebo umístění. Tento endpoint je užitečný pro aplikace, které potřebují zobrazit nebo analyzovat širokou škálu fotbalových soutěží, umožňující uživatelům prozkoumávat a vybírat události podle zájmu.',
        getCompetitionAvailable: 'Tato metoda načte seznam soutěží aktuálně označených jako dostupné v API. To zajišťuje, že vrácená data jsou aktuální a připravená k použití v aplikacích. Je obzvláště užitečná pro vývojáře vytvářející funkce závislé na aktivních nebo dostupných soutěžích, umožňující uživatelům prozkoumávat relevantní události bez setkání se zastaralými nebo neúplnými daty.',
        getCompetitionDetail: 'Tato metoda poskytuje podrobné informace o konkrétní soutěži dostupné v API. Je obzvláště užitečná pro aplikace vyžadující hloubkové informace o soutěži, umožňující funkce jako podrobné zobrazení, kontextové poznatky nebo možnosti filtrování na základě charakteristik soutěže.',
        getCompetitionSeasons: 'Tato metoda načte seznam všech sezón spojených s konkrétní soutěží. Tento endpoint je nezbytný pro aplikace, které mají za cíl poskytnout komplexní pokrytí historie soutěže nebo jejího současného stavu, umožňující uživatelům prozkoumávat data sezónu po sezóně.',
        getSeasonAvailable: 'Tato metoda poskytuje seznam sezón aktuálně označených jako dostupné v API. Je obzvláště užitečná pro aplikace zaměřené na živé nebo probíhající fotbalové události, umožňující uživatelům interagovat s relevantními a aktuálními daty sezóny.',
        getSeasonDetail: 'Tato metoda načte podrobné informace o konkrétní sezóně, včetně časové osy, přidružené soutěže a klíčových metadat. Tento endpoint je nezbytný pro aplikace vyžadující hloubkové poznatky o konkrétní sezóně, umožňující funkce jako přehledy sezón, filtrování podle soutěže nebo zobrazení podrobných časových os pro interakci uživatelů.',
        getSeasonTeams: 'Tato metoda poskytuje seznam všech týmů účastnících se konkrétní sezóny. Je ideální pro funkce jako správa soupisek, analýza výkonu týmů nebo vytváření sezónně specifických filtrů pro uživatele.',
        getSeasonPlayer: 'Tato metoda načte seznam všech hráčů registrovaných v konkrétní sezóně. Je ideální pro vytváření funkcí jako soupisky hráčů, sledování výkonu nebo filtrování hráčů na základě vybrané sezóny.',
        getSeasonPlayerStats: 'Tato metoda poskytuje podrobné statistiky pro všechny hráče v konkrétní sezóně. Je obzvláště užitečná pro aplikace zaměřené na analýzy, srovnání hráčů nebo vytváření dynamických vizualizací sezónních úspěchů hráčů.',
        getSeasonArrigoMetrics: 'Tato metoda poskytuje kombinované statistiky pro všechny hráče v konkrétní sezóně. Je obzvláště užitečná pro aplikace zaměřené na analýzy, srovnání hráčů nebo vytváření dynamických vizualizací sezónních úspěchů hráčů.',
        getSeasonTeamStats: 'Tato metoda poskytuje komplexní statistiky pro všechny týmy účastnící se konkrétní sezóny. Je obzvláště užitečná pro aplikace zaměřené na analýzu týmů, souhrny sezón nebo srovnání výkonu týmů v průběhu sezóny.',
        getSeasonCoaches: 'Tato metoda načte seznam všech trenérů, kteří vedli týmy během konkrétní sezóny. Je obzvláště užitečná pro aplikace zaměřené na poznatky o sezóně, analýzu trenérů nebo sledování změn v řízení týmů v průběhu sezóny.',
        getSeasonGames: 'Tato metoda poskytuje seznam všech zápasů odehraných v konkrétní sezóně. Je ideální pro aplikace, které potřebují zobrazit kompletní rozvrhy sezón, analyzovat výsledky zápasů nebo poskytnout uživatelům přístup k komplexním datům zápasů sezóny.',
        getSeasonGamesMatchday: 'Tato metoda načte všechny zápasy pro konkrétní kolo v rámci dané sezóny. Je obzvláště užitečná pro aplikace, které mají za cíl zobrazit rozvrhy kol, analyzovat konkrétní kola nebo poskytnout zaměřené poznatky do konkrétní sady zápasů během sezóny.',
        getSeasonLeagueTable: 'Tato metoda poskytuje ligovou tabulku pro konkrétní sezónu, včetně pořadí, bodů, výher, remíz, proher a dalších relevantních statistik pro každý tým. Tento endpoint je nezbytný pro aplikace zaměřené na sledování pozic týmů, analýzu postupu ligy nebo prezentování uživatelů aktuálními pořadími v průběhu sezóny.',
        getTeamDetail: 'Tato metoda poskytuje podrobné informace o konkrétním týmu, včetně jeho názvu, roku založení, stadionu a dalších metadat. Tento endpoint je ideální pro aplikace vyžadující specifické poznatky o týmu, umožňující funkce jako podrobné profily týmů, historický kontext nebo vylepšené uživatelské zážitky s bohatými daty souvisejícími s týmem.',
        getTeamLoans: 'Tato metoda načte informace o půjčkách zahrnujících konkrétní tým. Tento endpoint je obzvláště užitečný pro aplikace zaměřené na analýzu přestupů, správu soupisek týmů nebo sledování pohybů hráčů během sezóny.',
        getTeamRoster: 'Tato metoda poskytuje kompletní seznam hráčů v soupisce konkrétního týmu. Je ideální pro aplikace, které potřebují zobrazit sestavy týmů, analyzovat role hráčů nebo spravovat funkce související se soupiskami pro tým.',
        getTeamGames: 'Tato metoda načte seznam všech zápasů odehraných konkrétním týmem. Je obzvláště užitečná pro aplikace zaměřené na výkon týmů, sledování rozvrhů nebo poskytování uživatelům přístupu k kompletní historii zápasů týmu.',
        getTeamGameStats: 'Tato metoda poskytuje podrobné statistiky pro konkrétní tým v daném zápase. Je obzvláště užitečná pro aplikace zaměřené na analýzu zápasů, hodnocení výkonu nebo hloubkové rozbory výkonu týmu v jednotlivých zápasech.',
        getTeamTransfers: 'Tato metoda načte informace o přestupních transakcích zahrnujících konkrétní tým. Je obzvláště užitečná pro aplikace zaměřené na analýzu přestupního trhu, změny soupisek týmů nebo sledování pohybů hráčů v čase.',
        getGameStatus: 'Tato metoda poskytuje seznam všech možných stavů zápasů dostupných v API, jako jsou naplánované, probíhající, dokončené, odložené nebo zrušené. Tento endpoint je obzvláště užitečný pro aplikace vyžadující sledování zápasů v reálném čase, filtrování zápasů podle stavu nebo poskytování uživatelům jasných aktualizací o průběhu nebo stavu zápasu.',
        getPlayerPositions: 'Tato metoda vrátí seznam všech možných pozic hráčů, jako jsou brankář, obránce, záložník a útočník. Tento endpoint je obzvláště užitečný pro aplikace, které kategorizují hráče, analyzují pozicová data nebo umožňují uživatelům filtrovat hráče na základě jejich rolí na hřišti.',
        getGameDetail: 'Tato metoda poskytuje komplexní informace o konkrétním zápase, včetně detailů jako účastnící se týmy, datum a čas, místo konání, skóre a další klíčová metadata. Tento endpoint je ideální pro aplikace vyžadující hloubkové poznatky o zápase, umožňující funkce jako podrobné náhledy zápasů, zprávy nebo analýzy.',
        getGameStats: 'Tato metoda poskytuje podrobné statistiky pro konkrétní zápas, včetně metrik jako góly, střely, procenta držení míče, přihrávky a defenzivní akce. Tento endpoint je obzvláště užitečný pro aplikace zaměřené na analýzu zápasů, zprávy po zápase nebo vizualizace výkonu týmů během zápasu.',
        getGamePlayerStats: 'Tato metoda načte podrobné statistiky výkonu pro všechny hráče, kteří se účastnili konkrétního zápasu. Je obzvláště užitečná pro aplikace, které analyzují individuální výkony hráčů, generují zprávy o zápasech nebo porovnávají hráče v rámci kontextu jednoho zápasu.',
        getGamePlayerPhysicalStats: 'Tato metoda poskytuje podrobné metriky fyzického výkonu pro hráče v konkrétním zápase. Je obzvláště užitečná pro aplikace zaměřené na analýzu kondice hráčů, sledování fyzického výkonu nebo generování podrobných poznatků o zápasech pro jednotlivé hráče.',
        getGameTeamPhysicalStats: 'Tato metoda poskytuje podrobné metriky fyzického výkonu pro týmy v konkrétním zápase. To zahrnuje data jako celková uražená vzdálenost, počet sprintů, běhy vysoké intenzity a další fyzické atributy. Je obzvláště užitečná pro aplikace zaměřené na analýzu kondice týmů, porovnávání fyzického úsilí mezi týmy nebo hodnocení celkového výkonu v zápase.',
        getGamePlayerArrigoMetrics: 'Tato metoda poskytuje podrobné arrigo metriky pro hráče v konkrétním zápase. Je obzvláště užitečná pro aplikace zaměřené na analýzu a generování podrobných poznatků o hráčích v zápase.',
        getGameTeamArrigoMetrics: 'Tato metoda poskytuje podrobné arrigo metriky pro týmy v konkrétním zápase. To zahrnuje data jako překonaní hráči a další atributy. Je obzvláště užitečná pro aplikace zaměřené na analýzu a hodnocení celkového výkonu v zápase.',
        getGameLineup: 'Tato metoda načte sestavu pro konkrétní zápas, včetně startujících hráčů, náhradníků a jejich příslušných pozic. Tento endpoint je obzvláště užitečný pro aplikace, které zobrazují informace před zápasem, analyzují formace týmů nebo poskytují poznatky o taktických rozhodnutích učiněných týmy pro daný zápas.',
        getGameTimeline: 'Tato metoda poskytuje chronologický seznam událostí, které se odehrály během konkrétního zápasu. Je obzvláště užitečná pro aplikace, které nabízejí živé aktualizace zápasů, souhrny po zápase nebo podrobné analýzy událostí zápasu.',
        getGameTracking: 'Tato metoda poskytuje odkaz ke stažení souboru s tracking daty pro konkrétní zápas. Tento soubor obsahuje podrobná data o pohybu a pozicích hráčů a míče během zápasu. Je obzvláště užitečná pro aplikace zaměřené na pokročilé analýzy, taktickou analýzu nebo vytváření vizualizací pohybů hráčů a míče během zápasu.',
        getTrackingStatus: 'Tato metoda vrátí kompletní seznam všech stavů dostupných v trackingu, poskytující klíčové detaily jako jedinečný identifikátor a název každého stavu. Tento endpoint je ideální pro aplikace vyžadující sledování zápasů, umožňující funkce jako výběr stavu, filtrování a analýzu. Slouží také jako kritický zdroj pro interakci s jinými endpointy závislými na parametru `statusId`, zajišťující bezproblémovou navigaci a integraci s širší datovou sadou API.',
        getPlayerTransfersTypes: 'Tato metoda načte seznam možných typů přestupů hráčů, jako jsou trvalý přestup, půjčka, volný přestup nebo výměna. Tento endpoint je obzvláště užitečný pro aplikace, které analyzují trendy přestupního trhu, kategorizují pohyby hráčů nebo poskytují uživatelům podrobné poznatky o typech transakcí zahrnujících hráče.',
        getPlayerDetail: 'Tato metoda poskytuje podrobné informace o konkrétním hráči, včetně osobních detailů, kariérních statistik a současné příslušnosti k týmu. Tento endpoint je ideální pro aplikace, které nabízejí profily hráčů, historické poznatky nebo analýzy individuálních výkonů hráčů a kariérních trajektorií.',
        getPlayerGames: 'Tato metoda načte seznam všech zápasů, kterých se konkrétní hráč účastnil. Je obzvláště užitečná pro aplikace zaměřené na sledování výkonu hráčů, analýzu historie zápasů nebo poskytování uživatelům komplexních záznamů zápasů pro jednotlivé hráče.',
        getPlayerInjuries: 'Tato metoda poskytuje podrobný záznam zranění utrpěných konkrétním hráčem. Je obzvláště užitečná pro aplikace zaměřené na analýzu zdraví hráčů, hodnocení dopadu na kariéru nebo sledování časových os zotavení.',
        getPlayerNationalTeam: 'Tato metoda načte podrobné informace o účasti hráče v zápasech národního týmu. Je obzvláště užitečná pro aplikace zaměřené na výkon hráčů na národní úrovni, sledování mezinárodních kariér nebo poskytování poznatků o příspěvcích během turnajů a přátelských zápasů.',
        getPlayerSeasons: 'Tato metoda poskytuje seznam všech sezón, kterých se konkrétní hráč účastnil. Je obzvláště užitečná pro aplikace, které sledují kariérní postup hráče, analyzují výkon napříč sezónami nebo poskytují historický kontext pro jejich úspěchy.',
        getPlayerTransfers: 'Tato metoda načte podrobnou historii přestupních transakcí zahrnujících konkrétního hráče. Je obzvláště užitečná pro aplikace zaměřené na analýzu kariéry hráčů, poznatky o přestupním trhu nebo sledování pohybu hráčů mezi týmy v čase.',
        getPlayerSeasonTeamStats: 'Tato metoda poskytuje podrobné statistiky výkonu pro konkrétního hráče během konkrétní sezóny s týmem. Je obzvláště užitečná pro aplikace zaměřené na sezónní analýzu hráčů, srovnání napříč týmy nebo sezónami a sledování individuálních příspěvků k úspěchu týmu.',
        getPlayerSeasonPhysicalStats: 'Tato metoda poskytuje podrobné metriky fyzického výkonu pro konkrétního hráče v průběhu sezóny. Je obzvláště užitečná pro aplikace zaměřené na sledování kondice hráčů, analýzu fyzického výkonu nebo hodnocení zátěže hráče během sezóny.',
        getPlayerSeasonGamePhysicalStats: 'Tato metoda poskytuje podrobné metriky fyzického výkonu pro konkrétního hráče na základě zápasu po zápase v rámci sezóny. Je obzvláště užitečná pro aplikace zaměřené na analýzu kondice specifickou pro zápas, sledování zátěže hráče nebo porovnávání fyzického výkonu napříč různými zápasy.',
        getPlayerSeasonGameStats: 'Tato metoda načte podrobné statistiky výkonu pro konkrétního hráče na základě zápasu po zápase v rámci sezóny. Je obzvláště užitečná pro aplikace zaměřené na analýzu hráčů specifickou pro zápas, trendy výkonu nebo podrobná srovnání napříč zápasy v rámci sezóny.',
        getCoachDetail: 'Tato metoda poskytuje podrobné informace o konkrétním trenérovi, včetně jeho jména, kariérní historie, vedených týmů a pozoruhodných úspěchů. Tento endpoint je obzvláště užitečný pro aplikace, které zdůrazňují profily trenérů, sledují manažerské kariéry nebo analyzují dopad trenérů na výkon týmů.',
        getCoachHistory: 'Tato metoda načte komplexní historii kariéry konkrétního trenéra, včetně týmů, které vedl, soutěží, kterých se účastnil, a délky jejich působení. Tento endpoint je obzvláště užitečný pro aplikace zaměřené na analýzu trenérských kariér, sledování manažerských změn nebo poskytování poznatků o profesionální cestě trenéra a jeho úspěších.',
        getGameEventing: 'Tato metoda poskytuje všechny události',
        getLinkStream: 'Tato metoda načte odkaz ke sledování herního videa',
        getLinkDownload: 'Tato metoda načte odkaz pro stažení herního videa',
        getGameTs: 'Tato metoda poskytuje poslední časové razítko v konkrétním zápase',
        getGameFileTypes: 'Tato metoda poskytuje typy souborů pro shodu',
        deletePlayer: 'This method delete a player',
        getGeneralPositions: 'Tato metoda vrací seznam možných obecných pozic, jako je brankář, obránce, záložník a útočník.',
        getPercentiles: 'Tato metoda poskytuje všechny dostupné percentily',
        getPlayerPercentilesEventing: 'Tato metoda poskytuje všechny statistiky pro konkrétní percentil a pozici'
      },
      responseCodes: 'Kódy odpovědí',
      furtherInformation: 'Pro další informace si prosím přečtěte naši dokumentaci API',
      clipboard: 'Zkopírováno do schránky!',
      limit50: 'Zobrazuje se pouze prvních 50 výsledků'
    }
  },
  globalSearch: {
    subtitle: 'Hluboké filtrování'
  },
  global: {
    teamElos: {
      title: 'Týmové ELO',
      subtitle: 'Globální týmové žebříčky a pohledy',
      team: 'Tým',
      teams: 'Týmy',
      dates: 'Termíny',
      excludeInternational: 'Vyloučit mezinárodní týmy',
      elo: 'ELO',
      selectButton: 'Vyberte Nahoře',
      selectTeamFromTable: 'Vyberte tým z tabulky, abyste zobrazili trend ELO.',
      showingTeamAveragesLastSeason: 'Zobrazeny týmové průměry za minulou sezónu',
      showingTeamStatsLastSeason: 'Zobrazeny pouze týmové statistiky za jejich poslední aktivní sezónu',
      searchToolTip: 'Tip: Stisknutím Ctrl + B získáte přímý přístup k vyhledávací liště',
      selectTopTooltip: 'Zobrazte další týmy v grafu pro srovnání',
      loadingPage: 'Příprava dat...'
    },
    leagueElos: {
      title: 'LIGOVÉ ELO',
      subtitle: 'Globální žebříčky lig a analýzy',
      rankings: 'ŽEBŘÍČKY',
      insights: 'POHLEDY',
      filters: 'FILTRY',
      leagues: 'Ligy',
      from: 'Od',
      to: 'Do',
      elo: 'ELO',
      change: 'Změna',
      league: 'Liga',
      excludeContinental: 'Vyloučit mezinárodní soutěže',
      eloTrend: 'Trend ELO',
      eloRanking: 'ELO žebříček',
      currentELOLabel: '(Aktuální ELO)',
      allTime: 'Všechny časy',
      average: 'Průměr',
      noChartData: 'Pro vybrané filtry nejsou k dispozici žádná data grafu.',
      selectLeagueFromTable: 'Vyberte ligu z tabulky, abyste zobrazili trend ELO.',
      noInsightsData: 'Pro vybrané ligy nejsou k dispozici žádná analytická data. Ujistěte se, že ligy mají dostupné sezóny a týmová analytická data.',
      showingLeagueAveragesLastSeason: 'Zobrazeny pouze ligové průměry pro jejich poslední aktivní sezónu',
      selectTopTooltip: 'Pro srovnání zobrazte v grafu další ligy',
      confederations: {
        world: 'Svět',
        top5: 'TOP 5',
        uefa: 'UEFA',
        conmebol: 'CONMEBOL',
        concacaf: 'CONCACAF',
        caf: 'CAF',
        afc: 'AFC'
      },
      numberOfLeagues: 'Počet lig',
      minimumElo: 'Minimální ELO'
    },
    players: {
      title: 'GPI hráče',
      subtitle: 'Globální hodnocení a postřehy hráčů',
      gpiRanking: 'Hodnocení GPI',
      rankTooltip: 'Umístěním ukazatele myši zobrazíte globální hodnocení',
      globalRanking: 'Globální žebříček',
      player: 'Hráč',
      players: 'Hráči',
      gpiTrend: 'Trend GPI',
      currentGPILabel: '(Aktuální GPI)',
      nationality: 'Země narození',
      position: 'Pozice',
      marketValue: 'Tržní hodnota',
      apply: 'Použít',
      marketValueAndAgeTooltip: 'Zadejte rozsah a klikněte na Použít nebo stiskněte Enter.',
      searchPlaceholder: 'Hledat hráče...',
      selectTopTooltip: 'Zobrazte další hráče v grafu pro srovnání',
      gpi: 'GPI',
      numberOfPlayers: 'Počet hráčů',
      showingPlayerStatsLastSeason: 'Zobrazují se pouze průměrné statistiky hráčů za jejich poslední aktivní sezónu',
      date: 'DATUM',
      showChartLabels: 'Zobrazit štítky',
      marketValueTooltip: 'Zadejte rozsah a klikněte na Použít nebo stiskněte Enter.',
      freeAgents: 'Volní agenti',
      selectPlayerFromTable: 'Chcete-li zobrazit trend GPI, vyberte hráče z tabulky.'
    }
  },
  iso: {
    AF: 'Afghanistan',
    DZ: 'Algeria',
    AO: 'Angola',
    AR: 'Argentina',
    AU: 'Australia',
    AZ: 'Azerbaijan',
    BH: 'Bahrain',
    BB: 'Barbados',
    BE: 'Belgium',
    BJ: 'Benin',
    BO: 'Bolivia',
    BW: 'Botswana',
    BN: 'Brunei',
    BF: 'Burkina Faso',
    KH: 'Cambodia',
    CA: 'Canada',
    CF: 'Central African Rep.',
    CL: 'Chile',
    CO: 'Colombia',
    CD: 'Congo DR',
    CG: 'Congo',
    CI: 'Cote d\'Ivoire',
    CU: 'Cuba',
    CZ: 'Czech Republic',
    DJ: 'Djibouti',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    SV: 'El Salvador',
    ER: 'Eritrea',
    ET: 'Ethiopia',
    FI: 'Finland',
    PF: 'French Polynesia',
    GM: 'Gambia',
    DE: 'Germany',
    GI: 'Gibraltar',
    GL: 'Greenland',
    GP: 'Guadeloupe',
    GN: 'Guinea',
    GY: 'Guyana',
    HN: 'Honduras',
    HU: 'Hungary',
    IN: 'India',
    IR: 'Iran',
    IE: 'Ireland',
    IT: 'Italy',
    JP: 'Japón',
    KZ: 'Kazakhstan',
    KI: 'Kiribati',
    KR: 'Korea, South',
    KG: 'Kyrgyzstan',
    LV: 'Latvia',
    LS: 'Lesotho',
    LY: 'Libia',
    LT: 'Lithuania',
    MO: 'Macau SAR',
    MG: 'Madagascar',
    MY: 'Malaysia',
    ML: 'Mali',
    MH: 'Marshall Islands',
    MR: 'Mauritania',
    MX: 'Mexico',
    MD: 'Moldova',
    MN: 'Mongolia',
    MA: 'Morocco',
    MM: 'Myanmar',
    NR: 'Nauru',
    NL: 'Netherlands',
    NZ: 'New Zealand',
    NE: 'Niger',
    MP: 'Northern Mariana Islands',
    OM: 'Oman',
    PW: 'Palau',
    PA: 'Panama',
    PY: 'Paraguay',
    PH: 'Philippines',
    PT: 'Portugal',
    QA: 'Qatar',
    RO: 'Romania',
    RW: 'Rwanda',
    LC: 'Saint Lucia',
    SM: 'San Marino',
    SA: 'Saudi Arabia',
    RS: 'Serbia',
    SL: 'Sierra Leone',
    SK: 'Slovakia',
    SB: 'Solomon Islands',
    ZA: 'South Africa',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SZ: 'Swaziland',
    CH: 'Switzerland',
    TW: 'Taiwan',
    TZ: 'Tanzania',
    TG: 'Togo',
    TT: 'Trinidad and Tobago',
    TR: 'Turkey',
    TV: 'Tuvalu',
    UA: 'Ukraine',
    GB: 'United Kingdom',
    UY: 'Uruguay',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VG: 'Virgin Islands, British',
    EH: 'Western Sahara',
    ZM: 'Zambia',
    AL: 'Albania',
    AD: 'Andorra',
    AG: 'Antigua and Barbuda',
    AM: 'Armenia',
    AT: 'Austria',
    BS: 'Bahamas',
    BD: 'Bangladesh',
    BY: 'Belarus',
    BZ: 'Belize',
    BT: 'Bhutan',
    BA: 'Bosnia and Herz.',
    BR: 'Brazil',
    BG: 'Bulgaria',
    BI: 'Burundi',
    CM: 'Cameroon',
    CV: 'Cape Verde',
    TD: 'Chad',
    CN: 'China',
    KM: 'Comoras',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CY: 'Cyprus',
    DK: 'Denmark',
    DM: 'Dominica',
    TL: 'East Timor',
    EG: 'Egypt',
    GQ: 'Equatorial Guinea',
    EE: 'Estonia',
    FJ: 'Fiji',
    FR: 'France',
    GA: 'Gabon',
    GE: 'Georgia',
    GH: 'Ghana',
    GR: 'Greece',
    GD: 'Grenada',
    GT: 'Guatemala',
    GW: 'Guinea-Bissau',
    HT: 'Haiti',
    HK: 'Hong Kong SAR',
    IS: 'Iceland',
    ID: 'Indonesia',
    IQ: 'Iraq',
    IL: 'Israel',
    JM: 'Jamaica',
    JO: 'Jordan',
    KE: 'Kenya',
    KP: 'Korea, North',
    KW: 'Kuwait',
    LA: 'Laos',
    LB: 'Lebanon',
    LR: 'Liberia',
    LI: 'Liechtenstein',
    LU: 'Luxembourg',
    MK: 'Macedonia',
    MW: 'Malawi',
    MV: 'Maldives',
    MT: 'Malta',
    MQ: 'Martinica',
    MU: 'Mauritius',
    FM: 'Micronesia',
    MC: 'Monaco',
    ME: 'Montenegro',
    MZ: 'Mozambique',
    NA: 'Namibia',
    NP: 'Nepal',
    NC: 'New Caledonia',
    NI: 'Nicaragua',
    NG: 'Nigeria',
    NO: 'Norway',
    PK: 'Pakistan',
    PS: 'Palestinian Territories',
    PG: 'Papua New Guinea',
    PE: 'Peru',
    PL: 'Poland',
    PR: 'Puerto Rico',
    RE: 'Reunion',
    RU: 'Russian Federation',
    KN: 'Saint Kitts and Nevis',
    WS: 'Samoa',
    ST: 'Sao Tome and Princ.',
    SN: 'Senegal',
    SC: 'Seychelles',
    SG: 'Singapore',
    SI: 'Slovenia',
    SO: 'Somalia',
    ES: 'Spain',
    VC: 'St Vincent and Gren.',
    SR: 'Suriname',
    SE: 'Sweden',
    SY: 'Syria',
    TJ: 'Tajikistan',
    TH: 'Thailandia',
    TO: 'Tonga',
    TN: 'Tunisia',
    TM: 'Turkmenistan',
    UG: 'Uganda',
    AE: 'United Arab Emirates',
    US: 'United States',
    UZ: 'Uzbekistan',
    VA: 'Vatican City',
    VN: 'Vietnam',
    VI: 'Virgin Islands, U.S.',
    YE: 'Yemen',
    ZW: 'Zimbabue',
    EU: 'Europe',
    INT: 'International',
    CW: 'Curaçao',
    AFC: 'AFC',
    CONCACAF: 'CONCACAF',
    'GB-ENG': 'England',
    'GB-WLS': 'Wales',
    'GB-SCT': 'Scotland',
    LATAM: 'South America',
    CAF: 'CAF',
    XK: 'Kosovo',
    AI: 'Anguilla',
    AN: 'Netherlands Antilles',
    AS: 'American Samoa',
    AW: 'Aruba',
    BM: 'Bermuda',
    BQ: 'Bonaire, SE and Saba',
    CK: 'The Cook Islands',
    FO: 'The Faroe Islands',
    GF: 'Guyane',
    GG: 'The Bailiwick of Guernsey',
    GU: 'The Territory of Guam',
    IM: 'The Isle of Man',
    JE: 'The Bailiwick of Jersey',
    KY: 'The Cayman Islands',
    MF: 'The Collectivity of Saint-Martin',
    MS: 'Montserrat',
    NU: 'Niue',
    OC: 'Oceania',
    RI: 'Indonesia',
    SS: 'The Republic of South Sudan',
    TC: 'The Turks and Caicos Islands',
    YT: 'The Department of Mayotte',
    SX: 'Sint Maarten'
  },
  loadingMessages: {
    players: 'Příprava hráčů',
    teams: 'Řazení týmů',
    games: 'Načítání zápasů',
    stats: 'Výpočet metrik',
    graphs: 'Kreslení grafů',
    gettingReady: 'Zahřívání',
    placeholder: 'Připravte se'
  },
  requestReport: {
    subtitle: 'Získejte hloubkovou zprávu se vším, co potřebujete',
    categories: {
      scouting: {
        title: 'Skauting',
        subtitle: 'Kdo jsou nejlepší hráči určité ligy? A z několika lig dohromady? Požádejte o zprávu na míru s jakýmkoli filtrem, který chcete (věk, výška, konec smlouvy atd.) a zjistěte, kteří hráči se nejlépe hodí'
      },
      coaches: {
        title: 'Trenéři',
        subtitle: 'Jak by se trenér hodil do systému vašeho týmu? Získejte podrobné informace nebo, při daném profilu, zjistěte, kteří trenéři se nejlépe hodí'
      },
      'team analysis': {
        title: 'Tým',
        subtitle: 'Určete tým a získejte sezónní souhrn s cennými poznatky o stylu, defenzivním a útočném výkonu, slabých místech, nejlepších hráčích atd...'
      },
      'game analysis': {
        title: 'Analýza zápasu',
        subtitle: 'Pro daný zápas získejte hloubkovou předzápasovou a pozápasovou analýzu s podrobnými informacemi'
      },
      'special projects': {
        title: 'Speciální projekty',
        subtitle: 'Jak si hráč vede v zápasech venku? Jak se hráči mění z ligy do ligy? Kteří hráči jsou k dispozici na půjčku? Zeptejte se na cokoli, co vás napadne'
      },
      conversation: {
        title: 'Konverzace',
        subtitle: 'Začněte konverzaci s naším týmem'
      }
    },
    notesPlaceholder: 'Dejte nám vědět ligu, profil, statistiky, trenéra, tým nebo zápas, o kterém se chcete dozvědět více',
    chooseType: 'Vyberte typ zprávy',
    requestSummary: 'Souhrn žádosti',
    reportType: 'Typ zprávy',
    reportLanguage: 'Jazyk zprávy',
    detailTitle: 'Následná zpráva',
    detailSubtitle: 'Všechny informace o zprávě, kterou jste požádali'
  },
  bugReport: {
    modalSubtitle: 'Pomozte nám se zlepšit',
    about: 'O',
    sendSuccess: 'Úspěšně nahlášeno. Zkontrolujte aktualizace ve schránce',
    bugs: 'Chyby'
  },
  gbe: {
    autopass: 'Automatický průchod',
    bandX: 'Pásmo {0}',
    bandXCont: 'Pásmo {0} Kontinentální soutěž',
    points: 'Body',
    titleWinner: 'Vítěz titulu',
    qualifiedGroupsBandX: 'Kvalifikován do skupinové fáze pásma {0} Kontinentální soutěže',
    qualifiedQualifiersBandX: 'Kvalifikován do kvalifikace pásma {0} Kontinentální soutěže',
    midTable: 'Střed tabulky',
    relegation: 'Sestup',
    promotion: 'Postup',
    final: 'Finále',
    semifinal: 'Semifinále',
    quarterfinal: 'Čtvrtfinále',
    round16: 'Osmifinále',
    round32: '32. kolo',
    groupstage: 'Skupinová fáze',
    firstRound: '1. kolo',
    secondRound: '2. kolo',
    thirdRound: '3. kolo',
    fourthRound: '4. kolo',
    preliminaryRound: 'Předkolo',
    other: 'Jiné',
    score: 'Skóre',
    totalSummary: 'Celkový souhrn',
    currentlyPlayingInUK: 'Hráč je občanem Spojeného království nebo Irska, nebo je hráč trvalým rezidentem ve Spojeném království',
    bandsAlert: 'Existují minuty odehrané ve více než jednom pásmu, celkem je maximální hodnota',
    bandsAlertMax: 'Existují minuty odehrané ve více než jednom pásmu, celkem je maximální hodnota',
    bandsAlertAvg: 'Existují minuty odehrané ve více než jednom pásmu, celkem je průměrná hodnota',
    generate: 'GBEApplicationForm',
    debutYouthPlayer: 'Debut mládežnického hráče',
    table1: {
      name: 'Mezinárodní starty hráče',
      title1: 'Agregované FIFA světové hodnocení národní asociace hráče',
      title2: 'Mezinárodní starty hráče'
    },
    table2: {
      name: 'Domácí minuty hráče',
      title1: 'Domácí minuty hráče'
    },
    table3: {
      name: 'Kontinentální minuty hráče',
      title1: 'Kontinentální minuty hráče'
    },
    table4: {
      name: 'Finální ligová pozice posledního klubu hráče',
      title1: 'Finální ligová pozice posledního klubu'
    },
    table5: {
      name: 'Kontinentální postup posledního klubu hráče',
      title1: 'Kontinentální postup'
    },
    table6: {
      name: 'Kvalita ligy současného klubu hráče',
      title1: 'Pásmo současného klubu hráče'
    },
    table7: {
      name: 'Mládež - Debut',
      title1: 'Pásmo'
    },
    table8: {
      name: 'Mládež - Finální ligová pozice',
      title1: 'Finální ligová pozice posledního klubu'
    },
    table9: {
      name: 'Mládež - Kontinentální postup',
      title1: 'Kontinentální postup'
    },
    table10: {
      name: 'Mládež - Kvalita ligy současného klubu hráče',
      title1: 'Pásmo současného klubu hráče'
    },
    table11: {
      name: 'Mládež - Kvalita ligy současného klubu hráče',
      title1: 'Pásmo současného klubu hráče'
    },
    table12: {
      name: 'Mládež - Mezinárodní starty',
      title1: 'Mezinárodní starty hráče'
    }
  },
  mediaMode: {
    borderColor: 'Barva okraje',
    fillColor: 'Barva výplně',
    bgColor: 'Barva pozadí',
    upperText: 'Horní text',
    lowerText: 'Dolní text',
    socialMedia: 'Sociální média',
    textColor: 'Barva textu',
    axisColor: 'Barva osy',
    logo: 'Logo',
    comparisonBorderColor: 'Barva okraje srovnání',
    comparisonFillColor: 'Barva výplně srovnání',
    comparisonUpperText: 'Horní text srovnání',
    comparisonLowerText: 'Dolní text srovnání',
    homeFillColor: 'Barva výplně doma',
    homeBorderColor: 'Barva okraje doma',
    awayFillColor: 'Barva výplně venku',
    awayBorderColor: 'Barva okraje venku',
    face: 'Tvář',
    nationalTeam: 'Národní tým',
    comparisonFace: 'Tvář srovnání',
    upperTextX: 'Horní text {0}',
    lowerTextX: 'Dolní text {0}',
    borderColorX: 'Barva okraje {0}',
    fillColorX: 'Barva výplně {0}',
    homeFillColorX: 'Barva výplně (doma) {0}',
    homeBorderColorX: 'Barva okraje (doma) {0}',
    awayFillColorX: 'Barva výplně (venku) {0}',
    awayBorderColorX: 'Barva okraje (venku) {0}',
    faceX: 'Tvář {0}',
    selectField: 'Vyberte vlastnost',
    orientationX: 'Orientace {0}',
    searchBarPlaceholder: 'Hledat hráče a/nebo zápasy...',
    title: 'Mediální nástěnka',
    pageSubtitle: 'Prozkoumejte a stáhněte mapy a grafy',
    chooseChart: 'Vyberte graf...',
    headerTextX: 'Text hlavičky {0}',
    avatarLineLength: 'Délka čáry avatara',
    avatarLineWeight: 'Tloušťka čáry avatara',
    avatarSize: 'Velikost avatara',
    chartX: 'Graf {0}',
    chartHeaderFontSize: 'Velikost písma hlavičky grafů',
    chartHeaderFontWeight: 'Tloušťka písma hlavičky grafů',
    upperTextFontSize: 'Velikost písma horního textu',
    upperTextFontWeight: 'Tloušťka písma horního textu',
    lowerTextFontSize: 'Velikost písma dolního textu',
    lowerTextFontWeight: 'Tloušťka písma dolního textu',
    socialMediaFontSize: 'Velikost písma sociálních médií',
    socialMediaFontWeight: 'Tloušťka písma sociálních médií',
    subtitle: 'Podtitul',
    subtitleFontSize: 'Velikost písma podtitulu',
    subtitleFontWeight: 'Tloušťka písma podtitulu',
    subtitleX: 'Podtitul {0}',
    subtitleFontSizeX: 'Velikost písma podtitulu ${0}',
    subtitleFontWeightX: 'Tloušťka písma podtitulu ${0}',
    titleX: 'Název {0}',
    titleFontSize: 'Velikost písma názvu',
    titleFontWeight: 'Tloušťka písma názvu',
    sponsor: 'Sponzor',
    fontFamily: 'Rodina písma'
  },
  documents: {
    types: {
      SCOUTING_REPORT: 'Skautingové zprávy',
      GAME_REPORT: 'Zprávy o zápasech',
      MEDICAL_REPORT: 'Lékařské zprávy',
      PHYSICAL_REPORT: 'Fyzické zprávy',
      PSYCHOLOGICAL_REPORT: 'Psychologické zprávy',
      OTHER: 'Ostatní',
      QUICK_NOTES: 'Rychlé poznámky',
      PLAYER_REPORT: 'Zprávy o hráčích',
      GENERAL_COMMENTS: 'Obecné komentáře',
      PLAYER_ANALYSIS: 'Analýza hráče'
    },
    uploadDocument: 'Nahrát dokument',
    notesPlaceholder: 'Napište popisné poznámky nebo komentáře související s dokumentem',
    notesPlaceholderAlt: 'Napište popisné poznámky nebo komentáře související s hráčem',
    uploadedBy: 'Nahráno uživatelem',
    updatedBy: 'Aktualizováno uživatelem',
    seeNotes: 'Zobrazit poznámky',
    addNote: 'Přidat poznámku',
    rating: 'Hodnocení',
    position: 'Nejlepší pozice',
    physical: 'Fyzická kondice',
    onBall: 'S míčem',
    offBall: 'Bez míče',
    mental: 'Duševní',
    potential: 'Potenciál',
    conclusion: 'Závěr',
    recommendation: {
      1: 'Podepsat',
      2: 'Sledovat',
      3: 'Zamítnout',
      4: 'Zajímavé',
      label: 'Doporučení'
    },
    match: 'Zápas',
    deleteQuickNote: 'Smazat poznámku',
    deleteQuickNoteMessage: 'Poznámka bude trvale odstraněna. Jste si jisti?',
    noQuickNotes: 'Žádná data. Začněte přidáním rychlých poznámek!',
    deleteDocument: 'Smazat dokument',
    deleteDocumentMessage: 'Dokument bude trvale odstraněn. Jste si jisti?',
    noDocuments: 'Žádná data. Začněte přidáním dokumentů!'
  },
  notifications: {
    newReportMessage: 'V zprávě je nová zpráva'
  },
  blog: {
    subtitle: 'Nejnovější články, aktualizace a novinky',
    newEntry: 'Nový záznam',
    title: 'Název',
    text: 'Text',
    link: 'Odkaz',
    image: 'Obrázek',
    author: 'Autor',
    date: 'Datum vydání',
    deleteEntry: 'Smazat záznam',
    deleteEntryMessage: 'Jste si jisti, že chcete smazat tento záznam?',
    readMore: 'Číst více'
  },
  positionsOrlegi: {
    GK: 'Brankář',
    DC: 'Obránce',
    DR: 'Krajní obránce',
    MC: 'Záložník',
    AMC: 'Útočný záložník',
    FW: 'Útočník',
    FWR: 'Křídlo'
  },
  library: {
    subtitle: 'Zobrazit a sdílet nahrané dokumenty',
    mediaSubtitle: 'Zobrazit a sdílet exportované grafy',
    charts: 'Grafy',
    goToLibrary: 'Přejít do knihovny'
  },
  scatterPlot: {
    bubbleSize: 'Velikost bubliny',
    byMinutes: 'Podle minut',
    byAge: 'Podle věku',
    byMarketValue: 'Podle tržní hodnoty'
  },
  eventChart: {
    successfulEvent: 'Úspěšný',
    unsuccessfulEvent: 'Neúspěšný',
    possessionLost: 'Úspěšné nebylo obnoveno',
    successfulPass: 'Úspěšná přihrávka',
    unsuccessfulPass: 'Neúspěšná přihrávka',
    successfulCarry: 'Úspěšné nošení',
    unsuccessfulCarry: 'Neúspěšné nošení',
    carryAndKeyPass: 'Nosičství & Klíčová přihrávka',
    carryAndAssist: 'Nosičství & Asistence',
    carryAndShot: 'Nosičství & Střela',
    ballProgressionAndPass: 'Progrese míče & Přihrávka',
    ballProgression: 'Progrese míče',
    ballProgressionAndKeyPass: 'Progrese míče & Klíčová přihrávka',
    ballProgressionAndAssist: 'Progrese míče & Asistence',
    ballProgressionAndShot: 'Progrese míče & Střela',
    ballProgressionAndGoal: 'Progrese míče & Gól',
    pass: 'Přihrávka',
    carryAndPass: 'Nosičství & Přihrávka',
    carryAndGoal: 'Nosičství & Gól',
    totalTouches: 'Celkem dotyků',
    totalPasses: 'Celkové Přihrávky',
    successful: 'Úspěšné',
    unsuccessful: 'Neúspěšné',
    tacklePossessionLost: 'Úspěšný - Ztráta držení',
    gamesSelected: '{count} zápasů vybráno',
    allGamesOfSeason: 'Všechny zápasy sezóny',
    allGamesOfSeasons: 'Všechny zápasy sezón',
    allEvents: 'Všechny události',
    eventTypesCount: '{count} typů událostí',
    totalEvents: 'Celkem událostí',
    zoneDominanceNote: 'Dotyky zobrazené každým týmem v každé zóně představují pouze úspěšné doteky',
    selectedEvents: 'Vybrané události'
  },
  event: {
    Pass: 'Přihrávka',
    TakeOn: 'Driblink',
    Takeon: 'Driblink',
    Foul: 'Faul',
    Error: 'Chyba',
    Tackle: 'Skobrnutí',
    Interception: 'Zachycení',
    Clearance: 'Vykop',
    MissedShot: 'Minutá střela',
    ShotOnPost: 'Střela na tyč',
    SavedShot: 'Zachráněná střela',
    Goal: 'Gól',
    Aerial: 'Vzdušný souboj',
    BallRecovery: 'Znovuzískání míče',
    Dispossessed: 'Odepření míče',
    ChanceMissed: 'Promarněná šance',
    BallTouch: 'Dotyk míče',
    BlockedPass: 'Blokovaná přihrávka',
    Challenge: 'Souboj',
    lossPossession: 'Ztráta držení míče',
    OffsidePass: 'Přihrávka do ofsajdu',
    groundDuelsLost: 'Ztracené pozemní souboje',
    'Ball touch': 'Dotyk míče',
    Smother: 'Zachycení',
    'Keeper pickup': 'Sebrání brankářem',
    'Good skill': 'Dobrá dovednost',
    Punch: 'Výraz',
    'Saved shot': 'Zachráněná střela',
    'Shot on post': 'Střela na tyč',
    'Missed shot': 'Minutá střela',
    Save: 'Záchrana',
    'Take on': 'Driblink',
    'Offside pass': 'Přihrávka do ofsajdu',
    Claim: 'Zachycení',
    'Blocked pass': 'Blokovaná přihrávka',
    KeeperPickup: 'Vyzvednutí brankáře',
    'Ball recovery': 'Znovuzískání míče',
    'Ball Recovery': 'Znovuzískání míče',
    'Chance missed': 'Promarněná šance',
    'Loss possession': 'Ztráta držení míče',
    Carries: 'Přenášení míče',
    BallProgression: 'Progrese míče',
    MissedChance: 'Promarněná šance',
    Event: 'Událost',
    Shot: 'Střela',
    Assist: 'Asistence',
    KeyPass: 'Klíčová přihrávka',
    'Foul taken': 'Faul přijat'
  },
  leagueTab: {
    leagueTable: 'Ligová tabulka',
    matchdays: 'Kola',
    playerInsights: 'Poznatky o hráčích',
    onlyLocalPlayers: 'Pouze místní hráči',
    teamInsights: 'Poznatky o týmech',
    head2head: 'Vzájemná utkání',
    addNewChart: 'Přidat nový graf',
    rounds: {
      16: 'Osmifinále',
      32: '32. kolo',
      W: 'Vítěz',
      F: 'Finále',
      SF: 'Semifinále',
      QF: 'Čtvrtfinále',
      GR: 'Skupinová fáze',
      '4R': 'Čtvrté kolo',
      '3R': 'Třetí kolo',
      '2R': 'Druhé kolo',
      '1R': 'První kolo',
      PR: 'Předkolo',
      QPO1: 'Vytvořit 32. kolo úrovně níže',
      QPO2: 'Kvalifikace osmifinále',
      QPO3: 'Kvalifikační kolo 32'
    },
    positions: 'Pozice',
    prediction: 'Předpovědi',
    predicted: 'Předpověď',
    groups: 'Skupiny',
    ranking: 'Pořadí',
    numberOfTeams: 'Počet týmů',
    statsWithMinimum: {
      message: 'Zobrazují se pouze hráči s více než {0} {1} ve vybrané sezóně',
      dribblesTotal90: 'driblinků na 90 minut',
      crosses90: 'centrů na 90 minut',
      tacklesAttempted90: 'pokusů o skobrnutí na 90 minut',
      aerialsTotal90: 'vzdušných soubojů na 90 minut'
    },
    numberOfLeagues: 'Počet lig',
    position: {
      titleWinner: 'Vítěz titulu',
      championsLeague: 'Liga mistrů',
      qualifierChampionsLeague: 'Kvalifikace Ligy mistrů',
      europeLeague: 'evropská liga',
      qualifierEuropeLeague: 'kvalifikace Evropské ligy',
      conferenceLeague: 'Konferenční liga',
      qualifierConferenceLeague: 'Kvalifikační konferenční liga',
      midTable: 'Střed tabulky',
      relegation: 'Sestup',
      promotion: 'Podpora',
      relegationPlayoff: 'Play-off o sestup',
      promotionPlayoff: 'Postup Play-off',
      championshipGroup: 'Mistrovská skupina',
      relegationGroup: 'Sestupová skupina',
      championshipPlayoffs: 'Play-off mistrovství',
      preChampionshipPlayoffs2: 'Play-off před šampionátem 2',
      preChampionshipPlayoffs3: 'Play-off před šampionátem 3',
      playoffsQualifierBand3: 'Kvalifikační pásmo play off 3',
      continentalGroup: 'Kontinentální skupina'
    },
    group: {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'já',
      10: 'J',
      11: 'K',
      12: 'L'
    }
  },
  similarity: {
    subtitle: 'Najděte podobné hráče',
    searchBarPlaceholder: 'Hledejte a vyberte hráče pro nalezení podobných',
    radarFilters: 'Filtry radaru',
    similarityFilters: 'Filtry podobnosti',
    playersFilters: 'Filtry hráčů',
    similarPlayers: 'Podobní hráči',
    seasonWarning: 'Pouze dostupné sezóny v nástroji Podobnost, ve kterých odehrál více než 450 minut'
  },
  squadBuilder: {
    subtitle: 'Nakreslete své jedinečné jedenáctky',
    playerSelector: 'Výběr hráče',
    loadSquad: 'Načíst sestavu',
    yearsOld: 'let',
    playersPerPosition: 'Hráči na pozici',
    custom: 'Vlastní',
    removeSquad: 'Smazat sestavu',
    removeSquadMessage: 'Jste si jisti, že chcete smazat sestavu?',
    deleteSquadSuccess: 'Sestava byla úspěšně smazána',
    playerDetails: 'Viditelnost detailů hráče',
    ageFormat: 'Formát věku',
    mainPlayer: 'Hlavní hráč',
    showDetails: 'Zobrazit detaily',
    all: 'Vše',
    squadPosition: 'Pozice v sestavě',
    noData: 'Žádná data. Začněte přidáním hráčů na hřiště!'
  },
  tours: {
    buttons: {
      dontShowAgain: 'Znovu nezobrazovat',
      skipTour: 'Přeskočit průvodce',
      previous: 'Předchozí',
      next: 'Další',
      finish: 'Dokončit'
    },
    playerRadar: {
      step1: {
        title: 'OSOBNÍ SOUBOR',
        message: 'Zkontrolujte základní data hráče: věk, výška nebo datum smlouvy'
      },
      step2: {
        title: 'GBE FILTR',
        message: 'Funkce, která umožňuje zjistit, zda má hráč dostatek GBE bodů pro hraní ve Spojeném království'
      },
      step3: {
        title: 'DOSTUPNOST',
        message: 'Procento dostupných minut a procento odehraných minut'
      },
      step4: {
        title: 'POZICE',
        message: 'Zjistěte, na kterých pozicích hráč hrál a kolik minut odehrál na každé pozici'
      },
      step5: {
        title: 'FORMÁTY ZOBRAZENÍ',
        message: 'Měřte výkon pomocí 4 různých vizualizací, Radar, Polar, Lollipop a Text, pro srovnání s hráči na jeho pozici'
      },
      step6: {
        title: 'VÝKONNOSTNÍ RADAR',
        message: 'Zde je výkon zobrazen vizuálně. Panel je interaktivní, můžete najet myší na každou metriku a získat její definici'
      },
      step7: {
        title: 'VÝBĚR SEZÓNY',
        message: 'Vyberte nebo přidejte sezóny pro měření výkonu'
      },
      step8: {
        title: 'VÝBĚR VLASTNÍ ŠABLONY',
        message: 'Použijte vlastní šablony, které jste vytvořili, pro měření hráče s různými metrikami než standardní radar'
      },
      step9: {
        title: 'VÝBĚR ODEHRANÝCH POZIC',
        message: 'Zaškrtněte a odškrtněte různé pozice pro měření hráče na pozici, na které ho chcete měřit'
      },
      step10: {
        title: 'VÝBĚR MINIM A MAXIM',
        message: 'Měřte hráče s vrcholy a dny jeho sezóny, top pěti lig nebo vlastní a výchozí sezónou uživatelského účtu'
      },
      step11: {
        title: 'SROVNÁNÍ',
        message: 'Porovnává hráče s jeho předchozím výkonem, s jinými hráči na jeho pozici, s průměrem pozice'
      },
      step12: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      }
    },
    playerRanking: {
      step1: {
        title: 'SEZÓNA, SESTAVA A POZICE',
        message: 'Vyberte sezónu, sestavu a pozici pro srovnání hráče'
      },
      step2: {
        title: 'ZÁKLADNÍ FILTRY',
        message: 'Filtrujte hráče podle věku, odehraných minut nebo výšky'
      },
      step3: {
        title: 'ZVÝRAZNĚNÍ A VYLOUČENÍ',
        message: 'Zvýrazněte hráče, které chcete, a vylučte týmy v zobrazení'
      },
      step4: {
        title: 'FILTR PODLE KATEGORIE',
        message: 'Filtrujte statistiky podle kategorie: Asociace, Obrana, Přihrávky, Práce s míčem atd'
      },
      step5: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      }
    },
    playerFinishing: {
      step1: {
        title: 'VÝBĚR ZOBRAZENÍ',
        message: 'Můžete vidět mapu dokončování v hlavním zobrazení, zobrazení gólů a v distribuční tabulce'
      },
      step2: {
        title: 'VÝBĚR SEZÓN',
        message: 'Přidejte sezóny pro měření efektivity střelby'
      },
      step3: {
        title: 'UMÍSTĚNÍ STŘELY',
        message: 'Vyberte možnost vidět přesné umístění střely (kruhy) nebo podle oblastí pokutového území a hřiště (oblasti)'
      },
      step4: {
        title: 'xG NA BRANKU',
        message: 'Zaškrtněte políčka pro xG na gól a xG dokončení pro zobrazení přidané hodnoty, kterou hráč přidal po střele'
      },
      step5: {
        title: 'TYP STŘELY',
        message: 'Filtrujte podle typu střely, strategie, oblasti nebo části těla'
      },
      step6: {
        title: 'FILTR MINUT',
        message: 'Lišta minut pro výběr střel a gólů vstřelených v konkrétních obdobích zápasu'
      },
      step7: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      },
      step8: {
        title: 'MAPA STŘELBY',
        message: 'Mapa je interaktivní. Zkontrolujte každý kruh myší pro zjištění xG každé střely'
      }
    },
    playerKeyPass: {
      step1: {
        title: 'VÝBĚR SEZÓNY',
        message: 'Přidejte sezóny pro měření efektivity střelby'
      },
      step2: {
        title: 'UMÍSTĚNÍ KLÍČOVÉ PŘIHRÁVKY',
        message: 'Vyberte možnost zobrazit přesné umístění klíčové přihrávky (kruh) nebo podle oblastí pokutového území a hřiště (oblasti)'
      },
      step3: {
        title: 'TYP DOKONČENÍ PO KLÍČOVÉ PŘIHRÁVCE',
        message: 'Filtrujte podle typu střely, strategie, oblasti nebo části těla provedené po klíčové přihrávce'
      },
      step4: {
        title: 'FILTR MINUT',
        message: 'Lišta minut pro výběr střel a gólů vstřelených v konkrétních obdobích zápasu'
      },
      step5: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      },
      step6: {
        title: 'MAPA KLÍČOVÝCH PŘIHRÁVEK',
        message: 'Mapa je interaktivní. Prozkoumejte každý kruh myší pro zjištění xA každé přihrávky'
      }
    },
    playerThreat: {
      step1: {
        title: 'VÝBĚR SEZÓNY',
        message: 'Přidejte sezóny pro měření efektivity střelby'
      },
      step2: {
        title: 'UMÍSTĚNÍ HROZBY',
        message: 'Vyberte možnost zobrazit přesné umístění klíčové přihrávky (kruh) nebo podle oblastí a zón hřiště (oblasti)'
      },
      step3: {
        title: 'AKCE A DOKONČENÍ',
        message: 'Zaškrtněte a odškrtněte podle typu akce a dokončení, které chcete zobrazit na mapě'
      },
      step4: {
        title: 'MINUTY A HROZBA',
        message: 'Filtrujte podle období, minut a hodnoty hrozby akcí'
      },
      step5: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      },
      step6: {
        title: 'MAPA HROZBY',
        message: 'Mapa je interaktivní. Prozkoumejte každý kruh myší pro zjištění hrozby vygenerované v každé xT akci každé přihrávky'
      }
    },
    playerTouches: {
      step1: {
        title: 'VÝBĚR ZÁPASU A UDÁLOSTÍ',
        message: 'Vyberte zápas a události, které chcete zobrazit na mapě'
      },
      step2: {
        title: 'TYP UDÁLOSTI',
        message: 'Zaškrtněte a odškrtněte podle defenzivní nebo útočné povahy události hráče v průběhu zápasu'
      },
      step3: {
        title: 'FILTR ZOBRAZENÍ',
        message: 'Filtrujte mapu podle základních akcí, heat mapy, kruhů nebo boxů'
      },
      step4: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      },
      step5: {
        title: 'MAPA DOTYKŮ',
        message: 'Mapa je interaktivní. Můžete zobrazit každou událost kliknutím na každou událost'
      }
    },
    playerAllGames: {
      step1: {
        title: 'DOSTUPNOST',
        message: 'Zkontrolujte dostupnost a odehrané minuty zápas po zápase'
      },
      step2: {
        title: 'POZICE',
        message: 'Prozkoumejte pozice, na kterých hrál v každém zápase'
      }
    },
    playerInjuries: {
      step1: {
        title: 'HISTORIE A ZTRACENÉ DNY',
        message: 'Prozkoumejte zranění z posledního roku nebo celou historii a rozsah zranění podle jejich trvání ve dnech'
      },
      step2: {
        title: 'ZRANĚNÍ PODLE KLUBU',
        message: 'Prozkoumejte zranění rozdělená podle sezóny a/nebo klubu jeho trajektorie'
      }
    },
    playerInfo: {
      step1: {
        title: 'KARIÉRA A PŘESTUPY',
        message: 'Můžete prozkoumat historii minut, pozice nebo dostupnosti s jeho klubem, s jeho národním týmem a přestupy hráče v průběhu jeho kariéry'
      }
    },
    teamOverview: {
      step1: {
        title: 'TÝMOVÝ LIST',
        message: 'Prozkoumejte základní data týmu: průměrný věk, základní formace, ELO nebo bilance přestupů'
      },
      step2: {
        title: 'ZÁKLADNÍ STATISTIKY',
        message: 'Prozkoumejte držení míče, xG, Střely, PPDA nebo Vertikalitu'
      },
      step3: {
        title: 'RADAR A SEZÓNA',
        message: 'Vyberte radar, sezónu a domácí nebo venkovní zápasy pro měření výkonu týmu'
      },
      step4: {
        title: 'FILTR PODLE TRENÉRA A ZÁPASŮ',
        message: 'Vyberte výkon podle fáze pro každého trenéra'
      },
      step5: {
        title: 'VÝKONNOSTNÍ RADAR',
        message: 'Panel je interaktivní, můžete najet myší na každou metriku a získat její definici'
      },
      step6: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici dva formáty stahování: png a svg'
      },
      step7: {
        title: 'KALENDÁŘ',
        message: 'Zobrazte rozvrh zápasů týmu'
      },
      step8: {
        title: 'NEJLEPŠÍ HRÁČI PODLE METRIK',
        message: 'V tomto panelu můžete vybrat různé metriky a vidět, kteří hráči jsou nejdůležitější'
      },
      step9: {
        title: 'DALŠÍ ZÁPAS A ZRANĚNÍ',
        message: 'Zkontrolujte dalšího soupeře a zraněné a suspendované hráče týmu'
      },
      step10: {
        title: 'GRAFY A TRENDY',
        message: 'Zobrazte různé grafy pro posledních 10 nebo 20 zápasů'
      }
    },
    teamRoster: {
      step1: {
        title: 'TYP ZOBRAZENÍ',
        message: 'Zobrazte sestavu ze 6 různých kategorií: podle pozice, konce smlouvy, věku, dostupnosti, věkového profilu a hřiště'
      }
    },
    teamLoans: {
      step1: {
        title: 'PŮJČENÍ HRÁČI',
        message: 'Prozkoumejte hráče zapůjčené jiným týmům a na jaké pozici hrají'
      }
    },
    teamBeeswarm: {
      step1: {
        title: 'SEZÓNA A SESTAVA',
        message: 'Filtrujte podle sezóny, radarové sestavy a porovnejte s ligami podle vašeho výběru'
      },
      step2: {
        title: 'VÝKON PODLE METRIK',
        message: 'Podívejte se, kde se tým nachází v každé metrice ve srovnání se všemi týmy v dříve vybraných ligách'
      },
      step3: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      }
    },
    teamFinishingMap: {
      step1: {
        title: 'VÝBĚR SEZÓNY',
        message: 'Přidejte sezóny pro měření efektivity střelby'
      },
      step2: {
        title: 'VLASTNÍ NEBO SOUPEŘOVO DOKONČOVÁNÍ',
        message: 'Vyberte, zda chcete vidět mapu dokončování týmu nebo všech jeho soupeřů'
      },
      step3: {
        title: 'UMÍSTĚNÍ STŘELY',
        message: 'Vyberte, jak chcete vidět střely týmu, podle kruhů nebo podle zón (boxů)'
      },
      step4: {
        title: 'TYP STŘELY',
        message: 'Filtrujte podle typu střely, strategie, oblasti nebo části těla'
      },
      step5: {
        title: 'FILTR MINUT',
        message: 'Lišta minut pro výběr střel a gólů vstřelených v konkrétních obdobích zápasu'
      },
      step6: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      },
      step7: {
        title: 'MAPA STŘEL',
        message: 'Mapa je interaktivní. Zkontrolujte každý kruh myší pro zjištění xG každé střely'
      }
    },
    teamKeyPassMap: {
      step1: {
        title: 'VÝBĚR SEZÓNY',
        message: 'Přidejte sezóny pro měření efektivity střelby'
      },
      step2: {
        title: 'VLASTNÍ NEBO SOUPEŘOVY KLÍČOVÉ PŘIHRÁVKY',
        message: 'Vyberte, zda chcete vidět mapu klíčových přihrávek týmu nebo všech jeho soupeřů'
      },
      step3: {
        title: 'UMÍSTĚNÍ KLÍČOVÉ PŘIHRÁVKY',
        message: 'Vyberte, zda chcete vidět přesné umístění klíčové přihrávky (kruh) nebo podle oblasti a hřiště (boxy)'
      },
      step4: {
        title: 'TYP DOKONČENÍ PO PŘIHRÁVCE',
        message: 'Filtrujte podle typu střely, strategie, oblasti nebo části těla provedené po klíčové přihrávce'
      },
      step5: {
        title: 'FILTR MINUT',
        message: 'Lišta minut pro výběr střel a gólů vstřelených v konkrétních obdobích zápasu'
      },
      step6: {
        title: 'FORMÁTY STÁHNUTÍ OBRAZKU',
        message: 'Jsou k dispozici tři formáty stahování: png, svg a embed'
      },
      step7: {
        title: 'MAPA STŘEL',
        message: 'Mapa je interaktivní. Prozkoumejte každý kruh myší pro zjištění xA každé přihrávky'
      }
    },
    teamLatestGames: {
      step1: {
        title: 'NEJNOVĚJŠÍ ZÁPASY',
        message: 'Prozkoumejte výsledky, držení míče, xG a procento výher všech zápasů týmu'
      }
    },
    teamTransfers: {
      step1: {
        title: 'PŘÍCHODY',
        message: 'Prozkoumejte všechny příchody (nákupy + přestupy) podle kalendářního roku'
      },
      step2: {
        title: 'ODCHODY',
        message: 'Prozkoumejte všechny odchody (prodeje + přestupy) podle kalendářního roku'
      }
    },
    teamAnalysis: {
      step1: {
        title: 'TRENDY',
        message: 'Dotazujte se na formu týmu prostřednictvím sérií, výher, čistých kont, návratů, období s góly nebo typů gólů'
      },
      step2: {
        title: 'STANDARDNÍ SITUACE',
        message: 'Porovnejte výkon týmu mezi standardními situacemi a otevřenou hrou a získejte podrobný přehled standardních situací'
      },
      step3: {
        title: 'STŘÍDÁNÍ',
        message: 'Podívejte se, kdy tým provádí střídání a kteří hráči jsou střídáni nejčastěji'
      },
      step4: {
        title: 'SPOJENÍ',
        message: 'Prozkoumejte nejčastější spojení mezi hráči. Filtrujte podle sezóny a typu hry'
      },
      step5: {
        title: 'ÚTOČNÉ ZÓNY',
        message: 'Objevte útočné zóny týmu a filtrujte podle sezóny nebo typu útoku'
      },
      step6: {
        title: 'FORMACE',
        message: 'Zkontrolujte nejpoužívanější formace a jejich procento výher, remíz a proher s každou z nich'
      },
      step7: {
        title: 'ZÓNY STŘEL',
        message: 'Filtrujte podle sezóny, týmu nebo soupeře, způsobu vizualizace mapy, typů střel nebo minut'
      },
      step8: {
        title: 'CENTROVÁNÍ',
        message: 'Dotazujte se a filtrujte podle sezóny, typu zobrazení, úspěšné nebo neúspěšné, odkud začínají a končí nebo včetně rohových kopů'
      },
      step9: {
        title: 'HRÁČI',
        message: 'Filtrujte podle sezóny, typu zobrazení, úspěšné nebo neúspěšné, odkud začínají a končí nebo včetně rohových kopů'
      }
    },
    teamOnOff: {
      step1: {
        title: 'SEZÓNY A ZÁPASY',
        message: 'Filtrujte podle sezóny, zápasů nebo domácích nebo venkovních zápasů'
      },
      step2: {
        title: 'HRÁČI',
        message: 'Zobrazte výkon všech hráčů v sestavě prostřednictvím nesčetných metrik'
      }
    }
  },
  alerts: {
    numPlayers: 'Počet hráčů',
    newPlayersLastWeek: 'Noví hráči minulý týden',
    subtitle: 'Získejte upozornění, když noví hráči splní vaše kritéria vyhledávání',
    generalSubtitle: 'Přijímejte upozornění na nové hráče na základě vašich kritérií a novinky o vašich oblíbených hráčích',
    subtitlePlayer: 'Získejte upozornění, když máme novinky o vašich oblíbených hráčích',
    subtitleSearch: 'Získejte upozornění, když noví hráči splní vaše kritéria vyhledávání',
    favorite: 'Oblíbené',
    newEventCalendar: 'Nová událost',
    updatedEventCalendar: 'Aktualizovaná událost',
    newShareFrom: 'Nové sdílení od',
    injuryAlert: 'Upozornění na zranění',
    contractAlert: 'Upozornění na smlouvu',
    teamAlert: 'Upozornění na podpis',
    marketValueAlert: 'Upozornění na tržní hodnotu',
    gameAlert: 'Upozornění na odehraný zápas'
  },
  videoEvents: {
    highlights: 'Zajímavé momenty',
    fullGame: 'Celý zápas',
    autoplay: 'Automatické přehrávání',
    searchBarPlaceholder: 'Hledat hráče, zápas nebo tým...',
    subtitle: 'Analyzujte události prostřednictvím videa',
    successful: 'Úspěch',
    unsuccessful: 'Neúspěch',
    playing: 'Hraje',
    games: 'Zápasy',
    moreFilters: 'Více filtrů...',
    startArea: 'Počáteční oblast',
    endArea: 'Koncová oblast',
    select: 'Vybrat',
    selectLastXGames: 'Vybrat posledních {0} zápasů',
    advancedFilters: 'Pokročilé filtry',
    freeKicks: 'Volné kopy',
    cornerKicks: 'Rohové kopy',
    allShots: 'Všechny střely',
    generateZip: 'Stáhnout videa',
    zippedModalMessage: 'Právě vytváříme váš seznam videí a brzy vám ho pošleme na e-mail',
    clickToSeeVideo: 'Klikněte pro zobrazení videa'
  },
  videoUpload: {
    subtitle: 'Nahrajte video a vytvořte nový zápas',
    uploadVideo: 'Nahrát video',
    selectPeriod: 'Vybrat období',
    gameData: 'Data zápasu',
    venue: 'Místo konání',
    matchType: 'Typ zápasu',
    matchGroup: 'Skupina zápasu',
    roundType: 'Typ kola',
    roundNumber: 'Číslo kola',
    offsetFh: 'Posun první poločas',
    offsetSh: 'Posun druhý poločas',
    offsetFhOT: 'Posun prodloužení první poločas',
    offsetShOT: 'Posun prodloužení druhý poločas',
    homeLineup: 'Doma sestava',
    awayLineup: 'Venku sestava',
    existingPlayer: 'Existující hráč',
    newPlayer: 'Nový hráč',
    startingTeam: 'Startující',
    saveAndUpload: 'Uložit a nahrát',
    existingGame: 'Zápas již existuje',
    sendToKora: 'Odeslat',
    invalidForm: 'Neplatný formulář',
    warningModalTitle: 'Byly detekovány anomálie',
    noScoreSheetWarning: 'Není připojený zápis skóre',
    onlyOnePartUploadedWarning: 'Je připojen pouze jeden poločas',
    continueQuestion: 'pokračovat?',
    slaLimit: 'Nahráli jste {0} zápasů s {1}. Váš limit je {2}',
    requestedGames: 'Požadované zápasy',
    limitClose: 'Zbývá pouze {0} zápasů k požádání',
    limitReached: 'Dosáhli jste limitu nahrávání videí. Nahrávání dalších zápasů může vést k dodatečným poplatkům.',
    seasonFinishedWarning: 'Tím se vytvoří zápas v sezóně, která již skončila. Prosím zkontrolujte, zda je to správně.',
    teamCountryWarning: 'Tento tým je z jiné země než vybraná liga. Prosím zkontrolujte, zda je to správně.',
    uploading: 'Nahrávání',
    doNotNavigateAway: 'Během nahrávání nezavírejte tuto kartu, neobnovujte stránku ani neodcházejte jinam.',
    severalMinutes: 'Tento proces může trvat několik minut.'
  },
  videoPlaylists: {
    subtitle: 'Kolekce filtrů zajímavých momentů videí',
    savePlaylist: 'Uložit playlist',
    seeAllPlaylists: 'Zobrazit všechny playlisty'
  },
  videoHighlights: {
    recap: 'Shrnutí',
    homeCondensed: 'Doma kondenzovaný zápas',
    awayCondensed: 'Venku kondenzovaný zápas',
    selectedActions: 'Vybrané akce',
    noActions: 'Žádné akce neodpovídají zadaným kritériím filtru',
    noGames: 'Zatím nebyly nahrány žádné zápasy',
    attackingActions: 'Útočné akce',
    defensiveActions: 'Defenzivní akce',
    groundDuels: 'Pozemní souboje',
    penaltiesProvoked: 'Vyprovokované penalty',
    goalkeeperActions: 'Akce brankáře',
    addSomeGames: 'Začněte přidáním některých zápasů!',
    goToVideoUploadTool: 'Přejít na nástroj nahrávání videí',
    ballInPlay: 'Míč ve hře',
    filterSeasons: 'Filtrovat sezóny',
    streaming: 'Streamování',
    clips: 'Klipy',
    qualifiers: {
      Pass: 'Přihrávka',
      Save: 'Záchrana',
      'Saved Shot': 'Zachráněná střela',
      Shot: 'Střela',
      Goal: 'Gól',
      'Missed Shot': 'Minutá střela',
      'Shot on Post': 'Střela na tyč',
      Error: 'Chyba',
      Clearance: 'Vykop',
      Aerial: 'Vzdušný souboj',
      Challenge: 'Ztracený pozemní souboj',
      Dispossessed: 'Odepření míče',
      Foul: 'Faul',
      Card: 'Karta',
      'Offside Pass': 'Přihrávka do ofsajdu',
      Claim: 'Zachycení centru',
      'Keeper Pickup': 'Sebrání brankářem',
      'Ball Touch': 'Dotyk míče',
      Dribble: 'Driblink',
      Interception: 'Zachycení',
      Tackle: 'Skobrnutí',
      'Ball Recovery': 'Znovuzískání míče',
      Takeon: 'Driblink'
    },
    qualifierIds: {
      1: 'Dlouhý míč',
      2: 'Centr',
      5: 'Zahraný volný kop',
      6: 'Zahraný rohový kop',
      9: 'Penalty',
      15: 'Hlavou',
      20: 'Pravou nohou',
      21: 'Jiná část těla',
      22: 'Běžná hra',
      23: 'Rychlý protiútok',
      24: 'Standardní situace',
      25: 'Z rohu',
      26: 'Volný kop',
      28: 'Vlastní gól',
      29: 'S asistencí',
      31: 'Žlutá karta',
      32: 'Druhá žlutá karta',
      33: 'Červená karta',
      72: 'Levou nohou',
      73: 'Vlevo',
      82: 'Zachráněná střela (bez BR)',
      94: 'Blok obránce',
      123: 'Výhoz brankáře',
      124: 'Výkop',
      160: 'Vhazování standardní situace',
      170: 'Vedoucí k gólu',
      173: 'Odražené bezpečně',
      174: 'Odražené nebezpečně',
      177: 'Zachyceno',
      178: 'Stojící',
      179: 'Výraz',
      182: 'Ruce',
      183: 'Nohy',
      185: 'Blokovaný centr',
      210: 'Asistence',
      215: 'Individuální hra',
      279: 'Výkop',
      285: 'Defenzivní',
      286: 'Útočný'
    },
    areas: {
      goalArea: 'Gólová oblast',
      boxLeft: 'Pokutové území vlevo',
      boxCenter: 'Pokutové území střed',
      boxRight: 'Pokutové území vpravo',
      outBoxDeepLeft: 'Mimo pokutové území hluboko vlevo',
      outBoxDeepRight: 'Mimo pokutové území hluboko vpravo',
      outBoxLeft: 'Mimo pokutové území vlevo',
      outBoxCentreLeft: 'Mimo pokutové území střed vlevo',
      outBoxCentre: 'Mimo pokutové území střed',
      outBoxCentreRight: 'Mimo pokutové území střed vpravo',
      outBoxRight: 'Mimo pokutové území vpravo',
      midfieldLeft35: 'Střed hřiště vlevo',
      midfieldCentreLeft35: 'Střed hřiště střed vlevo',
      midfieldCentre35: 'Střed hřiště střed',
      midfieldCentreRight35: 'Střed hřiště střed vpravo',
      midfieldRight35: 'Střed hřiště vpravo',
      ownGoalArea: 'Vlastní gólová oblast',
      ownBoxLeft: 'Vlastní pokutové území vlevo',
      ownBoxCenter: 'Vlastní pokutové území střed',
      ownBoxRight: 'Vlastní pokutové území vpravo',
      ownFieldOutOfBoxDeepLeft: 'Vlastní pole mimo pokutové území hluboko vlevo',
      ownFieldOutOfBoxDeepRight: 'Vlastní pole mimo pokutové území hluboko vpravo',
      ownFieldOutOfBoxLeft: 'Vlastní pole mimo pokutové území vlevo',
      ownFieldOutOfBoxCentreLeft: 'Vlastní pole mimo pokutové území střed vlevo',
      ownFieldOutOfBoxCentre: 'Vlastní pole mimo pokutové území střed',
      ownFieldOutOfBoxCentreRight: 'Vlastní pole mimo pokutové území střed vpravo',
      ownFieldOutOfBoxRight: 'Vlastní pole mimo pokutové území vpravo',
      '6 YARD BOX': 'Goal area',
      'BOX RIGHT': 'Box right',
      'BOX CENTER': 'Box center',
      'BOX LEFT': 'Box left',
      'OUT BOX DEEP RIGHT': 'Out box deep right',
      'OUT BOX DEEP LEFT': 'Out box deep left',
      'OUT BOX RIGHT': 'Out box right',
      'OUT BOX LEFT': 'Out box left',
      'FINAL THIRD RIGHT': 'Final third right',
      'FINAL THIRD LEFT': 'Final third left',
      'FULL BOX': 'Full box',
      'OUT BOX DEEP RIGHT LARGE': 'Out box deep right large',
      'OUT BOX DEEP LEFT LARGE': 'Out box deep left large',
      'FINAL THIRD RIGHT LARGE': 'Final third right large',
      'FINAL THIRD LEFT LARGE': 'Final third left large',
      'OUT BOX CENTER RIGHT': 'Out box center right',
      'OUT BOX CENTER': 'Out box center',
      'OUT BOX CENTER LEFT': 'Out box center left',
      'FINAL THIRD CENTER RIGHT': 'Final third center right',
      'FINAL THIRD CENTER': 'Final third center',
      'FINAL THIRD CENTER LEFT': 'Final third center left',
      'OUT BOX CENTER RIGHT SMALL': 'Out box center right small',
      'OUT BOX CENTER SMALL': 'Out box center small',
      'OUT BOX CENTER LEFT SMALL': 'Out box center left small',
      'FINAL THIRD CENTER RIGHT LARGE': 'Final third center right large',
      'FINAL THIRD CENTER LARGE': 'Final third center large',
      'FINAL THIRD CENTER LEFT LARGE': 'Final third center left large',
      'OWN 6 YARD BOX': 'Own Goal area',
      'OWN BOX RIGHT': 'Own Box right',
      'OWN BOX CENTER': 'Own Box center',
      'OWN BOX LEFT': 'Own Box left',
      'OWN OUT BOX DEEP RIGHT': 'Own Out box deep right',
      'OWN OUT BOX DEEP LEFT': 'Own Out box deep left',
      'OWN OUT BOX RIGHT': 'Own Out box right',
      'OWN OUT BOX LEFT': 'Own Out box left',
      'OWN FINAL THIRD RIGHT': 'Own Final third right',
      'OWN FINAL THIRD LEFT': 'Own Final third left',
      'OWN FULL BOX': 'Own Full box',
      'OWN OUT BOX DEEP RIGHT LARGE': 'Own Out box deep right large',
      'OWN OUT BOX DEEP LEFT LARGE': 'Own Out box deep left large',
      'OWN FINAL THIRD RIGHT LARGE': 'Own Final third right large',
      'OWN FINAL THIRD LEFT LARGE': 'Own Final third left large',
      'OWN OUT BOX CENTER RIGHT': 'Own Out box center right',
      'OWN OUT BOX CENTER': 'Own Out box center',
      'OWN OUT BOX CENTER LEFT': 'Own Out box center left',
      'OWN FINAL THIRD CENTER RIGHT': 'Own Final third center right',
      'OWN FINAL THIRD CENTER': 'Own Final third center',
      'OWN FINAL THIRD CENTER LEFT': 'Own Final third center left',
      'OWN OUT BOX CENTER RIGHT SMALL': 'Own Out box center right small',
      'OWN OUT BOX CENTER SMALL': 'Own Out box center small',
      'OWN OUT BOX CENTER LEFT SMALL': 'Own Out box center left small',
      'OWN FINAL THIRD CENTER RIGHT LARGE': 'Own Final third center right large',
      'OWN FINAL THIRD CENTER LARGE': 'Own Final third center large',
      'OWN FINAL THIRD CENTER LEFT LARGE': 'Own Final third center left large'
    },
    outcomes: {
      success: 'Úspěch',
      fail: 'Neúspěch',
      possessionWon: 'Držení míče získáno',
      possessionNotWon: 'Držení míče nezískáno',
      received: 'Přijato',
      provoked: 'Vyprovokováno'
    },
    homePlayerHighlights: 'Zajímavosti domácích hráčů',
    awayPlayerHighlights: 'Zajímavosti hostujícího hráče'
  },
  share: {
    shareTo: 'Odeslat na',
    viaApp: 'Aplikace (Driblab zpráva)',
    viaEmail: 'E-mail',
    description: 'Popis',
    titleTab: 'Sdílení',
    toMe: 'Přijaté',
    fromMe: 'Odeslané',
    typeInternal: 'Interní',
    typeExternal: 'Externí',
    title: 'Sdíleno',
    subtitle: 'Přehled položek ve vašem seznamu sdílení a vašich sdílení',
    selectUser: 'Vybrat uživatele',
    expired: 'Vypršelo',
    limitReached: 'Odkaz dosáhl limitu použití'
  },
  homeStats: {
    data: 'Dostupná data',
    players: 'hráči',
    totalPlayers: 'celkem hráčů',
    teams: 'týmy',
    totalTeams: 'celkem týmů',
    leagues: 'ligy',
    totalLeagues: 'celkem lig',
    seasons: 'sezóny',
    totalSeasons: 'celkem sezón',
    games: 'zápasy',
    totalGames: 'celkem zápasů'
  },
  scoutingCalendar: {
    subtitle: 'Vytvářejte a organizujte své skautingové úkoly',
    myCalendars: 'Soukromý kalendář',
    publicCalendars: 'Veřejné kalendáře',
    otherCalendars: 'Jiné kalendáře',
    calendarSettings: 'Nastavení kalendáře',
    moreInfo: 'Více informací',
    individualScouting: 'Individuální skauting',
    matchScouting: 'Skauting zápasů',
    calendarView: {
      type: 'Typ kalendáře',
      month: 'Měsíc',
      week: 'Týden',
      day: 'Den'
    },
    weekView: {
      type: 'Typ týdne',
      monSun: 'Pondělí - Neděle',
      sunSat: 'Neděle - Sobota',
      monFri: 'Pondělí - Pátek'
    },
    tasks: {
      addNew: 'Přidat nový úkol',
      myTasks: 'Moje úkoly',
      filterTasks: 'Filtrovat úkoly',
      sharedWithMe: 'Sdíleno se mnou',
      createTask: 'Vytvořit úkol',
      newTask: 'Nový úkol',
      taskName: 'Název úkolu',
      allDay: 'Celý den',
      startDate: 'Datum začátku',
      endDate: 'Datum konce',
      startHour: 'Hodina začátku',
      endHour: 'Hodina konce',
      assignedTo: 'Přiřazeno',
      assignedToMe: 'Přiřazeno mně',
      color: 'Barva',
      scoutingType: 'Typ skautingu',
      taskLocation: 'Umístění úkolu',
      selectLeague: 'Vybrat ligu',
      selectMatch: 'Vybrat zápas',
      useMatchdate: 'Použít datum zápasu jako datum',
      stadium: 'Stadion',
      travel: 'Cestování',
      hotel: 'Hotel',
      tickets: 'Vstupenky',
      taskNotes: 'Napište popisné poznámky nebo komentáře související s úkolem',
      states: {
        toDo: 'K udělání',
        inProgress: 'Probíhá',
        done: 'Hotovo'
      },
      type: {
        player: 'Hodnocení hráče',
        team: 'Hodnocení týmu',
        other: 'Jiné'
      },
      location: {
        stadium: 'Na stadionu',
        video: 'Video'
      },
      accommodation: {
        accommodationDetails: 'Detaily ubytování',
        ownArrangement: 'Vlastní zařízení',
        required: 'Požadováno',
        notRequired: 'Není požadováno',
        booked: 'Rezervováno'
      },
      assignToMe: 'Přiřadit mně',
      addOther: 'Přidat jiné',
      deleteTask: 'Smazat úkol',
      deleteTaskMessage: 'Úkol bude odstraněn, jste si jisti?',
      cancelUpdate: 'Zrušit aktualizaci',
      cancelUpdateMessage: 'Změny nebudou uloženy, jste si jisti?',
      selectGame: 'Prosím, vyberte zápas pro přidání souborů',
      noData: 'Žádná data. Začněte přidáním některých úkolů!',
      widgetSubtitle: 'Zkontrolujte své další úkoly',
      scoutingDetails: 'Detaily skautingu',
      taskDetails: 'Detaily úkolu',
      playerDocuments: 'Dokumenty hráče',
      teamDocuments: 'Dokumenty týmu',
      gameDocuments: 'Dokumenty zápasu',
      taskDocuments: 'Dokumenty úkolu',
      task: 'Úkol'
    },
    nextGames: 'Další zápasy'
  },
  scoutingTasksBoard: {
    period: {
      week: 'Tento týden',
      month: 'Tento měsíc',
      year: 'Tento rok'
    },
    noTasks: 'Vytvořte nové úkoly nebo sem jeden přetáhněte!',
    goToBoard: 'Přejít na nástěnku'
  },
  profile: {
    title: 'Profil',
    subtitle: 'Přizpůsobte si svůj účet a detaily předplatného'
  },
  hub: {
    onlyHub: 'Pouze dostupné v Driblab Hub',
    blue: 'modrý',
    purple: 'fialová',
    orange: 'pomerančový',
    grey: 'šedá',
    indigo: 'indigo',
    teal: 'modrozelená',
    lightBlue: 'světle modrá',
    brown: 'hnědý'
  },
  uploadedGames: {
    subtitle: 'Všechny nahrané zápasy',
    timeRequested: 'Čas požádání',
    timeReceived: 'Kdy bylo přijato',
    diffHours: 'Rozdíl v hodinách',
    collectionCompleted: 'Kolekce dokončena',
    dateFrom: 'Datum od',
    dateTo: 'Datum do',
    goToUploadedGames: 'Přejít na nahrané zápasy',
    sla: 'Smlouva o úrovni služeb',
    matchDate: 'Datum zápasu',
    rejectedGame: 'Zamítnuto',
    reviewed: 'Zkontrolováno',
    requested: 'Požádáno',
    koraStatus: 'Status Kora',
    aws: 'AWS',
    fullVideo: 'Celé video',
    offset: 'Posun',
    updateFullVideo: 'Aktualizovat celé video?'
  },
  gameMap: {
    title: 'Mapa zápasů',
    subtitle: 'Prozkoumejte zápasy na příští dny',
    warning: 'Čas a místo nemusí být správné. Prosím potvrďte tyto informace.',
    taskAdded: 'Úkol byl úspěšně vytvořen. Zkontrolujte Skautingový kalendář.'
  },
  leagueRequestAccess: {
    sendSuccess: 'Úspěšně nahlášeno',
    notPermissions: 'Nemáte oprávnění k zobrazení',
    notPermissionsLeague: 'Nemáte oprávnění k zobrazení této ligy',
    notPermissionsGame: 'Nemáte oprávnění k zobrazení tohoto zápasu',
    requestAccessTo: 'Požádat o přístup k',
    sendRequest: 'Odeslat žádost'
  },
  videoTeams: {
    subtitle: 'Najděte nejnovější zápasy označené podle týmu',
    noGamesUploaded: 'Zatím nebyly nahrány žádné zápasy'
  },
  scoutingAnalysis: {
    scoutingAnalysis: 'Skautingová analýza',
    scoutingAnalyses: 'Skautingové analýzy',
    playerScoutingAnalyses: 'Skautingové analýzy hráčů',
    gameScoutingAnalyses: 'Skautingové analýzy zápasů',
    analyses: 'Analýzy',
    addReport: 'Přidat analýzu',
    technical: 'Technická',
    tactical: 'Taktická',
    physical: 'Fyzická',
    mental: 'Duševní',
    technicalNotes: 'Technické poznámky',
    tacticalNotes: 'Taktické poznámky',
    physicalNotes: 'Fyzické poznámky',
    mentalNotes: 'Duševní poznámky',
    conclusion: 'Závěr',
    charactersMax: 'Max 1000 znaků',
    globalRating: 'Celkové hodnocení',
    noData: 'Žádná data. Začněte přidáním některých skautingových analýz!',
    deleteAnalysis: 'Smazat skautingovou analýzu',
    deleteAnalysisMessage: 'Analýza bude trvale odstraněna. Jste si jisti?',
    avgTooltip: 'Průměr založený na finálních hodnoceních analýz viditelných pro vás',
    avgOverallScoreTooltip: 'Průměr založený na celkových skóre hráče viditelných pro vás',
    scouter: 'Skaut',
    lastEdited: 'Naposledy upraveno',
    analysisFilters: 'Filtry analýz',
    generalFilters: 'Obecné filtry',
    widgetSubtitle: 'Nejnovější přidané analýzy',
    addPlayerReport: 'Přidat skautingovou analýzu hráče',
    seeReports: 'Zobrazit zprávy',
    addGameReport: 'Přidat skautingovou analýzu zápasu',
    keyPlayers: 'Klíčoví hráči',
    formation: 'Formace',
    inPossession: 'S držením míče',
    notesIP: 'Poznámky s držením míče',
    outOfPossession: 'Bez držení míče',
    notesOP: 'Poznámky bez držení míče',
    transitions: 'Přechody',
    notesTransitions: 'Poznámky přechodů',
    notesSP: 'Poznámky standardních situací',
    finalRating: 'Finální hodnocení',
    gameNotesPlaceholder: 'Napište popisné poznámky nebo komentáře související se zápasem',
    avgPotentialTooltip: 'Průměr na základě potenciálu analýz, které vidíte',
    potential: 'Potenciál',
    tags: 'Tagy',
    tagsPlaceholder: 'Přidejte nějaké značky',
    tagsHint: 'Napište a stiskněte Enter pro přidání značky',
    exampleTags: {
      leadership: 'Vedení',
      resilience: 'Odolnost',
      competitiveMindset: 'Konkurenční myšlení',
      calmUnderPressure: 'Klid pod tlakem',
      focus: 'Soustředit',
      discipline: 'Disciplína',
      coachability: 'Koučovatelnost',
      poorBodyLanguage: 'Špatná řeč těla',
      lowConfidence: 'Nízká důvěra',
      easilyFrustrated: 'Snadno frustrovaný'
    },
    totals: 'Totals',
    byPossession: 'By Possession'
  },
  addPlayerForm: {
    noLeague: 'Vytvoření týmu bez ligy může mít negativní vliv na jeho indexování a následné vyhledávání v aplikaci.'
  },
  expenses: {
    expense: 'Výdaj',
    expenses: 'Výdaje',
    addExpense: 'Přidat výdaj',
    transportation: 'Doprava',
    accommodation: 'Ubytování',
    dietary: 'Strava',
    eventTicket: 'Vstupenka na událost',
    expenseType: 'Typ výdaje',
    amount: 'Částka',
    expenseDate: 'Datum výdaje',
    expenseFilters: 'Filtry výdajů',
    noData: 'Žádná data. Začněte přidáním některých výdajů!',
    deleteExpense: 'Smazat výdaj',
    deleteExpenseMessage: 'Výdaj bude trvale odstraněn. Jste si jisti?'
  },
  disabledTooltips: {
    general: 'Tato funkce je momentálně zakázána',
    youth: 'Musí být mládežnický pro nastavení věku',
    unit: 'Statistika musí být Běhy, HSR nebo SPR',
    seasonsWithout60MinsGames: 'Hráč neodehrál více než 60 minut v jednom zápase ve vybrané sezóně/sezónách',
    notEditable: 'Toto nelze upravit',
    noMatchdate: 'Datum zápasu není k dispozici',
    selectGame: 'Nejprve vyberte zápas',
    selectPlayer: 'Nejprve vyberte hráče',
    selectTeam: 'Nejprve vyberte tým',
    selectBoxes: 'Musí být vybrána vizualizace boxů',
    selectYear: 'Nejprve vyberte rok',
    pdScoreNotAvailable: 'Skóre není k dispozici pro hráče, kteří neodehráli 60 minut v zápase',
    pdSeasonNotAvailable: 'Fyzická data nejsou k dispozici pro tuto sezónu',
    pdGameNotAvailable: 'Fyzická data nejsou k dispozici pro tento zápas'
  },
  leagueTypes: {
    regular: 'Pravidelná',
    continental: 'Kontinentální',
    nationalTeam: 'Národní tým',
    countryCup: 'Národní pohár',
    qualifier: 'Kvalifikace',
    playOff: 'Play-off',
    regionalLeague: 'Regionální liga',
    friendly: 'Přátelský',
    nationalFriendly: 'Národní přátelský',
    nationaQualifier: 'Národní kvalifikace'
  },
  playerSides: {
    'Left/Right': 'Vlevo/Vpravo',
    'Left/Centre/Right': 'Vlevo/Střed/Vpravo',
    Right: 'Vpravo',
    Centre: 'Střed',
    'Centre/Right': 'Střed/Vpravo',
    Left: 'Vlevo',
    'Left/Centre': 'Vlevo/Střed'
  },
  areaSelector: {
    selectAreas: 'Vybrat oblasti',
    filterAreas: 'Filtrovat oblasti'
  },
  spatialCoverage: {
    lastDefenderDist: 'Vzdálenost posledního obránce',
    defensiveLineDist: 'Vzdálenost defenzivní linie',
    fullBackAvgDist: 'Průměrná vzdálenost krajního obránce',
    offensiveLineDist: 'Vzdálenost útočné linie',
    distanceToGoal: 'Vzdálenost k brance',
    avgLineWidth: 'Prům. šířka linie',
    leagueAvgDistanceToGoal: 'Prům. ligová vzd. k brance',
    leagueAvgLineWidth: 'Prům. ligová šířka linie',
    avgShort: 'Prům.',
    meters: 'metrů',
    leagueAvgDist: 'Prům. ligová vzdálenost',
    distance: 'Vzdálenost',
    avgPositionYAxis: 'Prům. vzdálenost na hřišti (Y)',
    leagueAvgPositionYAxis: 'Prům. ligová vzdálenost na hřišti (Y)',
    lbRbDistanceSeparation: 'Vzdálenost LB–RB',
    leagueAvgLbRbDistanceSeparation: 'Prům. ligová vzdálenost LB–RB',
    legendTeam: 'Tým',
    legendLeagueAvg: 'Prům. liga',
    maxLength: 'Maximální délka',
    maxWidth: 'Maximální šířka',
    avgBlockDistance: 'Prům. bloková vzdálenost'
  },
  arrigo: {
    beta: 'BETA',
    subtitle: 'Inteligentní data',
    passesUnderPressureSubtitle: 'Analyzujte úspěšnost přihrávek pod obranným tlakem',
    onBallPressureSubtitle: 'Analyzujte události tlaku na míč a jejich úspěšnost podle oblastí na hřišti',
    ballReceiptsInSpaceSubtitle: 'Analyzujte průchody přijaté v prostoru podle zóny pole',
    ballReceipts: 'účtenky',
    totalBallReceipts: 'Celkem příjmů míče',
    totalBallReceiptsCompleted: 'Celkem Příjmů Míče Dokončeno',
    completed: 'Dokončeno',
    lineBreakingPassesSubtitle: 'Analyzujte přihrávky, které prolomí linie a vytvoří výhody',
    bypassed: 'Překonání',
    oppsBypassed: 'Překonaní soupeři',
    passer: 'Přihrávající hráč',
    passedTo: 'Přihrát do',
    receivedFrom: 'Přijato z',
    distanceToNearestDefender: 'Vzdálenost k nejbližšímu obránci',
    lineBreaking: 'Prolamování linie {0}',
    keyPass: 'Klíčová přihrávka',
    receiver: 'Příjemce',
    dynamicTracking: 'Dynamické sledování',
    eventLockTooltip: 'Někteří hráči nebyli během hry vidět',
    bypassedPlayers: '{0} obejitých hráčů',
    playersCount: '{0} hráčů',
    bothTeams: 'Oba týmy',
    matchesCount: '{0} zápasů',
    lbpType: {
      F: 'Útočná řada',
      M: 'Záložní řada',
      B: 'Obranná řada',
      MF: 'Záložní a útočná řada',
      BM: 'Obranná a záložní řada',
      BF: 'Obranná a útočná řada',
      BMF: 'Obranná, záložní a útočná řada'
    },
    lbpCategory: {
      'G-IN-T': 'Po zemi uvnitř (láme obrannou linii)',
      'G-IN-NT': 'Po zemi uvnitř (neláme obrannou linii)',
      'G-OUT-T': 'Po zemi venku (láme obrannou linii)',
      'G-OUT-NT': 'Po zemi venku (neláme obrannou linii)',
      'O-IN-T': 'Vzduchem uvnitř (láme obrannou linii)',
      'O-IN-NT': 'Vzduchem uvnitř (neláme obrannou linii)',
      'O-OUT-T': 'Vzduchem venku (láme obrannou linii)',
      'O-OUT-NT': 'Vzduchem venku (neláme obrannou linii)',
      ground: 'Po zemi',
      over: 'Vzduchem',
      inside: 'Vnitřkem',
      outside: 'Vnějškem',
      through: 'Láme obrannou linii',
      notThrough: 'Neláme obrannou linii',
      throughAbbr: 'Prolomení def. čára',
      notThroughAbbr: 'Bez porušení def. čára'
    },
    lbpCategorySplit: {
      G: 'Ground: Průsmyk byl zem',
      O: 'Over: Míč byl vyražen do vzduchu',
      OUT: 'Venku: Přihrávka šla mimo',
      IN: 'Uvnitř: Průkaz šel dovnitř',
      T: 'Láme obrannou linii: přihrávka láme obrannou linii zevnitř',
      NT: 'Neláme obrannou linii: přihrávka ji zevnitř neláme; obchází ji zvenku'
    },
    obrType: {
      OL: 'Překrytí',
      UL: 'Podběh',
      RA: 'Běh vpřed',
      RB: 'Běh vzad',
      CR: 'Příjemce centru',
      SP: 'Podpora',
      CS: 'Přiblížení se'
    },
    visualization: 'Vizualizace',
    points: 'Kruhy',
    zones: 'Teplotní Mapa',
    pressureIntensity: 'Intenzita tlaku',
    pressureOutcome: 'Výsledek tlaku',
    passesOutcome: 'Výsledek Přihrávek',
    strong: 'Silný',
    light: 'Lehký',
    normal: 'Normální',
    successful: 'Úspěšný',
    unsuccessful: 'Neúspěšný',
    presses: 'Tlaky',
    passes: 'Passy',
    passUnder: 'Pass Under',
    successRate: 'Míra úspěšnosti',
    pressureOn: 'Tlak na',
    pressureOf: 'Tlak',
    pressure: 'Tlak',
    totalLabel: 'celkem',
    totalPasses: 'Celkový počet Průchodů',
    unknown: 'neznámý',
    selectGameToViewMap: 'Vyberte hru, aby se zobrazila mapa tlaku',
    noEventsFoundForGame: 'Nebyly nalezeny žádné události tlaku pro tuto hru',
    noEventsFoundForTeamAndSeason: 'Nebyly nalezeny žádné události tlaku pro tento tým a sezónu',
    noEventsFoundForPlayerAndSeason: 'Nebyly nalezeny žádné události tlaku pro tento hráč a sezónu',
    noEventsMatchFilters: 'Nebyly nalezeny žádné události, které by odpovídaly aktuálním filtrům',
    totalEventsAvailable: 'celkové události dostupné',
    passType: {
      P: 'Přihrávka',
      A: 'Asistujte',
      KP: 'Klíčový průkaz',
      PiOB: 'Průjezd do Opp. Krabice',
      PiFT: 'Přechod do závěrečné třetiny',
      SoPP: 'Přepnutí Play Pass'
    },
    minFrom: 'Min od',
    minTo: 'Min do',
    secondFrom: 'Seg From',
    secondTo: 'Seg To',
    positionPlayed: 'Hraná pozice',
    highlight: 'Zvýrazněte',
    passTypeLabel: 'Typ průkazu',
    offBallRunSubtitle: 'Analyzujte běhy s míčem',
    insights: 'Postřehy',
    insightsSubtitle: 'Hodnocení nejlepších s Advanced Arrigo Analytics',
    pressurePassTypeLabel: 'Pressure On Pass Type'
  },
  driblabAI: {
    chatText: 'Jak vám dnes mohu pomoci?',
    chatSubtext: 'Zeptejte se na cokoliv ohledně fotbalových dat!',
    thinking: 'Myslící...',
    giveFeedback: 'Dejte zpětnou vazbu',
    disclaimer: 'DriblabAI může dělat chyby. Prosím, nezapomeňte si ověřit informace.',
    recent: 'Nedávné',
    noConversations: 'Zde uvidíte své nedávné konverzace!',
    rename: 'Přejmenovat',
    deleteConversation: 'Smazat konverzaci',
    confirmDelete: 'Opravdu chcete smazat tuto konverzaci?',
    feedback: 'Zpětná vazba',
    feedbackQuestion: 'Byla tato odpověď užitečná?',
    feedbackComments: 'Další komentáře',
    feedbackPlaceholder: 'Řekněte nám, co bylo užitečné nebo co by se dalo zlepšit...',
    errorMessage: 'Zprávu nebylo možné zpracovat. Zkuste to znovu.',
    newConversation: 'Nový chat',
    write: 'Napište zprávu...'
  },
  periodId: {
    1: 'První polovina',
    2: 'Druhá polovina',
    3: 'Čas navíc - 1º',
    4: 'Čas navíc - 2º',
    5: 'Penaltový rozstřel',
    6: 'Plný úvazek',
    7: 'Před zápasem',
    8: 'Opuštěný',
    9: 'Žít',
    10: '0-15',
    11: '16-30',
    12: '31+',
    13: '45-60',
    14: '61-75',
    15: '76+',
    '-1': 'Ostatní'
  }
};
